// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/quote.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/pricing/content-creation.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/product/slider/watch-live-video.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/product/slider/video-over-document.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/product/slider/knowledge-retention.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/product/slider/explainer-video-content.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/product/slider/attention-to-short-form-videos.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/product/slider/clicks-and-engagement.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/product/slider/no-time-for-learning.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/product/slider/human-attention-span.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/product/slider/microlearning.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/product/community-power.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/product/develop-people.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/product/sentiments.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/product/cinemetic.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/solution/organization.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/solution/roi.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/solution/microai.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/solution/measure.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/solution/workplace/each-course-5-min.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/solution/workplace/real-workplace.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/solution/workplace/keep-in-mind.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/solution/workplace/scenario.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/solution/workplace/prescriptive-content.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/solution/workplace/bella.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/solution/workplace/track-progress.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/vission.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/purpose.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/footer-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, span, applet, object, iframe, h1, h2,
h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym,
address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var, b, u, i, center,
dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption,
tbody, tfoot, thead, tr, th, td, article, aside, canvas, details,
embed, figure, figcaption, footer, header, hgroup, menu,
nav, output, ruby, section, summary, time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

body,
html {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  line-height: 26px;
  color: #2e2d2d;
}

@media (max-width: 991px) {
  body,
  html {
    font-size: 14px;
    line-height: 20px;
  }
}
article, aside, details, figcaption, figure, footer,
header, hgroup, menu, nav, section, main {
  display: block;
}

strong, b {
  font-weight: 600;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a[href] {
  text-decoration: none;
  transition: 400ms ease;
  cursor: pointer;
}

a[href]:hover {
  color: #000;
}

img {
  max-width: 100%;
}

.container {
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
}

.container-fluid {
  max-width: 100%;
  width: 100%;
  display: block;
  margin: 0 auto;
  padding: 0 5%;
}

h1, h2, h3, h4, h5, h6 {
  color: #000;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  line-height: 1.3;
}
@media (max-width: 767px) {
  h1, h2, h3, h4, h5, h6 {
    margin: 5px 0;
  }
}

h1 {
  font-size: 60px;
  line-height: 68px;
}
@media (max-width: 991px) {
  h1 {
    font-size: 40px;
    line-height: 45px;
  }
}
@media (max-width: 767px) {
  h1 {
    font-size: 30px;
    line-height: 35px;
  }
}

h2 {
  font-size: 40px;
}
@media (max-width: 767px) {
  h2 {
    font-size: 24px;
    line-height: 32px;
  }
}

h3 {
  font-size: 21px;
}
@media (max-width: 991px) {
  h3 {
    font-size: 20px;
  }
}

h4 {
  font-size: 24px;
}

h5 {
  font-size: 20px;
}

h6 {
  font-size: 18px;
}
@media (max-width: 991px) {
  h6 {
    font-size: 20px;
  }
}

.heading {
  margin-bottom: 30px;
  text-align: center;
}
.heading .title {
  color: #666666;
  font-weight: 500;
  text-transform: uppercase;
  opacity: 0.7;
}

.heading h1, .heading h2 {
  line-height: 50px;
  color: #666666;
  font-weight: 500;
}
@media (max-width: 767px) {
  .heading h1, .heading h2 {
    line-height: 32px;
  }
}

*,
*::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}

input,
select,
button,
textarea {
  font-family: "Poppins", sans-serif;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}

button,
input[type=submit],
input[type=button] {
  cursor: pointer;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.text-right {
  text-align: right;
}

body::-webkit-scrollbar {
  width: 5px;
}

body::-webkit-scrollbar-thumb {
  background-color: #2e2d2d;
}

body::-webkit-scrollbar-track {
  box-shadow: unset;
  background: #fff;
}

.case_detail::-webkit-scrollbar {
  width: 5px;
}

.case_detail::-webkit-scrollbar-thumb {
  background-color: #2e2d2d;
}

.case_detail::-webkit-scrollbar-track {
  box-shadow: unset;
  background: #fff;
}

.img_hover {
  position: relative;
  overflow: hidden;
}

.img_hover:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  content: "";
  transition: transform 1s;
  z-index: 11;
  opacity: 0.3;
  transform: scale3d(1.9, 1.4, 1) rotate3d(0, 0, 1, 45deg) translate3d(0, -100%, 0);
  pointer-events: none !important;
}

.img_hover:hover:before {
  transform: scale3d(1.9, 1.4, 1) rotate3d(0, 0, 1, 45deg) translate3d(0, 100%, 0);
}

.social-links li {
  display: inline-block;
}

.modelPop {
  position: fixed;
  z-index: 1111;
}

.close_model {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  line-height: 0;
  width: 25px;
  height: 25px;
  z-index: 111;
}

.overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000;
  width: 100%;
  height: 100%;
  z-index: 111;
  opacity: 0;
  pointer-events: none;
}
.overlay.overlyflm {
  opacity: 0.5;
  pointer-events: all;
}

.bullet_points {
  padding-left: 30px;
}
.bullet_points li {
  padding-left: 20px;
  position: relative;
  color: #fff;
}
.bullet_points li::before {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 10px;
  left: 0;
  top: 8px;
}

.owl-carousel .owl-dots {
  margin-top: 10px;
}
.owl-carousel .owl-dots button.owl-dot {
  border-radius: 20px;
  width: 9px;
  height: 9px;
  background: #FFF;
  position: relative;
  border-color: transparent;
  margin: 0 5px;
  opacity: 0.5;
}
.owl-carousel .owl-dots button.owl-dot.active {
  background: #da3467;
  opacity: 1;
}

.coming-soon {
  height: 100vh;
  background: radial-gradient(dimgray, black);
}
.coming-soon h3 {
  margin: 0;
  padding: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #da3467;
  font-size: 6.5vw;
}
.coming-soon h3::before {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: bottom;
  line-height: 1.14em;
  opacity: 0.3;
}

.mob_strip {
  display: none;
}
@media (max-width: 767px) {
  .mob_strip {
    display: flex;
    justify-content: space-between;
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 111;
    background: #242424;
  }
  .mob_strip a {
    display: inline-block;
    color: #fff;
    max-width: 50%;
    text-align: center;
    font-size: 16px;
    padding: 10px 10px;
    flex: 0 0 50%;
    font-weight: 400;
  }
  .mob_strip a:first-child {
    border-right: 2px solid #fff;
  }
}

#response-message, #contact-message, #newsletter-message {
  color: #16cd16;
  font-weight: 600;
  margin-top: 20px;
}
#response-message.success, #contact-message.success, #newsletter-message.success {
  color: #16cd16;
}
#response-message.error, #contact-message.error, #newsletter-message.error {
  color: #ed2525;
}

.cs-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  display: none;
}
.cs-loader.show {
  display: flex;
}
.cs-loader__media {
  position: relative;
  max-width: 8rem;
  max-height: 8rem;
  margin-bottom: 1rem;
}
.cs-loader__media img {
  max-width: 100%;
  max-height: 100%;
}
.cs-loader .waviy {
  -webkit-box-reflect: below -5px linear-gradient(transparent, rgba(0, 0, 0, 0.4));
}
.cs-loader .waviy span {
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 1.8rem;
  font-weight: 600;
  position: relative;
  display: inline-block;
  text-transform: uppercase;
  animation: waviy 1s infinite;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  background: linear-gradient(70deg, #da3467, #d4567c, #e85480);
}

@keyframes waviy {
  0%, 40%, 100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-5px);
  }
}
header {
  background: #242424;
  position: relative;
  z-index: 11;
}
header::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #222222;
  box-shadow: 0 0 8px 1px rgba(51, 51, 51, 0.3294117647);
  transition: 700ms ease;
}
header .container-fluid {
  padding: 0 40px;
}
header .top-strip {
  position: relative;
  padding: 10px 0;
  transition: 700ms ease;
  z-index: 11;
  background: #da3467;
}
@media (max-width: 767px) {
  header .top-strip {
    display: none;
  }
}
header .top-strip .flex {
  position: relative;
  align-items: center;
}
header .top-strip .col1 {
  flex: 0 1 40%;
  max-width: 60%;
}
@media (max-width: 767px) {
  header .top-strip .col1 {
    flex: 0 1 50%;
    max-width: 50%;
  }
}
header .top-strip .col2 {
  flex: 0 1 60%;
  max-width: 60%;
}
@media (max-width: 767px) {
  header .top-strip .col2 {
    flex: 0 1 50%;
    max-width: 50%;
  }
}
header .top-strip .left-side ul li {
  display: inline-block;
  padding-right: 20px;
}
header .top-strip .left-side ul li svg {
  vertical-align: middle;
  width: 16px;
  fill: none;
  stroke: #fff;
}
header .top-strip .left-side ul li a {
  font-size: 12px;
  margin-left: 5px;
  color: #fff;
}
header .top-strip .right-side {
  text-align: right;
}
header .top-strip .right-side .social-links li {
  padding: 0 10px;
}
header .top-strip .right-side .social-links li svg {
  fill: #fff;
  vertical-align: middle;
}
header .header-wapper {
  position: relative;
  z-index: 1;
  padding: 10px 0;
}
header .header-wapper .flex {
  align-items: center;
  -webkit-box-align: center;
}
header .header-wapper .flex .col1 {
  flex: 0 1 20%;
  max-width: 20%;
}
@media (max-width: 1024px) {
  header .header-wapper .flex .col1 {
    flex: 0 1 20%;
    max-width: 20%;
  }
}
header .header-wapper .flex .col2 {
  flex: 0 1 80%;
  max-width: 80%;
}
@media (max-width: 1024px) {
  header .header-wapper .flex .col2 {
    flex: 0 1 80%;
    max-width: 80%;
  }
}
header .header-wapper .menu-trigger {
  width: 40px;
  height: 36px;
  position: absolute;
  right: 0;
  top: 50%;
  cursor: pointer;
  display: none;
  transform: translateY(-50%);
}
@media (max-width: 767px) {
  header .header-wapper .menu-trigger {
    display: block;
    right: 15px;
  }
}
header .header-wapper .menu-trigger span {
  display: block;
  height: 1px;
  background: #ffffff;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
}
header .header-wapper .menu-trigger span.sma {
  top: 27%;
  width: 20px;
}
header .header-wapper .menu-trigger span.smb {
  display: block;
  width: 30px;
}
header .header-wapper .menu-trigger span.smc {
  display: block;
  bottom: 26%;
  top: auto;
}
header .header-wapper .custom-nav {
  text-align: right;
}
header .header-wapper .custom-nav ul {
  display: inline-block;
}
@media (max-width: 767px) {
  header .header-wapper .custom-nav ul {
    display: none;
  }
}
header .header-wapper .custom-nav ul li {
  display: inline-block;
}
header .header-wapper .custom-nav ul li:nth-child(3).has-dropdown ul.dropdown {
  width: 150px;
}
@media (max-width: 991px) {
  header .header-wapper .custom-nav ul li:last-child {
    display: none;
  }
}
header .header-wapper .custom-nav ul li.has-dropdown {
  position: relative;
  margin-right: 10px;
}
header .header-wapper .custom-nav ul li.has-dropdown ul.dropdown {
  position: absolute;
  left: 0;
  width: 290px;
  top: 40px;
  background: #da3467;
  padding: 8px 0;
  text-align: left;
  opacity: 0;
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  box-shadow: 0 6px 13px 1px rgba(51, 51, 51, 0.1803921569);
  border-radius: 5px;
  transition: 400ms ease;
}
header .header-wapper .custom-nav ul li.has-dropdown ul.dropdown::before {
  content: "";
  position: absolute;
  top: -16px;
  width: 8px;
  height: 8px;
  border: 8px solid transparent;
  border-bottom-color: #da3467;
  left: 43px;
}
header .header-wapper .custom-nav ul li.has-dropdown ul.dropdown li {
  display: block;
}
header .header-wapper .custom-nav ul li.has-dropdown ul.dropdown li a {
  display: block;
  color: #fff;
  padding: 9px 15px;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  transition: 700ms ease;
}
header .header-wapper .custom-nav ul li.has-dropdown .dd-icon {
  display: inline-block;
  margin-left: 10px;
}
header .header-wapper .custom-nav ul li.has-dropdown:hover .dropdown {
  opacity: 1;
  pointer-events: all;
}
header .header-wapper .custom-nav ul li.has-dropdown:hover .dropdown li:hover a {
  background: #fff;
  color: #666666;
}
header .header-wapper .custom-nav ul li a {
  color: #fff;
  padding: 19px 15px;
}
header .header-wapper .custom-nav .demo-link {
  display: inline-block;
  padding-left: 19px;
}
@media (max-width: 991px) {
  header .header-wapper .custom-nav .demo-link {
    display: none;
  }
}
header .header-wapper .custom-nav .demo-link a {
  position: relative;
  color: #fff;
  padding: 10px 15px;
  border: 2px solid #fff;
  border-radius: 50px;
  background: #da3467;
}
header .header-wapper .custom-nav .demo-link a span {
  z-index: 1;
  position: relative;
}
header .header-wapper .custom-nav .demo-link a:hover::before {
  width: 100%;
  transform: translateX(0%);
}
header.header-fixed {
  position: fixed !important;
  width: 100%;
  animation: stickyanimations 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  box-shadow: 10px 0 20px rgba(8, 0, 41, 0.08);
  top: 0;
  left: 0;
  right: 0;
  z-index: 111;
}

@keyframes name {
  0% {
    transform: translateY(-100px);
  }
  100% {
    transform: translateY(0px);
  }
}
.custom-logo {
  line-height: 0;
}
.custom-logo a {
  display: block;
}
.custom-logo a img {
  -webkit-transform: 450ms ease;
  transition: 450ms ease;
  width: 80px;
  filter: invert(1);
}

@keyframes stickyanimations {
  0% {
    transform: translateY(-100px);
  }
  100% {
    transform: translateY(0px);
  }
}
.model.model-navigation {
  overflow-y: scroll;
}
.model.model-navigation, .model.EnquiryModel {
  background: #222222;
  top: 0;
  bottom: 0;
  right: 0;
  max-width: 360px;
  width: 100%;
  padding: 50px;
  transform: translateX(100%);
  transition: 450ms ease;
}
.model.model-navigation.is-open, .model.EnquiryModel.is-open {
  transform: translate(0%);
}
.model.model-navigation .navover, .model.EnquiryModel .navover {
  position: absolute;
  bottom: 5px;
  right: 20px;
  opacity: 0.2;
}
.model.model-navigation .navover img, .model.EnquiryModel .navover img {
  width: 200px;
  filter: invert(1);
}
.model.model-navigation .close_model img, .model.EnquiryModel .close_model img {
  filter: invert(1);
}
.model.model-navigation .modelBody, .model.EnquiryModel .modelBody {
  height: 100%;
}
.model.model-navigation .modelBody.contactform, .model.EnquiryModel .modelBody.contactform {
  padding-top: 40px;
}
.model.model-navigation .modelBody .navigation-list, .model.EnquiryModel .modelBody .navigation-list {
  height: 100%;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav, .model.EnquiryModel .modelBody .navigation-list .serviice_nav {
  padding: 40px 0;
  position: relative;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav ul .nablist, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul .nablist {
  width: 100%;
  position: relative;
  cursor: pointer;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav ul li, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li {
  position: relative;
  display: block;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav ul li a, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li a {
  display: inline-block;
  color: #e5e5e5;
  font-size: 23px;
  padding: 6px 0;
  margin: 4px 0;
  line-height: 30px;
  font-weight: 600;
  transition: 450ms ease;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .nablisting, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .nablisting {
  padding-left: 20px;
  display: none;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .nablisting.open, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .nablisting.open {
  display: block;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .nablisting li a, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .nablisting li a {
  font-size: 16px;
  margin: 0;
  margin-bottom: 3px;
  font-weight: 300px;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .downarrow, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .downarrow {
  position: absolute;
  top: 10px;
  right: 10px;
}
.model.model-navigation .modelBody .navigation-list .serviice_nav::after, .model.EnquiryModel .modelBody .navigation-list .serviice_nav::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background: #fff;
  opacity: 0.2;
}
.model.model-navigation .modelBody .navigation-list .nav_list, .model.EnquiryModel .modelBody .navigation-list .nav_list {
  position: relative;
  padding: 40px 0;
}
.model.model-navigation .modelBody .navigation-list .nav_list ul li, .model.EnquiryModel .modelBody .navigation-list .nav_list ul li {
  margin-bottom: 10px;
}
.model.model-navigation .modelBody .navigation-list .nav_list ul li a, .model.EnquiryModel .modelBody .navigation-list .nav_list ul li a {
  color: #fff;
  font-size: 16px;
  padding: 6px 0;
  margin: 4px 0;
  transition: 450ms ease;
}
.model.model-navigation .modelBody .navigation-list .social-links ul li, .model.EnquiryModel .modelBody .navigation-list .social-links ul li {
  display: inline-block;
  margin: 0 5px;
}
.model.model-navigation .modelBody .navigation-list .social-links ul li:first-child, .model.EnquiryModel .modelBody .navigation-list .social-links ul li:first-child {
  margin-left: 0;
}
.model.model-navigation .modelBody .navigation-list .social-links ul li a, .model.EnquiryModel .modelBody .navigation-list .social-links ul li a {
  width: 30px;
  height: 30px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: 450ms ease;
}
.model.model-navigation .modelBody .navigation-list .social-links ul li a svg, .model.EnquiryModel .modelBody .navigation-list .social-links ul li a svg {
  fill: #da3467;
}
.model.model-navigation .modelBody .back-input, .model.model-navigation .modelBody .back-textarea, .model.EnquiryModel .modelBody .back-input, .model.EnquiryModel .modelBody .back-textarea {
  position: relative;
  margin-bottom: 25px;
}
.model.model-navigation .modelBody .back-input .frm-cntrl, .model.model-navigation .modelBody .back-textarea .frm-cntrl, .model.EnquiryModel .modelBody .back-input .frm-cntrl, .model.EnquiryModel .modelBody .back-textarea .frm-cntrl {
  background: none;
  border: none;
  width: 100%;
  display: block;
  -webkit-user-select: none;
          user-select: none;
  padding: 10px 25px;
  color: #fff;
  border-radius: 10px;
  border: 2px solid #2e2d2d;
  transition: all 1s ease;
}
.model.model-navigation .modelBody .back-input .frm-cntrl:focus ~ label, .model.model-navigation .modelBody .back-textarea .frm-cntrl:focus ~ label, .model.EnquiryModel .modelBody .back-input .frm-cntrl:focus ~ label, .model.EnquiryModel .modelBody .back-textarea .frm-cntrl:focus ~ label {
  top: -12px;
  background: #222222;
  padding: 0 10px;
}
.model.model-navigation .modelBody .back-input .frm-cntrl:valid ~ label, .model.model-navigation .modelBody .back-textarea .frm-cntrl:valid ~ label, .model.EnquiryModel .modelBody .back-input .frm-cntrl:valid ~ label, .model.EnquiryModel .modelBody .back-textarea .frm-cntrl:valid ~ label {
  top: -12px;
  background: #222222;
  padding: 0 10px;
}
.model.model-navigation .modelBody .back-input label, .model.model-navigation .modelBody .back-textarea label, .model.EnquiryModel .modelBody .back-input label, .model.EnquiryModel .modelBody .back-textarea label {
  position: absolute;
  color: #fff;
  left: 10px;
  top: 10px;
  transition: 750ms ease;
}
.model.model-navigation .modelBody .back-input .custom, .model.model-navigation .modelBody .back-textarea .custom, .model.EnquiryModel .modelBody .back-input .custom, .model.EnquiryModel .modelBody .back-textarea .custom {
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 0;
  vertical-align: middle;
  width: auto;
}
.model.model-navigation .modelBody .back-input .text, .model.model-navigation .modelBody .back-textarea .text, .model.EnquiryModel .modelBody .back-input .text, .model.EnquiryModel .modelBody .back-textarea .text {
  display: inline-block;
  vertical-align: middle;
  color: #fff;
}
.model.model-navigation .modelBody .back-input .error, .model.model-navigation .modelBody .back-textarea .error, .model.EnquiryModel .modelBody .back-input .error, .model.EnquiryModel .modelBody .back-textarea .error {
  color: red;
  display: block;
  margin-top: 5px;
  font-size: 12px;
  line-height: 1;
}
.model.model-navigation .modelBody .demo-link, .model.EnquiryModel .modelBody .demo-link {
  background: #fff;
  text-align: center;
  padding: 8px 15px;
  border-radius: 10px;
  border: 0;
  width: 100%;
}
.model.model-navigation .modelBody .demo-link:hover, .model.EnquiryModel .modelBody .demo-link:hover {
  background: #da3467;
}
.model.model-navigation .modelBody .demo-link:hover a, .model.EnquiryModel .modelBody .demo-link:hover a {
  color: #fff;
}
.model.model-navigation .modelBody .demo-link a, .model.EnquiryModel .modelBody .demo-link a {
  color: #666666;
}

.model.model-video {
  max-width: 1000px;
  width: 100%;
  left: 50%;
  top: 100%;
  transform: translate(-50%, 100%);
  background: #fff;
  transition: all 1s ease;
}
.model.model-video.is-open {
  transform: translate(-50%, -50%);
  top: 50%;
}
.model.model-video .modelBody {
  width: 100%;
  line-height: 0;
}
.model.model-video .modelBody iframe {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 0;
  padding: 50px 0;
  padding-bottom: 30px;
}
.model.model-video .modelBody video {
  height: 400px;
  width: 100%;
}

.demo-video {
  width: 100%;
  line-height: 0;
  height: 500px;
  background: #272727;
}
@media (max-width: 767px) {
  .demo-video {
    height: 100%;
  }
}
.demo-video video {
  width: 100%;
  height: 100%;
}

/*----------------- sectionA ----------------*/
.about-app {
  position: relative;
  padding: 35px 0;
  background: #272727;
}
.about-app .flex {
  align-items: center;
}
.about-app .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
.about-app .flex .col:first-child {
  padding-right: 30px;
}
@media (max-width: 767px) {
  .about-app .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.about-app .flex.aiplatform {
  justify-content: center;
}
.about-app .flex.aiplatform .col {
  flex: 0 1 48%;
  max-width: 48%;
  padding: 0;
  margin: 0 10px;
  margin-bottom: 20px;
}
.about-app .bullet_points {
  display: none;
}
@media (max-width: 767px) {
  .about-app .bullet_points {
    display: block;
  }
}
.about-app .item {
  display: flex;
  align-items: center;
  position: relative;
}
.about-app .item .num {
  background: #da3467;
  height: 100px;
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10rem 0 0 10rem;
}
.about-app .item .num span {
  color: #fff;
  font-size: 24px;
  margin-right: 2rem;
}
.about-app .item .circle {
  background: #fff;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: absolute;
  left: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.about-app .item .circle::before {
  position: absolute;
  content: "";
  width: 85px;
  height: 85px;
  background: transparent;
  border-radius: 100%;
  border: 4px solid #da3467;
}
.about-app .item .circle .round {
  border-radius: 100%;
  width: 60px;
  height: 60px;
  background: #da3467;
  display: flex;
  align-items: center;
  justify-content: center;
}
.about-app .item .circle .round img {
  width: 30px;
}
.about-app .item .desc {
  background: #525252;
  padding: 1rem 30px 1rem 4rem;
  border-radius: 0 10rem 10rem 0;
  height: 100px;
  width: 75%;
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .about-app .item {
    display: none;
  }
}
.about-app .item p {
  color: #e4e4e4;
  font-size: 17px;
  font-weight: 400;
}
.about-app .item p span {
  color: #da3467;
  font-weight: 700;
}
.about-app .content {
  margin-bottom: 50px;
}
.about-app .content h2 {
  font-size: 48px;
  color: #fff;
  padding-bottom: 20px;
}
@media (max-width: 767px) {
  .about-app .content h2 {
    font-size: 28px;
  }
}
.about-app .content span {
  color: #da3467;
}
.about-app .content li {
  font-size: 16px;
}

/*----------------- sectionA ----------------*/
.home-sec-A .item {
  height: 60vh;
  position: relative;
  transition: all 1s ease;
}
.home-sec-A .item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home-sec-A .item .cover {
  padding: 75px 100px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
}
@media (max-width: 991px) {
  .home-sec-A .item .cover {
    padding: 75px 30px;
  }
}
.home-sec-A .item .cover .header-content {
  position: relative;
  padding: 56px;
  overflow: hidden;
}
@media (max-width: 767px) {
  .home-sec-A .item .cover .header-content {
    padding: 20PX;
  }
}
.home-sec-A .item .cover .header-content .line {
  content: "";
  display: inline-block;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  border: 9px solid #fff;
  clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%);
  pointer-events: none;
}
@media (max-width: 991px) {
  .home-sec-A .item .cover .header-content .line {
    clip-path: polygon(0 0, 90% 0, 55% 100%, 0 100%);
  }
}
@media (max-width: 767px) {
  .home-sec-A .item .cover .header-content .line {
    border: 5px solid #fff;
  }
}
.home-sec-A .item .cover .header-content h1 {
  color: #fff;
  font-size: 36px;
  line-height: 1.5;
  margin-bottom: 20px;
}
@media (max-width: 1024px) {
  .home-sec-A .item .cover .header-content h1 {
    font-size: 30px;
  }
}
@media (max-width: 767px) {
  .home-sec-A .item .cover .header-content h1 {
    font-size: 20px;
  }
}
.home-sec-A .item .cover .header-content .readmore a {
  color: #da3467;
  font-size: 14px;
  background: #fff;
  padding: 8px 25px;
  border-radius: 10px;
  margin-top: 20px;
  margin-left: 8rem;
  font-weight: 600;
  display: inline-block;
}
@media (max-width: 767px) {
  .home-sec-A .item .cover .header-content .readmore a {
    margin-left: 4rem;
  }
}
.home-sec-A .owl-item.active h2 {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: fadeInDown;
  animation-delay: 0.3s;
  color: #fff;
}
.home-sec-A .owl-item.active .line {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: fadeInLeft;
  animation-delay: 0.3s;
}
.home-sec-A .owl-nav {
  display: none;
}
.home-sec-A .owl-nav .owl-prev {
  position: absolute;
  left: 15px;
  top: 43%;
  opacity: 0;
  transition: all 0.4s ease-out;
  background: rgba(0, 0, 0, 0.5) !important;
  width: 40px;
  cursor: pointer;
  height: 40px;
  position: absolute;
  display: block;
  z-index: 1000;
  border-radius: 0;
}
.home-sec-A .owl-nav .owl-prev span {
  font-size: 1.6875rem;
  color: #fff;
}
.home-sec-A .owl-nav .owl-prev:focus {
  outline: 0;
}
.home-sec-A .owl-nav .owl-prev:hover {
  background: #000 !important;
}
.home-sec-A .owl-nav .owl-next {
  position: absolute;
  right: 15px;
  top: 43%;
  opacity: 0;
  transition: all 0.4s ease-out;
  background: rgba(0, 0, 0, 0.5) !important;
  width: 40px;
  cursor: pointer;
  height: 40px;
  position: absolute;
  display: block;
  z-index: 1000;
  border-radius: 0;
}
.home-sec-A .owl-nav .owl-next span {
  font-size: 1.6875rem;
  color: #fff;
}
.home-sec-A .owl-nav .owl-next:focus {
  outline: 0;
}
.home-sec-A .owl-nav .owl-next:hover {
  background: #000 !important;
}
.home-sec-A:hover .owl-prev {
  left: 0px;
  opacity: 1;
}
.home-sec-A:hover .owl-next {
  right: 0px;
  opacity: 1;
}
.home-sec-A .owl-dots {
  text-align: center;
  height: auto;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

/*----------------- sectionB ----------------*/
.home-sec-B1 {
  position: relative;
  padding: 50px 0;
  overflow: hidden;
  background: #e7e7e7;
  height: 95vh;
}
@media (max-width: 767px) {
  .home-sec-B1 {
    display: none;
  }
}
.home-sec-B1 .heading {
  margin-bottom: 7em;
}
.home-sec-B1 .heading h1 {
  font-size: 40px;
}
@media (max-width: 991px) {
  .home-sec-B1 .challenges {
    transform: rotate(90deg);
    position: relative;
    top: 15rem;
  }
}
@media (max-width: 767px) {
  .home-sec-B1 .challenges {
    transform: rotate(90deg);
    position: relative;
    top: 0;
  }
}
.home-sec-B1 .flex::before {
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 80%;
  left: 0px;
  top: 35px;
  pointer-events: none;
}
.home-sec-B1 .col {
  flex: 0 1 16.6%;
  max-width: 16.6%;
  position: relative;
  display: flex;
  justify-content: space-between;
  gap: 110px;
  flex-direction: column;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col {
    gap: 90px;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col {
    gap: 50px;
  }
}
.home-sec-B1 .col .hexa {
  position: relative;
  width: 6rem;
  height: 10rem;
  background: #b5b5b5;
  border-radius: 1em/0.5em;
  top: 3rem;
  left: -1rem;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col .hexa {
    left: 2rem;
    top: 1rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col .hexa {
    width: 5rem;
    height: 8rem;
    left: 4rem;
    top: 5.5rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col .hexa {
    left: 3rem;
    top: 1.5rem;
  }
}
@media (max-width: 767px) {
  .home-sec-B1 .col .hexa {
    width: 4rem;
    height: 6rem;
    left: 3rem;
    top: 1.5rem;
  }
}
.home-sec-B1 .col .hexa.hexa2 {
  left: 0.2rem;
  top: -3rem;
  background: #2f586a;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col .hexa.hexa2 {
    top: -5rem;
    left: 2.5rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col .hexa.hexa2 {
    left: 3.5rem;
    top: 0;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col .hexa.hexa2 {
    left: 2.5rem;
    top: 1.5rem;
  }
}
.home-sec-B1 .col .hexa.hexa3 {
  left: 2.5rem;
  background: #00b5d0;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col .hexa.hexa3 {
    top: 1rem;
    left: 3.5rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col .hexa.hexa3 {
    left: 3.3rem;
    top: 5.5rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col .hexa.hexa3 {
    left: 2rem;
    top: 1.5rem;
  }
}
.home-sec-B1 .col .hexa.hexa4 {
  top: -3rem;
  left: 5rem;
  background: #ee073f;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col .hexa.hexa4 {
    top: -5rem;
    left: 4rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col .hexa.hexa4 {
    left: 3rem;
    top: 0;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col .hexa.hexa4 {
    left: 1.5rem;
    top: 1.5rem;
  }
}
.home-sec-B1 .col .hexa.hexa5 {
  left: 7rem;
  background: #ffad27;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col .hexa.hexa5 {
    top: 1rem;
    left: 5rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col .hexa.hexa5 {
    left: 2.5rem;
    top: 5.5rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col .hexa.hexa5 {
    left: 1.2rem;
    top: 1.5rem;
  }
}
.home-sec-B1 .col .hexa.hexa6 {
  top: -3rem;
  left: 10rem;
  background: #8f4a81;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col .hexa.hexa6 {
    top: -5rem;
    left: 6rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col .hexa.hexa6 {
    left: 2rem;
    top: 0;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col .hexa.hexa6 {
    left: 1.5rem;
    top: 1.5rem;
  }
}
.home-sec-B1 .col .hexa::before, .home-sec-B1 .col .hexa::after {
  position: absolute;
  content: "";
  width: inherit;
  height: inherit;
  background: inherit;
  border-radius: inherit;
}
.home-sec-B1 .col .hexa::before {
  transform: rotate(60deg);
}
.home-sec-B1 .col .hexa::after {
  transform: rotate(-60deg);
}
.home-sec-B1 .col p {
  text-align: center;
  position: relative;
}
@media (max-width: 991px) {
  .home-sec-B1 .col p {
    transform: rotate(-90deg);
    width: 200px;
  }
}
@media (max-width: 767px) {
  .home-sec-B1 .col p {
    font-size: 12px;
  }
}
.home-sec-B1 .col p.text {
  left: -5rem;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col p.text {
    left: -1rem;
    top: -2rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col p.text {
    left: 2rem;
    top: 3rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col p.text {
    left: -1rem;
    top: 6rem;
  }
}
.home-sec-B1 .col p.text2 {
  left: -3rem;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col p.text2 {
    top: -2rem;
    left: -1rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col p.text2 {
    left: 1rem;
    top: 1rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col p.text2 {
    left: -1.5rem;
    top: -3rem;
  }
}
.home-sec-B1 .col p.text3 {
  top: -1rem;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col p.text3 {
    left: -0.5rem;
    top: -4rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col p.text3 {
    left: 0.5rem;
    top: 3rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col p.text3 {
    left: -2rem;
    top: 6rem;
  }
}
.home-sec-B1 .col p.text4 {
  left: 1rem;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col p.text4 {
    top: -2rem;
    left: 1rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col p.text4 {
    left: 0.5rem;
    top: 1rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col p.text4 {
    left: -2rem;
    top: -3rem;
  }
}
.home-sec-B1 .col p.text5 {
  top: -1rem;
  left: 4rem;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col p.text5 {
    left: 1rem;
    top: -4rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col p.text5 {
    left: 0rem;
    top: 3rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col p.text5 {
    left: -2rem;
    top: 6rem;
  }
}
.home-sec-B1 .col p.text6 {
  left: 5rem;
}
@media (max-width: 1440px) {
  .home-sec-B1 .col p.text6 {
    top: -2rem;
    left: 1rem;
  }
}
@media (max-width: 1024px) {
  .home-sec-B1 .col p.text6 {
    left: 0rem;
    top: 2rem;
  }
}
@media (max-width: 991px) {
  .home-sec-B1 .col p.text6 {
    left: -3rem;
    top: -3rem;
  }
}
.home-sec-B1 .col .icon {
  position: absolute;
  top: 32px;
  z-index: 1;
}
@media (max-width: 1024px) {
  .home-sec-B1 .col .icon {
    top: 22px;
  }
}
.home-sec-B1 .col .icon img {
  border-radius: 100%;
  filter: grayscale(1);
}

/*--------------------------- main-sec ------------------------*/
.main-sec {
  position: relative;
  padding: 50px 0;
  background: #272727;
  z-index: 1;
}
.main-sec .heading {
  position: relative;
}
.main-sec .heading h1 {
  color: #fff;
  font-size: 40px;
}
@media (max-width: 1024px) {
  .main-sec .heading h1 {
    font-size: 36px;
    margin-bottom: 50px;
  }
}
@media (max-width: 767px) {
  .main-sec .heading h1 {
    font-size: 28px;
    line-height: 1.5;
  }
}
.main-sec .flex {
  justify-content: center;
}
.main-sec .flex .col {
  flex: 0 1 100%;
  max-width: 100%;
  margin: 0 10px;
  position: relative;
  margin-bottom: 1rem;
}
.main-sec .content {
  background: linear-gradient(45deg, white, #b7b7b7);
  width: 50%;
  border-radius: 50px;
  padding: 20px;
  padding-left: 7rem;
  border: 10px solid;
  border-color: #da3467;
  margin: 0 auto;
}
.main-sec .content h3 {
  margin-bottom: 10px;
}
.main-sec .content .rounded {
  background: linear-gradient(45deg, #da3467, #da537c);
  display: inline-block;
  position: absolute;
  left: 22rem;
  top: 50%;
  transform: translateY(-50%);
  width: 70px;
  height: 70px;
  border-radius: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-sec .content .rounded span {
  color: #fff;
  font-size: 20px;
}
.main-sec .content .bullet_points li {
  color: #2e2d2d;
}
.main-sec .content .bullet_points li::before {
  background: #da3467;
}

/*--------------------------- sectionC ------------------------*/
.home-sec-C {
  padding: 50px 0;
}
@media (max-width: 767px) {
  .home-sec-C {
    background: #e8e8e8;
  }
}
.home-sec-C .heading {
  margin-bottom: 50px;
}
.home-sec-C .heading h1 {
  font-size: 40px;
}
@media (max-width: 1024px) {
  .home-sec-C .heading h1 {
    font-size: 36px;
  }
}
@media (max-width: 767px) {
  .home-sec-C .heading h1 {
    font-size: 24px;
  }
}
.home-sec-C .homeslider .owl-stage-outer .owl-item {
  transform: scale(0.9);
  opacity: 0.8;
}
.home-sec-C .homeslider .owl-stage-outer .owl-item.center {
  transform: scale(1.3);
  position: relative;
  z-index: 1;
  opacity: 1;
}
.home-sec-C .homeslider .owl-stage-outer .owl-item.center .itemslider .card .card__link {
  display: block;
}
.home-sec-C .homeslider .owl-dots {
  text-align: center;
}
.home-sec-C .homeslider .owl-dots .owl-dot {
  background: #d2d2d2;
}
.home-sec-C .homeslider .itemslider {
  position: relative;
  transition: transform 400ms;
}
.home-sec-C .homeslider .itemslider .test {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}
.home-sec-C .homeslider .itemslider .card {
  position: relative;
  height: 100%;
}
.home-sec-C .homeslider .itemslider .card::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.7;
  z-index: 1;
}
.home-sec-C .homeslider .itemslider .card .card__content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
}
.home-sec-C .homeslider .itemslider .card .card__content .card__content-inner {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
  color: rgb(255, 255, 255);
  isolation: isolate;
  z-index: 1;
}
.home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__excerpt {
  margin-bottom: 16px;
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__excerpt {
    font-size: 16px;
    padding: 0 10px;
  }
}
.home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__link {
  padding: 5px 24px;
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.5;
  display: none;
  border: 1px solid rgb(255, 255, 255);
  background: #da3467;
  font-weight: 600;
  border-radius: 10px;
}
@media (max-width: 767px) {
  .home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__link {
    padding: 5px 15px;
    font-size: 10px;
  }
}

/*--------------------------- sectionD ------------------------*/
.home-sec-D {
  position: relative;
  padding: 50px 0;
}
@media (max-width: 767px) {
  .home-sec-D {
    background: #ffffff;
  }
}
.home-sec-D .heading h1 {
  font-size: 40px;
}
.home-sec-D .flex {
  justify-content: center;
}
.home-sec-D .flex .col {
  flex: 0 1 25%;
  max-width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 30px;
  flex-direction: column;
}
@media (max-width: 991px) {
  .home-sec-D .flex .col {
    max-width: 33.33%;
    flex: 0 1 33.33;
  }
}
@media (max-width: 767px) {
  .home-sec-D .flex .col {
    max-width: 100%;
    flex: 0 1 100%;
  }
}
@media (max-width: 767px) {
  .home-sec-D .flex .col:last-child svg, .home-sec-D .flex .col:nth-last-child(2) svg {
    top: 0;
  }
}
.home-sec-D .flex .outer {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  padding: 20px;
  box-shadow: 6px 6px 10px -1px rgba(0, 0, 0, 0.15), -6px -6px 10px -1px rgba(176, 176, 176, 0.5);
}
.home-sec-D .flex .outer .inner {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: inset 4px 4px 6px -1px rgba(134, 134, 134, 0.2), inset -4px -4px 6px -1px rgba(202, 202, 202, 0.7), -0.5px -0.5px 0 rgb(225, 225, 225);
}
.home-sec-D .flex .outer .inner span {
  font-size: 20px;
  color: #da3467;
  font-weight: 600;
  display: inline-block;
}
.home-sec-D .flex circle {
  fill: none;
  stroke: url(#GradientColor);
  stroke-width: 20px;
  stroke-dasharray: 472;
  stroke-dashoffset: 472;
  animation: anim 2s linear forwards;
}
.home-sec-D .flex svg {
  position: absolute;
  top: 0;
}
.home-sec-D .flex .name {
  margin-top: 10px;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .home-sec-D .flex .name {
    font-size: 14px;
  }
}

@keyframes anim {
  100% {
    stroke-dashoffset: 0;
  }
}
/*--------------------------- sectionE ------------------------*/
.home-sec-E {
  position: relative;
  padding: 50px 0;
}
@media (max-width: 767px) {
  .home-sec-E {
    padding: 30px 0;
  }
}
.home-sec-E .heading {
  margin-bottom: 30px;
  text-align: center;
}
.home-sec-E .heading h1 {
  font-size: 40px;
}
.home-sec-E .partners {
  position: relative;
}
.home-sec-E .partners .flex {
  align-items: center;
}
.home-sec-E .partners .flex .col {
  flex: 0 1 20%;
  max-width: 20%;
}
@media (max-width: 991px) {
  .home-sec-E .partners .flex .col {
    flex: 33.33% 1;
    max-width: 33.33%;
  }
}
@media (max-width: 767px) {
  .home-sec-E .partners .flex .col {
    flex: 50% 1;
    max-width: 50%;
  }
}
.home-sec-E .partners .logo {
  width: 150px;
  max-width: 100%;
}
@media (max-width: 767px) {
  .home-sec-E .partners .logo {
    width: 100px;
    margin: 0 auto;
  }
}
.home-sec-E .partners .logo img {
  width: 100%;
  filter: grayscale(1);
}

/*-------------------- testimonial-sec-------------------*/
.testimonial-sec {
  background: #e7e7e7;
  position: relative;
  padding: 60px 0;
}
.testimonial-sec .heading {
  margin-bottom: 50px;
}
.testimonial-sec .heading h1 {
  font-size: 40px;
  color: #666666;
}
@media (max-width: 767px) {
  .testimonial-sec .heading h1 {
    font-size: 30px;
  }
}
.testimonial-sec .owl-carousel {
  overflow: hidden;
  padding: 0 20px;
  margin: 0px -40px;
  padding-right: 40px;
}
@media (max-width: 767px) {
  .testimonial-sec .owl-carousel {
    margin: 0;
    padding-right: 0;
  }
}
.testimonial-sec .owl-stage-outer {
  padding: 30px 50px;
  margin-left: -43px;
  width: calc(100% + 62px);
}
@media (max-width: 767px) {
  .testimonial-sec .owl-stage-outer {
    width: inherit;
    margin-left: 0;
    padding: 0;
  }
}
@media (max-width: 767px) {
  .testimonial-sec .testimonial-card {
    padding: 20px;
  }
}
.testimonial-sec .single-testimonial {
  border: 7px solid #222222;
  text-align: center;
  border-radius: 45px;
  position: relative;
  z-index: 2;
  height: 407px;
}
@media (max-width: 767px) {
  .testimonial-sec .single-testimonial {
    height: inherit;
  }
}
.testimonial-sec .single-testimonial p {
  color: #222;
  font-size: 14px;
  line-height: 24px;
  padding: 50px;
  padding-bottom: 30px;
  position: relative;
  z-index: 3;
}
.testimonial-sec .single-testimonial::before {
  content: "";
  position: absolute;
  left: -35px;
  top: -35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat #e7e7e7;
  background-size: 60%;
  width: 126px;
  height: 100px;
  transform: rotate(180deg);
  background-position: 34px 15px;
}
.testimonial-sec .single-testimonial::after {
  content: "";
  position: absolute;
  right: -35px;
  bottom: -34px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat #e7e7e7;
  background-size: 60%;
  width: 126px;
  height: 100px;
  background-position: 34px 19px;
}
@media (max-width: 767px) {
  .testimonial-sec .single-testimonial::after {
    bottom: -45px;
  }
}
.testimonial-sec .single-testimonial .round {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}
.testimonial-sec .single-testimonial .round-1::before {
  content: "";
  position: absolute;
  left: 88px;
  top: -6.7px;
  width: 50px;
  height: 7px;
  background: #222222;
  border-radius: 30px;
}
.testimonial-sec .single-testimonial .round-1::after {
  content: "";
  position: absolute;
  left: -6.5px;
  top: 62px;
  width: 7px;
  height: 50px;
  background: #222222;
  border-radius: 30px;
}
.testimonial-sec .single-testimonial .round-2::before {
  content: "";
  position: absolute;
  right: 87px;
  bottom: -7px;
  width: 50px;
  height: 7px;
  background: #222222;
  border-radius: 30px;
  z-index: 1;
}
.testimonial-sec .single-testimonial .round-2::after {
  content: "";
  position: absolute;
  right: -6.5px;
  bottom: 62px;
  width: 7px;
  height: 50px;
  background: #222222;
  border-radius: 30px;
  z-index: 1;
}
@media (max-width: 767px) {
  .testimonial-sec .single-testimonial .round-2::after {
    right: -7px;
    bottom: 50px;
  }
}
.testimonial-sec .single-testimonial .client-info {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  padding-bottom: 50px;
}
.testimonial-sec .single-testimonial .client-info .client-img {
  padding-right: 15px;
}
.testimonial-sec .single-testimonial .client-info .client-img img {
  width: 60px;
  height: 60px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.16);
  font-size: 22px;
}
.testimonial-sec .single-testimonial .client-info h6 {
  color: #000;
  font-weight: 700;
  font-size: 18px;
}
.testimonial-sec .single-testimonial .client-info span {
  display: inline-block;
  color: #000;
  font-size: 12px;
}

.owl-dots {
  text-align: center;
  margin-top: 50px;
}
.owl-dots button {
  background: #fff !important;
  width: 10px;
  height: 10px;
  border-radius: 26px;
  margin: 0 5px;
  transition: 0.3s;
}
.owl-dots button.active {
  width: 30px;
}

.review-sec {
  position: relative;
  padding: 30px 0;
}
.review-sec .flex {
  justify-content: center;
}
.review-sec .flex .col {
  flex: 0 1 31.33%;
  max-width: 31.33%;
}
@media (max-width: 767px) {
  .review-sec .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.review-sec iframe {
  height: 50vh;
}

.case-study-sec {
  position: relative;
  padding: 50px 0;
}
.case-study-sec h2 {
  margin-bottom: 20px;
}
.case-study-sec .swiper {
  top: 5vh;
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: none;
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card {
  position: relative;
  margin: auto;
  height: 70vh;
  width: 90vw;
  max-width: 1000px;
  border-radius: 50px;
  overflow: hidden;
  background: #2e0916;
  background: linear-gradient(331deg, #767676 0%, #252525 100%);
}
@media (max-width: 767px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card {
    flex-direction: column;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper {
  width: 100%;
  height: 70%;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper {
    position: relative;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper img {
  max-height: 80%;
  width: auto;
  position: relative;
  animation: floatAnim 6s ease-in-out infinite;
  border-radius: 20px;
  border: 2px solid #da3467;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper img {
    max-height: 60%;
  }
}
@media (max-width: 767px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper img {
    object-fit: cover;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper {
  left: -22%;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper {
    left: 0;
    right: 0;
    height: auto;
    width: 90%;
    margin: 0 auto;
    top: -10%;
  }
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper img {
    height: 350px;
    width: 350px;
  }
}
@media (max-width: 767px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper {
    top: 5%;
    left: inherit;
    right: inherit;
    display: block;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .img-wrapper {
  right: -22%;
  top: 0%;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .img-wrapper {
    left: 0;
    right: 0;
    height: auto;
    width: 90%;
    margin: 0 auto;
    top: -10%;
    top: -2%;
  }
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .img-wrapper img {
    height: 300px;
    width: 300px;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-content {
  max-width: 445px;
  width: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 24px;
}
@media (max-width: 767px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-content {
    top: inherit;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-content {
  margin-left: auto;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-content {
    max-width: 100%;
    margin: 0;
    transform: unset;
    text-align: center;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-content {
  margin-right: auto;
  margin-left: 5%;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-content {
    max-width: 100%;
    margin: 0;
    transform: unset;
    text-align: center;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info {
  position: absolute;
  bottom: 8%;
  line-height: 1;
  color: #ffffff;
  font-size: 1vw;
  font-weight: 400;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info {
    bottom: unset;
    top: 25%;
    font-size: 8px;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info .ghost-name {
  font-size: 1.5vw;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-weight: bold;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info .ghost-name {
    font-size: 14px;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info span {
  height: 70px;
  display: inline-block;
  width: 0.5px;
  background-color: #fff;
  position: absolute;
  bottom: 0px;
}
@media (max-width: 767px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info span {
    color: rgb(255, 91, 121);
    left: 50%;
    height: 34px;
    top: -42px;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info span:before {
  content: "";
  height: 5px;
  width: 5px;
  background-color: #fff;
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info .indus-name {
  font-size: 12px;
  text-align: center;
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info {
  left: 8%;
  text-align: right;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info {
    left: 3%;
  }
}
@media (max-width: 767px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info {
    left: 50%;
    transform: translateX(-50%);
    top: 49%;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info span {
  right: -15px;
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-ghost-info {
  right: 8%;
  text-align: left;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-ghost-info {
    right: 3%;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-ghost-info span {
  left: -15px;
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-title {
  max-width: 320px;
  color: #fff;
  font-weight: bold;
  font-size: 2vw;
  line-height: 1.3;
  margin: 14px 0 25px;
  position: relative;
  color: #fff;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-title {
    font-size: 24px;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-title {
    font-size: 20px;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-sub-title {
  color: #da3467;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.1vw;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-sub-title {
    font-size: 12px;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-description {
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  max-width: 300px;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-description {
    font-size: 10px;
    margin-left: auto;
    margin-right: auto;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta {
  margin-top: 30px;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta {
    margin-top: 10px;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta .cta-button {
  display: inline-block;
  padding: 20px 40px;
  background-color: #da3467;
  color: white;
  font-family: Arial, sans-serif;
  font-size: 18px;
  white-space: nowrap;
  text-decoration: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  width: 161px;
  height: 81px;
  clip-path: polygon(7.68786px 20.1081px, 7.68786px 20.1081px, 8.16364px 18.1351px, 8.88914px 16.2804px, 9.8446px 14.5617px, 11.0103px 12.9969px, 12.3663px 11.6038px, 13.8931px 10.4002px, 15.5708px 9.4038px, 17.3796px 8.63251px, 19.2998px 8.10411px, 21.3116px 7.83638px, 132.489px 0.710935px, 132.489px 0.710935px, 134.441px 0.714334px, 136.343px 0.968456px, 138.174px 1.46024px, 139.914px 2.17663px, 141.544px 3.10456px, 143.044px 4.23098px, 144.393px 5.54282px, 145.572px 7.02703px, 146.562px 8.67054px, 147.341px 10.4603px, 159.738px 44.9529px, 159.738px 44.9529px, 160.432px 47.6413px, 160.613px 50.3152px, 160.314px 52.9198px, 159.569px 55.4005px, 158.412px 57.7025px, 156.877px 59.7713px, 154.996px 61.5521px, 152.804px 62.9903px, 150.334px 64.0311px, 147.621px 64.62px, 16.6807px 80.5984px, 16.6807px 80.5984px, 13.7927px 80.6726px, 11.051px 80.2112px, 8.50526px 79.2659px, 6.20477px 77.8885px, 4.19901px 76.131px, 2.53742px 74.045px, 1.26946px 71.6825px, 0.444554px 69.0952px, 0.11216px 66.335px, 0.321718px 63.4536px, 7.68786px 20.1081px);
  transition: all 0.3s ease;
}
@media (max-width: 991px) {
  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta .cta-button {
    scale: 0.7;
    margin-left: auto;
    margin-right: auto;
  }
}
.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta .cta-button:hover {
  background-color: #fff;
  color: #da3467;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.swiper-pagination {
  text-align: center;
  padding-left: 0;
  bottom: 20px !important;
}
.swiper-pagination .swiper-pagination-bullet {
  display: inline-block;
  margin: 2px;
  height: 6px;
  width: 12px;
  background: rgba(254, 121, 194, 0.8);
  color: transparent;
  border-radius: 10px;
  overflow: hidden;
  transition: 0.5s ease;
  border: 0;
}
.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #da3467;
  width: 25px;
}

.swing {
  animation: swing 6s ease-in-out infinite;
  transform-origin: left;
}

.swiper-slide-active .card-cta {
  animation: bounce;
  animation-duration: 2.5s;
  animation-delay: 0.5s;
}
.swiper-slide-active .card-ghost-info div {
  animation: fadeInLeft;
  animation-duration: 1.5s;
  animation-delay: 0.3s;
}
.swiper-slide-active .card-title {
  animation: jackInTheBox;
  animation-duration: 1s;
  animation-delay: 0.8s;
}
.swiper-slide-active .card-sub-title {
  animation: bounceIn;
  animation-duration: 1s;
  animation-delay: 0.5s;
}
.swiper-slide-active .card-description {
  animation: bounceIn;
  animation-duration: 1s;
  animation-delay: 0.1s;
}

@keyframes floatAnim {
  0% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(-10px);
  }
}
@keyframes swing {
  0% {
    transform: translateY(-25px) rotate(10deg) scale(1);
  }
  50% {
    transform: translateY(25px) rotate(-5deg) scale(1.1);
  }
  100% {
    transform: translateY(-25px) rotate(10deg) scale(1);
  }
}
.home-sec-G {
  padding: 50px 0;
  background: #e7e7e7;
}
.home-sec-G .flex {
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .home-sec-G .flex {
    justify-content: center;
  }
}
.home-sec-G .flex .col {
  flex: 0 1 20%;
  max-width: 20%;
  margin-bottom: 50px;
}
@media (max-width: 767px) {
  .home-sec-G .flex .col {
    flex: 0 1 50%;
    max-width: 50%;
    margin-bottom: 20px;
  }
}
.home-sec-G .flex .col.hp .logo {
  width: 100px;
}
.home-sec-G .partners .logo {
  width: 200px;
  margin: 0 auto;
}
@media (max-width: 767px) {
  .home-sec-G .partners .logo {
    width: 150px;
  }
}

.casestudy_popup,
.Version_popup {
  position: fixed;
  right: 0;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 100%);
  max-width: 70%;
  width: 100%;
  height: 65%;
  padding: 50px;
  transition: all 1s ease;
  background: #222222;
  z-index: 111;
  pointer-events: none;
  border-radius: 20px;
  border: 2px solid #fff;
}
@media (max-width: 767px) {
  .casestudy_popup,
  .Version_popup {
    max-width: 95%;
    padding: 9rem 15px;
  }
}
.casestudy_popup.pop_open,
.Version_popup.pop_open {
  transform: translate(-50%, -50%);
  top: 50%;
  pointer-events: all;
}
.casestudy_popup .close_model,
.Version_popup .close_model {
  position: absolute;
  right: 32px;
  top: 32px;
  width: 32px;
  height: 32px;
  opacity: 1;
  cursor: pointer;
  z-index: 1;
}
.casestudy_popup .close_model::before,
.Version_popup .close_model::before {
  position: absolute;
  left: 15px;
  content: " ";
  height: 25px;
  width: 2px;
  cursor: pointer;
  background-color: #fff;
  transform: rotate(45deg);
}
.casestudy_popup .close_model::after,
.Version_popup .close_model::after {
  position: absolute;
  right: 15px;
  content: " ";
  height: 25px;
  width: 2px;
  cursor: pointer;
  background-color: #fff;
  transform: rotate(-45deg);
}
.casestudy_popup .case_detail,
.Version_popup .case_detail {
  margin: 0 20px;
}
.casestudy_popup .case_detail.version-sumry,
.Version_popup .case_detail.version-sumry {
  height: 300px;
  overflow-y: scroll;
  margin-bottom: 20px;
}
.casestudy_popup .case_detail.version-sumry p,
.Version_popup .case_detail.version-sumry p {
  font-size: 14px;
  line-height: 1.5;
  color: #c9c9c9;
}
.casestudy_popup .case_detail .caseimg,
.Version_popup .case_detail .caseimg {
  text-align: center;
}
.casestudy_popup .case_detail .name,
.Version_popup .case_detail .name {
  font-size: 22px;
  margin-bottom: 10px;
  color: #fff;
}
@media (max-width: 767px) {
  .casestudy_popup .case_detail .name,
  .Version_popup .case_detail .name {
    line-height: 1.3;
  }
}
.casestudy_popup .case_detail .summary ul li,
.Version_popup .case_detail .summary ul li {
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 10px;
}
.casestudy_popup .case_detail .summary ul li b,
.Version_popup .case_detail .summary ul li b {
  font-size: 14px;
}
.casestudy_popup .case_detail .summary h4,
.Version_popup .case_detail .summary h4 {
  color: #da3467;
  margin-bottom: 10px;
  font-size: 18px;
}

.announce {
  background: #e8e8e8;
  padding: 50px 20px;
}
.announce .flex {
  align-items: center;
}
.announce .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
@media (max-width: 767px) {
  .announce .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.announce .heading h2 {
  color: #da3467;
  margin-bottom: 10px;
}
.announce .bullet_points li {
  color: #666666;
}
.announce .bullet_points li::before {
  background: #da3467;
}
.announce .img img {
  height: 400px;
}
.announce .readmore {
  display: inline-block;
  margin-top: 20px;
  width: 100%;
}
.announce .readmore a {
  padding: 5px 18px;
  border-radius: 20px;
  background: #da3467;
  color: #fff;
  display: inline-block;
  margin: 0 auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.751);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.modal-overlay .close_model {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 18px;
  background: none;
  border: none;
  cursor: pointer;
}
.modal-overlay .modal-content {
  background: #222222;
  padding: 30px;
  border-radius: 10px;
  position: relative;
  width: 400px;
  max-width: 90%;
  border: 2px solid #fff;
}
.modal-overlay .modal-content h3 {
  margin-bottom: 25px;
  color: #fff;
  text-align: center;
}
.modal-overlay .modal-content .back-input {
  position: relative;
  margin-bottom: 25px;
}
.modal-overlay .modal-content .back-input .frm-cntrl {
  background: none;
  border: none;
  width: 100%;
  display: block;
  -webkit-user-select: none;
          user-select: none;
  padding: 10px 25px;
  color: #fff;
  border-radius: 10px;
  border: 2px solid #2e2d2d;
  transition: all 1s ease;
}
.modal-overlay .modal-content .back-input .frm-cntrl:focus ~ label {
  top: -12px;
  background: #222222;
  padding: 0 10px;
}
.modal-overlay .modal-content .back-input .frm-cntrl:valid ~ label {
  top: -12px;
  background: #222222;
  padding: 0 10px;
  font-size: 12px;
}
.modal-overlay .modal-content .back-input label {
  position: absolute;
  color: #fff;
  left: 10px;
  top: 10px;
  transition: 750ms ease;
}
.modal-overlay .modal-content .back-input .error {
  color: red;
  display: block;
  margin-top: 5px;
  font-size: 12px;
  line-height: 1;
}
.modal-overlay .modal-content .demo-link {
  background: #fff;
  text-align: center;
  padding: 8px 15px;
  border-radius: 10px;
  border: 0;
  width: 100%;
}
.modal-overlay .modal-content .demo-link:hover {
  background: #da3467;
}
.modal-overlay .modal-content .demo-link:hover a {
  color: #fff;
}
.modal-overlay .modal-content .demo-link a {
  color: #666666;
}

.newhome-sec {
  padding: 1rem 0;
}
@media (max-width: 767px) {
  .newhome-sec {
    padding: 3rem 0;
  }
}
.newhome-sec .flex {
  align-items: center;
}
.newhome-sec .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
  padding-right: 40px;
}
@media (max-width: 767px) {
  .newhome-sec .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    padding: 0;
  }
}
.newhome-sec .flex .col:last-child {
  padding-left: 40px;
}
@media (max-width: 767px) {
  .newhome-sec .flex .col:last-child {
    padding: 0;
  }
}
.newhome-sec .flex .col:first-child {
  text-align: center;
}
.newhome-sec h2 {
  font-size: 36px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .newhome-sec h2 {
    font-size: 28px;
  }
}
.newhome-sec p {
  font-size: 18px;
}
@media (max-width: 767px) {
  .newhome-sec p {
    font-size: 16px;
  }
}
.newhome-sec .highlight {
  font-size: 24px;
  margin-top: 20px;
  display: inline-block;
  color: #da3467;
  text-decoration: underline;
}
@media (max-width: 767px) {
  .newhome-sec .banner-image {
    width: 300px;
    margin: auto;
    display: block;
    margin-bottom: 20px;
  }
}
.newhome-sec .watch-demo {
  display: inline-block;
  width: 100%;
  text-align: center;
}
.newhome-sec .watch-demo a {
  background: #da3467;
  color: #fff;
  padding: 7px 45px;
  border-radius: 20px;
  margin-top: 40px;
  display: inline-block;
}
.newhome-sec img {
  width: 400px;
}

.features {
  padding: 5rem 0;
  position: relative;
  background: #e7e7e7;
  display: none;
}
.features .heading {
  margin-bottom: 2rem;
}
.features .flex {
  align-items: center;
  margin: 0 5rem;
}
.features .feature-list {
  margin-bottom: 2rem;
}
@media (max-width: 767px) {
  .features .feature-list:nth-child(3) .flex {
    flex-direction: column-reverse;
  }
}
@media (max-width: 767px) {
  .features .feature-list .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    text-align: center;
  }
}
.features .feature-list .feature-heading {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.features .feature-list .feature-heading .icon {
  background: rgb(245, 190, 209);
  height: 70px;
  display: inline-block;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin-right: 10px;
}
@media (max-width: 767px) {
  .features .feature-list .feature-heading .icon {
    display: none;
  }
}
.features .feature-list .feature-heading .icon img {
  width: 40px;
}
@media (max-width: 767px) {
  .features .feature-list .feature-heading h4 {
    font-size: 22px;
    text-align: left;
  }
}
.features .feature-list img {
  width: 300px;
}
@media (max-width: 767px) {
  .features .feature-list img {
    width: 250px !important;
  }
}
.features .feature-list ul {
  padding-left: 50px;
}
@media (max-width: 767px) {
  .features .feature-list ul {
    text-align: left;
    padding-left: 10px;
    margin-bottom: 20px;
  }
}

.licence-detial {
  padding: 3rem 0;
  background: #ffffff;
}
.licence-detial .flex .col {
  flex: 0 1 25%;
  max-width: 25%;
}
@media (max-width: 767px) {
  .licence-detial .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 10px;
  }
}
.licence-detial .heading {
  margin-bottom: 3rem;
}
.licence-detial .item {
  background: #222222;
  padding: 20px;
  border-radius: 20px;
  height: 325px;
  margin: 0 10px;
  box-shadow: 0px 3px 10px 0px rgba(24, 59, 86, 0.08);
}
@media (max-width: 767px) {
  .licence-detial .item {
    height: inherit;
  }
}
.licence-detial .item h4 {
  margin-bottom: 20px;
  font-weight: 600;
  text-align: center;
  color: #fff;
}
.licence-detial .item p {
  text-align: center;
  color: #fff;
}

.pricing {
  background: #e7e7e7;
  padding: 3rem 0;
  padding-bottom: 5rem;
}
.pricing .heading {
  margin-bottom: 5rem;
}
.pricing .flex .col {
  flex: 0 1 29%;
  margin: 0 20px;
}
@media (max-width: 767px) {
  .pricing .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.pricing .item {
  background: #fff;
  border-radius: 20px;
  height: 550px;
  position: relative;
  box-shadow: 0px 3px 10px 0px rgba(24, 59, 86, 0.08);
}
@media (max-width: 767px) {
  .pricing .item {
    height: inherit;
    border-radius: 10px;
  }
}
.pricing .item .price {
  padding: 20px;
  border-radius: 20px 20px 0 0;
  padding-bottom: 0;
  margin-bottom: 1.2rem;
}
.pricing .item .price .type-btn {
  display: inline-block;
  padding: 2px 0px;
  border-radius: 10px;
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 28px;
  text-align: center;
  width: 100%;
}
@media (max-width: 767px) {
  .pricing .item .price .type-btn {
    font-size: 22px;
  }
}
.pricing .item .price .rupees {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #2e2d2d;
  display: none;
}
.pricing .item .price .rupees .symbol {
  margin-right: 5px;
  color: #fff;
}
.pricing .item .price .rupees .rate {
  margin-right: 5px;
  color: #2e2d2d;
}
.pricing .item .price .rupees .year {
  font-size: 18px;
  font-weight: 500;
  color: #2e2d2d;
}
.pricing .item .price .user {
  font-weight: 600;
  margin-bottom: 5px;
  color: #2e2d2d;
  display: none;
}
.pricing .item .price p {
  padding-right: 20px;
  color: #fff;
}
.pricing .item .buy-now {
  display: inline-block;
  text-align: center;
  width: 100%;
  margin-bottom: 1.2rem;
  position: absolute;
  bottom: 0;
}
@media (max-width: 767px) {
  .pricing .item .buy-now {
    position: relative;
  }
}
.pricing .item .buy-now a {
  background: #da3467;
  padding: 8px 25px;
  color: #ffffff;
  border-radius: 10px;
}
.pricing .item ul {
  padding: 20px;
  padding-top: 0;
}
.pricing .item ul li {
  color: #000000;
}
.pricing .item ul li::before {
  background: #da3467;
}
.pricing .item ul .readmore a {
  display: block;
  color: #da3467;
  font-size: 20px;
  margin-top: 20px;
  font-weight: 600;
}

.ai-powered {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center/cover;
  padding: 6rem 0;
}
.ai-powered::before {
  position: absolute;
  content: "";
  background: #000000;
  width: 100%;
  height: 100%;
  top: 0;
  opacity: 0.7;
}
.ai-powered .content {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.ai-powered .content ul li:first-child {
  font-size: 36px;
  padding-left: 0;
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .ai-powered .content ul li:first-child {
    line-height: 1.2;
    font-size: 28px;
  }
}
.ai-powered .content ul li:first-child::before {
  content: none;
}
.ai-powered .content ul .learn-more {
  position: relative;
}
.ai-powered .content ul .learn-more a {
  margin-top: 20px;
  background: #fff;
  display: inline-block;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
}

.Pricing-form {
  background: #fff;
  width: 50%;
  top: 100%;
  left: 50%;
  height: 750px;
  transform: translate(-50%, 100%);
  transition: 450ms ease;
}
@media (max-width: 767px) {
  .Pricing-form {
    width: 100%;
  }
}
.Pricing-form.is-open {
  transform: translate(-50%, -50%);
  top: 50%;
}
.Pricing-form .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
@media (max-width: 767px) {
  .Pricing-form .flex .col {
    max-width: 100%;
    flex: 0 1 100%;
  }
}
@media (max-width: 767px) {
  .Pricing-form .flex .col:first-child {
    display: none;
  }
}
.Pricing-form .banner {
  line-height: 0;
}
.Pricing-form .banner img {
  height: 750px;
  object-fit: cover;
}
.Pricing-form .modelBody {
  padding: 20px;
}
.Pricing-form .modelBody .contact-form .title h3 {
  font-size: 24px;
  font-weight: 600;
}
.Pricing-form .modelBody .contact-form .back-input {
  position: relative;
  margin-top: 25px;
}
.Pricing-form .modelBody .contact-form .back-input .frm-cntrl {
  background: none;
  border: none;
  width: 100%;
  display: block;
  -webkit-user-select: none;
          user-select: none;
  padding: 10px 25px;
  color: #2e2d2d;
  border-radius: 10px;
  border: 2px solid #2e2d2d;
}
.Pricing-form .modelBody .contact-form .back-input .frm-cntrl:focus ~ label {
  top: -12px;
  background: #ffffff;
  padding: 0 10px;
}
.Pricing-form .modelBody .contact-form .back-input .frm-cntrl:valid ~ label {
  top: -12px;
  background: #ffffff;
  padding: 0 10px;
}
.Pricing-form .modelBody .contact-form .back-input .error {
  color: red;
}
.Pricing-form .modelBody .contact-form .back-input label {
  position: absolute;
  color: #2e2d2d;
  left: 10px;
  top: 10px;
  transition: 750ms ease;
}
.Pricing-form .modelBody .contact-form .demo-link {
  background: #fff;
  text-align: center;
  padding: 8px 15px;
  border-radius: 10px;
  border: 0;
  width: 100%;
  margin-top: 20px;
  background: #da3467;
}
.Pricing-form .modelBody .contact-form .demo-link a {
  color: #fff;
}

#form-message {
  color: green;
  margin: 10px 0;
  font-weight: 600;
}

.Tablemodel {
  background: #fff;
  width: 70%;
  top: 100%;
  left: 50%;
  height: 750px;
  border-radius: 20px;
  transform: translate(-50%, 100%);
  transition: 450ms ease;
}
.Tablemodel.is-open {
  transform: translate(-50%, -50%);
  top: 50%;
}
.Tablemodel .modelBody {
  padding: 10px;
}
.Tablemodel .modelBody .tableheading {
  margin-bottom: 20px;
}
.Tablemodel .modelBody .table-container {
  max-height: 600px;
  overflow-y: auto;
}
.Tablemodel .modelBody table, .Tablemodel .modelBody tr, .Tablemodel .modelBody th, .Tablemodel .modelBody td {
  border: 1px solid #000;
}
.Tablemodel .modelBody table {
  width: 100%;
  border-collapse: collapse;
}
.Tablemodel .modelBody table th {
  background: #da3467;
  color: #fff;
  text-align: center;
}
.Tablemodel .modelBody table th, .Tablemodel .modelBody table td {
  padding: 10px;
}
.Tablemodel .modelBody table tbody {
  max-height: 600px;
  overflow-y: auto;
  width: 100%;
}

.video-sec {
  position: relative;
  padding: 50px 0;
}
.video-sec .flex {
  align-items: center;
}
.video-sec .flex .video-item {
  flex: 0 1 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  background: #e7e7e7;
  border-radius: 25px;
  padding: 25px;
  margin-bottom: 20px;
}
.video-sec .video-heading {
  flex: 0 1 50%;
  max-width: 50%;
  padding-right: 30px;
}
.video-sec .video-heading h2 {
  font-size: 24px;
  color: #da3467;
  font-weight: 600;
}
.video-sec .video-heading h4 {
  font-size: 18px;
}
.video-sec .video-heading ul li {
  color: #2e2d2d;
  font-size: 14px;
  line-height: 1.4;
}
.video-sec .video-heading ul li::before {
  background: #da3467;
}
.video-sec .video-name {
  flex: 0 1 50%;
  max-width: 50%;
}
.video-sec .video-name h2 {
  color: #da3467;
  font-size: 24px;
  font-weight: 600;
}
.video-sec .video-name p {
  font-size: 14px;
  text-align: center;
}
.video-sec video {
  width: 100%;
  padding: 20px;
}

.cards {
  padding: 7rem 0;
  background: #e7e7e7;
}
@media (max-width: 767px) {
  .cards {
    padding: 7rem 1rem;
  }
}
.cards .card {
  width: 50%;
  cursor: pointer;
  margin: 0 auto;
}
@media (max-width: 767px) {
  .cards .card {
    width: 100%;
  }
}
.cards .card ul {
  margin: 0;
  padding: 0;
  list-style: none;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
}
.cards .card__outer {
  background: #da3467;
  position: relative;
  height: 30rem;
  border-radius: 0.625rem;
  display: flex;
  align-items: flex-end;
  padding: 1.25rem;
  transition: 0.3s ease-in-out;
}
.cards .card__outer a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-size: 20px;
}
.cards .card__outer a svg {
  margin-left: 0.375em;
  width: 1.625rem;
}
.cards .card__inner {
  background: #fff;
  position: absolute;
  bottom: 3.75rem;
  right: 1.25rem;
  width: 100%;
  height: 90%;
  border-radius: 0.625rem;
  padding: 1.875rem 2.188rem;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767px) {
  .cards .card__inner {
    height: 100%;
  }
}
.cards .card__inner .title {
  font-size: 24px;
  display: inline-block;
  position: relative;
  margin-top: 0.313em;
  margin-bottom: 0.938em;
}
@media (max-width: 767px) {
  .cards .card__inner .title {
    line-height: 1.3;
  }
}
.cards .card__inner .title:after {
  position: absolute;
  content: "";
  left: 0;
  bottom: -1.563rem;
  display: block;
  color: red;
  background: #da3467;
  height: 0.325rem;
  width: 100%;
}
.cards .card.active .card__outer a {
  color: #fff;
}

#roto {
  position: relative;
  overflow: hidden;
}
#roto::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  background: linear-gradient(0deg, #fff, transparent);
  opacity: 0;
  z-index: 4;
  transition: 0.2s all ease;
}
#roto::before.active::before {
  opacity: 1;
  height: 50%;
}

.slide {
  width: 100%;
  min-height: calc(100vh - 100px);
  position: relative;
  overflow: hidden;
  background-color: #000;
}
.slide .mainImage {
  position: absolute;
  width: 130vw;
  height: 130vw;
  object-fit: cover;
  object-position: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation-name: rotate;
  animation-timing-function: cubic-bezier(0.02, 0.63, 0.23, 0.99);
  animation-iteration-count: 1;
  animation-duration: 1.1s;
}
@media (max-width: 675px) {
  .slide .mainImage {
    width: 130vh;
    height: 130vh;
  }
}
.slide .roundOuter {
  position: absolute;
  width: 86vw;
  height: 86vw;
  overflow: hidden;
  border-radius: 50%;
  left: calc(50% - 43vw);
  top: calc(50% - 43vw);
  filter: brightness(0.9);
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
@media (max-width: 675px) {
  .slide .roundOuter {
    width: 86vh;
    height: 86vh;
    left: calc(50% - 43vh);
    top: calc(50% - 43vh);
  }
}
.slide .roundOuter img {
  position: absolute;
  width: 130vw;
  height: 130vw;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  object-position: center;
  animation-name: rotate;
  animation-timing-function: cubic-bezier(0.02, 0.63, 0.23, 0.99);
  animation-iteration-count: 1;
  animation-duration: 1.3s;
}
@media (max-width: 675px) {
  .slide .roundOuter img {
    width: 130vh;
    height: 130vh;
  }
}
.slide .roundInner {
  position: absolute;
  width: 50vw;
  height: 50vw;
  overflow: hidden;
  left: calc(50% - 25vw);
  top: calc(50% - 25vw);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 2;
}
@media (max-width: 675px) {
  .slide .roundInner {
    width: 50vh;
    height: 50vh;
    left: calc(50% - 25vh);
    top: calc(50% - 25vh);
  }
}
.slide .roundInner img {
  position: absolute;
  width: 130vw;
  height: 130vw;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  object-position: center;
  animation-name: rotate;
  animation-timing-function: cubic-bezier(0.02, 0.63, 0.23, 0.99);
  animation-iteration-count: 1;
  animation-duration: 1.2s;
}
@media (max-width: 675px) {
  .slide .roundInner img {
    width: 130vh;
    height: 130vh;
  }
}
.slide .slideText {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
.slide .slideText::after {
  content: "";
  position: absolute;
  width: 40vw;
  height: 1px;
  background-color: #fff;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.slide p {
  text-align: center;
  font-weight: 400;
  margin-bottom: 30px;
  font-size: 2.5rem;
  padding-left: 1.3rem;
  color: #fff;
  line-height: normal;
  animation-delay: 1.5s;
  filter: drop-shadow(0 2px 10px #000);
}
@media (max-width: 675px) {
  .slide p {
    font-size: 5vw;
    line-height: 1.5;
    padding-left: 2vw;
  }
}
.slide .buttonNav {
  display: flex;
  justify-content: center;
  gap: 12px;
  animation-delay: 1.7s;
}
.slide .buttonNav button {
  border: none;
  background: transparent;
  color: #da3467;
  font-size: 2rem;
  filter: drop-shadow(0 2px 10px #000);
}
.slide .buttonNav span {
  display: grid;
  width: 1px;
  flex: 0 0 1px;
  background-color: #fff;
  filter: drop-shadow(0 2px 10px #000);
}

@keyframes rotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg) scale(5);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg) scale(1);
  }
}
.prodouct-demo-video {
  width: 100%;
  height: calc(100vh - 100px);
  background: #222222;
}
@media (max-width: 767px) {
  .prodouct-demo-video {
    height: 100%;
    padding: 50px 0;
  }
}
.prodouct-demo-video video {
  width: 100%;
  height: 100%;
}

.product-sec-C {
  padding: 50px 0;
  position: relative;
}
.product-sec-C .heading {
  margin-bottom: 100px;
}
@media (max-width: 1024px) {
  .product-sec-C .flex {
    justify-content: center;
  }
}
.product-sec-C .flex .col {
  flex: 0 1 18%;
  max-width: 18%;
  background: linear-gradient(to right, #f1f1f1, #a1a1a1);
  padding: 10px;
  height: 200px;
  margin: 0 10px;
  position: relative;
  border: 2px solid #da3467;
  border-radius: 20px 20px 100% 100%;
}
@media (max-width: 1024px) {
  .product-sec-C .flex .col {
    flex: 0 1 30%;
    max-width: 30%;
    margin-bottom: 100px;
  }
}
@media (max-width: 767px) {
  .product-sec-C .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin: 0 35px;
    margin-bottom: 75px;
  }
  .product-sec-C .flex .col:last-child {
    margin-bottom: 0;
  }
}
.product-sec-C .content p {
  margin-top: 40px;
  font-size: 14px;
  text-align: center;
}
.product-sec-C .icon {
  position: absolute;
  top: -25%;
  left: 50%;
  transform: translate(-50%, 0%);
  height: 50px;
  width: 100px;
  border-radius: 150px 150px 0 0;
  background: linear-gradient(to bottom, #da3467, rgba(10, 10, 10, 0.8));
}
.product-sec-C .icon span {
  color: #fff;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #da3467;
  margin: 0 auto;
  position: relative;
  top: 15px;
}
@media (max-width: 767px) {
  .product-sec-C .icon span {
    top: 15px;
  }
}

.product-sec-D {
  background: #222222;
  position: relative;
  padding: 50px 0;
}
.product-sec-D .heading h2 {
  color: #fff;
}
.product-sec-D .flex .col1 {
  flex: 0 1 31%;
  max-width: 31%;
  margin: 0 10px;
  margin-bottom: 60px;
}
@media (max-width: 991px) {
  .product-sec-D .flex .col1 {
    flex: 0 1 47%;
    max-width: 47%;
  }
}
@media (max-width: 767px) {
  .product-sec-D .flex .col1 {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 60px;
  }
}
.product-sec-D .item {
  background: #eeecec;
  border-radius: 5px;
  height: 150px;
  position: relative;
  padding: 30px 35px 75px;
  transition: all 0.3s linear 0s;
  z-index: 2;
  cursor: pointer;
}
.product-sec-D .item::before {
  position: absolute;
  content: "";
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 5px;
  background-color: #da3467;
  border-radius: 0 0 5px 5px;
  transition: all 0.4s linear 0s;
  z-index: -1;
}
.product-sec-D .item:hover::before {
  height: 100%;
  opacity: 0.8;
  border-radius: 5px;
}
.product-sec-D .item:hover .img {
  opacity: 1;
  visibility: visible;
  height: 100%;
  transform: scale(1);
}
.product-sec-D .item:hover p {
  color: #fff;
  font-weight: 500;
}
.product-sec-D .item:hover .icon {
  background: #da3467;
  border: 3px solid #ffffff;
}
.product-sec-D .item:hover .icon img {
  display: none;
}
.product-sec-D .item:hover .icon img.white {
  display: block;
}
.product-sec-D .item .img {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 5px;
  z-index: -2;
  visibility: hidden;
  opacity: 0;
  object-fit: cover;
  transform: scale(0.8);
  transition: all 0.4s linear 0s;
}
.product-sec-D .item p {
  text-align: center;
}
.product-sec-D .item .icon {
  position: absolute;
  width: 70px;
  height: 70px;
  background: #eeecec;
  border-radius: 100%;
  left: 50%;
  bottom: -30px;
  transform: translate(-50%, 0%);
  border: 3px solid #222222;
  transition: all 0.4s linear 0s;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-sec-D .item .icon .white {
  display: none;
}

.pathbreak-sec-B.product-sec-6 {
  background: #fff;
}
.pathbreak-sec-B.product-sec-6 h4 {
  color: #666666;
}
.pathbreak-sec-B.product-sec-6 ul li {
  color: #666666;
}

.product-sec-7 {
  position: relative;
  padding: 50px 0;
  height: calc(100vh - 100px);
  background: #222222;
}
@media (max-width: 1440px) {
  .product-sec-7 {
    height: 100vh;
  }
}
@media (max-width: 1024px) {
  .product-sec-7 {
    height: 63vh;
  }
}
@media (max-width: 991px) {
  .product-sec-7 {
    height: none;
  }
}
@media (max-width: 767px) {
  .product-sec-7 {
    height: 100%;
  }
}
.product-sec-7 .container {
  position: relative;
  width: 320px;
  margin: 100px auto 0 auto;
  perspective: 1000px;
}
@media (max-width: 1024px) {
  .product-sec-7 .container {
    perspective: none;
  }
}
@media (max-width: 767px) {
  .product-sec-7 .container {
    width: inherit;
    margin: 0;
  }
}
.product-sec-7 .container .product-data {
  position: absolute;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  animation: rotate360 90s infinite forwards linear;
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data {
    animation: none;
    transform-style: inherit;
    position: static;
  }
}
.product-sec-7 .container .product-data:hover {
  animation-play-state: paused;
}
.product-sec-7 .container .product-data .image {
  position: absolute;
  height: 200px;
  top: 20px;
  left: 10px;
  right: 10px;
  background-size: cover;
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5);
  display: flex;
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image {
    position: static;
    border-radius: 20px;
    border: 2px solid #da3467;
    margin-bottom: 20px;
  }
}
.product-sec-7 .container .product-data .image span {
  margin: auto;
  font-size: 16px;
  color: #fff;
  padding: 0 20px;
  line-height: 1.3;
}
.product-sec-7 .container .product-data .image:nth-child(1) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  transform: rotateY(0deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(1) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(2) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  transform: rotateY(40deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(2) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(3) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  transform: rotateY(80deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(3) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(4) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  transform: rotateY(120deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(4) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(5) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  transform: rotateY(160deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(5) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(6) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  transform: rotateY(200deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(6) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(7) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  transform: rotateY(240deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(7) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(8) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  transform: rotateY(280deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(8) {
    transform: none;
  }
}
.product-sec-7 .container .product-data .image:nth-child(9) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  transform: rotateY(320deg) translateZ(450px);
}
@media (max-width: 767px) {
  .product-sec-7 .container .product-data .image:nth-child(9) {
    transform: none;
  }
}

@keyframes rotate360 {
  from {
    transform: rotateY(360deg);
  }
  to {
    transform: rotateY(-360deg);
  }
}
.product-head {
  background-color: #2b2b2b;
  border-top: 5px solid #fff;
  margin: 0;
  position: relative;
}
.product-head span {
  background: #da3467;
  position: absolute;
  border-radius: 0 0 10px 10px;
  top: 0;
  right: 2rem;
  padding: 10px 20px;
  margin-bottom: 20px;
  display: block;
  color: #fff;
  font-weight: 500;
  animation: animate 2s infinite alternate;
}
.product-head h2 {
  color: #fff;
  margin-top: 2rem;
}

.new-product-sec {
  justify-content: space-between;
  height: 80vh;
  overflow: hidden;
  background-color: #2b2b2b;
}
.new-product-sec h2 {
  color: #fff;
  font-size: 30px;
}
.new-product-sec .col1 {
  width: 40%;
  position: relative;
  background-color: #2b2b2b;
  display: flex;
  align-items: center;
}
.new-product-sec .col2 {
  width: 60%;
  position: relative;
}
.new-product-sec .content {
  padding: 0 5rem;
  position: relative;
}
.new-product-sec .content h4 {
  color: #fff;
}
.new-product-sec .content p {
  color: #eaeaea;
  font-size: 14px;
  line-height: 1.2;
}
.new-product-sec .content .bullet_points {
  margin-top: 20px;
  padding: 0;
}
.new-product-sec .imagesv {
  width: 100%;
  line-height: 0;
  height: 100%;
  position: relative;
}
.new-product-sec .imagesv::before {
  top: 0px;
  left: 0px;
  bottom: 0px;
  width: 50%;
  height: 100%;
  content: "";
  position: absolute;
  background-image: linear-gradient(to right, #2b2b2b, rgba(43, 43, 43, 0.9215686275), rgba(43, 43, 43, 0.4392156863), transparent);
}
.new-product-sec .imagesv::after {
  right: 0;
  left: 0;
  width: 100%;
  height: 50%;
  content: "";
  position: absolute;
  background-image: linear-gradient(to bottom, #2b2b2b, rgba(43, 43, 43, 0.9215686275), rgba(43, 43, 43, 0.4392156863), transparent);
}
.new-product-sec .imagesv img {
  width: 100%;
  height: 100%;
}
.new-product-sec .comson {
  background: #da3467;
  display: inline-block;
  padding: 5px 20px;
  border-radius: 15px;
  color: #fff;
  margin-top: 20px;
  text-align: center;
}

.new-product-sec-2 {
  position: relative;
  padding: 50px 0 0;
  background: #222222;
}
.new-product-sec-2 .container {
  margin: 0;
  padding: 0;
}
.new-product-sec-2 .heading {
  margin-bottom: 4rem;
}
.new-product-sec-2 .heading span {
  background: #da3467;
  position: absolute;
  border-radius: 0 0 10px 10px;
  top: 0;
  right: 2rem;
  padding: 10px 20px;
  margin-bottom: 20px;
  display: block;
  color: #fff;
  font-weight: 500;
  animation: animate 2s infinite alternate;
}
.new-product-sec-2 .heading h2 {
  color: #fff;
}
.new-product-sec-2 .flex .col {
  flex: 0 1 60%;
  position: relative;
  max-width: 60%;
  padding-right: 30px;
  padding: 50px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center center/cover;
  z-index: 11;
}
.new-product-sec-2 .flex .col::before {
  position: absolute;
  content: "";
  background: #000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.7;
  z-index: -1;
}
.new-product-sec-2 .flex .col:last-child {
  flex: 0 1 40%;
  max-width: 40%;
  padding-right: 0;
  display: flex;
  align-items: center;
  background: none;
}
.new-product-sec-2 .flex .col:last-child::before {
  content: none;
}
.new-product-sec-2 .content.rotating-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.new-product-sec-2 .content.rotating-text-wrapper p {
  font-size: 2em;
  margin: 0;
  padding: 0.3em;
  color: #fff;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2);
  border: 6px solid #da3467;
  border-radius: 20px;
  animation-duration: 15s;
  animation-iteration-count: infinite;
  opacity: 0;
  padding: 20px;
}
.new-product-sec-2 .content.rotating-text-wrapper p:first-child {
  background: rgba(255, 255, 255, 0.4745098039);
  animation-name: rotating-text-1;
}
.new-product-sec-2 .content.rotating-text-wrapper p:nth-child(2) {
  background: rgba(255, 255, 255, 0.4745098039);
  animation-name: rotating-text-2;
}
.new-product-sec-2 .content.rotating-text-wrapper p:nth-child(3) {
  background: rgba(255, 255, 255, 0.4745098039);
  animation-name: rotating-text-3;
}
.new-product-sec-2 .content.rotating-text-wrapper p:nth-child(4) {
  background: rgba(255, 255, 255, 0.4745098039);
  animation-name: rotating-text-4;
}

@keyframes animate {
  0% {
    box-shadow: 0 0 5px rgba(255, 61, 132, 0.6), 0 0 15px rgba(255, 30, 105, 0.4);
  }
  100% {
    box-shadow: 0 0 15px #ff3d64, 0 0 30px #ff1e5e;
  }
}
@keyframes rotating-text-1 {
  0% {
    transform: translateY(200%);
  }
  25% {
    transform: translateY(100%);
    opacity: 1;
  }
  30% {
    opacity: 0;
  }
}
@keyframes rotating-text-2 {
  25% {
    transform: translateY(100%);
    opacity: 0;
  }
  50% {
    transform: translateY(0);
    opacity: 1;
  }
  55% {
    opacity: 0;
  }
}
@keyframes rotating-text-3 {
  50% {
    transform: translateY(0);
    opacity: 0;
  }
  75% {
    transform: translateY(-100%);
    opacity: 1;
  }
  80% {
    opacity: 0;
  }
}
@keyframes rotating-text-4 {
  75% {
    transform: translateY(-100%);
    opacity: 0;
  }
  99% {
    transform: translateY(-200%);
    opacity: 1;
  }
  100% {
    transform: translateY(-200%);
    opacity: 0;
  }
}
.ai-sec-A {
  width: 100%;
  position: relative;
}
.ai-sec-A .bg {
  height: calc(100vh - 100px);
}
.ai-sec-A .bg video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ai-sec-A .content {
  position: absolute;
  top: 50%;
  max-width: 600px;
  width: 100%;
  padding-left: 30px;
  transform: translateY(-50%);
}
.ai-sec-A .content h2 {
  color: #fff;
  font-size: 36px;
}
.ai-sec-A .content .bullet_points {
  margin-top: 20px;
}
.ai-sec-A .content .bullet_points li {
  font-size: 16px;
}

.ai-sec-B {
  padding: 50px 0;
  position: relative;
  background: #d1d1d1;
}
.ai-sec-B .heading h2 {
  font-size: 36px;
}
@media (max-width: 767px) {
  .ai-sec-B .heading h2 {
    font-size: 28px;
  }
}
.ai-sec-B .item {
  position: relative;
  max-width: 1200px;
  margin: 50px auto;
}
.ai-sec-B .item::before {
  position: absolute;
  content: "";
  background: #da3467;
  width: 5px;
  height: 100%;
  z-index: 1;
  margin-left: -3px;
  top: 0;
  left: 50%;
  animation: moveline 6s linear forwards;
}
@media (max-width: 767px) {
  .ai-sec-B .item::before {
    left: 31px;
  }
}
.ai-sec-B .item .content {
  padding: 10px 50px;
  position: relative;
  width: 50%;
  animation: movedown 1s linear forwards;
  opacity: 0;
  z-index: 1;
}
@media (max-width: 767px) {
  .ai-sec-B .item .content {
    width: 100%;
    padding-left: 80px;
    padding-right: 25px;
  }
}
.ai-sec-B .item .content:first-child {
  animation-delay: 0s;
}
.ai-sec-B .item .content:nth-child(2) {
  animation-delay: 1s;
}
.ai-sec-B .item .content:nth-child(3) {
  animation-delay: 2s;
}
.ai-sec-B .item .content:nth-child(4) {
  animation-delay: 3s;
}
.ai-sec-B .item .content:nth-child(5) {
  animation-delay: 4s;
}
.ai-sec-B .item .content:nth-child(6) {
  animation-delay: 5s;
}
.ai-sec-B .item .content:nth-child(7) {
  animation-delay: 6s;
}
.ai-sec-B .item .content .text-box {
  padding: 20px 30px;
  background: #fff;
  border-radius: 6px;
  font-size: 15px;
  position: relative;
  height: 90px;
}
@media (max-width: 767px) {
  .ai-sec-B .item .content .text-box {
    height: 100%;
  }
}
.ai-sec-B .item .content .text-box::before {
  position: absolute;
  content: "";
  top: 10px;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid #fff;
  right: -15px;
}
@media (max-width: 767px) {
  .ai-sec-B .item .content .text-box::before {
    transform: rotate(180deg);
    right: 100%;
  }
}
.ai-sec-B .item .content .text-box p {
  font-size: 16px;
}
@media (max-width: 767px) {
  .ai-sec-B .item .content .text-box p {
    font-size: 14px;
  }
}
.ai-sec-B .item .content.left {
  left: 0;
}
.ai-sec-B .item .content.right {
  left: 50%;
}
@media (max-width: 767px) {
  .ai-sec-B .item .content.right {
    left: 0;
  }
}
.ai-sec-B .item .content.right .text-box::before {
  transform: rotate(180deg);
  right: 100%;
}
.ai-sec-B .item .content.right .icon {
  left: -20px;
}
@media (max-width: 767px) {
  .ai-sec-B .item .content.right .icon {
    left: 10px;
  }
}
.ai-sec-B .item .icon {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 15px;
  right: -20px;
  z-index: 10;
  background: #fff;
}
@media (max-width: 767px) {
  .ai-sec-B .item .icon {
    left: 10px;
  }
}

@keyframes moveline {
  0% {
    height: 0%;
  }
  100% {
    height: 100%;
  }
}
@keyframes movedown {
  0% {
    opacity: 1;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.ai-sec-3 {
  background: #222222;
}

.ai-video {
  height: 500px;
}
.ai-video video {
  height: 100%;
  width: 100%;
}

.ai-sec-4 {
  padding: 50px 0;
  position: relative;
}
.ai-sec-4 .heading h2 {
  font-size: 36px;
}
@media (max-width: 767px) {
  .ai-sec-4 .heading h2 {
    font-size: 24px;
  }
}
.ai-sec-4 .flex .col1 {
  flex: 0 1 31%;
  max-width: 31%;
  position: relative;
  margin: 0 10px;
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .ai-sec-4 .flex .col1 {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.ai-sec-4 .img {
  line-height: 0;
}
.ai-sec-4 .img::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 50%;
  bottom: 0;
  border-radius: 0 0 10px 10px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
}
.ai-sec-4 .img img {
  border-radius: 10px;
}
.ai-sec-4 .content {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  text-align: center;
  white-space: nowrap;
}
.ai-sec-4 .content p {
  color: #fff;
}

.ai-sec-5 {
  position: relative;
}
.ai-sec-5 .img {
  position: relative;
  line-height: 0;
}
.ai-sec-5 .img img {
  width: 100%;
}
.ai-sec-5 .content {
  padding: 50px 40px;
  position: absolute;
  top: 40px;
  left: 15%;
}
.ai-sec-5 .content h3 {
  margin-bottom: 20px;
  color: #fff;
  font-size: 36px;
}
.ai-sec-5 .content ul {
  padding-left: 0;
}

.managment-sec-A {
  position: relative;
  height: 500px;
  background: #e7e7e7;
}
.managment-sec-A video {
  width: 100%;
  height: 100%;
}

.management-sec-B {
  position: relative;
  padding: 50px 0;
}
.management-sec-B .flex {
  align-items: center;
}
.management-sec-B .flex .col1 {
  flex: 0 1 50%;
  max-width: 50%;
  padding-right: 40px;
}
@media (max-width: 767px) {
  .management-sec-B .flex .col1 {
    flex: 0 1 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: 20px;
  }
}
.management-sec-B .flex .col2 {
  flex: 0 1 50%;
  max-width: 50%;
  padding-left: 40px;
}
@media (max-width: 767px) {
  .management-sec-B .flex .col2 {
    flex: 0 1 100%;
    max-width: 100%;
    padding: 0;
  }
}
.management-sec-B .content h3 {
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: 500;
  color: #666666;
}
@media (max-width: 767px) {
  .management-sec-B .content h3 {
    font-size: 22px;
  }
}
.management-sec-B .content p {
  color: #7e7e7e;
}
@media (max-width: 767px) {
  .management-sec-B .content p {
    font-size: 14px;
  }
}
.management-sec-B .img {
  line-height: 0;
  text-align: center;
}
.management-sec-B .img img {
  width: 400px;
  border-radius: 10px;
}

.management-sec-C {
  position: relative;
  background: #222222;
  padding: 50px 0;
}
.management-sec-C .container {
  max-width: 700px;
}
.management-sec-C .flex {
  align-items: center;
}
.management-sec-C .flex .item {
  flex: 0 1 50%;
  max-width: 50%;
  text-align: center;
  margin-bottom: 30px;
}
.management-sec-C .flex .item:last-child {
  flex: 0 1 100%;
  max-width: 100%;
  margin-bottom: 0;
}
.management-sec-C p {
  background: #fff;
  display: inline-block;
  height: 200px;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 100%;
  padding: 10px;
  border: 15px solid #da3467;
  box-shadow: inset 0px 4px 17px 6px #000;
}
@media (max-width: 767px) {
  .management-sec-C p {
    width: 150px;
    height: 150px;
    border: 5px solid #da3467;
    box-shadow: inset 0px 1px 10px 4px #000;
    padding: 15px;
    font-size: 13px;
  }
}

.management-sec-D {
  position: relative;
  padding-top: 50px;
  height: calc(100vh - 200px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center center/cover;
}
@media (max-width: 767px) {
  .management-sec-D {
    height: 100%;
    padding-bottom: 50px;
  }
}
.management-sec-D::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #000000;
  opacity: 0.5;
}
.management-sec-D .content {
  position: relative;
  max-width: 500px;
  width: 100%;
}
.management-sec-D .content h3 {
  color: #fff;
  margin-bottom: 20px;
  font-size: 30px;
}
@media (max-width: 767px) {
  .management-sec-D .content h3 {
    font-size: 28px;
  }
}
.management-sec-D .content ul {
  padding: 0;
}
.management-sec-D .content ul li {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
}
.management-sec-D .content ul li::before {
  background: #da3467;
}

.management-sec-E {
  padding: 50px 0;
  position: relative;
}
.management-sec-E .heading {
  margin-bottom: 40px;
}
.management-sec-E .heading h2 {
  font-size: 36px;
}
.management-sec-E .flex .item {
  flex: 0 1 32%;
  max-width: 32%;
  text-align: center;
  padding: 20px;
  border-radius: 5px;
  background: #222222;
  margin: 0 5px;
}
@media (max-width: 767px) {
  .management-sec-E .flex .item {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.management-sec-E h4 {
  font-size: 18px;
  color: #da3467;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.management-sec-E ul {
  text-align: left;
}
.management-sec-E ul li {
  color: #fff;
}

.pathbreak-sec-A {
  padding: 50px 0;
  position: relative;
}
.pathbreak-sec-A .heading h2 {
  font-size: 36px;
}
@media (max-width: 767px) {
  .pathbreak-sec-A .heading h2 {
    font-size: 28px;
  }
}
@media (max-width: 767px) {
  .pathbreak-sec-A .flex {
    justify-content: center;
  }
}
.pathbreak-sec-A .flex .item {
  flex: 0 1 20%;
  max-width: 20%;
  padding: 0 10px;
  text-align: center;
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .pathbreak-sec-A .flex .item {
    flex: 0 1 50%;
    max-width: 50%;
  }
}
.pathbreak-sec-A .circle {
  background: rgba(106, 104, 104, 0.1490196078);
  width: 150px;
  height: 150px;
  margin: 0 auto;
  position: relative;
  border-radius: 100%;
}
.pathbreak-sec-A .circle::before {
  content: "";
  position: absolute;
  bottom: -30px;
  height: 8px;
  border: 13px solid transparent;
  border-top-color: #da3467;
  left: 50%;
  transform: translate(-50%);
}
.pathbreak-sec-A .circle .icon {
  padding: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: linear-gradient(white, white) padding-box, linear-gradient(to bottom, #dc1371, #da4a7e) border-box;
  border-radius: 50em;
  border: 10px solid transparent;
  opacity: 1;
  box-shadow: inset 0 0 8px #222222;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pathbreak-sec-A .circle .icon img {
  width: 50px;
}
.pathbreak-sec-A span {
  margin-top: 20px;
  display: block;
}

.pathbreak-sec-B {
  background: #222222;
  position: relative;
  padding: 50px 0;
}
.pathbreak-sec-B .heading h2 {
  color: #fff;
  font-size: 36px;
}
.pathbreak-sec-B .flex {
  align-items: center;
}
.pathbreak-sec-B .flex .col1 {
  flex: 0 1 60%;
  max-width: 60%;
}
@media (max-width: 767px) {
  .pathbreak-sec-B .flex .col1 {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.pathbreak-sec-B .flex .col2 {
  flex: 0 1 40%;
  max-width: 40%;
}
@media (max-width: 767px) {
  .pathbreak-sec-B .flex .col2 {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.pathbreak-sec-B .img {
  width: 500px;
  margin: 0 auto;
}
@media (max-width: 767px) {
  .pathbreak-sec-B .img {
    width: 100%;
    margin-bottom: 20px;
  }
}
.pathbreak-sec-B .img img {
  width: 100%;
  border-radius: 20px;
}
.pathbreak-sec-B .bullet_points {
  padding-left: 0;
}
.pathbreak-sec-B .bullet_points li {
  margin-bottom: 5px;
}
.pathbreak-sec-B .bullet_points li::before {
  background: #da3467;
}

.pathbreak-sec-C {
  padding: 50px 0;
}
.pathbreak-sec-C .flex .item {
  flex: 0 1 25%;
  max-width: 25%;
  text-align: center;
  position: relative;
}
@media (max-width: 767px) {
  .pathbreak-sec-C .flex .item {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.pathbreak-sec-C .img {
  line-height: 0;
  max-width: 280px;
  width: 100%;
  margin: 0 auto;
}
.pathbreak-sec-C .img::before {
  position: absolute;
  content: "";
  width: 280px;
  bottom: 0;
  height: 50%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #da3467);
}
.pathbreak-sec-C .img img {
  width: 100%;
}
.pathbreak-sec-C p {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 14px;
  bottom: 20px;
  color: #fff;
  font-weight: 600;
}

.polls-sec-A {
  position: relative;
  padding: 100px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center/cover;
}
.polls-sec-A .text {
  max-width: 500px;
  width: 100%;
}
.polls-sec-A .text h3 {
  color: #fff;
  font-size: 30px;
  line-height: 1.5;
}

.polls-sec-B {
  position: relative;
  padding: 60px 0;
}
.polls-sec-B .flex {
  align-items: center;
}
.polls-sec-B .flex .item {
  flex: 0 1 50%;
  max-width: 50%;
  text-align: center;
}
@media (max-width: 767px) {
  .polls-sec-B .flex .item {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.polls-sec-B ul {
  text-align: left;
  width: 450px;
  margin: 0 auto;
}
@media (max-width: 767px) {
  .polls-sec-B ul {
    width: 100%;
  }
}
.polls-sec-B ul li {
  color: #666666;
  margin-bottom: 5px;
  padding-right: 10px;
}
.polls-sec-B ul li::before {
  background: #da3467;
  top: 10px;
}
.polls-sec-B img {
  border-radius: 10px;
}

.polls-sec-C {
  position: relative;
  padding: 50px 0;
  background: #222222;
  z-index: 1;
}
.polls-sec-C .flex .item {
  flex: 0 1 18%;
  max-width: 18%;
  background: #fff;
  height: 150px;
  margin: 0 12px;
  border-radius: 10px;
  box-shadow: 4px 2px 4px 3px #424242;
  position: relative;
  border: 5px solid #da3467;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .polls-sec-C .flex .item {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.polls-sec-C .text {
  text-align: center;
  padding: 30px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.polls-sec-C .text h4 {
  font-size: 16px;
}
.polls-sec-C .point {
  position: absolute;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-items: center;
  background: #da3467;
  border-radius: 100%;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
}
.polls-sec-C .point span {
  color: #fff;
  text-align: center;
  width: 100%;
  font-size: 18px;
}

.assesment-sec-A {
  position: relative;
  padding: 50px 0;
}
.assesment-sec-A.assesment-sec-B {
  background: #222222;
}
.assesment-sec-A.assesment-sec-B .flex .col {
  flex: 0 1 40%;
  max-width: 40%;
}
@media (max-width: 767px) {
  .assesment-sec-A.assesment-sec-B .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.assesment-sec-A.assesment-sec-B .flex .col:last-child {
  padding-left: 40px;
  flex: 0 1 60%;
  max-width: 60%;
}
@media (max-width: 767px) {
  .assesment-sec-A.assesment-sec-B .flex .col:last-child {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
    padding-left: 0;
  }
}
.assesment-sec-A.assesment-sec-B h3 {
  color: #fff;
}
.assesment-sec-A.assesment-sec-B ul li {
  color: #fff;
}
@media (max-width: 767px) {
  .assesment-sec-A.assesment-sec-B ul li {
    margin-bottom: 10px;
  }
}
.assesment-sec-A .flex {
  align-items: center;
}
.assesment-sec-A .flex .col {
  flex: 0 1 60%;
  max-width: 60%;
  padding-right: 40px;
}
@media (max-width: 767px) {
  .assesment-sec-A .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
    padding-right: 0;
  }
}
.assesment-sec-A .flex .col:last-child {
  flex: 0 1 40%;
  max-width: 40%;
}
@media (max-width: 767px) {
  .assesment-sec-A .flex .col:last-child {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.assesment-sec-A h3 {
  color: #575757;
  margin-bottom: 30px;
}
.assesment-sec-A ul {
  padding: 0;
}
.assesment-sec-A ul li {
  color: #666666;
}
@media (max-width: 767px) {
  .assesment-sec-A ul li {
    margin-bottom: 10px;
  }
}
.assesment-sec-A ul li::before {
  background: #da3467;
}
.assesment-sec-A img {
  border-radius: 10px;
}

.community-sec-A {
  padding: 50px 0;
}
.community-sec-A .heading {
  margin-bottom: 50px;
}
.community-sec-A .heading h2 {
  font-size: 36px;
  line-height: 1.3;
}
@media (max-width: 767px) {
  .community-sec-A .heading h2 {
    font-size: 28px;
  }
}
.community-sec-A .flex {
  align-items: center;
}
.community-sec-A .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
@media (max-width: 767px) {
  .community-sec-A .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.community-sec-A .flex .col:first-child {
  padding-right: 30px;
}
.community-sec-A .text p {
  margin-bottom: 20px;
}
.community-sec-A img {
  border-radius: 20px;
}

.community-sec-C {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center center/cover;
  height: calc(100vh - 200px);
  padding: 100px 0;
}
@media (max-width: 767px) {
  .community-sec-C {
    height: 100%;
    padding: 50px 0;
  }
}
.community-sec-C::before {
  position: absolute;
  content: "";
  background: #000;
  opacity: 0.5;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.community-sec-C .content {
  position: relative;
}
.community-sec-C .content h3 {
  margin-bottom: 20px;
  color: #fff;
}
.community-sec-C ul {
  padding: 0;
}
.community-sec-C ul li {
  margin-bottom: 10px;
}

.compliance-sec-A {
  padding: 50px 0;
  background: #e7e7e7;
  position: relative;
}
.compliance-sec-A .heading {
  margin-bottom: 60px;
}
.compliance-sec-A .heading h2 {
  font-size: 36px;
}
@media (max-width: 767px) {
  .compliance-sec-A .heading h2 {
    font-size: 28px;
  }
}
.compliance-sec-A .item {
  position: relative;
  flex: 0 1 50%;
  max-width: 50%;
  margin-bottom: 5rem;
}
@media (max-width: 767px) {
  .compliance-sec-A .item {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.compliance-sec-A .item .circle {
  width: 150px;
  height: 150px;
  background: linear-gradient(#da3467, #f5c0d0);
  border-radius: 100%;
  border: 10px solid #ffffff;
  position: absolute;
  box-shadow: inset 0 0 8px #312b2d;
  top: -27px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 767px) {
  .compliance-sec-A .item .circle {
    width: 120px;
    height: 120px;
    top: -10px;
  }
}
.compliance-sec-A .item .circle .icon {
  background: #fbfbfb;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  box-shadow: 0 0 8px 0 #312b2d;
}
@media (max-width: 767px) {
  .compliance-sec-A .item .circle .icon {
    width: 50px;
    height: 50px;
  }
}
.compliance-sec-A .item .text {
  background: #fff;
  height: 100px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  width: 85%;
}
@media (max-width: 767px) {
  .compliance-sec-A .item .text {
    width: 100%;
  }
}
.compliance-sec-A .item .text p {
  margin-left: 11rem;
}
@media (max-width: 767px) {
  .compliance-sec-A .item .text p {
    margin-left: 9rem;
  }
}

.compliance-sec-B {
  position: relative;
  padding: 50px 0;
}
.compliance-sec-B .heading {
  margin-bottom: 50px;
}
.compliance-sec-B .heading h2 {
  font-size: 36px;
}
@media (max-width: 767px) {
  .compliance-sec-B .heading h2 {
    font-size: 28px;
  }
}
.compliance-sec-B .flex .col {
  flex: 0 1 30%;
  max-width: 30%;
  margin: 0 20px;
  text-align: center;
}
@media (max-width: 767px) {
  .compliance-sec-B .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.compliance-sec-B .flex .col:last-child .img::before {
  content: none;
}
.compliance-sec-B .img {
  position: relative;
}
.compliance-sec-B .img::before {
  position: absolute;
  content: "";
  left: 0;
  right: -20px;
  border-right: 3px solid #da3467;
  padding: 10px;
  height: 100%;
}
@media (max-width: 767px) {
  .compliance-sec-B .img::before {
    content: none;
  }
}
.compliance-sec-B .img img {
  border-radius: 0px 100px 0 100px;
  height: 100%;
}
.compliance-sec-B p {
  padding: 10px;
  font-weight: 500;
}

.compliance-sec-C {
  position: relative;
  padding: 100px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.compliance-sec-C::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #000000;
  opacity: 0.6;
}
.compliance-sec-C .content {
  position: relative;
}
.compliance-sec-C .content h3 {
  color: #fff;
  margin-bottom: 20px;
  font-size: 28px;
}
.compliance-sec-C .content ul {
  padding-left: 0;
}

.content-banner-sec {
  position: relative;
}
.content-banner-sec .bg {
  width: 100%;
  line-height: 0;
  height: calc(100vh - 100px);
}
.content-banner-sec .bg::before {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.6;
}
.content-banner-sec .bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.content-banner-sec .content {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10%;
  width: 600px;
}
@media (max-width: 767px) {
  .content-banner-sec .content {
    left: 0;
    width: 100%;
    padding: 0 10px;
  }
}
.content-banner-sec .content p {
  color: #ffffff;
  font-size: 24px;
  line-height: 1.2;
}

.content-sec-A {
  padding: 100px 0;
}
.content-sec-A .flex {
  justify-content: center;
}
.content-sec-A .flex .col {
  flex: 0 1 25%;
  max-width: 25%;
  text-align: center;
}
@media (max-width: 767px) {
  .content-sec-A .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 100px;
  }
}
.content-sec-A .item {
  background: linear-gradient(to left, #da3467, #303030);
  height: 180px;
  width: 180px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 10px;
  position: relative;
  transform: rotate(45deg);
}
.content-sec-A .item .text {
  background: #f1f1f1;
  height: 150px;
  width: 150px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 0 8px 0 #000000;
}
.content-sec-A .item .text p {
  transform: rotate(-45deg);
}

.content-sec-B {
  position: relative;
  background: #222222;
  padding: 50px 0;
}
.content-sec-B .flex {
  align-items: center;
}
.content-sec-B .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
@media (max-width: 767px) {
  .content-sec-B .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.content-sec-B .img {
  width: 400px;
  margin: 0 auto;
  line-height: 0;
}
@media (max-width: 767px) {
  .content-sec-B .img {
    width: 100%;
  }
}
.content-sec-B .img img {
  width: 100%;
  border-radius: 10px;
}
.content-sec-B .content h3 {
  margin-bottom: 20px;
  color: #fff;
}
.content-sec-B .content ul {
  text-align: left;
}

.content-sec-C {
  padding: 50px 0;
}
.content-sec-C .flex .item {
  flex: 0 1 25%;
  max-width: 25%;
  text-align: center;
  position: relative;
}
@media (max-width: 767px) {
  .content-sec-C .flex .item {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.content-sec-C .img {
  line-height: 0;
  max-width: 280px;
  width: 100%;
  margin: 0 auto;
}
.content-sec-C .img::before {
  position: absolute;
  content: "";
  width: 280px;
  bottom: 0;
  height: 50%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
}
.content-sec-C .img img {
  width: 100%;
}
.content-sec-C p {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
  bottom: 20px;
  color: #fff;
  font-weight: 600;
  width: 100%;
  padding: 0 10px;
}

.content-sec-E {
  padding: 50px 0;
  background: #222222;
}
.content-sec-E .heading h2 {
  color: #fff;
  font-size: 36px;
}
.content-sec-E .item {
  position: relative;
  margin: auto;
  transition: all 0.5s ease-in-out;
  cursor: pointer;
}
.content-sec-E .item::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.44);
  transition: all 1s ease-in-out;
}
.content-sec-E .item:hover::after {
  height: 0%;
}
.content-sec-E .img {
  overflow: hidden;
  height: 270px;
}
.content-sec-E .img img {
  width: 100%;
  height: 100%;
  transition: all 1s ease-in-out;
}
.content-sec-E .text {
  position: absolute;
  bottom: 15px;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
.content-sec-E .text p {
  color: #fff;
}
.content-sec-E .VdeMnSemn {
  position: absolute;
  left: 50%;
  top: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.content-sec-E .VdeMnSemn::before {
  position: absolute;
  content: "";
  width: 50px;
  height: 50px;
  right: 0;
  bottom: 0;
  transform: translate(-50%, -50%);
  display: block;
  background: #fff;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  animation: pulse-border 1500ms ease-out infinite;
}
.content-sec-E .VdeMnSemn .VdeIcnMn {
  width: 50px;
  height: 50px;
  border: 2px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.content-sec-E .VdeMnSemn .VdeIcnMn img {
  width: auto;
}
.content-sec-E .owl-dots {
  text-align: center;
}

@keyframes pulse-border {
  0% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
    opacity: 0.5;
  }
  100% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
    opacity: 0;
  }
}
.solution-sec-A {
  padding: 50px 0;
}
.solution-sec-A .heading h2 {
  font-size: 36px;
}
@media (max-width: 767px) {
  .solution-sec-A .heading h2 {
    font-size: 28px;
  }
}
.solution-sec-A .flex {
  align-items: center;
}
.solution-sec-A .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
.solution-sec-A .flex .col:last-child {
  padding-left: 50px;
}
@media (max-width: 767px) {
  .solution-sec-A .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
  .solution-sec-A .flex .col:last-child {
    padding-left: 0;
  }
}
.solution-sec-A video {
  height: 400px;
  width: 100%;
  background: #222222;
}
.solution-sec-A .content p {
  margin-bottom: 20px;
}

.solution-sec-B {
  position: relative;
  padding: 50px 0;
  background: #222222;
}
.solution-sec-B .heading h2 {
  color: #fff;
  font-size: 36px;
}
.solution-sec-B .flex {
  align-items: center;
}
.solution-sec-B .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
.solution-sec-B .flex .col:first-child {
  padding-right: 50px;
}
@media (max-width: 767px) {
  .solution-sec-B .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.solution-sec-B video {
  height: 400px;
  width: 100%;
  background: #222222;
}
.solution-sec-B .content ul {
  padding: 0;
}
.solution-sec-B .content ul li {
  margin-bottom: 15px;
}
.solution-sec-B .content b {
  color: #da3467;
}

.solution-sec-C {
  position: relative;
  background: #f1f1f1;
  line-height: 0;
}
.solution-sec-C video {
  height: 400px;
  width: 100%;
}

.solution-sec-D {
  position: relative;
  padding: 50px 0;
  background: #222222;
}
.solution-sec-D .heading h2 {
  color: #fff;
  font-size: 36px;
}
@media (max-width: 767px) {
  .solution-sec-D .heading h2 {
    font-size: 28px;
  }
}
.solution-sec-D .flex .col {
  flex: 0 1 33.33%;
  max-width: 33.33%;
}
@media (max-width: 767px) {
  .solution-sec-D .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.solution-sec-D .item {
  background: #fff;
  height: 300px;
  padding: 60px 30px;
  border-radius: 10px;
  margin: 0 10px;
  box-shadow: inset 0 0 10px 2px #222222;
}
.solution-sec-D .item ul {
  padding: 0;
}
.solution-sec-D .item ul li {
  color: #505050;
}
.solution-sec-D .item ul li::before {
  background: #da3467;
}

.solution-sec-E {
  position: relative;
  padding: 100px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center center/cover;
}
.solution-sec-E::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #222222;
  opacity: 0.6;
}
.solution-sec-E .heading {
  text-align: left;
  position: relative;
}
.solution-sec-E .heading h2 {
  color: #fff;
}
.solution-sec-E ul {
  padding: 0;
}

.frontline-sec-A {
  padding: 50px 0;
  padding-bottom: 100px;
  position: relative;
}
.frontline-sec-A .heading {
  margin-bottom: 5rem;
}
.frontline-sec-A .flex {
  justify-content: center;
}
.frontline-sec-A .flex .col {
  flex: 0 1 33.33%;
  max-width: 33.33%;
}
@media (max-width: 767px) {
  .frontline-sec-A .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 60px;
  }
}
.frontline-sec-A .flex .col:last-child .item, .frontline-sec-A .flex .col:nth-last-child(2) .item {
  transform: rotate(-135deg);
}
@media (max-width: 767px) {
  .frontline-sec-A .flex .col:last-child .item, .frontline-sec-A .flex .col:nth-last-child(2) .item {
    transform: rotate(45deg);
  }
}
.frontline-sec-A .flex .col:last-child .item p, .frontline-sec-A .flex .col:nth-last-child(2) .item p {
  transform: rotate(-225deg);
}
@media (max-width: 767px) {
  .frontline-sec-A .flex .col:last-child .item p, .frontline-sec-A .flex .col:nth-last-child(2) .item p {
    transform: rotate(-45deg);
  }
}
.frontline-sec-A .item {
  background: linear-gradient(to left, #777777, #303030);
  height: 250px;
  width: 250px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-top-left-radius: 40%;
  border: 3px solid #da3467;
  position: relative;
  transform: rotate(45deg);
}
@media (max-width: 767px) {
  .frontline-sec-A .item {
    width: 200px;
    height: 200px;
  }
}
.frontline-sec-A p {
  transform: rotate(-45deg);
  color: #fff;
  font-size: 14px;
}
@media (max-width: 767px) {
  .frontline-sec-A p {
    padding: 0 10px;
    font-size: 12px;
  }
}

.frontline-sec-B .bg {
  position: relative;
  line-height: 0;
  height: 500px;
}
@media (max-width: 767px) {
  .frontline-sec-B .bg {
    height: 350px;
  }
}
.frontline-sec-B .bg::before {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #000000;
  opacity: 0.6;
}
.frontline-sec-B .bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.frontline-sec-B .content {
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}
@media (max-width: 767px) {
  .frontline-sec-B .content {
    width: 100%;
    padding: 0 25px;
    top: 35%;
  }
}
.frontline-sec-B .content h2 {
  color: #fff;
  margin-bottom: 20px;
}
.frontline-sec-B .content p {
  color: #fff;
}
@media (max-width: 767px) {
  .frontline-sec-B .content p {
    width: 100%;
  }
}
.frontline-sec-B .growth-sec {
  background: #222222;
}
@media (max-width: 767px) {
  .frontline-sec-B .growth-sec {
    padding: 0 15px;
  }
}
.frontline-sec-B .growth-sec .flex {
  padding: 30px 0;
  align-items: center;
}
.frontline-sec-B .growth-sec .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
@media (max-width: 767px) {
  .frontline-sec-B .growth-sec .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.frontline-sec-B .growth-sec .flex .col:last-child {
  padding-left: 50px;
}
@media (max-width: 767px) {
  .frontline-sec-B .growth-sec .flex .col:last-child {
    margin-top: 20px;
    padding: 0;
  }
}
.frontline-sec-B .growth-sec .flex img {
  border: 4px solid #da3467;
  width: 100%;
  border-radius: 20px;
}
.frontline-sec-B .growth-sec .flex .text h3 {
  margin-bottom: 20px;
  color: #fff;
}
.frontline-sec-B .growth-sec .flex .text ul {
  padding: 0;
}
.frontline-sec-B .growth-sec .flex .text ul li {
  color: #fff;
  margin-bottom: 5px;
}
.frontline-sec-B .growth-sec .flex .text ul li::before {
  background: #da3467;
}

.frontline-sec-C {
  position: relative;
  padding: 100px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.frontline-sec-C::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #000000;
  opacity: 0.6;
}
.frontline-sec-C .container {
  max-width: 1400px;
}
.frontline-sec-C .heading {
  position: relative;
  text-align: left;
}
.frontline-sec-C .heading h2 {
  color: #fff;
}
.frontline-sec-C .content {
  width: 600px;
}
@media (max-width: 767px) {
  .frontline-sec-C .content {
    width: 100%;
  }
}
.frontline-sec-C ul {
  padding-left: 0;
}
@media (max-width: 767px) {
  .frontline-sec-C ul li {
    margin-bottom: 10px;
  }
}

.frontline-sec-D {
  padding: 50px 0;
}
.frontline-sec-D .heading h2 {
  margin-bottom: 10px;
}
.frontline-sec-D .heading p {
  font-size: 16px;
}
.frontline-sec-D .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
  padding-right: 50px;
}
@media (max-width: 767px) {
  .frontline-sec-D .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    padding-right: 0;
    margin-bottom: 20px;
  }
}
.frontline-sec-D .flex .col:first-child .text {
  padding: 70px 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.frontline-sec-D .flex .col:first-child .text::before {
  position: absolute;
  content: "";
  background: #000;
  width: 100%;
  left: 0;
  top: 0;
  border-radius: 10px;
  opacity: 0.6;
  height: 100%;
}
.frontline-sec-D .flex .col:nth-last-child(2) .text {
  padding-left: 50px;
  padding: 58px 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.frontline-sec-D .flex .col:last-child {
  margin-top: 20px;
  flex: 0 1 100%;
  max-width: 100%;
}
@media (max-width: 767px) {
  .frontline-sec-D .flex .col:last-child {
    margin-top: 0px;
  }
}
.frontline-sec-D .flex .col:last-child .content {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center center/cover;
  padding: 50px 20px;
}
@media (max-width: 767px) {
  .frontline-sec-D .flex .col:last-child .content ul {
    padding-left: 0;
  }
}
.frontline-sec-D .text, .frontline-sec-D .content {
  position: relative;
  border-radius: 10px;
}
.frontline-sec-D .text::before, .frontline-sec-D .content::before {
  position: absolute;
  content: "";
  background: #000;
  width: 100%;
  left: 0;
  top: 0;
  border-radius: 10px;
  opacity: 0.6;
  height: 100%;
}
.frontline-sec-D .text h3, .frontline-sec-D .content h3 {
  position: relative;
  color: #fff;
  font-weight: 500;
}
.frontline-sec-D .text p, .frontline-sec-D .content p {
  position: relative;
  color: #fff;
}
.frontline-sec-D .text p a, .frontline-sec-D .content p a {
  color: #da3467;
}
.frontline-sec-D .text p a:hover, .frontline-sec-D .content p a:hover {
  color: #da3467;
}
.frontline-sec-D .solution-sec {
  padding: 0 100px;
}
@media (max-width: 767px) {
  .frontline-sec-D .solution-sec {
    padding: 0 20px;
  }
}

.communc-sec-A {
  padding: 50px 0;
  position: relative;
  background: #222222;
}
.communc-sec-A .flex {
  align-items: center;
}
.communc-sec-A .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
@media (max-width: 767px) {
  .communc-sec-A .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.communc-sec-A .flex .col:first-child {
  padding-right: 50px;
}
@media (max-width: 767px) {
  .communc-sec-A .flex .col:first-child {
    margin-bottom: 20px;
  }
}
.communc-sec-A .flex h3 {
  margin-bottom: 20px;
  color: #fff;
}
.communc-sec-A .flex ul li {
  color: #fff;
}
.communc-sec-A .flex ul li::before {
  background: #da3467;
}
.communc-sec-A .flex video {
  width: 100%;
  height: 500px;
}

.communc-sec-B {
  padding: 50px 0;
  position: relative;
}
.communc-sec-B .flex .col {
  flex: 0 1 20%;
  max-width: 20%;
  text-align: center;
  position: relative;
}
@media (max-width: 767px) {
  .communc-sec-B .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.communc-sec-B .flex .img {
  width: 230px;
  position: relative;
  margin: 0 10px;
}
@media (max-width: 767px) {
  .communc-sec-B .flex .img {
    width: 100%;
    margin: 0;
  }
}
.communc-sec-B .flex .img::before {
  position: absolute;
  content: "";
  background: linear-gradient(to top, #000000, transparent);
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.communc-sec-B .flex .img img {
  width: 100%;
  border-radius: 10px;
}
.communc-sec-B .flex p {
  position: absolute;
  bottom: 5%;
  left: 50%;
  color: #fff;
  transform: translateX(-50%);
  width: 100%;
  padding: 0 40px;
}

.communc-sec-C {
  background: #222222;
  padding: 50px 0;
}
.communc-sec-C .heading h2 {
  color: #fff;
}
.communc-sec-C .flex .col {
  flex: 0 1 25%;
  max-width: 25%;
}
@media (max-width: 991px) {
  .communc-sec-C .flex .col {
    flex: 0 1 50%;
    max-width: 50%;
  }
}
@media (max-width: 767px) {
  .communc-sec-C .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.communc-sec-C .item {
  box-shadow: 0 0 8px 1px #717171;
  display: flex;
  height: 150px;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 15px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 10px;
  position: relative;
  transition: 450ms ease;
  background: linear-gradient(45deg, #211a1a, #534c4c);
}
.communc-sec-C .item::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #da3467;
  clip-path: polygon(0 100%, 0 98%, 0 100%, 0 100%);
  transition: 450ms ease;
}
.communc-sec-C .item:hover::before {
  clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);
}
.communc-sec-C .item p {
  color: #fff;
  padding: 0 20px;
  position: relative;
}

.communc-sec-D {
  padding: 50px 0;
  position: relative;
}
.communc-sec-D .heading {
  margin-bottom: 50px;
}
.communc-sec-D .owl-carousel .owl-stage-outer .owl-item {
  transform: scale(0.9);
  opacity: 0.6;
  background: #f1f1f1;
}
.communc-sec-D .owl-carousel .owl-stage-outer .owl-item.center {
  transform: scale(1.1);
  box-shadow: 0px -1px 10px -2px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 1;
  background: #222222;
  opacity: 1;
}
.communc-sec-D .owl-carousel .owl-stage-outer .owl-item.center .item p {
  color: #fff;
}
.communc-sec-D .owl-carousel .owl-dots {
  text-align: center;
}
.communc-sec-D .owl-carousel .owl-dots .owl-dot {
  background: #d2d2d2;
}
.communc-sec-D .item {
  position: relative;
  display: flex;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat center center/cover;
  padding: 55px 15px;
  height: 150px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
}
.communc-sec-D .item.item2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center center/cover;
}
.communc-sec-D .item.item3 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat center center/cover;
}
.communc-sec-D .item.item4 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) no-repeat center center/cover;
}
.communc-sec-D .item.item5 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat center center/cover;
}
.communc-sec-D .item.item6 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat center center/cover;
}
.communc-sec-D .item.item7 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat center center/cover;
}
.communc-sec-D .item::before {
  position: absolute;
  content: "";
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #222222;
  opacity: 0.6;
  border-radius: 10px;
}
.communc-sec-D .item p {
  position: relative;
  color: #fff;
}

.blog {
  background: #e8e8e8;
  padding: 50px 0;
}

.blog-grid .blog-img {
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  line-height: 0;
}
.blog-grid .blog-img:hover .img::before, .blog-grid .blog-img:hover .img::after {
  width: 0%;
}
.blog-grid .blog-img .img {
  display: block;
  height: 250px;
}
.blog-grid .blog-img .img img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
.blog-grid .blog-img .img::before {
  position: absolute;
  content: "";
  background-color: rgba(28, 30, 39, 0.3);
  width: 50%;
  height: 100%;
  left: 0px;
  top: 0px;
  transition: all 500ms ease;
}
.blog-grid .blog-img .img::after {
  position: absolute;
  content: "";
  background-color: rgba(28, 30, 39, 0.3);
  width: 50%;
  height: 100%;
  right: 0px;
  top: 0px;
  transition: all 500ms ease;
}
.blog-grid .date {
  position: absolute;
  background: #ffffff;
  color: #282828;
  padding: 15px;
  right: 0;
  top: 15px;
  font-size: 14px;
  z-index: 1;
}
.blog-grid .blog-info {
  box-shadow: 0 0 30px rgba(31, 45, 61, 0.125);
  border-radius: 5px;
  background: #222222;
  padding: 20px;
  margin: -30px 20px 0;
  position: relative;
  z-index: 1;
}
.blog-grid .blog-info h5 {
  color: #2e2d2d;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: #fff;
}
.blog-grid .blog-info p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  color: #fff;
}
.blog-grid .blog-info .btn-primary {
  background: #da3467;
}
.blog-grid .blog-info .btn-primary svg {
  margin-left: 5px;
  vertical-align: middle;
}

.pagination {
  text-align: center;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-item {
  cursor: pointer;
  background-color: white;
  color: #999;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease;
}

.blog_detail_sec .blog-wrap {
  position: relative;
  overflow: hidden;
  line-height: 0;
}
.blog_detail_sec .blog-wrap::before {
  position: absolute;
  content: "";
  background: #000;
  opacity: 0.4;
  width: 100%;
  height: 100%;
}
.blog_detail_sec .blog-wrap img {
  height: 500px;
  object-fit: cover;
  width: 100%;
}
.blog_detail_sec .blog-wrap .container {
  position: relative;
}
.blog_detail_sec .blog-wrap .blog-inner {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.blog_detail_sec .blog-wrap .blog-inner .blog-text h2 {
  color: #fff;
  width: 100%;
  font-weight: 600;
  margin: 0 0 15px;
}
.blog_detail_sec .blog-wrap .blog-inner .blog-text .user-section li {
  padding-right: 30px;
  font-size: 16px;
  color: #fff;
  vertical-align: middle;
}
.blog_detail_sec .blog-wrap .blog-inner .blog-text .user-section li svg {
  width: 18px;
  position: relative;
  top: -2px;
  margin-right: 5px;
  vertical-align: middle;
}
.blog_detail_sec .blog-detailcontent {
  padding: 50px 0;
}
.blog_detail_sec .blog-detailcontent h1 {
  margin-bottom: 30px;
}
.blog_detail_sec .blog-detailcontent p, .blog_detail_sec .blog-detailcontent h4, .blog_detail_sec .blog-detailcontent h3 {
  margin-bottom: 20px;
}
.blog_detail_sec .blog-detailcontent p a, .blog_detail_sec .blog-detailcontent h4 a, .blog_detail_sec .blog-detailcontent h3 a {
  color: #da3467;
}
.blog_detail_sec .blog-detailcontent h2 {
  margin-bottom: 25px;
}
.blog_detail_sec .blog-detailcontent img {
  height: 100%;
}
.blog_detail_sec .blog-detailcontent ul li {
  display: block;
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
}
.blog_detail_sec .blog-detailcontent ul li::before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background: #da3467;
  border-radius: 100%;
  left: 0;
  top: 8px;
}

.team-sec {
  padding: 50px 0;
  background-color: #ececec;
}
.team-sec .heading {
  margin-bottom: 40px;
}
.team-sec .team-details {
  position: relative;
}
.team-sec .team-details .team_details_sec {
  position: relative;
}
.team-sec .team-details .team_details_sec a {
  overflow: hidden;
}
.team-sec .team-details .team_img {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  overflow: hidden;
}
.team-sec .team-details .team_img::before {
  width: 300px;
  height: 300px;
  position: absolute;
  content: "";
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7019607843), transparent);
  pointer-events: none;
  border-radius: 20px;
}
.team-sec .team-details .team_img img {
  border-radius: 20px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.team-sec .team-details .name {
  font-size: 20px;
  margin: 10px 0;
  font-weight: 400;
  color: #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 23%;
  width: 100%;
}
.team-sec .team-details .designation {
  color: #2e2d2d;
  font-weight: 600;
  font-size: 16px;
  margin-top: 15px;
}
.team-sec .team-details .linked_profile a {
  display: inline-block;
}
.team-sec .team-details .linked_profile a svg {
  fill: #da3467;
}
.team-sec.leadership {
  background: #222222;
}
.team-sec.leadership .designation {
  color: #e1e1e1;
}
.team-sec.leadership .linked_profile a svg {
  fill: #fff;
}

.about-sec-A {
  position: relative;
  background: #222222;
}
.about-sec-A .container {
  padding: 50px;
  height: 100vh;
  width: 100%;
  display: flex;
  overflow: hidden;
}
@media (max-width: 768px) {
  .about-sec-A .container {
    flex-direction: column;
  }
}
.about-sec-A .slide-mission {
  flex: 1 1;
  cursor: pointer;
  padding: 0 50px;
  height: 100%;
  pointer-events: auto;
  transition: all 500ms ease;
}
@media (max-width: 768px) {
  .about-sec-A .slide-mission {
    overflow: auto;
    overflow-x: hidden;
  }
}
.about-sec-A .slide-mission.vission {
  background: linear-gradient(rgba(0, 0, 0, 0.623), rgba(0, 0, 0, 0.623)), url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-size: cover;
  background-position: center center;
}
.about-sec-A .slide-mission.mission {
  background: linear-gradient(rgba(0, 0, 0, 0.623), rgba(0, 0, 0, 0.623)), url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-size: cover;
  background-position: center center;
}
.about-sec-A .slide-mission:hover {
  flex-grow: 2;
}
.about-sec-A .slide-mission:hover .title {
  top: 20%;
  transform: rotate(0deg);
}
.about-sec-A .slide-mission:hover .desc {
  opacity: 1;
  width: 100%;
  top: 35%;
}
.about-sec-A .slide-mission .title {
  color: #fff;
  position: relative;
  font-size: 48px;
  margin: auto;
  text-align: center;
  transform: rotate(90deg);
  top: 50%;
  transition: all 500ms ease;
}
@media (max-width: 768px) {
  .about-sec-A .slide-mission .title {
    transform: rotate(0deg) !important;
  }
}
.about-sec-A .slide-mission .desc {
  opacity: 0;
  color: #f1f1f1;
  position: relative;
  width: 70%;
  font-size: 16px;
  padding: 5%;
  top: 50%;
  border: 2px solid #f1f1f1;
  border-radius: 10px;
  line-height: 1.3;
  margin: auto;
  text-align: left;
  transform: rotate(0deg);
  transition: all 500ms ease;
}
@media screen and (max-width: 768px) {
  .about-sec-A .slide-mission .desc {
    padding: 0%;
    border: 0px solid #f1f1f1;
  }
}
.about-sec-A .slide-mission .desc p {
  margin-bottom: 10px;
}

.newsletter {
  padding: 50px 0;
}
.newsletter .flex .col {
  flex: 0 1 33.33%;
  max-width: 33.33%;
}
.newsletter .post-slide {
  background: #fff;
  margin: 20px 15px 20px;
  border-radius: 15px;
  padding-top: 1px;
  box-shadow: 0px 14px 22px -9px #bbcbd8;
}
.newsletter .post-slide .post-img {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  margin: -12px 15px 8px 15px;
  margin-left: -10px;
}
.newsletter .post-slide .post-img img {
  width: 100%;
  height: auto;
  transform: scale(1, 1);
  transition: transform 0.2s linear;
}
.newsletter .post-slide:hover .post-img img {
  transform: scale(1.1, 1.1);
}
.newsletter .post-slide .over-layer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  background: linear-gradient(-45deg, rgba(6, 190, 244, 0.75) 0%, rgba(45, 112, 253, 0.6) 100%);
  transition: all 0.5s linear;
}
.newsletter .post-slide .over-layer i {
  position: relative;
  top: 45%;
  text-align: center;
  display: block;
  color: #fff;
  font-size: 25px;
}
.newsletter .post-slide:hover .over-layer {
  opacity: 1;
  text-decoration: none;
}
.newsletter .post-slide .post-content {
  background: #fff;
  padding: 2px 20px 40px;
  border-radius: 15px;
}
.newsletter .post-slide .post-title a {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  display: inline-block;
  text-transform: uppercase;
  transition: all 0.3s ease 0s;
}
.newsletter .post-slide .post-title a:hover {
  text-decoration: none;
  color: #da3467;
}
.newsletter .post-slide .post-description {
  line-height: 24px;
  color: #808080;
  margin-bottom: 25px;
}
.newsletter .post-slide .post-date {
  color: #2c2c2c;
  font-size: 14px;
  font-weight: 600;
  vertical-align: middle;
}
.newsletter .post-slide .post-date .date {
  margin-left: 5px;
}
.newsletter .post-slide .read-more {
  padding: 7px 20px;
  float: right;
  font-size: 12px;
  background: #da3467;
  color: #ffffff;
  box-shadow: 0px 10px 20px -10px #1376c5;
  border-radius: 25px;
  text-transform: uppercase;
}
.newsletter .post-slide .read-more:hover {
  background: #da3467;
  text-decoration: none;
  color: #fff;
}
.newsletter.news-sec .col {
  position: relative;
}
.newsletter.news-sec .inkalllm {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.newsletter.news-sec .post-slide .post-img {
  margin: 0;
  height: 250px;
}
.newsletter.news-sec .post-slide .post-title {
  margin: 20px 0;
}
.newsletter.news-sec .post-slide .post-title a {
  text-transform: none;
}
.newsletter.news-sec .post-slide .read-btn {
  display: inline-block;
  text-align: center;
  width: 100%;
}
.newsletter.news-sec .post-slide .read-btn .read-more {
  float: inherit;
  text-transform: lowercase;
}

.contact-sec {
  background: rgba(166, 166, 166, 0.2666666667);
  padding: 50px 0;
}
.contact-sec .heading h2 {
  font-size: 36px;
  margin-bottom: 10px;
}
.contact-sec .heading h2 .text-darkpink {
  color: #da3467;
}
.contact-sec .contact-form {
  background: #fff;
  padding: 25px;
  box-shadow: 1px 0px 7px 1px rgba(153, 153, 153, 0.8588235294);
  border-radius: 20px;
  display: flex;
  flex-wrap: wrap;
}
.contact-sec .contact-form .img_cnt {
  flex: 0 1 40%;
  max-width: 40%;
  position: relative;
}
@media (max-width: 767px) {
  .contact-sec .contact-form .img_cnt {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.contact-sec .contact-form .img_cnt::before {
  position: absolute;
  content: "";
  background: linear-gradient(to bottom, transparent, #000000);
  width: 100%;
  border-radius: 20px;
  height: 100%;
}
.contact-sec .contact-form .img_cnt img {
  border-radius: 20px;
}
.contact-sec .contact-form .content {
  position: absolute;
  bottom: 20px;
  left: 20px;
  padding: 0 20px;
}
.contact-sec .contact-form .content h5 {
  color: #fff;
  margin-bottom: 10px;
}
.contact-sec .contact-form .content p {
  color: #fff;
}
.contact-sec .contact-form form {
  flex: 0 1 60%;
  max-width: 60%;
  padding: 36px;
  position: relative;
  border-radius: 6px;
}
@media (max-width: 767px) {
  .contact-sec .contact-form form {
    flex: 0 1 100%;
    max-width: 100%;
    padding: 20px;
  }
}
.contact-sec .contact-form form .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
  padding: 0 15px;
  margin-top: 20px;
}
@media (max-width: 767px) {
  .contact-sec .contact-form form .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    padding: 0;
  }
}
.contact-sec .contact-form form .flex .col:nth-last-child(2), .contact-sec .contact-form form .flex .col:last-child {
  flex: 0 1 100%;
  max-width: 100%;
}
.contact-sec .contact-form form .flex .col:last-child {
  text-align: center;
}
.contact-sec .contact-form form .back-input .frm-cntrl, .contact-sec .contact-form form .back-textarea .frm-cntrl {
  display: block;
  width: 100%;
  padding: 8px 15px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 5px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.contact-sec .contact-form form .back-input label, .contact-sec .contact-form form .back-textarea label {
  margin-bottom: 5px;
}
.contact-sec .contact-form form .back-input .error, .contact-sec .contact-form form .back-textarea .error {
  display: block;
  margin-top: 5px;
  color: red;
}
.contact-sec .contact-form form .demo-link {
  background: #da3467;
  padding: 7px 25px;
  text-align: center;
  margin: 0 auto;
  border-radius: 25px;
  width: 200px;
  margin-top: 20px;
  border: 0;
  margin: 0 auto;
}
.contact-sec .contact-form form .demo-link a {
  color: #fff;
  display: block;
}

.office-sec {
  padding: 50px 0;
}
.office-sec .heading h2 {
  font-size: 36px;
  margin-bottom: 10px;
}
.office-sec .heading h2 .text-darkpink {
  color: #da3467;
}
.office-sec .flex .col {
  flex: 0 1 50%;
  max-width: 50%;
}
@media (max-width: 767px) {
  .office-sec .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
  }
}
.office-sec .offer_card {
  border: 1px solid #a6a6a6;
  width: 400px;
  border-radius: 20px;
  padding: 20px;
  margin: 0 auto;
  height: 250px;
  background: #222222;
}
@media (max-width: 767px) {
  .office-sec .offer_card {
    width: 100%;
    margin-bottom: 20px;
  }
}
.office-sec .offer_card img {
  width: 60px;
}
.office-sec .offer_card h4 {
  color: #fff;
}
.office-sec .offer_card p {
  color: #fff;
}

.download-banner {
  position: relative;
}
.download-banner .bg {
  width: 100%;
  height: calc(100vh - 400px);
  line-height: 0;
}
.download-banner .bg::before {
  position: absolute;
  content: "";
  background: #000000;
  width: 100%;
  height: 100%;
  opacity: 0.7;
}
.download-banner .bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.download-banner .content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.download-banner .content h2 {
  color: #fff;
  margin-bottom: 10px;
}
.download-banner .content p {
  font-size: 18px;
  color: #fff;
}

.download-sec {
  position: relative;
  padding: 50px 0;
}
.download-sec .flex {
  align-items: center;
}
.download-sec .flex .col {
  text-align: center;
  flex: 0 1 50%;
  max-width: 50%;
}
.download-sec .qrcode {
  width: 200px;
  border-radius: 10px;
}
.download-sec .app-links .app-store, .download-sec .app-links .playstore {
  width: 200px;
  display: inline-block;
}

.react-footer {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) no-repeat center center/cover;
  color: #fff;
}
@media (max-width: 767px) {
  .react-footer {
    padding-bottom: 50px;
  }
}
.react-footer::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: rgba(34, 34, 34, 0.5764705882);
}
.react-footer .footer-top {
  position: relative;
  padding: 100px 0 50px;
  border-bottom: 1px solid #fff;
}
@media (max-width: 767px) {
  .react-footer .footer-top {
    padding-top: 30px;
    padding-bottom: 0;
  }
}
.react-footer .footer-top .flex.reviews {
  width: 50%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 30px;
}
.react-footer .footer-top .flex .col {
  flex: 0 1 25%;
  max-width: 25%;
}
@media (max-width: 767px) {
  .react-footer .footer-top .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.react-footer .footer-top .footer-logo a img {
  filter: invert(1);
  width: 90px;
}
.react-footer .footer-top h6 {
  color: #fff;
  font-size: 14px;
  padding-right: 30px;
  line-height: 1.3;
}
.react-footer .footer-top .footer-title {
  margin-bottom: 10px;
  color: #fff;
}
.react-footer .footer-top .footer-menu svg {
  margin-right: 10px;
  vertical-align: middle;
}
.react-footer .footer-top .footer-menu li {
  transition: 450ms ease;
}
.react-footer .footer-top .footer-menu li a {
  color: #f7f7f7;
}
.react-footer .footer-top .footer-menu li:hover a {
  margin-left: 10px;
  color: #da3467;
}
.react-footer .footer-top .footer3__form p {
  margin-bottom: 10px;
}
.react-footer .footer-top .footer3__form form {
  position: relative;
}
.react-footer .footer-top .footer3__form form .email {
  position: relative;
}
.react-footer .footer-top .footer3__form form input {
  padding: 15px 80px 16px 30px;
  border: none;
  outline: none;
  background: #ffffff;
  border-radius: 4px;
  width: 90%;
}
.react-footer .footer-top .footer3__form form button {
  position: absolute;
  width: 60px;
  bottom: 0;
  border-radius: 0 4px 4px 0;
  background-color: #da3467;
  color: #ffffff;
  top: 0px;
  right: 0px;
  border: none;
}
.react-footer .footer-top .footer3__form form button svg {
  width: 20px;
}
.react-footer .footer-top .footer3__form form .error {
  display: block;
  color: red;
  margin-top: 5px;
}
.react-footer .copyright {
  padding: 10px 0;
  position: relative;
}
.react-footer .copyright .byteedge {
  color: #da3467;
}
.react-footer .copyright .flex {
  align-items: center;
}
.react-footer .copyright .flex .col {
  flex: 0 1 33.33%;
  max-width: 33.33%;
  text-align: center;
}
@media (max-width: 767px) {
  .react-footer .copyright .flex .col {
    flex: 0 1 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
}
.react-footer .copyright .flex .col:last-child {
  text-align: right;
}
@media (max-width: 767px) {
  .react-footer .copyright .flex .col:last-child {
    text-align: left;
  }
}
.react-footer .copyright .isocerti {
  display: flex;
  align-items: center;
  justify-content: center;
}
.react-footer .copyright .isocerti span {
  color: #fff;
  margin-left: 10px;
}
.react-footer .copyright .social-links li:first-child {
  margin-right: 10px;
}
.react-footer .copyright .social-links li a {
  margin: 0 10px;
  border: 1px solid #fff;
  width: 40px;
  height: 40px;
  display: block;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.react-footer .copyright .social-links li svg {
  fill: #da3467;
}

.software-logo a img {
  width: 100px;
}

.privacy-sec-A {
  position: relative;
  padding: 50px 0;
}
.privacy-sec-A .content h3, .privacy-sec-A .content h2 {
  margin-bottom: 20px;
}
.privacy-sec-A .content h3 {
  color: #da3467;
  font-weight: 600;
  margin: 35px 0;
}
.privacy-sec-A .content h4 {
  font-size: 20px;
  margin-bottom: 20px;
}
.privacy-sec-A .content a {
  color: #da3467;
  font-weight: 600;
}
.privacy-sec-A .content p {
  margin-bottom: 10px;
  color: #666666;
}
.privacy-sec-A .content table {
  width: 100%;
}
.privacy-sec-A .content table th {
  font-weight: 600;
}
.privacy-sec-A .content table, .privacy-sec-A .content tr, .privacy-sec-A .content th, .privacy-sec-A .content td {
  margin-top: 20px;
  padding: 20px;
  color: #666666;
  border: 1px solid #666666;
}
.privacy-sec-A .content table span, .privacy-sec-A .content tr span, .privacy-sec-A .content th span, .privacy-sec-A .content td span {
  display: block;
}
.privacy-sec-A .content .bullet_points li {
  color: #666666;
  margin-bottom: 10px;
}
.privacy-sec-A .content .bullet_points li::before {
  background: #da3467;
}

.page_404 {
  padding: 50px 0;
}
.page_404 .four_zero_four_bg {
  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
  height: 400px;
  background-position: center;
}
.page_404 .contant_box_404 {
  text-align: center;
}
.page_404 .contant_box_404 .link_404 {
  color: #fff;
  padding: 10px 20px;
  background: #da3467;
  margin: 20px 0;
  border-radius: 20px;
  display: inline-block;
}

.chatbot-popup {
  position: fixed;
  bottom: 90px;
  right: 35px;
  opacity: 0;
  pointer-events: none;
  margin: 10px 0;
  width: 350px;
  overflow: hidden;
  transform: scale(0.2);
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 0 128px 0 rgba(0, 0, 0, 0.1), 0 32px 64px -48px rgba(0, 0, 0, 0.5);
  transition: all 0.1s ease;
  z-index: 111;
}
.chatbot-popup .chat-header {
  background: #da3467;
  display: flex;
  padding: 15px 20px;
  align-items: center;
  justify-content: space-between;
}
.chatbot-popup .chat-header .header-info {
  display: flex;
  gap: 10px;
  align-items: center;
}
.chatbot-popup .chat-header .header-info h2 {
  font-size: 20px;
  color: #fff;
}
.chatbot-popup .chat-header .header-info img {
  border-radius: 100%;
  border: 2px solid #fff;
  max-width: 50px;
}
.chatbot-popup .chat-header button {
  outline: none;
  border: none;
  background: none;
  color: #fff;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  transition: 0.2 ease;
}
.chatbot-popup .chat-header button:hover {
  background: #ce2559;
}
.chatbot-popup .chatbot-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 280px;
  overflow-y: auto;
  padding: 25px 20px;
  scrollbar-width: thin;
  scrollbar-color: #da3467 transparent;
}
.chatbot-popup .chatbot-body .message {
  display: flex;
  gap: 10px;
  align-items: center;
}
.chatbot-popup .chatbot-body .message .message-text {
  background: #da3467;
  padding: 5px 10px;
  color: #fff;
  max-width: 75%;
  font-weight: 400;
  word-wrap: break-word;
  white-space: pre-line;
  font-size: 0.95rem;
  line-height: 1.3;
}
.chatbot-popup .chatbot-body .message.bot-message img {
  border-radius: 100%;
  width: 40px;
  border: 2px solid #da3467;
  flex-shrink: 0;
  align-self: flex-start;
}
.chatbot-popup .chatbot-body .message.bot-message .message-text {
  background: rgba(218, 52, 103, 0.3803921569);
  color: #2e2d2d;
  border-radius: 10px 10px 10px 2px;
}
.chatbot-popup .chatbot-body .message.user-message {
  flex-direction: column;
  align-items: flex-end;
}
.chatbot-popup .chatbot-body .message.user-message .message-text {
  border-radius: 10px 10px 2px 10px;
}
.chatbot-popup .ai-sugesstion {
  padding: 8px 20px;
}
.chatbot-popup .ai-sugesstion span {
  background: rgba(218, 52, 103, 0.7294117647);
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 27px;
  margin-left: 5px;
  margin-bottom: 5px;
  display: inline-block;
  line-height: 1.3;
  cursor: pointer;
}
.chatbot-popup .chat-footer {
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 15px 20px;
}
.chatbot-popup .chat-footer .chat-form {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 30px;
  outline: 2px solid #c2c2c2;
}
.chatbot-popup .chat-footer .chat-form:focus-within {
  outline: 2px solid #da3467;
}
.chatbot-popup .chat-footer .chat-form .message-input {
  outline: none;
  background: none;
  border: none;
  width: 100%;
  padding: 0 10px;
  height: 40px;
  font-size: 0.95rem;
}
.chatbot-popup .chat-footer .chat-form .message-input:valid ~ button {
  display: block;
}
.chatbot-popup .chat-footer .chat-form button {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  outline: none;
  font-size: 1.15rem;
  flex-shrink: 0;
  margin-right: 8px;
  background: #da3467;
  border: none;
  display: none;
  color: #fff;
}

#chatbot-toogler {
  position: fixed;
  bottom: 30px;
  right: 35px;
  border: none;
  height: 80px;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(218, 52, 103, 0.831372549);
  border-radius: 50%;
  z-index: 11;
  transition: all 0.2s ease;
  overflow: hidden;
  animation: bounce 1.5s infinite, glow 2s infinite alternate;
}
#chatbot-toogler span {
  position: absolute;
  color: #fff;
}
#chatbot-toogler span img {
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
@keyframes glow {
  0% {
    box-shadow: 0 0 15px rgba(255, 61, 132, 0.6), 0 0 30px rgba(255, 30, 105, 0.4);
  }
  100% {
    box-shadow: 0 0 25px #ff3d64, 0 0 50px #ff1e5e;
  }
}
.container.show-chatbot .chatbot-popup {
  opacity: 1;
  transform: scale(1);
  pointer-events: auto;
}
.container.show-chatbot #chatbot-toogler {
  transform: rotate(90deg);
  animation: none;
  height: 50px;
  width: 50px;
}
.container.show-chatbot #chatbot-toogler span:first-child {
  opacity: 0;
}
.container.show-chatbot #chatbot-toogler span:last-child {
  opacity: 1;
}

#chatbot-toogler span:last-child {
  opacity: 0;
}

.typing {
  position: relative;
}
.typing span {
  content: "";
  animation: blink 1.5s infinite;
  animation-fill-mode: both;
  height: 10px;
  width: 10px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
}
.typing span:nth-child(2) {
  animation-delay: 0.2s;
  margin-left: 15px;
}
.typing span:nth-child(3) {
  animation-delay: 0.4s;
  margin-left: 30px;
}

@keyframes blink {
  0% {
    opacity: 0.1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}`, "",{"version":3,"sources":["webpack://./src/sass/_common.sass","webpack://./src/sass/style.css","webpack://./src/sass/_var.sass","webpack://./src/sass/header/_header.sass","webpack://./src/sass/modelnavigation/_modelnavigation.sass","webpack://./src/sass/modelnavigation/_modelvideo.sass","webpack://./src/sass/home/_home.sass","webpack://./src/sass/home/_pricing.sass","webpack://./src/sass/product/_product.sass","webpack://./src/sass/product/_textvideo.sass","webpack://./src/sass/product/_mangement.sass","webpack://./src/sass/product/_pathbreak.sass","webpack://./src/sass/product/_polls.sass","webpack://./src/sass/product/_assessment.sass","webpack://./src/sass/product/_community.sass","webpack://./src/sass/product/_compliance.sass","webpack://./src/sass/product/_content.sass","webpack://./src/sass/solution/_solution.sass","webpack://./src/sass/solution/_frontline.sass","webpack://./src/sass/solution/_workplace.sass","webpack://./src/sass/resources/_blog.sass","webpack://./src/sass/resources/_blogdetails.sass","webpack://./src/sass/resources/_people.sass","webpack://./src/sass/resources/_newsletter.sass","webpack://./src/sass/contact/_contact.sass","webpack://./src/sass/download/_download.sass","webpack://./src/sass/footer/_footer.sass","webpack://./src/sass/privacy/_privacy.sass","webpack://./src/sass/pagenotfound/_pagenotfound.sass","webpack://./src/sass/footer/_chatbot.sass"],"names":[],"mappings":"AAAA;;;;;;;;EAQE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;ACCF;;ADEA;;EAEE,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,cEgDW;AD/Cb;;ADCA;EACE;;IAEE,eAAA;IACA,iBAAA;ECEF;AACF;ADCA;;EAEE,cAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;ADEA;EACE,gBAAA;ACCF;;ADEA;EACE,YAAA;ACCF;;ADEA;EACE,WAAA;EACA,aAAA;ACCF;;ADEA;EACE,yBAAA;EACA,iBAAA;ACCF;;ADEA;EACE,qBAAA;EACA,sBAAA;EACA,eAAA;ACCF;;ADCA;EACE,WEGY;ADDd;;ADAA;EACE,eAAA;ACGF;;ADDA;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;ACIF;;ADFA;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;ACKF;;ADHA;EACE,WEhBY;EFiBZ,gBAAA;EACA,iCAAA;EACA,gBAAA;ACMF;AC9DQ;EFoDR;IAMI,aAAA;ECQF;AACF;;ADNA;EACE,eAAA;EACA,iBAAA;ACSF;AC/DQ;EFoDR;IAII,eAAA;IACA,iBAAA;ECWF;AACF;AC9EQ;EF6DR;IAOI,eAAA;IACA,iBAAA;ECcF;AACF;;ADbA;EACE,eAAA;ACgBF;ACxFQ;EFuER;IAGI,eAAA;IACA,iBAAA;ECkBF;AACF;;ADjBA;EACE,eAAA;ACoBF;ACzFQ;EFoER;IAGI,eAAA;ECsBF;AACF;;ADpBA;EACE,eAAA;ACuBF;;ADpBA;EACE,eAAA;ACuBF;;ADpBA;EACE,eAAA;ACuBF;AC1GQ;EFkFR;IAGI,eAAA;ECyBF;AACF;;ADxBA;EACI,mBAAA;EACA,kBAAA;AC2BJ;AD1BI;EACE,cEhEY;EFiEZ,gBAAA;EACA,yBAAA;EACA,YAAA;AC4BN;;ADzBE;EACE,iBAAA;EACA,cExEc;EFyEd,gBAAA;AC4BJ;ACzIQ;EF0GN;IAKI,iBAAA;EC8BJ;AACF;;AD7BA;;EAEE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;ACgCF;;AD7BA;;;;EAIE,kCAAA;ACgCF;;AD7BA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;ACgCF;;AD7BA;;;EAGE,eAAA;ACgCF;;AD7BA;EACE,aAAA;EACA,eAAA;ACgCF;;AD7BA;EACE,iBAAA;ACgCF;;AD7BA;EACE,UAAA;ACgCF;;AD7BA;EACE,yBEpHW;ADoJb;;AD7BA;EACE,iBAAA;EACA,gBAAA;ACgCF;;AD9BA;EACE,UAAA;ACiCF;;AD/BA;EACE,yBE/HW;ADiKb;;AD/BA;EACE,iBAAA;EACA,gBAAA;ACkCF;;AD/BA;EACE,kBAAA;EACA,gBAAA;ACkCF;;AD/BA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,iFAAA;EACA,+BAAA;ACkCF;;AD/BA;EACE,gFAAA;ACkCF;;AD/BE;EACE,qBAAA;ACkCJ;;ADhCA;EACE,eAAA;EACA,aAAA;ACmCF;;ADjCA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;ACoCJ;;ADlCA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;ACqCF;ADpCE;EACE,YAAA;EACA,mBAAA;ACsCJ;;ADpCA;EACE,kBAAA;ACuCF;ADtCE;EACE,kBAAA;EACA,kBAAA;EACA,WEtMU;AD8Od;ADvCI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBE5MQ;EF6MR,mBAAA;EACA,OAAA;EACA,QAAA;ACyCN;;ADpCE;EACE,gBAAA;ACuCJ;ADrCQ;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;ACuCV;ADtCU;EACE,mBEpOI;EFqOJ,UAAA;ACwCZ;;ADtCA;EACE,aAAA;EACA,2CAAA;ACyCF;ADxCE;EACE,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cEjPY;EFkPZ,gBAAA;AC0CJ;ADzCI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;EACA,mBAAA;EACA,YAAA;AC2CN;;ADzCA;EACE,aAAA;AC4CF;AC3UQ;EF8RR;IAGI,aAAA;IACA,8BAAA;IACA,eAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;EC8CF;ED7CE;IACE,qBAAA;IACA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;IACA,aAAA;IACA,gBAAA;EC+CJ;ED9CI;IACE,4BAAA;ECgDN;AACF;;AD/CA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;ACkDF;ADjDE;EACE,cAAA;ACmDJ;ADlDE;EACE,cAAA;ACoDJ;;ADlDA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;ACqDJ;ADpDI;EACI,aAAA;ACsDR;ADrDI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;ACuDR;ADtDQ;EACI,eAAA;EACA,gBAAA;ACwDZ;ADvDI;EACI,gFAAA;ACyDR;ADxDQ;EACI,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,4BAAA;EACA,wCAAA;EACA,oCAAA;EACA,6DAAA;AC0DZ;;ADxDA;EACE;IACE,wBAAA;EC2DF;ED1DA;IACE,2BAAA;EC4DF;AACF;AE5bA;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;AF8bJ;AE7bI;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EAEA,sDAAA;EAGA,sBAAA;AF+bR;AE9bI;EACI,eAAA;AFgcR;AE9bI;EACI,kBAAA;EACA,eAAA;EAGA,sBAAA;EACA,WAAA;EACA,mBDsCQ;AD0ZhB;AC7bQ;ECVJ;IASQ,aAAA;EFkcV;AACF;AElcQ;EACI,kBAAA;EAEA,mBAAA;AFocZ;AEncQ;EACI,aAAA;EACA,cAAA;AFqcZ;AC3cQ;ECIA;IAIQ,aAAA;IACA,cAAA;EFucd;AACF;AEvcQ;EACI,aAAA;EACA,cAAA;AFycZ;ACrdQ;ECUA;IAIQ,aAAA;IACA,cAAA;EF2cd;AACF;AEzcgB;EACI,qBAAA;EACA,mBAAA;AF2cpB;AE1coB;EACI,sBAAA;EACA,WAAA;EACA,UAAA;EACA,YDaV;AD+bd;AE3coB;EACI,eAAA;EACA,gBAAA;EACA,WDSV;ADocd;AE5cQ;EACI,iBAAA;AF8cZ;AE5cgB;EACI,eAAA;AF8cpB;AE7coB;EACI,UDEV;ECDU,sBAAA;AF+cxB;AE9cI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AFgdR;AE/cQ;EACI,mBAAA;EACA,yBAAA;AFidZ;AEhdY;EACI,aAAA;EACA,cAAA;AFkdhB;AClfQ;EC8BI;IAIQ,aAAA;IACA,cAAA;EFodlB;AACF;AEpdY;EACI,aAAA;EACA,cAAA;AFsdhB;AC5fQ;ECoCI;IAIQ,aAAA;IACA,cAAA;EFwdlB;AACF;AExdQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;AF0dZ;AC3hBQ;ECyDA;IAUQ,cAAA;IACA,WAAA;EF4dd;AACF;AE5dY;EACI,cAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;AF8dhB;AE7dgB;EACI,QAAA;EACA,WAAA;AF+dpB;AE9dgB;EACI,cAAA;EACA,WAAA;AFgepB;AE/dgB;EACI,cAAA;EACA,WAAA;EACA,SAAA;AFiepB;AEheQ;EACI,iBAAA;AFkeZ;AEjeY;EACI,qBAAA;AFmehB;AC7jBQ;ECyFI;IAGQ,aAAA;EFqelB;AACF;AEregB;EACI,qBAAA;AFuepB;AEnegC;EACI,YAAA;AFqepC;AC/jBQ;EC8FgB;IACI,aAAA;EFoe1B;AACF;AEpeoB;EACI,kBAAA;EACA,kBAAA;AFsexB;AEpe4B;EACI,kBAAA;EACA,OAAA;EACA,YAAA;EACA,SAAA;EACA,mBD/EhB;ECgFgB,cAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;EAGA,iBAAA;EAEA,yDAAA;EACA,kBAAA;EAGA,sBAAA;AFsehC;AEregC;EACQ,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,4BDrGxB;ECsGwB,UAAA;AFuexC;AEtegC;EACI,cAAA;AFwepC;AEveoC;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGA,sBAAA;AFyexC;AExewB;EACI,qBAAA;EACA,iBAAA;AF0e5B;AExe4B;EACI,UAAA;EACA,mBAAA;AF0ehC;AEvewC;EACI,gBD1H9B;EC2H8B,cD7H1B;ADsmBlB;AEveoB;EACI,WD9HV;EC+HU,kBAAA;AFyexB;AExeY;EACI,qBAAA;EACA,kBAAA;AF0ehB;ACzoBQ;EC6JI;IAIQ,aAAA;EF4elB;AACF;AE5egB;EACI,kBAAA;EACA,WDvIN;ECwIM,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBD9IJ;AD4nBhB;AE7eoB;EACI,UAAA;EACA,kBAAA;AF+exB;AEjewB;EACI,WAAA;EAEA,yBAAA;AFke5B;AEjeI;EACI,0BAAA;EACA,WAAA;EAEA,0EAAA;EACA,4CAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AFmeR;;AEleA;EACI;IACI,6BAAA;EFqeN;EEpeE;IACI,0BAAA;EFseN;AACF;AEreA;EACI,cAAA;AFueJ;AEteI;EACI,cAAA;AFweR;AEveQ;EACI,6BAAA;EAEA,sBAAA;EACA,WAAA;EACA,iBAAA;AFyeZ;;AEveA;EACI;IAEE,6BAAA;EF0eJ;EExeE;IAEE,0BAAA;EF0eJ;AACF;AGhvBI;EACI,kBAAA;AHkvBR;AGjvBI;EACI,mBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;AHmvBR;AGlvBQ;EACI,wBAAA;AHovBZ;AGnvBQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AHqvBZ;AGpvBY;EACI,YAAA;EACA,iBAAA;AHsvBhB;AGpvBY;EACI,iBAAA;AHsvBhB;AGrvBQ;EACI,YAAA;AHuvBZ;AGtvBY;EACI,iBAAA;AHwvBhB;AGvvBY;EACI,YAAA;AHyvBhB;AGxvBgB;EACI,eAAA;EACA,kBAAA;AH0vBpB;AGxvBwB;EACI,WAAA;EACA,kBAAA;EACA,eAAA;AH0vB5B;AGzvBwB;EACI,kBAAA;EACA,cAAA;AH2vB5B;AG1vB4B;EACI,qBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AH4vBhC;AG3vB4B;EACI,kBAAA;EACA,aAAA;AH6vBhC;AG5vBgC;EACI,cAAA;AH8vBpC;AG5vBoC;EACI,eAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AH8vBxC;AG7vB4B;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AH+vBhC;AG9vBoB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,gBFNV;EEOU,YAAA;AHgwBxB;AG/vBgB;EACI,kBAAA;EACA,eAAA;AHiwBpB;AG/vBwB;EACI,mBAAA;AHiwB5B;AGhwB4B;EACI,WFflB;EEgBkB,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AHkwBhC;AG/vBwB;EACI,qBAAA;EACA,aAAA;AHiwB5B;AGhwB4B;EACG,cAAA;AHkwB/B;AGjwB4B;EACI,WAAA;EACA,YAAA;EACA,gBF9BlB;EE+BkB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AHmwBhC;AGlwBgC;EACI,aFxCpB;AD4yBhB;AGnwBY;EACI,kBAAA;EACA,mBAAA;AHqwBhB;AGpwBgB;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,WFhDN;EEiDM,mBAAA;EACA,yBAAA;EACA,uBAAA;AHswBpB;AGrwBoB;EACQ,UAAA;EACA,mBAAA;EACA,eAAA;AHuwB5B;AGtwBoB;EACQ,UAAA;EACA,mBAAA;EACA,eAAA;AHwwB5B;AGtwBgB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;AHwwBpB;AGvwBgB;EACI,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AHywBpB;AGxwBgB;EACI,qBAAA;EACA,sBAAA;EACA,WF5EN;ADs1Bd;AGzwBgB;EACI,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AH2wBpB;AG1wBY;EACI,gBFpFF;EEqFE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AH4wBhB;AG3wBgB;EACI,mBF9FJ;AD22BhB;AG5wBoB;EACI,WF7FV;AD22Bd;AG7wBgB;EACI,cFjGF;ADg3BlB;;AIj7BI;EACI,iBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,uBAAA;AJo7BR;AIn7BQ;EACI,gCAAA;EACA,QAAA;AJq7BZ;AIp7BQ;EAEI,WAAA;EACA,cAAA;AJq7BZ;AIj7BY;EACI,WAAA;EACA,YAAA;EAEA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;AJm7BhB;AIl7BY;EACI,aAAA;EACA,WAAA;AJo7BhB;;AKj9BA;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;ALo9BJ;AC17BQ;EI9BR;IAMQ,YAAA;ELs9BN;AACF;AKt9BI;EACI,WAAA;EACA,YAAA;ALw9BR;;AKt9BA,8CAAA;AACA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;ALy9BJ;AKx9BI;EACI,mBAAA;AL09BR;AKz9BQ;EACI,aAAA;EACA,cAAA;AL29BZ;AK19BY;EACI,mBAAA;AL49BhB;ACp9BQ;EIZA;IAMQ,cAAA;IACA,eAAA;EL89Bd;AACF;AK99BQ;EACI,uBAAA;ALg+BZ;AK/9BY;EACI,aAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;ALi+BhB;AKh+BI;EACI,aAAA;ALk+BR;ACv+BQ;EIIJ;IAGQ,cAAA;ELo+BV;AACF;AKp+BI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;ALs+BR;AKp+BQ;EACI,mBJqBI;EIpBJ,aAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;ALs+BZ;AKr+BY;EACI,WJgBF;EIfE,eAAA;EACA,kBAAA;ALu+BhB;AKt+BQ;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALw+BZ;AKv+BY;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;ALy+BhB;AKx+BY;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AL0+BhB;AKz+BgB;EACI,WAAA;AL2+BpB;AKz+BQ;EACI,mBAAA;EACA,4BAAA;EACA,8BAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AL2+BZ;ACxiCQ;EIQJ;IAuDQ,aAAA;EL6+BV;AACF;AK7+BQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AL++BZ;AK9+BY;EACI,cJlCA;EImCA,gBAAA;ALg/BhB;AK9+BI;EACI,mBAAA;ALg/BR;AK/+BQ;EACI,eAAA;EACA,WJtCE;EIuCF,oBAAA;ALi/BZ;AC9jCQ;EI0EA;IAKQ,eAAA;ELm/Bd;AACF;AKn/BQ;EACI,cJ9CI;ADmiChB;AKp/BQ;EACI,eAAA;ALs/BZ;;AKp/BA,8CAAA;AAEI;EACI,YAAA;EACA,kBAAA;EACA,uBAAA;ALs/BR;AKr/BQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ALu/BZ;AKt/BQ;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;ALw/BZ;ACvlCQ;EIsFA;IAWQ,kBAAA;EL0/Bd;AACF;AK1/BY;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;AL4/BhB;AC1mCQ;EI2GI;IAKQ,aAAA;EL8/BlB;AACF;AK9/BgB;EACI,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,sBAAA;EAEA,gDAAA;EACA,oBAAA;ALggCpB;ACnnCQ;EIwGQ;IAaQ,gDAAA;ELkgCtB;AACF;ACjoCQ;EIiHQ;IAeQ,sBAAA;ELqgCtB;AACF;AKrgCgB;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;ALugCpB;AC7nCQ;EIkHQ;IAMQ,eAAA;ELygCtB;AACF;ACjpCQ;EIiIQ;IAQQ,eAAA;EL4gCtB;AACF;AK3gCoB;EACI,cJzGR;EI0GQ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AL6gCxB;ACjqCQ;EI2IY;IAWQ,iBAAA;EL+gC1B;AACF;AK7gCY;EAEI,sBAAA;EAEA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,WAAA;AL+gChB;AK9gCY;EAEI,sBAAA;EAEA,yBAAA;EACA,0BAAA;EACA,qBAAA;ALghChB;AK/gCI;EACI,aAAA;ALihCR;AKhhCQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,6BAAA;EACA,yCAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;ALkhCZ;AKjhCY;EACI,oBAAA;EACA,WAAA;ALmhChB;AKlhCY;EACI,UAAA;ALohChB;AKnhCY;EACI,2BAAA;ALqhChB;AKphCQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EAEA,6BAAA;EACA,yCAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;ALshCZ;AKrhCY;EACI,oBAAA;EACA,WAAA;ALuhChB;AKthCY;EACI,UAAA;ALwhChB;AKvhCY;EACI,2BAAA;ALyhChB;AKvhCQ;EACI,SAAA;EACA,UAAA;ALyhCZ;AKxhCQ;EACI,UAAA;EACA,UAAA;AL0hCZ;AKzhCI;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AL2hCR;;AKzhCA,8CAAA;AACA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AL4hCJ;ACvwCQ;EIsOR;IAOQ,aAAA;EL8hCN;AACF;AK9hCI;EACI,kBAAA;ALgiCR;AK/hCQ;EACI,eAAA;ALiiCZ;ACzwCQ;EIyOJ;IAEQ,wBAAA;IACA,kBAAA;IACA,UAAA;ELkiCV;AACF;ACzxCQ;EIkPJ;IAMQ,wBAAA;IACA,kBAAA;IACA,MAAA;ELqiCV;AACF;AKpiCQ;EACI,kBAAA;EAEA,WAAA;EACA,YAAA;EACA,oEAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;ALqiCZ;AKpiCI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;EACA,sBAAA;ALsiCR;ACrxCQ;EIwOJ;IASQ,SAAA;ELwiCV;AACF;ACzyCQ;EIuPJ;IAWQ,SAAA;EL2iCV;AACF;AK3iCQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,SAAA;EACA,WAAA;AL6iCZ;ACxyCQ;EIoPA;IASQ,UAAA;IACA,SAAA;EL+iCd;AACF;AC7zCQ;EImQA;IAYQ,WAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;ELkjCd;AACF;AC30CQ;EIyQA;IAiBQ,UAAA;IACA,WAAA;ELqjCd;AACF;AC11CQ;EIkRA;IAoBQ,WAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;ELwjCd;AACF;AKxjCY;EACI,YAAA;EACA,UAAA;EACA,mBAAA;AL0jChB;ACz0CQ;EI4QI;IAKQ,UAAA;IACA,YAAA;EL4jClB;AACF;AC91CQ;EI2RI;IAQQ,YAAA;IACA,MAAA;EL+jClB;AACF;AC12CQ;EIiSI;IAWQ,YAAA;IACA,WAAA;ELkkClB;AACF;AKlkCY;EACI,YAAA;EACA,mBAAA;ALokChB;AC/1CQ;EIyRI;IAIQ,SAAA;IACA,YAAA;ELskClB;AACF;ACp3CQ;EIwSI;IAOQ,YAAA;IACA,WAAA;ELykClB;AACF;ACh4CQ;EI8SI;IAUQ,UAAA;IACA,WAAA;EL4kClB;AACF;AK5kCY;EACI,UAAA;EACA,UAAA;EACA,mBAAA;AL8kChB;ACt3CQ;EIqSI;IAKQ,UAAA;IACA,UAAA;ELglClB;AACF;AC34CQ;EIoTI;IAQQ,UAAA;IACA,MAAA;ELmlClB;AACF;ACv5CQ;EI0TI;IAWQ,YAAA;IACA,WAAA;ELslClB;AACF;AKtlCY;EACI,UAAA;EACA,mBAAA;ALwlChB;AC54CQ;EIkTI;IAIQ,SAAA;IACA,UAAA;EL0lClB;AACF;ACj6CQ;EIiUI;IAOQ,YAAA;IACA,WAAA;EL6lClB;AACF;AC76CQ;EIuUI;IAUQ,YAAA;IACA,WAAA;ELgmClB;AACF;AKhmCY;EACI,UAAA;EACA,WAAA;EACA,mBAAA;ALkmChB;ACn6CQ;EI8TI;IAKQ,UAAA;IACA,UAAA;ELomClB;AACF;ACx7CQ;EI6UI;IAQQ,UAAA;IACA,MAAA;ELumClB;AACF;ACp8CQ;EImVI;IAWQ,YAAA;IACA,WAAA;EL0mClB;AACF;AK1mCY;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AL4mChB;AK3mCY;EACI,wBAAA;AL6mChB;AK5mCY;EACI,yBAAA;AL8mChB;AK7mCQ;EACI,kBAAA;EACA,kBAAA;AL+mCZ;AC59CQ;EI2WA;IAIQ,yBAAA;IACA,YAAA;ELinCd;AACF;AC3+CQ;EIoXA;IAOQ,eAAA;ELonCd;AACF;AKpnCY;EACI,WAAA;ALsnChB;ACr9CQ;EI8VI;IAGQ,WAAA;IACA,UAAA;ELwnClB;AACF;AC1+CQ;EI6WI;IAMQ,UAAA;IACA,SAAA;EL2nClB;AACF;ACt/CQ;EImXI;IASQ,WAAA;IACA,SAAA;EL8nClB;AACF;AK9nCY;EACI,WAAA;ALgoChB;AC1+CQ;EIyWI;IAGQ,UAAA;IACA,WAAA;ELkoClB;AACF;AC//CQ;EIwXI;IAMQ,UAAA;IACA,SAAA;ELqoClB;AACF;AC3gDQ;EI8XI;IASQ,aAAA;IACA,UAAA;ELwoClB;AACF;AKxoCY;EACI,UAAA;AL0oChB;AC//CQ;EIoXI;IAGQ,aAAA;IACA,UAAA;EL4oClB;AACF;ACphDQ;EImYI;IAMQ,YAAA;IACA,SAAA;EL+oClB;AACF;AChiDQ;EIyYI;IASQ,WAAA;IACA,SAAA;ELkpClB;AACF;AKlpCY;EACI,UAAA;ALopChB;ACphDQ;EI+XI;IAGQ,UAAA;IACA,UAAA;ELspClB;AACF;ACziDQ;EI8YI;IAMQ,YAAA;IACA,SAAA;ELypClB;AACF;ACrjDQ;EIoZI;IASQ,WAAA;IACA,UAAA;EL4pClB;AACF;AK5pCY;EACI,UAAA;EACA,UAAA;AL8pChB;AC1iDQ;EI0YI;IAIQ,UAAA;IACA,UAAA;ELgqClB;AACF;AC/jDQ;EIyZI;IAOQ,UAAA;IACA,SAAA;ELmqClB;AACF;AC3kDQ;EI+ZI;IAUQ,WAAA;IACA,SAAA;ELsqClB;AACF;AKtqCY;EACI,UAAA;ALwqChB;AC/jDQ;EIsZI;IAGQ,UAAA;IACA,UAAA;EL0qClB;AACF;ACplDQ;EIqaI;IAMQ,UAAA;IACA,SAAA;EL6qClB;AACF;AChmDQ;EI2aI;IASQ,WAAA;IACA,UAAA;ELgrClB;AACF;AKhrCQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;ALkrCZ;ACrmDQ;EIgbA;IAKQ,SAAA;ELorCd;AACF;AKprCY;EACI,mBAAA;EACA,oBAAA;ALsrChB;;AKprCA,gEAAA;AACA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EAEA,UAAA;ALsrCJ;AKrrCI;EACI,kBAAA;ALurCR;AKtrCQ;EACI,WJ7aE;EI8aF,eAAA;ALwrCZ;AC7nDQ;EImcA;IAIQ,eAAA;IACA,mBAAA;EL0rCd;AACF;AClpDQ;EIkdA;IAOQ,eAAA;IACA,gBAAA;EL6rCd;AACF;AK7rCI;EACI,uBAAA;AL+rCR;AK9rCQ;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;ALgsCZ;AK/rCI;EACI,kDAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ALisCR;AKhsCQ;EACI,mBAAA;ALksCZ;AKjsCQ;EACI,oDAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALmsCZ;AKlsCY;EACI,WJtdF;EIudE,eAAA;ALosChB;AKlsCY;EACI,cJzdH;AD6pDb;AKnsCgB;EACI,mBJ/dJ;ADoqDhB;;AKnsCA,gEAAA;AACA;EACI,eAAA;ALssCJ;AC5sDQ;EIqgBR;IAGQ,mBAAA;ELwsCN;AACF;AKxsCI;EACI,mBAAA;AL0sCR;AKzsCQ;EACI,eAAA;AL2sCZ;ACxsDQ;EI4fA;IAIQ,eAAA;EL4sCd;AACF;AC5tDQ;EI2gBA;IAMQ,eAAA;EL+sCd;AACF;AK5sCY;EACI,qBAAA;EACA,YAAA;AL8sChB;AK7sCgB;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AL+sCpB;AK5sC4B;EACI,cAAA;AL8sChC;AK7sCQ;EACI,kBAAA;AL+sCZ;AK9sCY;EACI,mBAAA;ALgtChB;AK/sCQ;EACI,kBAAA;EAGA,2BAAA;AL+sCZ;AK9sCY;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ALgtChB;AK/sCY;EACI,kBAAA;EACA,YAAA;ALitChB;AKpsCgB;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;ALssCpB;AKrsCgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ALusCpB;AKtsCoB;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;ALwsCxB;AKvsCwB;EACI,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;ALysC5B;AC3yDQ;EI8lBgB;IAMQ,eAAA;IACA,eAAA;EL2sC9B;AACF;AK3sCwB;EACI,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AL6sC5B;AC7zDQ;EIsmBgB;IAYQ,iBAAA;IACA,eAAA;EL+sC9B;AACF;;AK9sCA,gEAAA;AACA;EACI,kBAAA;EACA,eAAA;ALitCJ;ACz0DQ;EIsnBR;IAKQ,mBAAA;ELktCN;AACF;AKjtCQ;EACI,eAAA;ALmtCZ;AKltCI;EACI,uBAAA;ALotCR;AKntCQ;EACI,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;ALqtCZ;ACr1DQ;EIwnBA;IAUQ,iBAAA;IACA,eAAA;ELutCd;AACF;ACp2DQ;EIioBA;IAaQ,eAAA;IACA,cAAA;EL0tCd;AACF;AC12DQ;EIipBQ;IAGQ,MAAA;EL0tCtB;AACF;AKhtCQ;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,+FAAA;ALktCZ;AKjtCY;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kJAAA;ALmtChB;AKltCgB;EACI,eAAA;EACA,cJ5oBJ;EI6oBI,gBAAA;EACA,qBAAA;ALotCpB;AKntCQ;EACI,UAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kCAAA;ALqtCZ;AKptCQ;EACI,kBAAA;EACA,MAAA;ALstCZ;AKrtCQ;EACI,gBAAA;EACA,eAAA;ALutCZ;ACt4DQ;EI6qBA;IAIQ,eAAA;ELytCd;AACF;;AKztCA;EACI;IACI,oBAAA;EL4tCN;AACF;AK3tCA,gEAAA;AACA;EACI,kBAAA;EACA,eAAA;AL6tCJ;ACr6DQ;EIssBR;IAKQ,eAAA;EL8tCN;AACF;AK9tCI;EACI,mBAAA;EACA,kBAAA;ALguCR;AK/tCQ;EACI,eAAA;ALiuCZ;AKhuCI;EACI,kBAAA;ALkuCR;AKjuCQ;EACI,mBAAA;ALmuCZ;AKjuCY;EACI,aAAA;EACA,cAAA;ALmuChB;ACl7DQ;EI6sBI;IAIQ,cAAA;IACA,iBAAA;ELquClB;AACF;ACj8DQ;EIstBI;IAOQ,WAAA;IACA,cAAA;ELwuClB;AACF;AKxuCQ;EACI,YAAA;EACA,eAAA;AL0uCZ;AC38DQ;EI+tBA;IAIQ,YAAA;IACA,cAAA;EL4uCd;AACF;AK5uCY;EACI,WAAA;EACA,oBAAA;AL8uChB;;AKzsCA,0DAAA;AACA;EAEI,mBAAA;EACA,kBAAA;EACA,eAAA;AL2sCJ;AKzsCI;EACI,mBAAA;AL2sCR;AK1sCQ;EACI,eAAA;EACA,cAAA;AL4sCZ;ACn+DQ;EIqxBA;IAIQ,eAAA;EL8sCd;AACF;AK7sCI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AL+sCR;AC9+DQ;EI2xBJ;IAMQ,SAAA;IACA,gBAAA;ELitCV;AACF;AKjtCI;EACQ,kBAAA;EACA,kBAAA;EACA,wBAAA;ALmtCZ;ACz/DQ;EImyBJ;IAKY,cAAA;IACA,cAAA;IACA,UAAA;ELqtCd;AACF;AChgEQ;EI2yBJ;IAEQ,aAAA;ELutCV;AACF;AKvtCI;EACI,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;ALytCR;AC7gEQ;EI8yBJ;IAQQ,eAAA;EL2tCV;AACF;AK3tCQ;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AL6tCZ;AK3tCQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,qEAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,8BAAA;AL6tCZ;AK3tCQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,qEAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AL6tCZ;ACljEQ;EI40BA;IAWQ,aAAA;EL+tCd;AACF;AK9tCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;ALguCZ;AK7tCY;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AL+tChB;AK7tCY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AL+tChB;AK5tCY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AL8tChB;AK5tCY;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AL8tChB;ACvmEQ;EIg4BI;IAWQ,WAAA;IACA,YAAA;ELguClB;AACF;AK9tCQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;ALguCZ;AK/tCY;EACI,mBAAA;ALiuChB;AKhuCgB;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;ALkuCpB;AKjuCY;EACI,WAAA;EACA,gBAAA;EACA,eAAA;ALmuChB;AKhuCY;EACI,qBAAA;EACA,WAAA;EACA,eAAA;ALkuChB;;AKhuCA;EACI,kBAAA;EACA,gBAAA;ALmuCJ;AKluCI;EACI,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;ALouCR;AKnuCQ;EACI,WAAA;ALquCZ;;AKvoCA;EACI,kBAAA;EACA,eAAA;AL0oCJ;AKzoCI;EACI,uBAAA;AL2oCR;AK1oCQ;EACI,gBAAA;EACA,iBAAA;AL4oCZ;ACvqEQ;EIyhCA;IAIQ,cAAA;IACA,eAAA;EL8oCd;AACF;AK9oCI;EACI,YAAA;ALgpCR;;AK9oCA;EACI,kBAAA;EACA,eAAA;ALipCJ;AKhpCI;EACI,mBAAA;ALkpCR;AKjpCI;EACI,QAAA;ALmpCR;AK/oCY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;ALipChB;AKhpCgB;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6DAAA;ALkpCpB;AC7sEQ;EIkjCQ;IAWQ,sBAAA;ELopCtB;AACF;AKnpCoB;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALqpCxB;AC3tEQ;EI+jCY;IASQ,kBAAA;ELupC1B;AACF;AKvpCwB;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,4CAAA;EACA,mBAAA;EACA,yBAAA;ALypC5B;AC/tEQ;EIgkCgB;IAQQ,eAAA;EL2pC9B;AACF;AC7uEQ;EIykCgB;IAUQ,iBAAA;EL8pC9B;AACF;AK7pCoB;EACI,UAAA;AL+pCxB;AC5uEQ;EI4kCY;IAGQ,OAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;IACA,cAAA;IACA,SAAA;ELiqC1B;EKhqC0B;IACI,aAAA;IACA,YAAA;ELkqC9B;AACF;ACnwEQ;EIqlCY;IAaQ,OAAA;IACA,aAAA;IACA,cAAA;IACA,cAAA;ELqqC1B;AACF;AKpqCoB;EACI,WAAA;EACA,OAAA;ALsqCxB;ACtwEQ;EI8lCY;IAIQ,OAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;IACA,cAAA;IACA,SAAA;IACA,QAAA;ELwqC1B;EKvqC0B;IACI,aAAA;IACA,YAAA;ELyqC9B;AACF;AKzqCgB;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AL2qCpB;ACtyEQ;EIqnCQ;IAQQ,YAAA;EL6qCtB;AACF;AK5qCoB;EACI,iBAAA;AL8qCxB;ACryEQ;EIsnCY;IAGQ,eAAA;IACA,SAAA;IACA,gBAAA;IACA,kBAAA;ELgrC1B;AACF;AK9qCoB;EACI,kBAAA;EACA,eAAA;ALgrCxB;ACjzEQ;EI+nCY;IAIQ,eAAA;IACA,SAAA;IACA,gBAAA;IACA,kBAAA;ELkrC1B;AACF;AKjrCgB;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;ALmrCpB;ACj0EQ;EIwoCQ;IAQQ,aAAA;IACA,QAAA;IACA,cAAA;ELqrCtB;AACF;AKprCoB;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;ALsrCxB;AC90EQ;EIopCY;IAMQ,eAAA;ELwrC1B;AACF;AKxrCoB;EACI,YAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AL0rCxB;ACp2EQ;EIoqCY;IAQQ,wBAAA;IACA,SAAA;IACA,YAAA;IACA,UAAA;EL4rC1B;AACF;AK5rCwB;EACI,WAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;AL8rC5B;AK7rCoB;EACI,eAAA;EACA,kBAAA;AL+rCxB;AK7rCoB;EACI,QAAA;EACA,iBAAA;AL+rCxB;ACt3EQ;EIqrCY;IAIQ,QAAA;ELisC1B;AACF;ACp4EQ;EI8rCY;IAMQ,SAAA;IACA,2BAAA;IACA,QAAA;ELosC1B;AACF;AKpsCwB;EACI,YAAA;ALssC5B;AKnsCoB;EACI,SAAA;EACA,gBAAA;ALqsCxB;ACz4EQ;EIksCY;IAIQ,SAAA;ELusC1B;AACF;AKvsCwB;EACI,WAAA;ALysC5B;AKvsCgB;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WJrrCN;AD83Ed;AC35EQ;EI0sCQ;IAUQ,eAAA;IACA,iBAAA;IACA,kBAAA;EL2sCtB;AACF;ACl6EQ;EI0sCQ;IAcQ,eAAA;EL8sCtB;AACF;AK7sCgB;EACI,cJjsCJ;EIksCI,yBAAA;EACA,iBAAA;EACA,gBAAA;AL+sCpB;AC76EQ;EI0tCQ;IAMQ,eAAA;ELitCtB;AACF;AKjtCgB;EACI,WJrsCN;EIssCM,gBAAA;EACA,eAAA;EACA,gBAAA;ALmtCpB;ACx7EQ;EIiuCQ;IAMQ,eAAA;IACA,iBAAA;IACA,kBAAA;ELqtCtB;AACF;AKrtCgB;EACI,gBAAA;ALutCpB;ACl8EQ;EI0uCQ;IAGQ,gBAAA;ELytCtB;AACF;AKztCoB;EACI,qBAAA;EACA,kBAAA;EACA,yBJvtCR;EIwtCQ,YAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,qhCAAA;EACA,yBAAA;AL2tCxB;AC19EQ;EI8uCY;IAmBQ,UAAA;IACA,iBAAA;IACA,kBAAA;EL6tC1B;AACF;AK7tCwB;EACI,sBAAA;EACA,cJ5uCZ;AD28EhB;;AK9tCA;EACI;IACI,UAAA;IACA,2BAAA;ELiuCN;EKhuCE;IACI,UAAA;IACA,wBAAA;ELkuCN;AACF;AKluCA;EACI,kBAAA;EACA,eAAA;EACA,uBAAA;ALouCJ;AKnuCI;EACI,qBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,SAAA;ALquCR;AKpuCQ;EACI,mBJpwCI;EIqwCJ,WAAA;ALsuCZ;;AKruCA;EACE,wCAAA;EACA,sBAAA;ALwuCF;;AKruCI;EACI,iBAAA;EACA,wBAAA;EACA,qBAAA;ALwuCR;AKruCQ;EACI,qBAAA;EACA,wBAAA;EACA,qBAAA;ALuuCZ;AKruCI;EACI,uBAAA;EACA,sBAAA;EACA,qBAAA;ALuuCR;AKruCI;EACI,mBAAA;EACA,sBAAA;EACA,qBAAA;ALuuCR;AKruCI;EACI,mBAAA;EACA,sBAAA;EACA,qBAAA;ALuuCR;;AKtuCA;EACI;IACI,4BAAA;ELyuCN;EKvuCE;IACI,2BAAA;ELyuCN;EKvuCE;IACI,4BAAA;ELyuCN;AACF;AKxuCA;EACI;IACI,mDAAA;EL0uCN;EKxuCE;IACI,oDAAA;EL0uCN;EKxuCE;IACI,mDAAA;EL0uCN;AACF;AKxuCA;EACI,eAAA;EACA,mBAAA;AL0uCJ;AKzuCI;EACI,mBAAA;EACA,uBAAA;AL2uCR;AC5kFQ;EI+1CJ;IAIQ,uBAAA;EL6uCV;AACF;AK7uCQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;AL+uCZ;ACtlFQ;EIo2CA;IAKQ,aAAA;IACA,cAAA;IACA,mBAAA;ELivCd;AACF;AKhvCgB;EACI,YAAA;ALkvCpB;AKhvCQ;EACI,YAAA;EACA,cAAA;ALkvCZ;ACpmFQ;EIg3CA;IAIQ,YAAA;ELovCd;AACF;;AKhvCA;;EAEI,eAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;ALmvCJ;AC5nFQ;EIy3CR;;IAkBQ,cAAA;IACA,kBAAA;ELsvCN;AACF;AKtvCI;;EACI,gCAAA;EACA,QAAA;EACA,mBAAA;ALyvCR;AKxvCI;;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AL2vCR;AK1vCQ;;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,wBAAA;AL6vCZ;AK5vCQ;;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;AL+vCZ;AK9vCI;;EACI,cAAA;ALiwCR;AKhwCQ;;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;ALmwCZ;AKlwCY;;EACI,eAAA;EACA,gBAAA;EACA,cAAA;ALqwChB;AKpwCQ;;EACI,kBAAA;ALuwCZ;AKtwCQ;;EACI,eAAA;EACA,mBAAA;EACA,WJr5CE;AD8pFd;ACpsFQ;EIw7CA;;IAKQ,gBAAA;EL4wCd;AACF;AK1wCgB;;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AL6wCpB;AK5wCoB;;EACI,eAAA;AL+wCxB;AK9wCY;;EACI,cJp6CA;EIq6CA,mBAAA;EACA,eAAA;ALixChB;;AK/wCA;EACI,mBAAA;EACA,kBAAA;ALkxCJ;AKjxCI;EACI,mBAAA;ALmxCR;AKlxCQ;EACI,aAAA;EACA,cAAA;ALoxCZ;ACtuFQ;EIg9CA;IAIQ,cAAA;IACA,eAAA;ELsxCd;AACF;AKrxCQ;EACI,cJr7CI;EIs7CJ,mBAAA;ALuxCZ;AKrxCQ;EACI,cJx7CM;AD+sFlB;AKtxCY;EACI,mBJ37CA;ADmtFhB;AKtxCQ;EACI,aAAA;ALwxCZ;AKvxCI;EACI,qBAAA;EACA,gBAAA;EACA,WAAA;ALyxCR;AKxxCQ;EACI,iBAAA;EACA,mBAAA;EACA,mBJt8CI;EIu8CJ,WAAA;EACA,qBAAA;EACA,cAAA;AL0xCZ;;AKtxCA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;ALyxCJ;AKxxCI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AL0xCR;AKzxCI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AL2xCR;AK1xCQ;EACI,mBAAA;EACA,WJv+CE;EIw+CF,kBAAA;AL4xCZ;AK3xCQ;EACI,kBAAA;EACA,mBAAA;AL6xCZ;AK5xCY;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,WJn/CF;EIo/CE,mBAAA;EACA,yBAAA;EACA,uBAAA;AL8xChB;AK7xCgB;EACQ,UAAA;EACA,mBAAA;EACA,eAAA;AL+xCxB;AK9xCgB;EACQ,UAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;ALgyCxB;AK/xCY;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;ALiyChB;AKhyCY;EACI,UAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;ALkyChB;AKhyCQ;EACI,gBJ9gDE;EI+gDF,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;ALkyCZ;AKjyCY;EACI,mBJxhDA;AD2zFhB;AKlyCgB;EACI,WJvhDN;AD2zFd;AKnyCY;EACI,cJ3hDE;ADg0FlB;;AMl4FA;EAEI,eAAA;ANo4FJ;ACx2FQ;EK9BR;IAIQ,eAAA;ENs4FN;AACF;AMt4FI;EACI,mBAAA;ANw4FR;AMv4FQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;ANy4FZ;ACr3FQ;EKvBA;IAKQ,cAAA;IACA,eAAA;IACA,UAAA;EN24Fd;AACF;AM34FY;EACI,kBAAA;AN64FhB;AC/3FQ;EKfI;IAGQ,UAAA;EN+4FlB;AACF;AM/4FY;EACI,kBAAA;ANi5FhB;AMh5FI;EACI,eAAA;EACA,mBAAA;ANk5FR;AC34FQ;EKTJ;IAIQ,eAAA;ENo5FV;AACF;AMp5FI;EACI,eAAA;ANs5FR;ACn5FQ;EKJJ;IAGQ,eAAA;ENw5FV;AACF;AMx5FI;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cL+BQ;EK9BR,0BAAA;AN05FR;AC/5FQ;EKMJ;IAEQ,YAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;EN25FV;AACF;AM35FI;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;AN65FR;AM55FQ;EACI,mBLkBI;EKjBJ,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AN85FZ;AM75FI;EACI,YAAA;AN+5FR;;AM75FA;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;ANg6FJ;AM/5FI;EACI,mBAAA;ANi6FR;AMh6FI;EACI,mBAAA;EACA,cAAA;ANk6FR;AMh6FI;EACI,mBAAA;ANk6FR;ACx8FQ;EKwCI;IAEQ,8BAAA;ENk6FlB;AACF;AC78FQ;EK4CI;IAEQ,cAAA;IACA,eAAA;IACA,kBAAA;ENm6FlB;AACF;AMn6FQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;ANq6FZ;AMp6FY;EACI,8BAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;ANs6FhB;ACp+FQ;EKqDI;IAWQ,aAAA;ENw6FlB;AACF;AMx6FgB;EACI,WAAA;AN06FpB;AC5+FQ;EKmEI;IAEQ,eAAA;IACA,gBAAA;EN26FlB;AACF;AM36FQ;EACI,YAAA;AN66FZ;ACr/FQ;EKuEA;IAGQ,uBAAA;EN+6Fd;AACF;AM/6FQ;EACI,kBAAA;ANi7FZ;AC7/FQ;EK2EA;IAGQ,gBAAA;IACA,kBAAA;IACA,mBAAA;ENm7Fd;AACF;;AMl7FA;EACI,eAAA;EACA,mBAAA;ANq7FJ;AMl7FQ;EACI,aAAA;EACA,cAAA;ANo7FZ;AC7gGQ;EKuFA;IAMQ,cAAA;IACA,eAAA;IACA,mBAAA;ENo7Fd;AACF;AMp7FI;EACI,mBAAA;ANs7FR;AMr7FI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,mDAAA;ANu7FR;AC/hGQ;EKkGJ;IAQQ,eAAA;ENy7FV;AACF;AMz7FQ;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WLzEE;ADogGd;AM17FQ;EACI,kBAAA;EACA,WL5EE;ADwgGd;;AM17FA;EACI,mBAAA;EACA,eAAA;EACA,oBAAA;AN67FJ;AM57FI;EACI,mBAAA;AN87FR;AM57FQ;EACI,aAAA;EACA,cAAA;AN87FZ;AC3jGQ;EK2HA;IAIQ,cAAA;IACA,eAAA;IACA,mBAAA;ENg8Fd;AACF;AMh8FI;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mDAAA;ANk8FR;ACzkGQ;EKkIJ;IAOQ,eAAA;IACA,mBAAA;ENo8FV;AACF;AMp8FQ;EACI,aAAA;EACA,4BAAA;EACA,iBAAA;EACA,qBAAA;ANs8FZ;AMr8FY;EACI,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;ANu8FhB;AC/lGQ;EKgJI;IAUQ,eAAA;ENy8FlB;AACF;AMz8FY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cLxHH;EKyHG,aAAA;AN28FhB;AM18FgB;EACI,iBAAA;EACA,WL7HN;ADykGd;AM38FgB;EACI,iBAAA;EACA,cL/HP;AD4kGb;AM58FgB;EACI,eAAA;EACA,gBAAA;EACA,cLnIP;ADilGb;AM78FY;EACI,gBAAA;EACA,kBAAA;EACA,cLvIH;EKwIG,aAAA;AN+8FhB;AM98FY;EACI,mBAAA;EACA,WL5IF;AD4lGd;AM/8FQ;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;ANi9FZ;AC1oGQ;EKmLA;IAQQ,kBAAA;ENm9Fd;AACF;AMn9FY;EACI,mBL1JA;EK2JA,iBAAA;EACA,cAAA;EACA,mBAAA;ANq9FhB;AMp9FQ;EACI,aAAA;EACA,cAAA;ANs9FZ;AMr9FY;EACI,cAAA;ANu9FhB;AMt9FgB;EACI,mBLpKJ;AD4nGhB;AMt9FgB;EACI,cAAA;EACA,cLxKJ;EKyKI,eAAA;EACA,gBAAA;EACA,gBAAA;ANw9FpB;;AMt9FA;EACI,kBAAA;EACA,iFAAA;EACA,eAAA;ANy9FJ;AMx9FI;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,YAAA;AN09FR;AMz9FI;EACI,aAAA;EACA,qBAAA;EACA,sBAAA;AN29FR;AMx9FgB;EACI,eAAA;EACA,eAAA;EACA,mBAAA;AN09FpB;AC/rGQ;EKkOQ;IAKQ,gBAAA;IACA,eAAA;EN49FtB;AACF;AM59FoB;EACI,aAAA;AN89FxB;AM79FY;EACI,kBAAA;AN+9FhB;AM99FgB;EACI,gBAAA;EACA,gBLzMN;EK0MM,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ANg+FpB;;AM99FA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;EACA,sBAAA;ANi+FJ;AC7tGQ;EKqPR;IASQ,WAAA;ENm+FN;AACF;AMn+FI;EACI,gCAAA;EACA,QAAA;ANq+FR;AMn+FQ;EACI,aAAA;EACA,cAAA;ANq+FZ;AC1uGQ;EKmQA;IAIQ,eAAA;IACA,cAAA;ENu+Fd;AACF;AChvGQ;EKyQI;IAEQ,aAAA;ENy+FlB;AACF;AMz+FI;EACI,cAAA;AN2+FR;AM1+FQ;EACI,aAAA;EACA,iBAAA;AN4+FZ;AM3+FI;EACI,aAAA;AN6+FR;AM1+FgB;EACI,eAAA;EACA,gBAAA;AN4+FpB;AM3+FY;EACI,kBAAA;EACA,gBAAA;AN6+FhB;AM5+FgB;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,cL3PP;EK4PO,mBAAA;EACA,yBAAA;AN8+FpB;AM7+FoB;EACI,UAAA;EACA,mBAAA;EACA,eAAA;AN++FxB;AM9+FoB;EACI,UAAA;EACA,mBAAA;EACA,eAAA;ANg/FxB;AM3+FgB;EACI,UAAA;AN6+FpB;AM3+FgB;EACI,kBAAA;EACA,cL/QP;EKgRO,UAAA;EACA,SAAA;EACA,sBAAA;AN6+FpB;AM5+FY;EACI,gBLrRF;EKsRE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,mBL/RA;AD6wGhB;AM7+FgB;EACI,WAAA;AN++FpB;;AM9+FA;EACI,YAAA;EACA,cAAA;EACA,gBAAA;ANi/FJ;;AM/+FA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;ANk/FJ;AMj/FI;EACI,gCAAA;EACA,QAAA;ANm/FR;AMl/FI;EACI,aAAA;ANo/FR;AMn/FQ;EACI,mBAAA;ANq/FZ;AMp/FQ;EACI,iBAAA;EACA,gBAAA;ANs/FZ;AMr/FQ;EACI,sBAAA;ANu/FZ;AMt/FQ;EACI,WAAA;EACA,yBAAA;ANw/FZ;AMr/FY;EACI,mBLlUA;EKmUA,WLhUF;EKiUE,kBAAA;ANu/FhB;AMt/FY;EACI,aAAA;ANw/FhB;AMv/FY;EACI,iBAAA;EACA,gBAAA;EACA,WAAA;ANy/FhB;;AMv/FA;EACI,kBAAA;EACA,eAAA;AN0/FJ;AMz/FI;EACI,mBAAA;AN2/FR;AM1/FQ;EACI,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AN4/FZ;AM3/FI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;AN6/FR;AM5/FQ;EACI,eAAA;EACA,cLhWI;EKiWJ,gBAAA;AN8/FZ;AM7/FQ;EACI,eAAA;AN+/FZ;AM7/FY;EACI,cLlWH;EKmWG,eAAA;EACA,gBAAA;AN+/FhB;AM9/FgB;EACI,mBL1WJ;AD02GhB;AM//FI;EACI,aAAA;EACA,cAAA;ANigGR;AMhgGQ;EACI,cL/WI;EKgXJ,eAAA;EACA,gBAAA;ANkgGZ;AMjgGQ;EACI,eAAA;EACA,kBAAA;ANmgGZ;AMlgGI;EACI,WAAA;EACA,aAAA;ANogGR;;AM//FA;EACI,eAAA;EACA,mBAAA;ANkgGJ;ACn6GQ;EK+ZR;IAIQ,kBAAA;ENogGN;AACF;AMpgGI;EACI,UAAA;EACA,eAAA;EACA,cAAA;ANsgGR;AC76GQ;EKoaJ;IAKQ,WAAA;ENwgGV;AACF;AMxgGQ;EACI,SAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AN0gGZ;AMxgGQ;EACI,mBLlZI;EKmZJ,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,4BAAA;AN0gGZ;AMzgGY;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EAEA,WL5ZF;EK+ZE,eAAA;ANwgGhB;AMtgGgB;EACI,oBAAA;EACA,eAAA;ANwgGpB;AMtgGQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;ANwgGZ;AC79GQ;EK2cA;IAYQ,YAAA;EN0gGd;AACF;AM1gGY;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AN4gGhB;ACz+GQ;EKwdI;IAOQ,gBAAA;EN8gGlB;AACF;AM9gGgB;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,mBLpcJ;EKqcI,gBAAA;EACA,WAAA;ANghGpB;AM3gGgB;EACI,WAAA;AN6gGpB;;AOzhHA;EACI,kBAAA;EACA,gBAAA;AP4hHJ;AO3hHI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,OAAA;EACA,oBAAA;EACA,oDAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;AP6hHR;AO5hHQ;EACI,UAAA;EACA,WAAA;AP8hHZ;;AO5hHA;EACI,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AP+hHJ;AO9hHI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,sBAAA;EACA,+DApCD;EAqCC,4BAAA;EACA,wBAAA;APgiHR;AC3iHQ;EMDJ;IAcQ,YAAA;IACA,aAAA;EPkiHV;AACF;AOjiHI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;EACA,0CAAA;APmiHR;AC7jHQ;EMgBJ;IAYQ,WAAA;IACA,YAAA;IACA,sBAAA;IACA,qBAAA;EPqiHV;AACF;AOpiHQ;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,+DAtEL;EAuEK,4BAAA;EACA,wBAAA;APsiHZ;ACnlHQ;EMiCA;IAcQ,YAAA;IACA,aAAA;EPwiHd;AACF;AOxiHI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,0CAAA;EACA,UAAA;AP0iHR;ACpmHQ;EMiDJ;IAWQ,WAAA;IACA,YAAA;IACA,sBAAA;IACA,qBAAA;EP4iHV;AACF;AO5iHQ;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,+DArGL;EAsGK,4BAAA;EACA,wBAAA;AP8iHZ;AC1nHQ;EMgEA;IAcQ,YAAA;IACA,aAAA;EPgjHd;AACF;AOhjHI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,oCAAA;APkjHR;AOjjHQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;APmjHZ;AOljHI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WN/DM;EMgEN,mBAAA;EACA,qBAAA;EACA,oCAAA;APojHR;AC/pHQ;EMkGJ;IAWQ,cAAA;IACA,gBAAA;IACA,iBAAA;EPsjHV;AACF;AOrjHI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;APujHR;AOtjHQ;EACI,YAAA;EACA,uBAAA;EACA,cNnFI;EMoFJ,eAAA;EACA,oCAAA;APwjHZ;AOtjHQ;EACI,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;APwjHZ;;AOtjHA;EACI;IACI,sDAAA;EPyjHN;EOvjHE;IACI,wDAAA;EPyjHN;AACF;AOvjHA;EACI,WAAA;EACA,2BAAA;EACA,mBAAA;APyjHJ;ACrsHQ;EMyIR;IAKQ,YAAA;IACA,eAAA;EP2jHN;AACF;AO3jHI;EACI,WAAA;EACA,YAAA;AP6jHR;;AO1jHA;EACI,eAAA;EACA,kBAAA;AP6jHJ;AO5jHI;EACI,oBAAA;AP8jHR;ACxsHQ;EM2IJ;IAEQ,uBAAA;EP+jHV;AACF;AO/jHQ;EACI,aAAA;EACA,cAAA;EACA,uDAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kCAAA;APikHZ;ACxtHQ;EM8IA;IAWQ,aAAA;IACA,cAAA;IACA,oBAAA;EPmkHd;AACF;AC9uHQ;EM6JA;IAeQ,cAAA;IACA,eAAA;IACA,cAAA;IACA,mBAAA;EPskHd;EOrkHc;IACI,gBAAA;EPukHlB;AACF;AOrkHQ;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;APukHZ;AOtkHI;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,sEAAA;APwkHR;AOvkHQ;EACI,WN5JE;EM6JF,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBNtKI;EMuKJ,cAAA;EACA,kBAAA;EACA,SAAA;APykHZ;ACrxHQ;EMiMA;IAaQ,SAAA;EP2kHd;AACF;;AOzkHA;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;AP4kHJ;AO1kHQ;EACI,WNjLE;AD6vHd;AO1kHQ;EACI,aAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AP4kHZ;AChyHQ;EMgNA;IAMQ,aAAA;IACA,cAAA;EP8kHd;AACF;AC/yHQ;EMyNA;IASQ,cAAA;IACA,eAAA;IAEA,mBAAA;EPglHd;AACF;AO/kHI;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EAKA,8BAAA;EACA,UAAA;EACA,eAAA;APilHR;AOhlHQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,yBNzNI;EM0NJ,0BAAA;EAKA,8BAAA;EACA,WAAA;APklHZ;AOhlHY;EACI,YAAA;EACA,YAAA;EACA,kBAAA;APklHhB;AOjlHY;EACI,UAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;APmlHhB;AOllHY;EACI,WNzOF;EM0OE,gBAAA;APolHhB;AOnlHY;EACI,mBN/OA;EMgPA,yBAAA;APqlHhB;AOplHgB;EACI,aAAA;APslHpB;AOrlHoB;EACI,cAAA;APulHxB;AOrlHQ;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EAKA,8BAAA;APulHZ;AOtlHQ;EACI,kBAAA;APwlHZ;AOvlHQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,8BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;APylHZ;AOxlHY;EACI,aAAA;AP0lHhB;;AO9kHI;EACI,gBNnSM;ADo3Hd;AOhlHQ;EACI,cAAA;APklHZ;AOhlHY;EACI,cAAA;APklHhB;;AO/kHA;EACI,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;APklHJ;ACz4HQ;EMmTR;IAMQ,aAAA;EPolHN;AACF;AC75HQ;EMkUR;IAQQ,YAAA;EPulHN;AACF;ACx6HQ;EMwUR;IAUQ,YAAA;EP0lHN;AACF;ACt7HQ;EMiVR;IAYQ,YAAA;EP6lHN;AACF;AO7lHI;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AP+lHR;ACl7HQ;EM+UJ;IAMQ,iBAAA;EPimHV;AACF;ACt8HQ;EM8VJ;IAQQ,cAAA;IACA,SAAA;EPomHV;AACF;AOpmHQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,iDAAA;APsmHZ;ACn9HQ;EMwWA;IAOQ,eAAA;IACA,wBAAA;IACA,gBAAA;EPwmHd;AACF;AOxmHY;EACI,4BAAA;AP0mHhB;AOzmHY;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,iDAAA;EACA,aAAA;AP2mHhB;ACv+HQ;EMoXI;IAUQ,gBAAA;IACA,mBAAA;IACA,yBAAA;IACA,mBAAA;EP6mHlB;AACF;AO7mHgB;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AP+mHpB;AO9mHgB;EACI,yDAAA;EACA,0CAAA;APgnHpB;AC1/HQ;EMwYQ;IAIQ,eAAA;EPknHtB;AACF;AOlnHgB;EACI,yDAAA;EACA,2CAAA;APonHpB;ACngIQ;EM6YQ;IAIQ,eAAA;EPsnHtB;AACF;AOtnHgB;EACI,yDAAA;EACA,2CAAA;APwnHpB;AC5gIQ;EMkZQ;IAIQ,eAAA;EP0nHtB;AACF;AO1nHgB;EACI,yDAAA;EACA,4CAAA;AP4nHpB;ACrhIQ;EMuZQ;IAIQ,eAAA;EP8nHtB;AACF;AO9nHgB;EACI,yDAAA;EACA,4CAAA;APgoHpB;AC9hIQ;EM4ZQ;IAIQ,eAAA;EPkoHtB;AACF;AOloHgB;EACI,yDAAA;EACA,4CAAA;APooHpB;ACviIQ;EMiaQ;IAIQ,eAAA;EPsoHtB;AACF;AOtoHgB;EACI,yDAAA;EACA,4CAAA;APwoHpB;AChjIQ;EMsaQ;IAIQ,eAAA;EP0oHtB;AACF;AO1oHgB;EACI,0DAAA;EACA,4CAAA;AP4oHpB;ACzjIQ;EM2aQ;IAIQ,eAAA;EP8oHtB;AACF;AO9oHgB;EACI,0DAAA;EACA,4CAAA;APgpHpB;AClkIQ;EMgbQ;IAIQ,eAAA;EPkpHtB;AACF;;AOjpHA;EACI;IACI,0BAAA;EPopHN;EOlpHE;IACI,2BAAA;EPopHN;AACF;AOlpHA;EACI,yBAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;APopHJ;AOnpHI;EACI,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,MAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WNtaM;EMuaN,gBAAA;EACA,wCAAA;APqpHR;AOppHI;EACI,WN1aM;EM2aN,gBAAA;APspHR;;AOppHA;EACI,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;APupHJ;AOtpHI;EACI,WNnbM;EMobN,eAAA;APwpHR;AOvpHI;EACI,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;APypHR;AOxpHI;EACI,UAAA;EACA,kBAAA;AP0pHR;AOzpHI;EACI,eAAA;EACA,kBAAA;AP2pHR;AOzpHQ;EACI,WNncE;AD8lId;AO1pHQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AP4pHZ;AO3pHQ;EACI,gBAAA;EACA,UAAA;AP6pHZ;AO5pHI;EACI,WAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AP8pHR;AO7pHQ;EACI,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iIAAA;AP+pHZ;AO9pHQ;EAKI,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kIAAA;AP4pHZ;AO3pHQ;EACI,WAAA;EACA,YAAA;AP6pHZ;AO5pHI;EACI,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AP8pHR;;AO5pHA;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AP+pHJ;AO9pHI;EACI,SAAA;EACA,UAAA;APgqHR;AO/pHI;EACI,mBAAA;APiqHR;AOhqHQ;EACI,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,MAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WNngBE;EMogBF,gBAAA;EACA,wCAAA;APkqHZ;AOjqHQ;EACI,WNvgBE;AD0qId;AOjqHQ;EACI,aAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kFAAA;EACA,WAAA;APmqHZ;AOlqHY;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;APoqHhB;AOnqHY;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;APqqHhB;AOpqHgB;EACI,aAAA;APsqHpB;AOjpHQ;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;APkpHZ;AOhpHY;EACI,cAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,0CAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,UAAA;EACA,aAAA;APkpHhB;AOjpHgB;EACI,6CAAA;EACA,+BAAA;APmpHpB;AOlpHgB;EACI,6CAAA;EACA,+BAAA;APopHpB;AOnpHgB;EACI,6CAAA;EACA,+BAAA;APqpHpB;AOppHgB;EACI,6CAAA;EACA,+BAAA;APspHpB;;AOnpHA;EACI;IACI,6EAAA;EPspHN;EOrpHE;IACI,8CAAA;EPupHN;AACF;AOtpHA;EACI;IACI,2BAAA;EPwpHN;EOtpHE;IACI,2BAAA;IACA,UAAA;EPwpHN;EOvpHE;IACI,UAAA;EPypHN;AACF;AOxpHA;EACI;IACI,2BAAA;IACA,UAAA;EP0pHN;EOzpHE;IACI,wBAAA;IACA,UAAA;EP2pHN;EO1pHE;IACI,UAAA;EP4pHN;AACF;AO3pHA;EACI;IACI,wBAAA;IACA,UAAA;EP6pHN;EO5pHE;IACI,4BAAA;IACA,UAAA;EP8pHN;EO7pHE;IACI,UAAA;EP+pHN;AACF;AO9pHA;EACI;IACI,4BAAA;IACA,UAAA;EPgqHN;EO/pHE;IACI,4BAAA;IACA,UAAA;EPiqHN;EOhqHE;IACI,4BAAA;IACA,UAAA;EPkqHN;AACF;AQ92IA;EACI,WAAA;EACA,kBAAA;ARg3IJ;AQ/2II;EACI,2BAAA;ARi3IR;AQh3IQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ARk3IZ;AQj3II;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;ARm3IR;AQl3IQ;EACI,WPmDE;EOlDF,eAAA;ARo3IZ;AQn3IQ;EACI,gBAAA;ARq3IZ;AQp3IY;EACI,eAAA;ARs3IhB;;AQl3IA;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;ARq3IJ;AQn3IQ;EACI,eAAA;ARq3IZ;ACv3IQ;EOCA;IAGQ,eAAA;ERu3Id;AACF;AQv3II;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;ARy3IR;AQx3IQ;EACI,kBAAA;EACA,WAAA;EACA,mBPuBI;EOtBJ,UAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,MAAA;EACA,SAAA;EACA,sCAAA;AR03IZ;AC74IQ;EOSA;IAYQ,UAAA;ER43Id;AACF;AQ33IQ;EACI,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,sCAAA;EACA,UAAA;EACA,UAAA;AR63IZ;AC15IQ;EOuBA;IAQQ,WAAA;IACA,kBAAA;IACA,mBAAA;ER+3Id;AACF;AQ/3IY;EACI,mBAAA;ARi4IhB;AQh4IY;EACI,mBAAA;ARk4IhB;AQj4IY;EACI,mBAAA;ARm4IhB;AQl4IY;EACI,mBAAA;ARo4IhB;AQn4IY;EACI,mBAAA;ARq4IhB;AQp4IY;EACI,mBAAA;ARs4IhB;AQr4IY;EACI,mBAAA;ARu4IhB;AQr4IY;EACI,kBAAA;EACA,gBPbF;EOcE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;ARu4IhB;AC97IQ;EOiDI;IAQQ,YAAA;ERy4IlB;AACF;AQz4IgB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,4BAAA;EACA,YAAA;AR24IpB;AC58IQ;EO0DQ;IASQ,yBAAA;IACA,WAAA;ER64ItB;AACF;AQ74IgB;EACI,eAAA;AR+4IpB;ACr9IQ;EOqEQ;IAGQ,eAAA;ERi5ItB;AACF;AQj5IY;EACI,OAAA;ARm5IhB;AQl5IY;EACI,SAAA;ARo5IhB;ACh+IQ;EO2EI;IAGQ,OAAA;ERs5IlB;AACF;AQr5IoB;EACI,yBAAA;EACA,WAAA;ARu5IxB;AQt5IgB;EACI,WAAA;ARw5IpB;AC5+IQ;EOmFQ;IAGQ,UAAA;ER05ItB;AACF;AQ15IQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gBP5DE;ADw9Id;AC9/IQ;EOuFA;IAaQ,UAAA;ER85Id;AACF;;AQ75IA;EACI;IACI,UAAA;ERg6IN;EQ/5IE;IACI,YAAA;ERi6IN;AACF;AQj6IA;EACI;IACG,UAAA;IACA,4BAAA;ERm6IL;EQl6IE;IACG,UAAA;IACA,0BAAA;ERo6IL;AACF;AQl6IA;EACI,mBAAA;ARo6IJ;;AQn6IA;EACI,aAAA;ARs6IJ;AQr6II;EACI,YAAA;EACA,WAAA;ARu6IR;;AQn6IA;EACI,eAAA;EACA,kBAAA;ARs6IJ;AQp6IQ;EACI,eAAA;ARs6IZ;ACziJQ;EOkIA;IAGQ,eAAA;ERw6Id;AACF;AQv6IQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;ARy6IZ;ACrjJQ;EOuIA;IAOQ,cAAA;IACA,eAAA;ER26Id;AACF;AQ16II;EACI,cAAA;AR46IR;AQ36IQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,4BAAA;EACA,iEAAA;AR66IZ;AQ56IQ;EACI,mBAAA;AR86IZ;AQ76II;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AR+6IR;AQ96IQ;EACI,WP/HE;AD+iJd;;AQ56IA;EACI,kBAAA;AR+6IJ;AQ96II;EACI,kBAAA;EACA,cAAA;ARg7IR;AQ/6IQ;EACI,WAAA;ARi7IZ;AQh7II;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;ARk7IR;AQj7IQ;EACI,mBAAA;EACA,WPjJE;EOkJF,eAAA;ARm7IZ;AQl7IQ;EACI,eAAA;ARo7IZ;;AS5oJA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AT+oJJ;AS9oJI;EACI,WAAA;EACA,YAAA;ATgpJR;;AS7oJA;EACI,kBAAA;EACA,eAAA;ATgpJJ;AS/oJI;EACI,mBAAA;ATipJR;AShpJQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;ATkpJZ;ACroJQ;EQhBA;IAKQ,cAAA;IACA,eAAA;IACA,UAAA;IACA,mBAAA;ETopJd;AACF;ASppJQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;ATspJZ;AClpJQ;EQPA;IAKQ,cAAA;IACA,eAAA;IACA,UAAA;ETwpJd;AACF;ASvpJQ;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ATypJZ;AC/pJQ;EQEA;IAMQ,eAAA;ET2pJd;AACF;AS3pJQ;EACI,cAAA;AT6pJZ;ACvqJQ;EQSA;IAGQ,eAAA;ET+pJd;AACF;AS/pJI;EACI,cAAA;EACA,kBAAA;ATiqJR;AShqJQ;EACI,YAAA;EACA,mBAAA;ATkqJZ;;AS/pJA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;ATkqJJ;ASjqJI;EACI,gBAAA;ATmqJR;ASlqJI;EACI,mBAAA;AToqJR;ASlqJQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AToqJZ;ASnqJY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;ATqqJhB;ASpqJI;EACI,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,uCAAA;ATsqJR;ACztJQ;EQuCJ;IAcQ,YAAA;IACA,aAAA;IACA,yBAAA;IACA,uCAAA;IACA,aAAA;IACA,eAAA;ETwqJV;AACF;;AStqJA;EACI,kBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kFAAA;ATyqJJ;AC1uJQ;EQ6DR;IAMQ,YAAA;IACA,oBAAA;ET2qJN;AACF;AS3qJI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AT6qJR;AS5qJI;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AT8qJR;AS7qJQ;EACI,WR7CE;EQ8CF,mBAAA;EACA,eAAA;AT+qJZ;ACpwJQ;EQkFA;IAKQ,eAAA;ETirJd;AACF;ASjrJQ;EACI,UAAA;ATmrJZ;ASlrJY;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;ATorJhB;ASlrJgB;EACI,mBR7DJ;ADivJhB;;ASjrJA;EACI,eAAA;EACA,kBAAA;ATorJJ;ASnrJI;EACI,mBAAA;ATqrJR;ASprJQ;EACI,eAAA;ATsrJZ;ASprJQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;ATsrJZ;ACxyJQ;EQ2GA;IASQ,cAAA;IACA,eAAA;ETwrJd;AACF;ASxrJI;EACI,eAAA;EACA,cRrFQ;EQsFR,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AT0rJR;ASzrJI;EACI,gBAAA;AT2rJR;AS1rJQ;EACI,WR1FE;ADsxJd;;AU11JA;EACI,eAAA;EACA,kBAAA;AV61JJ;AU31JQ;EACI,eAAA;AV61JZ;ACp0JQ;ES1BA;IAGQ,eAAA;EV+1Jd;AACF;ACz0JQ;EStBJ;IAEQ,uBAAA;EVi2JV;AACF;AUj2JQ;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AVm2JZ;ACr1JQ;ESnBA;IAOQ,aAAA;IACA,cAAA;EVq2Jd;AACF;AUp2JI;EACI,6CAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AVs2JR;AUr2JQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,yBT+BI;ES9BJ,SAAA;EACA,0BAAA;AVu2JZ;AUt2JQ;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,8GAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVw2JZ;AUv2JY;EACI,WAAA;AVy2JhB;AUx2JI;EACI,gBAAA;EACA,cAAA;AV02JR;;AUt2JA;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;AVy2JJ;AUv2JQ;EACI,WTCE;ESAF,eAAA;AVy2JZ;AUx2JI;EACI,mBAAA;AV02JR;AUz2JQ;EACI,aAAA;EACA,cAAA;AV22JZ;ACt5JQ;ESyCA;IAIQ,cAAA;IACA,eAAA;EV62Jd;AACF;AU72JQ;EACI,aAAA;EACA,cAAA;AV+2JZ;ACh6JQ;ES+CA;IAIQ,cAAA;IACA,eAAA;EVi3Jd;AACF;AUj3JI;EACI,YAAA;EACA,cAAA;AVm3JR;AC16JQ;ESqDJ;IAIQ,WAAA;IACA,mBAAA;EVq3JV;AACF;AUr3JQ;EACI,WAAA;EACA,mBAAA;AVu3JZ;AUt3JI;EACI,eAAA;AVw3JR;AUv3JQ;EACI,kBAAA;AVy3JZ;AUx3JY;EACI,mBThCA;AD05JhB;;AUv3JA;EACI,eAAA;AV03JJ;AUx3JQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AV03JZ;ACv8JQ;ESyEA;IAMQ,cAAA;IACA,eAAA;IACA,mBAAA;EV43Jd;AACF;AU53JI;EACI,cAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AV83JR;AU73JQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iEAAA;AV+3JZ;AU93JQ;EACI,WAAA;AVg4JZ;AU/3JI;EACI,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,WTjEM;ESkEN,gBAAA;AVi4JR;;AWvgKA;EACI,kBAAA;EACA,gBAAA;EACA,kFAAA;AX0gKJ;AWzgKI;EACI,gBAAA;EACA,WAAA;AX2gKR;AW1gKQ;EACI,WV4DE;EU3DF,eAAA;EACA,gBAAA;AX4gKZ;;AW1gKA;EACI,kBAAA;EACA,eAAA;AX6gKJ;AW5gKI;EACI,mBAAA;AX8gKR;AW7gKQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;AX+gKZ;ACrgKQ;EUbA;IAKQ,cAAA;IACA,eAAA;IACA,mBAAA;EXihKd;AACF;AWjhKI;EACI,gBAAA;EACA,YAAA;EACA,cAAA;AXmhKR;ACjhKQ;EULJ;IAKQ,WAAA;EXqhKV;AACF;AWrhKQ;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;AXuhKZ;AWthKY;EACI,mBV6BA;EU5BA,SAAA;AXwhKhB;AWvhKI;EACI,mBAAA;AXyhKR;;AWvhKA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;AX0hKJ;AWxhKQ;EACI,aAAA;EACA,cAAA;EACA,gBVkBE;EUjBF,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AX0hKZ;ACxjKQ;EUiBA;IAeQ,cAAA;IACA,eAAA;EX4hKd;AACF;AW5hKI;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AX8hKR;AW7hKQ;EACI,eAAA;AX+hKZ;AW9hKI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBVfQ;EUgBR,mBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;AXgiKR;AW/hKQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AXiiKZ;;AY1nKA;EACI,kBAAA;EACA,eAAA;AZ6nKJ;AY5nKI;EACI,mBAAA;AZ8nKR;AY5nKY;EACI,aAAA;EACA,cAAA;AZ8nKhB;ACxmKQ;EWxBI;IAIQ,cAAA;IACA,eAAA;IACA,mBAAA;EZgoKlB;AACF;AYhoKgB;EACI,kBAAA;EACA,aAAA;EACA,cAAA;AZkoKpB;ACpnKQ;EWjBQ;IAKQ,cAAA;IACA,eAAA;IACA,mBAAA;IACA,eAAA;EZooKtB;AACF;AYpoKQ;EACI,WX6CE;ADylKd;AYpoKY;EACI,WX0CF;AD4lKd;ACloKQ;EWLI;IAGQ,mBAAA;EZwoKlB;AACF;AYxoKI;EACI,mBAAA;AZ0oKR;AYzoKQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;AZ2oKZ;AC/oKQ;EWCA;IAKQ,cAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;EZ6oKd;AACF;AY7oKY;EACI,aAAA;EACA,cAAA;AZ+oKhB;AC3pKQ;EWUI;IAIQ,cAAA;IACA,eAAA;EZipKlB;AACF;AYjpKI;EACI,cAAA;EACA,mBAAA;AZmpKR;AYlpKI;EACI,UAAA;AZopKR;AYnpKQ;EACI,cAAA;AZqpKZ;AC3qKQ;EWqBA;IAGQ,mBAAA;EZupKd;AACF;AYvpKY;EACI,mBXSA;ADgpKhB;AYxpKI;EACI,mBAAA;AZ0pKR;;AaptKA;EACI,eAAA;AbutKJ;AattKI;EACI,mBAAA;AbwtKR;AavtKQ;EACI,eAAA;EACA,gBAAA;AbytKZ;ACjsKQ;EY1BA;IAIQ,eAAA;Eb2tKd;AACF;Aa3tKI;EACI,mBAAA;Ab6tKR;Aa5tKQ;EACI,aAAA;EACA,cAAA;Ab8tKZ;AC7sKQ;EYnBA;IAIQ,cAAA;IACA,eAAA;EbguKd;AACF;AahuKY;EACI,mBAAA;AbkuKhB;AahuKQ;EACI,mBAAA;AbkuKZ;AajuKI;EACI,mBAAA;AbmuKR;;AajuKA;EACI,kBAAA;EACA,kFAAA;EACA,2BAAA;EACA,gBAAA;AbouKJ;ACnuKQ;EYLR;IAMQ,YAAA;IACA,eAAA;EbsuKN;AACF;AatuKI;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AbwuKR;AavuKI;EACI,kBAAA;AbyuKR;AaxuKQ;EACI,mBAAA;EACA,WAAA;Ab0uKZ;AazuKI;EACI,UAAA;Ab2uKR;Aa1uKQ;EACI,mBAAA;Ab4uKZ;;Ac9xKA;EACI,eAAA;EACA,mBAAA;EACA,kBAAA;AdiyKJ;AchyKI;EACI,mBAAA;AdkyKR;AcjyKQ;EACI,eAAA;AdmyKZ;AC5wKQ;EaxBA;IAGQ,eAAA;EdqyKd;AACF;AcryKI;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AduyKR;ACvxKQ;EapBJ;IAMQ,cAAA;IACA,eAAA;EdyyKV;AACF;AczyKQ;EACI,YAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iCAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;Ad2yKZ;AC1yKQ;EaZA;IAaQ,YAAA;IACA,aAAA;IACA,UAAA;Ed6yKd;AACF;Ac7yKY;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;Ad+yKhB;AC3zKQ;EaII;IAUQ,WAAA;IACA,YAAA;EdizKlB;AACF;Ac/yKQ;EACI,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AdizKZ;ACz0KQ;EakBA;IAQQ,WAAA;EdmzKd;AACF;AcnzKY;EACI,kBAAA;AdqzKhB;ACj1KQ;Ea2BI;IAGQ,iBAAA;EduzKlB;AACF;;AcrzKA;EACI,kBAAA;EACA,eAAA;AdwzKJ;AcvzKI;EACI,mBAAA;AdyzKR;AcxzKQ;EACI,eAAA;Ad0zKZ;ACj2KQ;EasCA;IAGQ,eAAA;Ed4zKd;AACF;Ac3zKQ;EACI,aAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;Ad6zKZ;AC52KQ;Ea2CA;IAMQ,cAAA;IACA,eAAA;IACA,mBAAA;Ed+zKd;AACF;Ac7zKoB;EACI,aAAA;Ad+zKxB;Ac9zKI;EACI,kBAAA;Adg0KR;Ac/zKQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,YAAA;Adi0KZ;ACl4KQ;Ea0DA;IASQ,aAAA;Edm0Kd;AACF;Acl0KQ;EACI,gCAAA;EACA,YAAA;Ado0KZ;Acn0KI;EACI,aAAA;EACA,gBAAA;Adq0KR;;Acl0KA;EACI,kBAAA;EACA,gBAAA;EACA,oDAAA;Adq0KJ;Acp0KI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;Ads0KR;Acr0KI;EACI,kBAAA;Adu0KR;Act0KQ;EACI,WAAA;EACA,mBAAA;EACA,eAAA;Adw0KZ;Acv0KQ;EACI,eAAA;Ady0KZ;;Aex8KA;EACI,kBAAA;Af28KJ;Ae18KI;EACI,WAAA;EACA,cAAA;EACA,2BAAA;Af48KR;Ae38KQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;Af68KZ;Ae58KQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;Af88KZ;Ae78KI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,YAAA;Af+8KR;ACz8KQ;EcXJ;IAOQ,OAAA;IACA,WAAA;IACA,eAAA;Efi9KV;AACF;Aej9KQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;Afm9KZ;;Aej9KA;EACI,gBAAA;Afo9KJ;Aen9KI;EACI,uBAAA;Afq9KR;Aep9KQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;Afs9KZ;ACj+KQ;EcQA;IAKQ,cAAA;IACA,eAAA;IACA,oBAAA;Efw9Kd;AACF;Aex9KI;EACI,sDAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;Af09KR;Aez9KQ;EACI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;Af29KZ;Ae19KY;EACI,yBAAA;Af49KhB;;Aez9KA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;Af49KJ;Ae39KI;EACI,mBAAA;Af69KR;Ae59KQ;EACI,aAAA;EACA,cAAA;Af89KZ;AClhLQ;EckDA;IAIQ,cAAA;IACA,eAAA;IACA,mBAAA;Efg+Kd;AACF;Aeh+KI;EACI,YAAA;EACA,cAAA;EACA,cAAA;Afk+KR;AC9hLQ;EcyDJ;IAKQ,WAAA;Efo+KV;AACF;Aep+KQ;EACI,WAAA;EACA,mBAAA;Afs+KZ;Aen+KQ;EACI,mBAAA;EACA,WAAA;Afq+KZ;Aep+KQ;EACI,gBAAA;Afs+KZ;;Aep+KA;EACI,eAAA;Afu+KJ;Aer+KQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;Afu+KZ;ACxjLQ;Ec6EA;IAMQ,cAAA;IACA,eAAA;IACA,mBAAA;Efy+Kd;AACF;Aez+KI;EACI,cAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;Af2+KR;Ae1+KQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iEAAA;Af4+KZ;Ae3+KQ;EACI,WAAA;Af6+KZ;Ae5+KI;EACI,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,WdpEM;EcqEN,gBAAA;EACA,WAAA;EACA,eAAA;Af8+KR;;Aet+KA;EACI,eAAA;EACA,mBAAA;Afy+KJ;Aev+KQ;EACI,WdpFE;EcqFF,eAAA;Afy+KZ;Aex+KI;EACI,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;Af0+KR;Aez+KQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,8BAAA;Af2+KZ;Aez+KY;EACI,UAAA;Af2+KhB;Ae1+KI;EACI,gBAAA;EACA,aAAA;Af4+KR;Ae3+KQ;EACI,WAAA;EACA,YAAA;EACA,8BAAA;Af6+KZ;Ae5+KI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;Af8+KR;Ae7+KQ;EACI,WdtHE;ADqmLd;Ae9+KI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,gCAAA;EACA,UAAA;Afg/KR;Ae/+KQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,gBdvIE;EcwIF,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gDAAA;Afi/KZ;Aeh/KQ;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;Afk/KZ;Aej/KY;EACI,WAAA;Afm/KhB;Ael/KI;EACI,kBAAA;Afo/KR;;Aej/KA;EACI;IACI,mEAAA;IACA,YAAA;Efo/KN;Een/KE;IACI,qEAAA;IACA,UAAA;Efq/KN;AACF;AgB1tLA;EACI,eAAA;AhB4tLJ;AgB1tLQ;EACI,eAAA;AhB4tLZ;AClsLQ;Ee3BA;IAGQ,eAAA;EhB8tLd;AACF;AgB9tLI;EACI,mBAAA;AhBguLR;AgB/tLQ;EACI,aAAA;EACA,cAAA;AhBiuLZ;AgBhuLY;EACI,kBAAA;AhBkuLhB;ACjtLQ;EerBA;IAMQ,cAAA;IACA,eAAA;IACA,mBAAA;EhBouLd;EgBnuLc;IACI,eAAA;EhBquLlB;AACF;AgBruLI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;AhBuuLR;AgBruLQ;EACI,mBAAA;AhBuuLZ;;AgBpuLA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;AhBuuLJ;AgBruLQ;EACI,WfiCE;EehCF,eAAA;AhBuuLZ;AgBtuLI;EACI,mBAAA;AhBwuLR;AgBvuLQ;EACI,aAAA;EACA,cAAA;AhByuLZ;AgBxuLY;EACI,mBAAA;AhB0uLhB;ACvvLQ;EeSA;IAMQ,cAAA;IACA,eAAA;EhB4uLd;AACF;AgB5uLI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;AhB8uLR;AgB5uLQ;EACI,UAAA;AhB8uLZ;AgB7uLY;EACI,mBAAA;AhB+uLhB;AgB9uLQ;EACI,cfQI;ADwuLhB;;AgB7uLA;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;AhBgvLJ;AgB/uLI;EACI,aAAA;EACA,WAAA;AhBivLR;;AgB9uLA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;AhBivLJ;AgB/uLQ;EACI,WfPE;EeQF,eAAA;AhBivLZ;AC/xLQ;Ee4CA;IAIQ,eAAA;EhBmvLd;AACF;AgBlvLQ;EACI,gBAAA;EACA,iBAAA;AhBovLZ;ACxyLQ;EekDA;IAIQ,cAAA;IACA,eAAA;IACA,mBAAA;EhBsvLd;AACF;AgBrvLI;EACI,gBfrBM;EesBN,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,sCAAA;AhBuvLR;AgBtvLQ;EACI,UAAA;AhBwvLZ;AgBvvLY;EACI,cAAA;AhByvLhB;AgBxvLgB;EACI,mBfnCJ;AD6xLhB;;AgBvvLA;EACI,kBAAA;EACA,gBAAA;EACA,kFAAA;AhB0vLJ;AgBzvLI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AhB2vLR;AgB1vLI;EACI,gBAAA;EACA,kBAAA;AhB4vLR;AgB3vLQ;EACI,WfpDE;ADizLd;AgB5vLI;EACI,UAAA;AhB8vLR;;AiBx3LA;EACI,eAAA;EACA,qBAAA;EACA,kBAAA;AjB23LJ;AiB13LI;EACI,mBAAA;AjB43LR;AiB33LI;EACI,uBAAA;AjB63LR;AiB53LQ;EACI,gBAAA;EACA,iBAAA;AjB83LZ;AC12LQ;EgBtBA;IAIQ,cAAA;IACA,eAAA;IACA,mBAAA;EjBg4Ld;AACF;AiB/3LgB;EACI,0BAAA;AjBi4LpB;ACp3LQ;EgBdQ;IAGQ,wBAAA;EjBm4LtB;AACF;AiBn4LoB;EACI,0BAAA;AjBq4LxB;AC53LQ;EgBVY;IAGQ,yBAAA;EjBu4L1B;AACF;AiBv4LI;EACI,sDAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;AjBy4LR;AC/4LQ;EgBNJ;IAcQ,YAAA;IACA,aAAA;EjB24LV;AACF;AiB34LI;EACI,yBAAA;EACA,WhB0BM;EgBzBN,eAAA;AjB64LR;AC15LQ;EgBUJ;IAKQ,eAAA;IACA,eAAA;EjB+4LV;AACF;;AiB74LI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;AjBg5LR;ACt6LQ;EgBmBJ;IAKQ,aAAA;EjBk5LV;AACF;AiBl5LQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;AjBo5LZ;AiBn5LQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AjBq5LZ;AiBp5LI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AjBs5LR;ACj8LQ;EgBsCJ;IAOQ,WAAA;IACA,eAAA;IACA,QAAA;EjBw5LV;AACF;AiBx5LQ;EACI,WhBXE;EgBYF,mBAAA;AjB05LZ;AiBz5LQ;EACI,WhBdE;ADy6Ld;AC/8LQ;EgBmDA;IAGQ,WAAA;EjB65Ld;AACF;AiB75LI;EACI,mBAAA;AjB+5LR;ACv9LQ;EgBuDJ;IAGQ,eAAA;EjBi6LV;AACF;AiBj6LQ;EACI,eAAA;EACA,mBAAA;AjBm6LZ;AiBl6LY;EACI,aAAA;EACA,cAAA;AjBo6LhB;ACp+LQ;EgB8DI;IAIQ,cAAA;IACA,eAAA;EjBs6LlB;AACF;AiBt6LgB;EACI,kBAAA;AjBw6LpB;AC7+LQ;EgBoEQ;IAGQ,gBAAA;IACA,UAAA;EjB06LtB;AACF;AiB16LY;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;AjB46LhB;AiB16LgB;EACI,mBAAA;EACA,WhB1CN;ADs9Ld;AiB36LgB;EACI,UAAA;AjB66LpB;AiB36LoB;EACI,WhB/CV;EgBgDU,kBAAA;AjB66LxB;AiB56LwB;EACI,mBhBrDZ;ADm+LhB;;AiB56LA;EACI,kBAAA;EACA,gBAAA;EACA,oDAAA;AjB+6LJ;AiB96LI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AjBg7LR;AiB/6LI;EACI,iBAAA;AjBi7LR;AiBh7LI;EACI,kBAAA;EACA,gBAAA;AjBk7LR;AiBj7LQ;EACI,WhBvEE;AD0/Ld;AiBl7LI;EACI,YAAA;AjBo7LR;ACniMQ;EgB8GJ;IAGQ,WAAA;EjBs7LV;AACF;AiBt7LI;EACI,eAAA;AjBw7LR;AC3iMQ;EgBoHA;IAEQ,mBAAA;EjBy7Ld;AACF;;AiBv7LA;EACI,eAAA;AjB07LJ;AiBx7LQ;EACI,mBAAA;AjB07LZ;AiBz7LQ;EACI,eAAA;AjB27LZ;AiBz7LQ;EACI,aAAA;EACA,cAAA;EACA,mBAAA;AjB27LZ;AC/jMQ;EgBiIA;IAKQ,cAAA;IACA,eAAA;IACA,gBAAA;IACA,mBAAA;EjB67Ld;AACF;AiB57LgB;EACI,kBAAA;EACA,oDAAA;AjB87LpB;AiB57LoB;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AjB87LxB;AiB57LgB;EACI,kBAAA;EACA,kBAAA;EACA,oDAAA;AjB87LpB;AiB77LY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AjB+7LhB;AChmMQ;EgB8JI;IAKQ,eAAA;EjBi8LlB;AACF;AiBj8LgB;EACI,kFAAA;EACA,kBAAA;AjBm8LpB;ACzmMQ;EgBwKgB;IACI,eAAA;EjBo8L1B;AACF;AiBp8LI;EACI,kBAAA;EACA,mBAAA;AjBs8LR;AiBr8LQ;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AjBu8LZ;AiBt8LQ;EACI,kBAAA;EACA,WhBnJE;EgBoJF,gBAAA;AjBw8LZ;AiBv8LQ;EACI,kBAAA;EACA,WhBvJE;ADgmMd;AiBx8LY;EACI,chB5JA;ADsmMhB;AiBz8LgB;EACI,chB9JJ;ADymMhB;AiBz8LI;EACI,gBAAA;AjB28LR;AC/oMQ;EgBmMJ;IAGQ,eAAA;EjB68LV;AACF;;AkBlrMA;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;AlBqrMJ;AkBprMI;EACI,mBAAA;AlBsrMR;AkBrrMQ;EACI,aAAA;EACA,cAAA;AlBurMZ;ACjqMQ;EiBxBA;IAIQ,cAAA;IACA,eAAA;ElByrMd;AACF;AkBzrMY;EACI,mBAAA;AlB2rMhB;AC1qMQ;EiBlBI;IAGQ,mBAAA;ElB6rMlB;AACF;AkB7rMQ;EACI,mBAAA;EACA,WjBkDE;AD6oMd;AkB7rMY;EACI,WjB+CF;ADgpMd;AkB9rMgB;EACI,mBjB0CJ;ADspMhB;AkB/rMQ;EACI,WAAA;EACA,aAAA;AlBisMZ;;AkB9rMA;EACI,eAAA;EACA,kBAAA;AlBisMJ;AkB/rMQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AlBisMZ;ACxsMQ;EiBGA;IAMQ,cAAA;IACA,eAAA;IACA,mBAAA;ElBmsMd;AACF;AkBnsMQ;EACI,YAAA;EACA,kBAAA;EACA,cAAA;AlBqsMZ;ACptMQ;EiBYA;IAKQ,WAAA;IACA,SAAA;ElBusMd;AACF;AkBvsMY;EACI,kBAAA;EACA,WAAA;EACA,yDAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AlBysMhB;AkBxsMY;EACI,WAAA;EACA,mBAAA;AlB0sMhB;AkBxsMQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WjBIE;EiBHF,2BAAA;EACA,WAAA;EACA,eAAA;AlB0sMZ;;AkBvsMA;EAEI,mBAAA;EACA,eAAA;AlBysMJ;AkBvsMQ;EACI,WjBRE;ADitMd;AkBvsMQ;EACI,aAAA;EACA,cAAA;AlBysMZ;AClvMQ;EiBuCA;IAIQ,aAAA;IACA,cAAA;ElB2sMd;AACF;ACjwMQ;EiBgDA;IAOQ,cAAA;IACA,eAAA;IACA,mBAAA;ElB8sMd;AACF;AkB9sMI;EACI,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oDAAA;AlBgtMR;AkB/sMQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBjB5CI;EiB8CJ,iDAAA;EACA,sBAAA;AlBitMZ;AkB/sMY;EAEI,oDAAA;AlBitMhB;AkBhtMQ;EACI,WjBlDE;EiBmDF,eAAA;EACA,kBAAA;AlBktMZ;;AkBhtMA;EACI,eAAA;EACA,kBAAA;AlBmtMJ;AkBltMI;EACI,mBAAA;AlBotMR;AkBjtMY;EACI,qBAAA;EACA,YAAA;EACA,mBAAA;AlBmtMhB;AkBltMgB;EACI,qBAAA;EACA,iDAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;AlBotMpB;AkBltMwB;EACI,WjB1Ed;AD8xMd;AkBntMQ;EACI,kBAAA;AlBqtMZ;AkBptMY;EACI,mBAAA;AlBstMhB;AkBptMI;EACI,kBAAA;EACA,aAAA;EACA,kFAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AlBstMR;AkBrtMQ;EACI,kFAAA;AlButMZ;AkBttMQ;EACI,kFAAA;AlBwtMZ;AkBvtMQ;EACI,kFAAA;AlBytMZ;AkBxtMQ;EACI,kFAAA;AlB0tMZ;AkBztMQ;EACI,kFAAA;AlB2tMZ;AkB1tMQ;EACI,kFAAA;AlB4tMZ;AkB3tMQ;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AlB6tMZ;AkB5tMQ;EACI,kBAAA;EACA,WjBjHE;AD+0Md;;AmBn5MA;EACI,mBAAA;EACA,eAAA;AnBs5MJ;;AmBn5MI;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AnBs5MR;AmBn5MgB;EACI,SAAA;AnBq5MpB;AmBp5MQ;EACI,cAAA;EACA,aAAA;AnBs5MZ;AmBr5MY;EACI,WAAA;EACA,aAAA;EACA,iBAAA;AnBu5MhB;AmBt5MY;EACI,kBAAA;EACA,WAAA;EACA,uCAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EAEA,0BAAA;AnBu5MhB;AmBt5MY;EACI,kBAAA;EACA,WAAA;EACA,uCAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EAEA,0BAAA;AnBu5MhB;AmBt5MI;EACI,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AnBw5MR;AmBv5MI;EACI,4CAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AnBy5MR;AmBx5MQ;EACI,clBUC;EkBTD,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,WlBIE;ADs5Md;AmBz5MQ;EACI,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,WlBFE;AD65Md;AmB15MQ;EACI,mBlBPI;ADm6MhB;AmB35MY;EACI,gBAAA;EACA,sBAAA;AnB65MhB;;AmB15MA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnB65MJ;;AmB35MA;EACI,eAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AnB85MJ;;AoB1/MI;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;ApB6/MR;AoB5/MQ;EACI,kBAAA;EACA,WAAA;EACA,gBnB2DE;EmB1DF,YAAA;EACA,WAAA;EACA,YAAA;ApB8/MZ;AoB7/MQ;EACI,aAAA;EACA,iBAAA;EACA,WAAA;ApB+/MZ;AoB9/MQ;EACI,kBAAA;ApBggNZ;AoB//MQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;ApBigNZ;AoB//MgB;EACI,WnB2CN;EmB1CM,WAAA;EACA,gBAAA;EACA,gBAAA;ApBigNpB;AoB//MoB;EACI,mBAAA;EACA,eAAA;EACA,WnBmCV;EmBlCU,sBAAA;ApBigNxB;AoBhgNwB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;ApBkgN5B;AoBjgNI;EACI,eAAA;ApBmgNR;AoBlgNQ;EACI,mBAAA;ApBogNZ;AoBngNQ;EACI,mBAAA;ApBqgNZ;AoBpgNY;EACI,cnBiBA;ADq/MhB;AoBrgNQ;EACI,mBAAA;ApBugNZ;AoBtgNQ;EACI,YAAA;ApBwgNZ;AoBtgNY;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;ApBwgNhB;AoBvgNgB;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBnBCJ;EmBAI,mBAAA;EACA,OAAA;EACA,QAAA;ApBygNpB;;AqB5kNA;EACI,eAAA;EACA,yBAAA;ArB+kNJ;AqB9kNI;EACI,mBAAA;ArBglNR;AqB/kNI;EACI,kBAAA;ArBilNR;AqBhlNQ;EACI,kBAAA;ArBklNZ;AqBjlNY;EACI,gBAAA;ArBmlNhB;AqBllNQ;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;ArBolNZ;AqBnlNY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,6EAAA;EACA,oBAAA;EACA,mBAAA;ArBqlNhB;AqBplNY;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;ArBslNhB;AqBrlNQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,WpBmCE;EoBlCF,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;ArBulNZ;AqBrlNQ;EACI,cpB4BC;EoB3BD,gBAAA;EACA,eAAA;EACA,gBAAA;ArBulNZ;AqBrlNY;EACI,qBAAA;ArBulNhB;AqBtlNgB;EACI,apBgBJ;ADwkNhB;AqBvlNI;EACI,mBAAA;ArBylNR;AqBxlNQ;EACI,cAAA;ArB0lNZ;AqBtlNgB;EACI,UpBUN;AD8kNd;;AqBllNA;EACI,kBAAA;EACA,mBAAA;ArBqlNJ;AqBplNI;EACI,aAAA;EACA,aAAA;EACA,WAAA;EAEA,aAAA;EACA,gBAAA;ArBslNR;AC9nNQ;EoBkCJ;IAQQ,sBAAA;ErBwlNV;AACF;AqBxlNI;EAGI,SAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EAKA,0BAAA;ArB0lNR;ACjpNQ;EoB2CJ;IAcQ,cAAA;IACA,kBAAA;ErB4lNV;AACF;AqB5lNQ;EACI,iHAAA;EACA,sBAAA;EACA,kCAAA;ArB8lNZ;AqB7lNQ;EACI,iHAAA;EACA,sBAAA;EACA,kCAAA;ArB+lNZ;AqB9lNQ;EACI,YAAA;ArBgmNZ;AqB/lNY;EACI,QAAA;EACA,uBAAA;ArBimNhB;AqBhmNY;EACI,UAAA;EACA,WAAA;EACA,QAAA;ArBkmNhB;AqBjmNQ;EACI,WpB1CE;EoB2CF,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,QAAA;EAKA,0BAAA;ArBmmNZ;AC3rNQ;EoB4EA;IAcQ,kCAAA;ErBqmNd;AACF;AqBrmNQ;EACI,UAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EAKA,0BAAA;ArBumNZ;AqBtmNY;EAnBJ;IAoBQ,WAAA;IACA,yBAAA;ErBymNd;AACF;AqBzmNY;EACI,mBAAA;ArB2mNhB;;AsB9vNA;EACI,eAAA;AtBiwNJ;AsB/vNQ;EACI,gBAAA;EACA,iBAAA;AtBiwNZ;AsBhwNI;EACI,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sCAAA;AtBkwNR;AsBjwNQ;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AtBmwNZ;AsBlwNY;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iCAAA;AtBowNhB;AsBjwNgB;EACI,0BAAA;AtBmwNpB;AsBlwNQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,6FAAA;EACA,2BAAA;AtBowNZ;AsBnwNY;EACI,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AtBqwNhB;AsBnwNY;EACI,UAAA;EACA,qBAAA;AtBqwNhB;AsBpwNQ;EACI,gBAAA;EACA,sBAAA;EACA,mBAAA;AtBswNZ;AsBpwNY;EACI,eAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,4BAAA;AtBswNhB;AsBrwNgB;EACI,qBAAA;EACA,crBIJ;ADmwNhB;AsBrwNQ;EACI,iBAAA;EACA,cAAA;EACA,mBAAA;AtBuwNZ;AsBtwNQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AtBwwNZ;AsBvwNY;EACI,gBAAA;AtBywNhB;AsBxwNQ;EACI,iBAAA;EACA,YAAA;EACA,eAAA;EACA,mBrBbI;EqBcJ,cAAA;EACA,uCAAA;EACA,mBAAA;EACA,yBAAA;AtB0wNZ;AsBzwNY;EACI,mBrBnBA;EqBoBA,qBAAA;EACA,WAAA;AtB2wNhB;AsBzwNQ;EACI,kBAAA;AtB2wNZ;AsB1wNQ;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AtB4wNZ;AsB1wNY;EACI,SAAA;EACA,aAAA;AtB4wNhB;AsB1wNY;EACI,cAAA;AtB4wNhB;AsB3wNgB;EACI,oBAAA;AtB6wNpB;AsB5wNY;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;AtB8wNhB;AsB7wNgB;EACI,cAAA;EACA,yBAAA;AtB+wNpB;;AuBh4NA;EACI,6CAAA;EACA,eAAA;AvBm4NJ;AuBj4NQ;EACI,eAAA;EACA,mBAAA;AvBm4NZ;AuBl4NY;EACI,ctByDA;AD20NhB;AuBn4NI;EACI,gBtB0DM;EsBzDN,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AvBq4NR;AuBp4NQ;EACI,aAAA;EACA,cAAA;EACA,kBAAA;AvBs4NZ;AC33NQ;EsBdA;IAKQ,cAAA;IACA,eAAA;EvBw4Nd;AACF;AuBx4NY;EACI,kBAAA;EACA,WAAA;EACA,4DAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AvB04NhB;AuBz4NY;EACI,mBAAA;AvB24NhB;AuB14NQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AvB44NZ;AuB34NY;EACI,WtB8BF;EsB7BE,mBAAA;AvB64NhB;AuB54NY;EACI,WtB2BF;ADm3Nd;AuB74NQ;EACI,aAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AvB+4NZ;ACh6NQ;EsBYA;IAOQ,cAAA;IACA,eAAA;IACA,aAAA;EvBi5Nd;AACF;AuBh5NgB;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AvBk5NpB;AC76NQ;EsBuBQ;IAMQ,cAAA;IACA,eAAA;IACA,UAAA;EvBo5NtB;AACF;AuBp5NoB;EACI,cAAA;EACA,eAAA;AvBs5NxB;AuBr5NoB;EACI,kBAAA;AvBu5NxB;AuBp5NgB;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wEAAA;AvBs5NpB;AuBr5NgB;EACI,kBAAA;AvBu5NpB;AuBt5NgB;EACI,cAAA;EACA,eAAA;EACA,UAAA;AvBw5NpB;AuBv5NY;EACI,mBtBzBA;EsB0BA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AvBy5NhB;AuBx5NgB;EACI,WtBhCN;EsBiCM,cAAA;AvB05NpB;;AuBv5NA;EACI,eAAA;AvB05NJ;AuBx5NQ;EACI,eAAA;EACA,mBAAA;AvB05NZ;AuBz5NY;EACI,ctB9CA;ADy8NhB;AuBz5NQ;EACI,aAAA;EACA,cAAA;AvB25NZ;ACh/NQ;EsBmFA;IAIQ,cAAA;IACA,eAAA;EvB65Nd;AACF;AuB55NI;EACI,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AvB85NR;AC//NQ;EsB0FJ;IASQ,WAAA;IACA,mBAAA;EvBg6NV;AACF;AuBh6NQ;EACI,WAAA;AvBk6NZ;AuBj6NQ;EACI,WtBlEE;ADq+Nd;AuBl6NQ;EACI,WtBpEE;ADw+Nd;;AwB5iOA;EACI,kBAAA;AxB+iOJ;AwB9iOI;EACI,WAAA;EACA,2BAAA;EACA,cAAA;AxBgjOR;AwB/iOQ;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AxBijOZ;AwBhjOQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AxBkjOZ;AwBjjOI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AxBmjOR;AwBljOQ;EACI,WvB4CE;EuB3CF,mBAAA;AxBojOZ;AwBnjOQ;EACI,eAAA;EACA,WvBwCE;AD6gOd;;AwBnjOA;EACI,kBAAA;EACA,eAAA;AxBsjOJ;AwBrjOI;EACI,mBAAA;AxBujOR;AwBtjOQ;EACI,kBAAA;EACA,aAAA;EACA,cAAA;AxBwjOZ;AwBvjOI;EACI,YAAA;EACA,mBAAA;AxByjOR;AwBvjOQ;EACI,YAAA;EACA,qBAAA;AxByjOZ;;AyBtmOA;EACI,kBAAA;EACA,kFAAA;EACA,WAAA;AzBymOJ;AC9kOQ;EwB9BR;IAKQ,oBAAA;EzB2mON;AACF;AyB3mOI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AzB6mOR;AyB3mOI;EACI,kBAAA;EACA,qBAAA;EACA,6BAAA;AzB6mOR;AC/lOQ;EwBjBJ;IAKQ,iBAAA;IACA,iBAAA;EzB+mOV;AACF;AyB9mOY;EACI,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AzBgnOhB;AyB/mOY;EACI,aAAA;EACA,cAAA;AzBinOhB;AChnOQ;EwBHI;IAIQ,cAAA;IACA,eAAA;IACA,mBAAA;EzBmnOlB;AACF;AyBjnOgB;EACI,iBAAA;EACA,WAAA;AzBmnOpB;AyBjnOQ;EACI,WxB2BE;EwB1BF,eAAA;EACA,mBAAA;EACA,gBAAA;AzBmnOZ;AyBlnOQ;EACI,mBAAA;EACA,WxBqBE;AD+lOd;AyBlnOY;EACI,kBAAA;EACA,sBAAA;AzBonOhB;AyBnnOY;EACI,sBAAA;AzBqnOhB;AyBpnOgB;EACI,cAAA;AzBsnOpB;AyBpnOoB;EACI,iBAAA;EACA,cxBMR;ADgnOhB;AyBpnOY;EACI,mBAAA;AzBsnOhB;AyBrnOY;EACI,kBAAA;AzBunOhB;AyBtnOgB;EACI,kBAAA;AzBwnOpB;AyBvnOgB;EACI,4BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AzBynOpB;AyBvnOgB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,yBxBfJ;EwBgBI,cAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AzBynOpB;AyBxnOoB;EACI,WAAA;AzB0nOxB;AyBznOgB;EACI,cAAA;EACA,UAAA;EACA,eAAA;AzB2nOpB;AyB1nOI;EACI,eAAA;EACA,kBAAA;AzB4nOR;AyB3nOQ;EACI,cxB9BI;AD2pOhB;AyB5nOQ;EACI,mBAAA;AzB8nOZ;AyB7nOY;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AzB+nOhB;ACtsOQ;EwBoEI;IAKQ,cAAA;IACA,eAAA;IACA,mBAAA;EzBioOlB;AACF;AyBjoOgB;EACI,iBAAA;AzBmoOpB;AChtOQ;EwB4EQ;IAGQ,gBAAA;EzBqoOtB;AACF;AyBroOQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AzBuoOZ;AyBtoOY;EACI,WxB/CF;EwBgDE,iBAAA;AzBwoOhB;AyBroOgB;EACI,kBAAA;AzBuoOpB;AyBroOgB;EACI,cAAA;EACA,sBAAA;EAEA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzBsoOpB;AyBpoOgB;EACI,axBtEJ;AD4sOhB;;AyBloOQ;EACI,YAAA;AzBqoOZ;;A0BjxOA;EACI,kBAAA;EACA,eAAA;A1BoxOJ;A0BlxOQ;EACI,mBAAA;A1BoxOZ;A0BnxOQ;EACI,czB0DI;EyBzDJ,gBAAA;EACA,cAAA;A1BqxOZ;A0BpxOQ;EACI,eAAA;EACA,mBAAA;A1BsxOZ;A0BrxOQ;EACI,czBmDI;EyBlDJ,gBAAA;A1BuxOZ;A0BtxOQ;EACI,mBAAA;EACA,cAAA;A1BwxOZ;A0BvxOQ;EACI,WAAA;A1ByxOZ;A0BxxOY;EACI,gBAAA;A1B0xOhB;A0BzxOQ;EACI,gBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;A1B2xOZ;A0B1xOY;EACI,cAAA;A1B4xOhB;A0B1xOY;EACI,cAAA;EACA,mBAAA;A1B4xOhB;A0B3xOgB;EACI,mBzB8BJ;AD+vOhB;;A2Bh0OA;EACI,eAAA;A3Bm0OJ;A2Bh0OI;EACI,+FAAA;EACA,aAAA;EACA,2BAAA;A3Bk0OR;A2Bj0OI;EACI,kBAAA;A3Bm0OR;A2Bl0OQ;EACI,WAAA;EACA,kBAAA;EACA,mB1BoDI;E0BnDJ,cAAA;EACA,mBAAA;EACA,qBAAA;A3Bo0OZ;;A4Bp1OA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,gB3B0DU;E2BzDV,mBAAA;EACA,gFAAA;EACA,yBAAA;EACA,YAAA;A5Bu1OJ;A4Bt1OI;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;A5Bw1OR;A4Bv1OQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;A5By1OZ;A4Bx1OY;EACI,eAAA;EACA,W3ByCF;ADizOd;A4Bz1OY;EACI,mBAAA;EACA,sBAAA;EACA,eAAA;A5B21OhB;A4B11OQ;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;A5B41OZ;A4B31OY;EACI,mBAAA;A5B61OhB;A4B51OI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EAEA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;A5B61OR;A4B51OQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;A5B81OZ;A4B71OY;EACI,mB3BOA;E2BNA,iBAAA;EACA,W3BQF;E2BPE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;A5B+1OhB;A4B71OgB;EACI,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;A5B+1OpB;A4B91OgB;EACI,4CAAA;EACA,c3BPP;E2BQO,iCAAA;A5Bg2OpB;A4B91OY;EACI,sBAAA;EACA,qBAAA;A5Bg2OhB;A4B/1OgB;EACI,iCAAA;A5Bi2OpB;A4Bh2OI;EAGI,iBAAA;A5Bg2OR;A4B/1OQ;EACI,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;A5Bi2OZ;A4B/1OI;EAEI,SAAA;EACA,WAAA;EACA,gB3BnCM;E2BoCN,kBAAA;A5Bg2OR;A4B/1OQ;EACI,aAAA;EACA,mBAAA;EACA,gB3BxCE;E2ByCF,mBAAA;EACA,0BAAA;A5Bi2OZ;A4Bh2OY;EACI,0BAAA;A5Bk2OhB;A4Bj2OY;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;A5Bm2OhB;A4Bl2OgB;EACI,cAAA;A5Bo2OpB;A4Bl2OY;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mB3BnEA;E2BoEA,YAAA;EACA,aAAA;EACA,W3BnEF;ADu6Od;;A4Bl2OA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,2DAAA;A5Bq2OJ;A4Bp2OI;EACI,kBAAA;EACA,W3BvFM;AD67Od;A4Br2OQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A5Bu2OZ;;A4Br2OA;EACI;IACG,wBAAA;E5Bw2OL;E4Bv2OE;IACI,4BAAA;E5By2ON;AACF;A4Bz2OA;EACI;IACG,8EAAA;E5B22OL;E4B12OE;IACI,8CAAA;E5B42ON;AACF;A4Bz2OQ;EACI,UAAA;EACA,mBAAA;EACA,oBAAA;A5B22OZ;A4B12OQ;EACI,wBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;A5B42OZ;A4B12OgB;EACI,UAAA;A5B42OpB;A4B32OgB;EACI,UAAA;A5B62OpB;;A4B12OQ;EACI,UAAA;A5B62OZ;;A4B32OA;EACI,kBAAA;A5B82OJ;A4B72OI;EACI,WAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gB3BvIM;E2BwIN,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;A5B+2OR;A4B92OQ;EACI,qBAAA;EACA,iBAAA;A5Bg3OZ;A4B/2OQ;EACI,qBAAA;EACA,iBAAA;A5Bi3OZ;;A4B/2OA;EACI;IACI,YAAA;E5Bk3ON;E4Bj3OE;IACI,UAAA;E5Bm3ON;E4Bl3OE;IACI,YAAA;E5Bo3ON;AACF","sourcesContent":["html, body, div, span, applet, object, iframe, h1, h2,\r\nh3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym,\r\naddress, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp,\r\nsmall, strike, strong, sub, sup, tt, var, b, u, i, center,\r\ndl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption,\r\ntbody, tfoot, thead, tr, th, td, article, aside, canvas, details,\r\nembed, figure, figcaption, footer, header, hgroup, menu,\r\nnav, output, ruby, section, summary, time, mark, audio, video \r\n  margin: 0\r\n  padding: 0\r\n  border: 0\r\n  font-size: 100%\r\n  font: inherit\r\n  vertical-align: baseline \r\n\r\n\r\nbody,\r\nhtml\r\n  font-family: \"Poppins\", sans-serif\r\n  font-size: 15px\r\n  line-height: 26px\r\n  color: $text-color\r\n\r\n@media (max-width: 991px) \r\n  body,\r\n  html \r\n    font-size: 14px\r\n    line-height: 20px\r\n  \r\n\r\n\r\narticle, aside, details, figcaption, figure, footer,\r\nheader, hgroup, menu, nav, section, main \r\n  display: block\r\n\r\n\r\nstrong, b \r\n  font-weight: 600\r\n\r\n\r\nol, ul \r\n  list-style: none\r\n\r\n\r\nblockquote, q \r\n  quotes: none\r\n\r\n\r\nblockquote:before, blockquote:after \r\n  content: \"\"\r\n  content: none\r\n\r\n\r\ntable \r\n  border-collapse: collapse\r\n  border-spacing: 0\r\n\r\n\r\na[href] \r\n  text-decoration: none\r\n  transition: 400ms ease\r\n  cursor: pointer\r\n  \r\na[href]:hover \r\n  color: $black-color\r\n\r\nimg \r\n  max-width: 100%\r\n\r\n.container\r\n  max-width: 1250px\r\n  width: 100%\r\n  margin: 0 auto\r\n  padding: 0 15px\r\n\r\n.container-fluid\r\n  max-width: 100%\r\n  width: 100%\r\n  display: block\r\n  margin: 0 auto\r\n  padding: 0 5%    \r\n\r\nh1, h2, h3, h4, h5, h6 \r\n  color: $black-color\r\n  font-weight: 400\r\n  font-family: \"Roboto\", sans-serif\r\n  line-height: 1.3\r\n  @include respond-to(screen-767)\r\n    margin: 5px 0\r\n    \r\n\r\nh1 \r\n  font-size: 60px\r\n  line-height: 68px\r\n  @include respond-to(screen-991)  \r\n    font-size: 40px\r\n    line-height: 45px\r\n  @include respond-to(screen-767)  \r\n    font-size: 30px\r\n    line-height: 35px\r\n \r\nh2 \r\n  font-size: 40px\r\n  @include respond-to(screen-767)  \r\n    font-size: 24px\r\n    line-height: 32px\r\n\r\nh3 \r\n  font-size: 21px\r\n  @include respond-to(screen-991)  \r\n    font-size: 20px\r\n    \r\n\r\nh4 \r\n  font-size: 24px\r\n\r\n\r\nh5 \r\n  font-size: 20px\r\n\r\n\r\nh6 \r\n  font-size: 18px\r\n  @include respond-to(screen-991)  \r\n    font-size: 20px  \r\n\r\n.heading \r\n    margin-bottom: 30px\r\n    text-align: center\r\n    .title \r\n      color: $secondary-color\r\n      font-weight: 500\r\n      text-transform: uppercase\r\n      opacity: 0.7\r\n        \r\n.heading \r\n  h1,h2\r\n    line-height: 50px\r\n    color: $secondary-color\r\n    font-weight: 500\r\n    @include respond-to(screen-767)\r\n      line-height: 32px  \r\n\r\n*,\r\n*::before, *::after \r\n  margin: 0\r\n  padding: 0\r\n  box-sizing: border-box\r\n  outline: none\r\n\r\n\r\ninput,\r\nselect,\r\nbutton,\r\ntextarea \r\n  font-family: \"Poppins\", sans-serif\r\n\r\n\r\nselect \r\n  -webkit-appearance: none\r\n  -moz-appearance: none\r\n  text-indent: 1px\r\n  text-overflow: \"\"\r\n\r\n\r\nbutton,\r\ninput[type=submit],\r\ninput[type=button] \r\n  cursor: pointer\r\n\r\n\r\n.flex \r\n  display: flex\r\n  flex-wrap: wrap\r\n\r\n\r\n.text-right \r\n  text-align: right\r\n\r\n\r\nbody::-webkit-scrollbar \r\n  width: 5px\r\n\r\n\r\nbody::-webkit-scrollbar-thumb \r\n  background-color: $text-color\r\n\r\n\r\nbody::-webkit-scrollbar-track \r\n  box-shadow: unset\r\n  background: #fff\r\n\r\n.case_detail::-webkit-scrollbar \r\n  width: 5px\r\n\r\n.case_detail::-webkit-scrollbar-thumb \r\n  background-color: $text-color\r\n\r\n\r\n.case_detail::-webkit-scrollbar-track \r\n  box-shadow: unset\r\n  background: #fff\r\n\r\n\r\n.img_hover \r\n  position: relative\r\n  overflow: hidden\r\n\r\n\r\n.img_hover:before \r\n  position: absolute\r\n  top: 0\r\n  left: 0\r\n  width: 100%\r\n  height: 100%\r\n  background: rgba(255, 255, 255, 0.5)\r\n  content: \"\"\r\n  transition: transform 1s\r\n  z-index: 11\r\n  opacity: 0.3\r\n  transform: scale3d(1.9, 1.4, 1) rotate3d(0, 0, 1, 45deg) translate3d(0, -100%, 0)\r\n  pointer-events: none !important\r\n\r\n\r\n.img_hover:hover:before \r\n  transform: scale3d(1.9, 1.4, 1) rotate3d(0, 0, 1, 45deg) translate3d(0, 100%, 0)\r\n\r\n.social-links \r\n  li\r\n    display: inline-block\r\n\r\n.modelPop\r\n  position: fixed\r\n  z-index: 1111\r\n\r\n.close_model\r\n    position: absolute\r\n    right: 15px\r\n    top: 15px\r\n    cursor: pointer\r\n    line-height: 0\r\n    width: 25px\r\n    height: 25px\r\n    z-index: 111 \r\n\r\n.overlay\r\n  position: fixed\r\n  left: 0\r\n  top: 0\r\n  right: 0\r\n  bottom: 0\r\n  background: #000\r\n  width: 100%\r\n  height: 100%\r\n  z-index: 111\r\n  opacity: 0\r\n  pointer-events: none\r\n  &.overlyflm\r\n    opacity: 0.5\r\n    pointer-events: all\r\n\r\n.bullet_points\r\n  padding-left: 30px\r\n  li\r\n    padding-left: 20px\r\n    position: relative\r\n    color: $white-color\r\n    &::before\r\n      position: absolute\r\n      content: \"\"\r\n      width: 8px\r\n      height: 8px\r\n      background: $white-color\r\n      border-radius: 10px\r\n      left: 0\r\n      top: 8px\r\n      \r\n\r\n\r\n.owl-carousel\r\n  .owl-dots\r\n    margin-top: 10px\r\n    button\r\n        &.owl-dot\r\n          border-radius: 20px\r\n          width: 9px\r\n          height: 9px\r\n          background: #FFF\r\n          position: relative\r\n          border-color: transparent\r\n          margin: 0 5px\r\n          opacity: .5\r\n          &.active\r\n            background: $primary-color\r\n            opacity: 1    \r\n\r\n.coming-soon\r\n  height: 100vh\r\n  background: radial-gradient(dimgray, black)\r\n  h3 \r\n    margin: 0\r\n    padding: 0\r\n    position: absolute\r\n    top: 50%\r\n    left: 50%\r\n    transform: translate(-50%,-50%)\r\n    color: $primary-color\r\n    font-size: 6.5vw\r\n    &::before\r\n      position: absolute\r\n      top: 0\r\n      left: 0\r\n      transform-origin: bottom\r\n      line-height: 1.14em\r\n      opacity: 0.3\r\n\r\n.mob_strip\r\n  display: none\r\n  @include respond-to(screen-767)\r\n    display: flex\r\n    justify-content: space-between\r\n    position: fixed\r\n    left: 0px\r\n    right: 0px\r\n    bottom: 0px\r\n    z-index: 111\r\n    background: #242424\r\n    a\r\n      display: inline-block\r\n      color: #fff\r\n      max-width: 50%\r\n      text-align: center\r\n      font-size: 16px\r\n      padding: 10px 10px\r\n      flex: 0 0 50%\r\n      font-weight: 400\r\n      &:first-child\r\n        border-right: 2px solid $white-color\r\n\r\n#response-message,#contact-message,#newsletter-message      \r\n  color: #16cd16\r\n  font-weight: 600\r\n  margin-top: 20px\r\n  &.success\r\n    color: #16cd16\r\n  &.error\r\n    color: #ed2525\r\n\r\n.cs-loader\r\n    display: flex\r\n    align-items: center\r\n    justify-content: center\r\n    flex-direction: column\r\n    display: none\r\n    &.show\r\n        display: flex\r\n    &__media\r\n        position: relative\r\n        max-width: 8rem\r\n        max-height: 8rem\r\n        margin-bottom: 1rem\r\n        img\r\n            max-width: 100%\r\n            max-height: 100%\r\n    .waviy\r\n        -webkit-box-reflect: below -5px linear-gradient(transparent, rgba(0,0,0,.4))\r\n        span\r\n            text-transform: uppercase\r\n            letter-spacing: 2px\r\n            font-size: 1.8rem\r\n            font-weight: 600\r\n            position: relative\r\n            display: inline-block\r\n            text-transform: uppercase\r\n            animation: waviy 1s infinite\r\n            -webkit-background-clip: text !important\r\n            -webkit-text-fill-color: transparent\r\n            background: linear-gradient( 70deg, #da3467,#d4567c,#e85480)\r\n\r\n@keyframes waviy\r\n  0%,40%,100%\r\n    transform: translateY(0)\r\n  20%\r\n    transform: translateY(-5px)\r\n\r\n ","html, body, div, span, applet, object, iframe, h1, h2,\nh3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym,\naddress, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var, b, u, i, center,\ndl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption,\ntbody, tfoot, thead, tr, th, td, article, aside, canvas, details,\nembed, figure, figcaption, footer, header, hgroup, menu,\nnav, output, ruby, section, summary, time, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\nbody,\nhtml {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 15px;\n  line-height: 26px;\n  color: #2e2d2d;\n}\n\n@media (max-width: 991px) {\n  body,\n  html {\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\narticle, aside, details, figcaption, figure, footer,\nheader, hgroup, menu, nav, section, main {\n  display: block;\n}\n\nstrong, b {\n  font-weight: 600;\n}\n\nol, ul {\n  list-style: none;\n}\n\nblockquote, q {\n  quotes: none;\n}\n\nblockquote:before, blockquote:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\na[href] {\n  text-decoration: none;\n  transition: 400ms ease;\n  cursor: pointer;\n}\n\na[href]:hover {\n  color: #000;\n}\n\nimg {\n  max-width: 100%;\n}\n\n.container {\n  max-width: 1250px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.container-fluid {\n  max-width: 100%;\n  width: 100%;\n  display: block;\n  margin: 0 auto;\n  padding: 0 5%;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: #000;\n  font-weight: 400;\n  font-family: \"Roboto\", sans-serif;\n  line-height: 1.3;\n}\n@media (max-width: 767px) {\n  h1, h2, h3, h4, h5, h6 {\n    margin: 5px 0;\n  }\n}\n\nh1 {\n  font-size: 60px;\n  line-height: 68px;\n}\n@media (max-width: 991px) {\n  h1 {\n    font-size: 40px;\n    line-height: 45px;\n  }\n}\n@media (max-width: 767px) {\n  h1 {\n    font-size: 30px;\n    line-height: 35px;\n  }\n}\n\nh2 {\n  font-size: 40px;\n}\n@media (max-width: 767px) {\n  h2 {\n    font-size: 24px;\n    line-height: 32px;\n  }\n}\n\nh3 {\n  font-size: 21px;\n}\n@media (max-width: 991px) {\n  h3 {\n    font-size: 20px;\n  }\n}\n\nh4 {\n  font-size: 24px;\n}\n\nh5 {\n  font-size: 20px;\n}\n\nh6 {\n  font-size: 18px;\n}\n@media (max-width: 991px) {\n  h6 {\n    font-size: 20px;\n  }\n}\n\n.heading {\n  margin-bottom: 30px;\n  text-align: center;\n}\n.heading .title {\n  color: #666666;\n  font-weight: 500;\n  text-transform: uppercase;\n  opacity: 0.7;\n}\n\n.heading h1, .heading h2 {\n  line-height: 50px;\n  color: #666666;\n  font-weight: 500;\n}\n@media (max-width: 767px) {\n  .heading h1, .heading h2 {\n    line-height: 32px;\n  }\n}\n\n*,\n*::before, *::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  outline: none;\n}\n\ninput,\nselect,\nbutton,\ntextarea {\n  font-family: \"Poppins\", sans-serif;\n}\n\nselect {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-indent: 1px;\n  text-overflow: \"\";\n}\n\nbutton,\ninput[type=submit],\ninput[type=button] {\n  cursor: pointer;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.text-right {\n  text-align: right;\n}\n\nbody::-webkit-scrollbar {\n  width: 5px;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: #2e2d2d;\n}\n\nbody::-webkit-scrollbar-track {\n  box-shadow: unset;\n  background: #fff;\n}\n\n.case_detail::-webkit-scrollbar {\n  width: 5px;\n}\n\n.case_detail::-webkit-scrollbar-thumb {\n  background-color: #2e2d2d;\n}\n\n.case_detail::-webkit-scrollbar-track {\n  box-shadow: unset;\n  background: #fff;\n}\n\n.img_hover {\n  position: relative;\n  overflow: hidden;\n}\n\n.img_hover:before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.5);\n  content: \"\";\n  transition: transform 1s;\n  z-index: 11;\n  opacity: 0.3;\n  transform: scale3d(1.9, 1.4, 1) rotate3d(0, 0, 1, 45deg) translate3d(0, -100%, 0);\n  pointer-events: none !important;\n}\n\n.img_hover:hover:before {\n  transform: scale3d(1.9, 1.4, 1) rotate3d(0, 0, 1, 45deg) translate3d(0, 100%, 0);\n}\n\n.social-links li {\n  display: inline-block;\n}\n\n.modelPop {\n  position: fixed;\n  z-index: 1111;\n}\n\n.close_model {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  cursor: pointer;\n  line-height: 0;\n  width: 25px;\n  height: 25px;\n  z-index: 111;\n}\n\n.overlay {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: #000;\n  width: 100%;\n  height: 100%;\n  z-index: 111;\n  opacity: 0;\n  pointer-events: none;\n}\n.overlay.overlyflm {\n  opacity: 0.5;\n  pointer-events: all;\n}\n\n.bullet_points {\n  padding-left: 30px;\n}\n.bullet_points li {\n  padding-left: 20px;\n  position: relative;\n  color: #fff;\n}\n.bullet_points li::before {\n  position: absolute;\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  background: #fff;\n  border-radius: 10px;\n  left: 0;\n  top: 8px;\n}\n\n.owl-carousel .owl-dots {\n  margin-top: 10px;\n}\n.owl-carousel .owl-dots button.owl-dot {\n  border-radius: 20px;\n  width: 9px;\n  height: 9px;\n  background: #FFF;\n  position: relative;\n  border-color: transparent;\n  margin: 0 5px;\n  opacity: 0.5;\n}\n.owl-carousel .owl-dots button.owl-dot.active {\n  background: #da3467;\n  opacity: 1;\n}\n\n.coming-soon {\n  height: 100vh;\n  background: radial-gradient(dimgray, black);\n}\n.coming-soon h3 {\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #da3467;\n  font-size: 6.5vw;\n}\n.coming-soon h3::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform-origin: bottom;\n  line-height: 1.14em;\n  opacity: 0.3;\n}\n\n.mob_strip {\n  display: none;\n}\n@media (max-width: 767px) {\n  .mob_strip {\n    display: flex;\n    justify-content: space-between;\n    position: fixed;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    z-index: 111;\n    background: #242424;\n  }\n  .mob_strip a {\n    display: inline-block;\n    color: #fff;\n    max-width: 50%;\n    text-align: center;\n    font-size: 16px;\n    padding: 10px 10px;\n    flex: 0 0 50%;\n    font-weight: 400;\n  }\n  .mob_strip a:first-child {\n    border-right: 2px solid #fff;\n  }\n}\n\n#response-message, #contact-message, #newsletter-message {\n  color: #16cd16;\n  font-weight: 600;\n  margin-top: 20px;\n}\n#response-message.success, #contact-message.success, #newsletter-message.success {\n  color: #16cd16;\n}\n#response-message.error, #contact-message.error, #newsletter-message.error {\n  color: #ed2525;\n}\n\n.cs-loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  display: none;\n}\n.cs-loader.show {\n  display: flex;\n}\n.cs-loader__media {\n  position: relative;\n  max-width: 8rem;\n  max-height: 8rem;\n  margin-bottom: 1rem;\n}\n.cs-loader__media img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.cs-loader .waviy {\n  -webkit-box-reflect: below -5px linear-gradient(transparent, rgba(0, 0, 0, 0.4));\n}\n.cs-loader .waviy span {\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  font-size: 1.8rem;\n  font-weight: 600;\n  position: relative;\n  display: inline-block;\n  text-transform: uppercase;\n  animation: waviy 1s infinite;\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent;\n  background: linear-gradient(70deg, #da3467, #d4567c, #e85480);\n}\n\n@keyframes waviy {\n  0%, 40%, 100% {\n    transform: translateY(0);\n  }\n  20% {\n    transform: translateY(-5px);\n  }\n}\nheader {\n  background: #242424;\n  position: relative;\n  z-index: 11;\n}\nheader::before {\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: #222222;\n  box-shadow: 0 0 8px 1px rgba(51, 51, 51, 0.3294117647);\n  transition: 700ms ease;\n}\nheader .container-fluid {\n  padding: 0 40px;\n}\nheader .top-strip {\n  position: relative;\n  padding: 10px 0;\n  transition: 700ms ease;\n  z-index: 11;\n  background: #da3467;\n}\n@media (max-width: 767px) {\n  header .top-strip {\n    display: none;\n  }\n}\nheader .top-strip .flex {\n  position: relative;\n  align-items: center;\n}\nheader .top-strip .col1 {\n  flex: 0 1 40%;\n  max-width: 60%;\n}\n@media (max-width: 767px) {\n  header .top-strip .col1 {\n    flex: 0 1 50%;\n    max-width: 50%;\n  }\n}\nheader .top-strip .col2 {\n  flex: 0 1 60%;\n  max-width: 60%;\n}\n@media (max-width: 767px) {\n  header .top-strip .col2 {\n    flex: 0 1 50%;\n    max-width: 50%;\n  }\n}\nheader .top-strip .left-side ul li {\n  display: inline-block;\n  padding-right: 20px;\n}\nheader .top-strip .left-side ul li svg {\n  vertical-align: middle;\n  width: 16px;\n  fill: none;\n  stroke: #fff;\n}\nheader .top-strip .left-side ul li a {\n  font-size: 12px;\n  margin-left: 5px;\n  color: #fff;\n}\nheader .top-strip .right-side {\n  text-align: right;\n}\nheader .top-strip .right-side .social-links li {\n  padding: 0 10px;\n}\nheader .top-strip .right-side .social-links li svg {\n  fill: #fff;\n  vertical-align: middle;\n}\nheader .header-wapper {\n  position: relative;\n  z-index: 1;\n  padding: 10px 0;\n}\nheader .header-wapper .flex {\n  align-items: center;\n  -webkit-box-align: center;\n}\nheader .header-wapper .flex .col1 {\n  flex: 0 1 20%;\n  max-width: 20%;\n}\n@media (max-width: 1024px) {\n  header .header-wapper .flex .col1 {\n    flex: 0 1 20%;\n    max-width: 20%;\n  }\n}\nheader .header-wapper .flex .col2 {\n  flex: 0 1 80%;\n  max-width: 80%;\n}\n@media (max-width: 1024px) {\n  header .header-wapper .flex .col2 {\n    flex: 0 1 80%;\n    max-width: 80%;\n  }\n}\nheader .header-wapper .menu-trigger {\n  width: 40px;\n  height: 36px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  cursor: pointer;\n  display: none;\n  transform: translateY(-50%);\n}\n@media (max-width: 767px) {\n  header .header-wapper .menu-trigger {\n    display: block;\n    right: 15px;\n  }\n}\nheader .header-wapper .menu-trigger span {\n  display: block;\n  height: 1px;\n  background: #ffffff;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n}\nheader .header-wapper .menu-trigger span.sma {\n  top: 27%;\n  width: 20px;\n}\nheader .header-wapper .menu-trigger span.smb {\n  display: block;\n  width: 30px;\n}\nheader .header-wapper .menu-trigger span.smc {\n  display: block;\n  bottom: 26%;\n  top: auto;\n}\nheader .header-wapper .custom-nav {\n  text-align: right;\n}\nheader .header-wapper .custom-nav ul {\n  display: inline-block;\n}\n@media (max-width: 767px) {\n  header .header-wapper .custom-nav ul {\n    display: none;\n  }\n}\nheader .header-wapper .custom-nav ul li {\n  display: inline-block;\n}\nheader .header-wapper .custom-nav ul li:nth-child(3).has-dropdown ul.dropdown {\n  width: 150px;\n}\n@media (max-width: 991px) {\n  header .header-wapper .custom-nav ul li:last-child {\n    display: none;\n  }\n}\nheader .header-wapper .custom-nav ul li.has-dropdown {\n  position: relative;\n  margin-right: 10px;\n}\nheader .header-wapper .custom-nav ul li.has-dropdown ul.dropdown {\n  position: absolute;\n  left: 0;\n  width: 290px;\n  top: 40px;\n  background: #da3467;\n  padding: 8px 0;\n  text-align: left;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  box-shadow: 0 6px 13px 1px rgba(51, 51, 51, 0.1803921569);\n  border-radius: 5px;\n  transition: 400ms ease;\n}\nheader .header-wapper .custom-nav ul li.has-dropdown ul.dropdown::before {\n  content: \"\";\n  position: absolute;\n  top: -16px;\n  width: 8px;\n  height: 8px;\n  border: 8px solid transparent;\n  border-bottom-color: #da3467;\n  left: 43px;\n}\nheader .header-wapper .custom-nav ul li.has-dropdown ul.dropdown li {\n  display: block;\n}\nheader .header-wapper .custom-nav ul li.has-dropdown ul.dropdown li a {\n  display: block;\n  color: #fff;\n  padding: 9px 15px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  transition: 700ms ease;\n}\nheader .header-wapper .custom-nav ul li.has-dropdown .dd-icon {\n  display: inline-block;\n  margin-left: 10px;\n}\nheader .header-wapper .custom-nav ul li.has-dropdown:hover .dropdown {\n  opacity: 1;\n  pointer-events: all;\n}\nheader .header-wapper .custom-nav ul li.has-dropdown:hover .dropdown li:hover a {\n  background: #fff;\n  color: #666666;\n}\nheader .header-wapper .custom-nav ul li a {\n  color: #fff;\n  padding: 19px 15px;\n}\nheader .header-wapper .custom-nav .demo-link {\n  display: inline-block;\n  padding-left: 19px;\n}\n@media (max-width: 991px) {\n  header .header-wapper .custom-nav .demo-link {\n    display: none;\n  }\n}\nheader .header-wapper .custom-nav .demo-link a {\n  position: relative;\n  color: #fff;\n  padding: 10px 15px;\n  border: 2px solid #fff;\n  border-radius: 50px;\n  background: #da3467;\n}\nheader .header-wapper .custom-nav .demo-link a span {\n  z-index: 1;\n  position: relative;\n}\nheader .header-wapper .custom-nav .demo-link a:hover::before {\n  width: 100%;\n  transform: translateX(0%);\n}\nheader.header-fixed {\n  position: fixed !important;\n  width: 100%;\n  animation: stickyanimations 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n  box-shadow: 10px 0 20px rgba(8, 0, 41, 0.08);\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 111;\n}\n\n@keyframes name {\n  0% {\n    transform: translateY(-100px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n.custom-logo {\n  line-height: 0;\n}\n.custom-logo a {\n  display: block;\n}\n.custom-logo a img {\n  -webkit-transform: 450ms ease;\n  transition: 450ms ease;\n  width: 80px;\n  filter: invert(1);\n}\n\n@keyframes stickyanimations {\n  0% {\n    transform: translateY(-100px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n.model.model-navigation {\n  overflow-y: scroll;\n}\n.model.model-navigation, .model.EnquiryModel {\n  background: #222222;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  max-width: 360px;\n  width: 100%;\n  padding: 50px;\n  transform: translateX(100%);\n  transition: 450ms ease;\n}\n.model.model-navigation.is-open, .model.EnquiryModel.is-open {\n  transform: translate(0%);\n}\n.model.model-navigation .navover, .model.EnquiryModel .navover {\n  position: absolute;\n  bottom: 5px;\n  right: 20px;\n  opacity: 0.2;\n}\n.model.model-navigation .navover img, .model.EnquiryModel .navover img {\n  width: 200px;\n  filter: invert(1);\n}\n.model.model-navigation .close_model img, .model.EnquiryModel .close_model img {\n  filter: invert(1);\n}\n.model.model-navigation .modelBody, .model.EnquiryModel .modelBody {\n  height: 100%;\n}\n.model.model-navigation .modelBody.contactform, .model.EnquiryModel .modelBody.contactform {\n  padding-top: 40px;\n}\n.model.model-navigation .modelBody .navigation-list, .model.EnquiryModel .modelBody .navigation-list {\n  height: 100%;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav, .model.EnquiryModel .modelBody .navigation-list .serviice_nav {\n  padding: 40px 0;\n  position: relative;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav ul .nablist, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul .nablist {\n  width: 100%;\n  position: relative;\n  cursor: pointer;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav ul li, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li {\n  position: relative;\n  display: block;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav ul li a, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li a {\n  display: inline-block;\n  color: #e5e5e5;\n  font-size: 23px;\n  padding: 6px 0;\n  margin: 4px 0;\n  line-height: 30px;\n  font-weight: 600;\n  transition: 450ms ease;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .nablisting, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .nablisting {\n  padding-left: 20px;\n  display: none;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .nablisting.open, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .nablisting.open {\n  display: block;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .nablisting li a, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .nablisting li a {\n  font-size: 16px;\n  margin: 0;\n  margin-bottom: 3px;\n  font-weight: 300px;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav ul li .downarrow, .model.EnquiryModel .modelBody .navigation-list .serviice_nav ul li .downarrow {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.model.model-navigation .modelBody .navigation-list .serviice_nav::after, .model.EnquiryModel .modelBody .navigation-list .serviice_nav::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 2px;\n  background: #fff;\n  opacity: 0.2;\n}\n.model.model-navigation .modelBody .navigation-list .nav_list, .model.EnquiryModel .modelBody .navigation-list .nav_list {\n  position: relative;\n  padding: 40px 0;\n}\n.model.model-navigation .modelBody .navigation-list .nav_list ul li, .model.EnquiryModel .modelBody .navigation-list .nav_list ul li {\n  margin-bottom: 10px;\n}\n.model.model-navigation .modelBody .navigation-list .nav_list ul li a, .model.EnquiryModel .modelBody .navigation-list .nav_list ul li a {\n  color: #fff;\n  font-size: 16px;\n  padding: 6px 0;\n  margin: 4px 0;\n  transition: 450ms ease;\n}\n.model.model-navigation .modelBody .navigation-list .social-links ul li, .model.EnquiryModel .modelBody .navigation-list .social-links ul li {\n  display: inline-block;\n  margin: 0 5px;\n}\n.model.model-navigation .modelBody .navigation-list .social-links ul li:first-child, .model.EnquiryModel .modelBody .navigation-list .social-links ul li:first-child {\n  margin-left: 0;\n}\n.model.model-navigation .modelBody .navigation-list .social-links ul li a, .model.EnquiryModel .modelBody .navigation-list .social-links ul li a {\n  width: 30px;\n  height: 30px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  transition: 450ms ease;\n}\n.model.model-navigation .modelBody .navigation-list .social-links ul li a svg, .model.EnquiryModel .modelBody .navigation-list .social-links ul li a svg {\n  fill: #da3467;\n}\n.model.model-navigation .modelBody .back-input, .model.model-navigation .modelBody .back-textarea, .model.EnquiryModel .modelBody .back-input, .model.EnquiryModel .modelBody .back-textarea {\n  position: relative;\n  margin-bottom: 25px;\n}\n.model.model-navigation .modelBody .back-input .frm-cntrl, .model.model-navigation .modelBody .back-textarea .frm-cntrl, .model.EnquiryModel .modelBody .back-input .frm-cntrl, .model.EnquiryModel .modelBody .back-textarea .frm-cntrl {\n  background: none;\n  border: none;\n  width: 100%;\n  display: block;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  padding: 10px 25px;\n  color: #fff;\n  border-radius: 10px;\n  border: 2px solid #2e2d2d;\n  transition: all 1s ease;\n}\n.model.model-navigation .modelBody .back-input .frm-cntrl:focus ~ label, .model.model-navigation .modelBody .back-textarea .frm-cntrl:focus ~ label, .model.EnquiryModel .modelBody .back-input .frm-cntrl:focus ~ label, .model.EnquiryModel .modelBody .back-textarea .frm-cntrl:focus ~ label {\n  top: -12px;\n  background: #222222;\n  padding: 0 10px;\n}\n.model.model-navigation .modelBody .back-input .frm-cntrl:valid ~ label, .model.model-navigation .modelBody .back-textarea .frm-cntrl:valid ~ label, .model.EnquiryModel .modelBody .back-input .frm-cntrl:valid ~ label, .model.EnquiryModel .modelBody .back-textarea .frm-cntrl:valid ~ label {\n  top: -12px;\n  background: #222222;\n  padding: 0 10px;\n}\n.model.model-navigation .modelBody .back-input label, .model.model-navigation .modelBody .back-textarea label, .model.EnquiryModel .modelBody .back-input label, .model.EnquiryModel .modelBody .back-textarea label {\n  position: absolute;\n  color: #fff;\n  left: 10px;\n  top: 10px;\n  transition: 750ms ease;\n}\n.model.model-navigation .modelBody .back-input .custom, .model.model-navigation .modelBody .back-textarea .custom, .model.EnquiryModel .modelBody .back-input .custom, .model.EnquiryModel .modelBody .back-textarea .custom {\n  display: inline-block;\n  margin-right: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  width: auto;\n}\n.model.model-navigation .modelBody .back-input .text, .model.model-navigation .modelBody .back-textarea .text, .model.EnquiryModel .modelBody .back-input .text, .model.EnquiryModel .modelBody .back-textarea .text {\n  display: inline-block;\n  vertical-align: middle;\n  color: #fff;\n}\n.model.model-navigation .modelBody .back-input .error, .model.model-navigation .modelBody .back-textarea .error, .model.EnquiryModel .modelBody .back-input .error, .model.EnquiryModel .modelBody .back-textarea .error {\n  color: red;\n  display: block;\n  margin-top: 5px;\n  font-size: 12px;\n  line-height: 1;\n}\n.model.model-navigation .modelBody .demo-link, .model.EnquiryModel .modelBody .demo-link {\n  background: #fff;\n  text-align: center;\n  padding: 8px 15px;\n  border-radius: 10px;\n  border: 0;\n  width: 100%;\n}\n.model.model-navigation .modelBody .demo-link:hover, .model.EnquiryModel .modelBody .demo-link:hover {\n  background: #da3467;\n}\n.model.model-navigation .modelBody .demo-link:hover a, .model.EnquiryModel .modelBody .demo-link:hover a {\n  color: #fff;\n}\n.model.model-navigation .modelBody .demo-link a, .model.EnquiryModel .modelBody .demo-link a {\n  color: #666666;\n}\n\n.model.model-video {\n  max-width: 1000px;\n  width: 100%;\n  left: 50%;\n  top: 100%;\n  transform: translate(-50%, 100%);\n  background: #fff;\n  transition: all 1s ease;\n}\n.model.model-video.is-open {\n  transform: translate(-50%, -50%);\n  top: 50%;\n}\n.model.model-video .modelBody {\n  width: 100%;\n  line-height: 0;\n}\n.model.model-video .modelBody iframe {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  border: 0;\n  padding: 50px 0;\n  padding-bottom: 30px;\n}\n.model.model-video .modelBody video {\n  height: 400px;\n  width: 100%;\n}\n\n.demo-video {\n  width: 100%;\n  line-height: 0;\n  height: 500px;\n  background: #272727;\n}\n@media (max-width: 767px) {\n  .demo-video {\n    height: 100%;\n  }\n}\n.demo-video video {\n  width: 100%;\n  height: 100%;\n}\n\n/*----------------- sectionA ----------------*/\n.about-app {\n  position: relative;\n  padding: 35px 0;\n  background: #272727;\n}\n.about-app .flex {\n  align-items: center;\n}\n.about-app .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n.about-app .flex .col:first-child {\n  padding-right: 30px;\n}\n@media (max-width: 767px) {\n  .about-app .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.about-app .flex.aiplatform {\n  justify-content: center;\n}\n.about-app .flex.aiplatform .col {\n  flex: 0 1 48%;\n  max-width: 48%;\n  padding: 0;\n  margin: 0 10px;\n  margin-bottom: 20px;\n}\n.about-app .bullet_points {\n  display: none;\n}\n@media (max-width: 767px) {\n  .about-app .bullet_points {\n    display: block;\n  }\n}\n.about-app .item {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.about-app .item .num {\n  background: #da3467;\n  height: 100px;\n  width: 25%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10rem 0 0 10rem;\n}\n.about-app .item .num span {\n  color: #fff;\n  font-size: 24px;\n  margin-right: 2rem;\n}\n.about-app .item .circle {\n  background: #fff;\n  width: 100px;\n  height: 100px;\n  border-radius: 100%;\n  position: absolute;\n  left: 6rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.about-app .item .circle::before {\n  position: absolute;\n  content: \"\";\n  width: 85px;\n  height: 85px;\n  background: transparent;\n  border-radius: 100%;\n  border: 4px solid #da3467;\n}\n.about-app .item .circle .round {\n  border-radius: 100%;\n  width: 60px;\n  height: 60px;\n  background: #da3467;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.about-app .item .circle .round img {\n  width: 30px;\n}\n.about-app .item .desc {\n  background: #525252;\n  padding: 1rem 30px 1rem 4rem;\n  border-radius: 0 10rem 10rem 0;\n  height: 100px;\n  width: 75%;\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 767px) {\n  .about-app .item {\n    display: none;\n  }\n}\n.about-app .item p {\n  color: #e4e4e4;\n  font-size: 17px;\n  font-weight: 400;\n}\n.about-app .item p span {\n  color: #da3467;\n  font-weight: 700;\n}\n.about-app .content {\n  margin-bottom: 50px;\n}\n.about-app .content h2 {\n  font-size: 48px;\n  color: #fff;\n  padding-bottom: 20px;\n}\n@media (max-width: 767px) {\n  .about-app .content h2 {\n    font-size: 28px;\n  }\n}\n.about-app .content span {\n  color: #da3467;\n}\n.about-app .content li {\n  font-size: 16px;\n}\n\n/*----------------- sectionA ----------------*/\n.home-sec-A .item {\n  height: 60vh;\n  position: relative;\n  transition: all 1s ease;\n}\n.home-sec-A .item img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.home-sec-A .item .cover {\n  padding: 75px 100px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 991px) {\n  .home-sec-A .item .cover {\n    padding: 75px 30px;\n  }\n}\n.home-sec-A .item .cover .header-content {\n  position: relative;\n  padding: 56px;\n  overflow: hidden;\n}\n@media (max-width: 767px) {\n  .home-sec-A .item .cover .header-content {\n    padding: 20PX;\n  }\n}\n.home-sec-A .item .cover .header-content .line {\n  content: \"\";\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  position: absolute;\n  border: 9px solid #fff;\n  -webkit-clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%);\n  clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%);\n  pointer-events: none;\n}\n@media (max-width: 991px) {\n  .home-sec-A .item .cover .header-content .line {\n    -webkit-clip-path: polygon(0 0, 90% 0, 55% 100%, 0 100%);\n            clip-path: polygon(0 0, 90% 0, 55% 100%, 0 100%);\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-A .item .cover .header-content .line {\n    border: 5px solid #fff;\n  }\n}\n.home-sec-A .item .cover .header-content h1 {\n  color: #fff;\n  font-size: 36px;\n  line-height: 1.5;\n  margin-bottom: 20px;\n}\n@media (max-width: 1024px) {\n  .home-sec-A .item .cover .header-content h1 {\n    font-size: 30px;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-A .item .cover .header-content h1 {\n    font-size: 20px;\n  }\n}\n.home-sec-A .item .cover .header-content .readmore a {\n  color: #da3467;\n  font-size: 14px;\n  background: #fff;\n  padding: 8px 25px;\n  border-radius: 10px;\n  margin-top: 20px;\n  margin-left: 8rem;\n  font-weight: 600;\n  display: inline-block;\n}\n@media (max-width: 767px) {\n  .home-sec-A .item .cover .header-content .readmore a {\n    margin-left: 4rem;\n  }\n}\n.home-sec-A .owl-item.active h2 {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n  animation-name: fadeInDown;\n  animation-delay: 0.3s;\n  color: #fff;\n}\n.home-sec-A .owl-item.active .line {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n  animation-name: fadeInLeft;\n  animation-delay: 0.3s;\n}\n.home-sec-A .owl-nav {\n  display: none;\n}\n.home-sec-A .owl-nav .owl-prev {\n  position: absolute;\n  left: 15px;\n  top: 43%;\n  opacity: 0;\n  transition: all 0.4s ease-out;\n  background: rgba(0, 0, 0, 0.5) !important;\n  width: 40px;\n  cursor: pointer;\n  height: 40px;\n  position: absolute;\n  display: block;\n  z-index: 1000;\n  border-radius: 0;\n}\n.home-sec-A .owl-nav .owl-prev span {\n  font-size: 1.6875rem;\n  color: #fff;\n}\n.home-sec-A .owl-nav .owl-prev:focus {\n  outline: 0;\n}\n.home-sec-A .owl-nav .owl-prev:hover {\n  background: #000 !important;\n}\n.home-sec-A .owl-nav .owl-next {\n  position: absolute;\n  right: 15px;\n  top: 43%;\n  opacity: 0;\n  transition: all 0.4s ease-out;\n  background: rgba(0, 0, 0, 0.5) !important;\n  width: 40px;\n  cursor: pointer;\n  height: 40px;\n  position: absolute;\n  display: block;\n  z-index: 1000;\n  border-radius: 0;\n}\n.home-sec-A .owl-nav .owl-next span {\n  font-size: 1.6875rem;\n  color: #fff;\n}\n.home-sec-A .owl-nav .owl-next:focus {\n  outline: 0;\n}\n.home-sec-A .owl-nav .owl-next:hover {\n  background: #000 !important;\n}\n.home-sec-A:hover .owl-prev {\n  left: 0px;\n  opacity: 1;\n}\n.home-sec-A:hover .owl-next {\n  right: 0px;\n  opacity: 1;\n}\n.home-sec-A .owl-dots {\n  text-align: center;\n  height: auto;\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n}\n\n/*----------------- sectionB ----------------*/\n.home-sec-B1 {\n  position: relative;\n  padding: 50px 0;\n  overflow: hidden;\n  background: #e7e7e7;\n  height: 95vh;\n}\n@media (max-width: 767px) {\n  .home-sec-B1 {\n    display: none;\n  }\n}\n.home-sec-B1 .heading {\n  margin-bottom: 7em;\n}\n.home-sec-B1 .heading h1 {\n  font-size: 40px;\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .challenges {\n    transform: rotate(90deg);\n    position: relative;\n    top: 15rem;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-B1 .challenges {\n    transform: rotate(90deg);\n    position: relative;\n    top: 0;\n  }\n}\n.home-sec-B1 .flex::before {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: url(../images/line.png) no-repeat center;\n  background-size: 80%;\n  left: 0px;\n  top: 35px;\n  pointer-events: none;\n}\n.home-sec-B1 .col {\n  flex: 0 1 16.6%;\n  max-width: 16.6%;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  gap: 110px;\n  flex-direction: column;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col {\n    gap: 90px;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col {\n    gap: 50px;\n  }\n}\n.home-sec-B1 .col .hexa {\n  position: relative;\n  width: 6rem;\n  height: 10rem;\n  background: #b5b5b5;\n  border-radius: 1em/0.5em;\n  top: 3rem;\n  left: -1rem;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col .hexa {\n    left: 2rem;\n    top: 1rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col .hexa {\n    width: 5rem;\n    height: 8rem;\n    left: 4rem;\n    top: 5.5rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col .hexa {\n    left: 3rem;\n    top: 1.5rem;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-B1 .col .hexa {\n    width: 4rem;\n    height: 6rem;\n    left: 3rem;\n    top: 1.5rem;\n  }\n}\n.home-sec-B1 .col .hexa.hexa2 {\n  left: 0.2rem;\n  top: -3rem;\n  background: #2f586a;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col .hexa.hexa2 {\n    top: -5rem;\n    left: 2.5rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col .hexa.hexa2 {\n    left: 3.5rem;\n    top: 0;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col .hexa.hexa2 {\n    left: 2.5rem;\n    top: 1.5rem;\n  }\n}\n.home-sec-B1 .col .hexa.hexa3 {\n  left: 2.5rem;\n  background: #00b5d0;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col .hexa.hexa3 {\n    top: 1rem;\n    left: 3.5rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col .hexa.hexa3 {\n    left: 3.3rem;\n    top: 5.5rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col .hexa.hexa3 {\n    left: 2rem;\n    top: 1.5rem;\n  }\n}\n.home-sec-B1 .col .hexa.hexa4 {\n  top: -3rem;\n  left: 5rem;\n  background: #ee073f;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col .hexa.hexa4 {\n    top: -5rem;\n    left: 4rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col .hexa.hexa4 {\n    left: 3rem;\n    top: 0;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col .hexa.hexa4 {\n    left: 1.5rem;\n    top: 1.5rem;\n  }\n}\n.home-sec-B1 .col .hexa.hexa5 {\n  left: 7rem;\n  background: #ffad27;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col .hexa.hexa5 {\n    top: 1rem;\n    left: 5rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col .hexa.hexa5 {\n    left: 2.5rem;\n    top: 5.5rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col .hexa.hexa5 {\n    left: 1.2rem;\n    top: 1.5rem;\n  }\n}\n.home-sec-B1 .col .hexa.hexa6 {\n  top: -3rem;\n  left: 10rem;\n  background: #8f4a81;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col .hexa.hexa6 {\n    top: -5rem;\n    left: 6rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col .hexa.hexa6 {\n    left: 2rem;\n    top: 0;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col .hexa.hexa6 {\n    left: 1.5rem;\n    top: 1.5rem;\n  }\n}\n.home-sec-B1 .col .hexa::before, .home-sec-B1 .col .hexa::after {\n  position: absolute;\n  content: \"\";\n  width: inherit;\n  height: inherit;\n  background: inherit;\n  border-radius: inherit;\n}\n.home-sec-B1 .col .hexa::before {\n  transform: rotate(60deg);\n}\n.home-sec-B1 .col .hexa::after {\n  transform: rotate(-60deg);\n}\n.home-sec-B1 .col p {\n  text-align: center;\n  position: relative;\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col p {\n    transform: rotate(-90deg);\n    width: 200px;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-B1 .col p {\n    font-size: 12px;\n  }\n}\n.home-sec-B1 .col p.text {\n  left: -5rem;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col p.text {\n    left: -1rem;\n    top: -2rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col p.text {\n    left: 2rem;\n    top: 3rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col p.text {\n    left: -1rem;\n    top: 6rem;\n  }\n}\n.home-sec-B1 .col p.text2 {\n  left: -3rem;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col p.text2 {\n    top: -2rem;\n    left: -1rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col p.text2 {\n    left: 1rem;\n    top: 1rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col p.text2 {\n    left: -1.5rem;\n    top: -3rem;\n  }\n}\n.home-sec-B1 .col p.text3 {\n  top: -1rem;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col p.text3 {\n    left: -0.5rem;\n    top: -4rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col p.text3 {\n    left: 0.5rem;\n    top: 3rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col p.text3 {\n    left: -2rem;\n    top: 6rem;\n  }\n}\n.home-sec-B1 .col p.text4 {\n  left: 1rem;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col p.text4 {\n    top: -2rem;\n    left: 1rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col p.text4 {\n    left: 0.5rem;\n    top: 1rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col p.text4 {\n    left: -2rem;\n    top: -3rem;\n  }\n}\n.home-sec-B1 .col p.text5 {\n  top: -1rem;\n  left: 4rem;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col p.text5 {\n    left: 1rem;\n    top: -4rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col p.text5 {\n    left: 0rem;\n    top: 3rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col p.text5 {\n    left: -2rem;\n    top: 6rem;\n  }\n}\n.home-sec-B1 .col p.text6 {\n  left: 5rem;\n}\n@media (max-width: 1440px) {\n  .home-sec-B1 .col p.text6 {\n    top: -2rem;\n    left: 1rem;\n  }\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col p.text6 {\n    left: 0rem;\n    top: 2rem;\n  }\n}\n@media (max-width: 991px) {\n  .home-sec-B1 .col p.text6 {\n    left: -3rem;\n    top: -3rem;\n  }\n}\n.home-sec-B1 .col .icon {\n  position: absolute;\n  top: 32px;\n  z-index: 1;\n}\n@media (max-width: 1024px) {\n  .home-sec-B1 .col .icon {\n    top: 22px;\n  }\n}\n.home-sec-B1 .col .icon img {\n  border-radius: 100%;\n  filter: grayscale(1);\n}\n\n/*--------------------------- main-sec ------------------------*/\n.main-sec {\n  position: relative;\n  padding: 50px 0;\n  background: #272727;\n  z-index: 1;\n}\n.main-sec .heading {\n  position: relative;\n}\n.main-sec .heading h1 {\n  color: #fff;\n  font-size: 40px;\n}\n@media (max-width: 1024px) {\n  .main-sec .heading h1 {\n    font-size: 36px;\n    margin-bottom: 50px;\n  }\n}\n@media (max-width: 767px) {\n  .main-sec .heading h1 {\n    font-size: 28px;\n    line-height: 1.5;\n  }\n}\n.main-sec .flex {\n  justify-content: center;\n}\n.main-sec .flex .col {\n  flex: 0 1 100%;\n  max-width: 100%;\n  margin: 0 10px;\n  position: relative;\n  margin-bottom: 1rem;\n}\n.main-sec .content {\n  background: linear-gradient(45deg, white, #b7b7b7);\n  width: 50%;\n  border-radius: 50px;\n  padding: 20px;\n  padding-left: 7rem;\n  border: 10px solid;\n  border-color: #da3467;\n  margin: 0 auto;\n}\n.main-sec .content h3 {\n  margin-bottom: 10px;\n}\n.main-sec .content .rounded {\n  background: linear-gradient(45deg, #da3467, #da537c);\n  display: inline-block;\n  position: absolute;\n  left: 22rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 70px;\n  height: 70px;\n  border-radius: 100% !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.main-sec .content .rounded span {\n  color: #fff;\n  font-size: 20px;\n}\n.main-sec .content .bullet_points li {\n  color: #2e2d2d;\n}\n.main-sec .content .bullet_points li::before {\n  background: #da3467;\n}\n\n/*--------------------------- sectionC ------------------------*/\n.home-sec-C {\n  padding: 50px 0;\n}\n@media (max-width: 767px) {\n  .home-sec-C {\n    background: #e8e8e8;\n  }\n}\n.home-sec-C .heading {\n  margin-bottom: 50px;\n}\n.home-sec-C .heading h1 {\n  font-size: 40px;\n}\n@media (max-width: 1024px) {\n  .home-sec-C .heading h1 {\n    font-size: 36px;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-C .heading h1 {\n    font-size: 24px;\n  }\n}\n.home-sec-C .homeslider .owl-stage-outer .owl-item {\n  transform: scale(0.9);\n  opacity: 0.8;\n}\n.home-sec-C .homeslider .owl-stage-outer .owl-item.center {\n  transform: scale(1.3);\n  position: relative;\n  z-index: 1;\n  opacity: 1;\n}\n.home-sec-C .homeslider .owl-stage-outer .owl-item.center .itemslider .card .card__link {\n  display: block;\n}\n.home-sec-C .homeslider .owl-dots {\n  text-align: center;\n}\n.home-sec-C .homeslider .owl-dots .owl-dot {\n  background: #d2d2d2;\n}\n.home-sec-C .homeslider .itemslider {\n  position: relative;\n  transition: transform 400ms;\n}\n.home-sec-C .homeslider .itemslider .test {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 5;\n}\n.home-sec-C .homeslider .itemslider .card {\n  position: relative;\n  height: 100%;\n}\n.home-sec-C .homeslider .itemslider .card::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.7;\n  z-index: 1;\n}\n.home-sec-C .homeslider .itemslider .card .card__content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 11;\n}\n.home-sec-C .homeslider .itemslider .card .card__content .card__content-inner {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 32px;\n  color: rgb(255, 255, 255);\n  isolation: isolate;\n  z-index: 1;\n}\n.home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__excerpt {\n  margin-bottom: 16px;\n  font-size: 20px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n@media (max-width: 767px) {\n  .home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__excerpt {\n    font-size: 16px;\n    padding: 0 10px;\n  }\n}\n.home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__link {\n  padding: 5px 24px;\n  color: #ffffff;\n  text-decoration: none;\n  font-size: 14px;\n  line-height: 1.5;\n  display: none;\n  border: 1px solid rgb(255, 255, 255);\n  background: #da3467;\n  font-weight: 600;\n  border-radius: 10px;\n}\n@media (max-width: 767px) {\n  .home-sec-C .homeslider .itemslider .card .card__content .card__content-inner .card__link {\n    padding: 5px 15px;\n    font-size: 10px;\n  }\n}\n\n/*--------------------------- sectionD ------------------------*/\n.home-sec-D {\n  position: relative;\n  padding: 50px 0;\n}\n@media (max-width: 767px) {\n  .home-sec-D {\n    background: #ffffff;\n  }\n}\n.home-sec-D .heading h1 {\n  font-size: 40px;\n}\n.home-sec-D .flex {\n  justify-content: center;\n}\n.home-sec-D .flex .col {\n  flex: 0 1 25%;\n  max-width: 25%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-bottom: 30px;\n  flex-direction: column;\n}\n@media (max-width: 991px) {\n  .home-sec-D .flex .col {\n    max-width: 33.33%;\n    flex: 0 1 33.33;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-D .flex .col {\n    max-width: 100%;\n    flex: 0 1 100%;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-D .flex .col:last-child svg, .home-sec-D .flex .col:nth-last-child(2) svg {\n    top: 0;\n  }\n}\n.home-sec-D .flex .outer {\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  padding: 20px;\n  box-shadow: 6px 6px 10px -1px rgba(0, 0, 0, 0.15), -6px -6px 10px -1px rgba(176, 176, 176, 0.5);\n}\n.home-sec-D .flex .outer .inner {\n  width: 120px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  box-shadow: inset 4px 4px 6px -1px rgba(134, 134, 134, 0.2), inset -4px -4px 6px -1px rgba(202, 202, 202, 0.7), -0.5px -0.5px 0 rgb(225, 225, 225);\n}\n.home-sec-D .flex .outer .inner span {\n  font-size: 20px;\n  color: #da3467;\n  font-weight: 600;\n  display: inline-block;\n}\n.home-sec-D .flex circle {\n  fill: none;\n  stroke: url(#GradientColor);\n  stroke-width: 20px;\n  stroke-dasharray: 472;\n  stroke-dashoffset: 472;\n  animation: anim 2s linear forwards;\n}\n.home-sec-D .flex svg {\n  position: absolute;\n  top: 0;\n}\n.home-sec-D .flex .name {\n  margin-top: 10px;\n  font-size: 16px;\n}\n@media (max-width: 1024px) {\n  .home-sec-D .flex .name {\n    font-size: 14px;\n  }\n}\n\n@keyframes anim {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n/*--------------------------- sectionE ------------------------*/\n.home-sec-E {\n  position: relative;\n  padding: 50px 0;\n}\n@media (max-width: 767px) {\n  .home-sec-E {\n    padding: 30px 0;\n  }\n}\n.home-sec-E .heading {\n  margin-bottom: 30px;\n  text-align: center;\n}\n.home-sec-E .heading h1 {\n  font-size: 40px;\n}\n.home-sec-E .partners {\n  position: relative;\n}\n.home-sec-E .partners .flex {\n  align-items: center;\n}\n.home-sec-E .partners .flex .col {\n  flex: 0 1 20%;\n  max-width: 20%;\n}\n@media (max-width: 991px) {\n  .home-sec-E .partners .flex .col {\n    flex: 33.33%;\n    max-width: 33.33%;\n  }\n}\n@media (max-width: 767px) {\n  .home-sec-E .partners .flex .col {\n    flex: 50%;\n    max-width: 50%;\n  }\n}\n.home-sec-E .partners .logo {\n  width: 150px;\n  max-width: 100%;\n}\n@media (max-width: 767px) {\n  .home-sec-E .partners .logo {\n    width: 100px;\n    margin: 0 auto;\n  }\n}\n.home-sec-E .partners .logo img {\n  width: 100%;\n  filter: grayscale(1);\n}\n\n/*-------------------- testimonial-sec-------------------*/\n.testimonial-sec {\n  background: #e7e7e7;\n  position: relative;\n  padding: 60px 0;\n}\n.testimonial-sec .heading {\n  margin-bottom: 50px;\n}\n.testimonial-sec .heading h1 {\n  font-size: 40px;\n  color: #666666;\n}\n@media (max-width: 767px) {\n  .testimonial-sec .heading h1 {\n    font-size: 30px;\n  }\n}\n.testimonial-sec .owl-carousel {\n  overflow: hidden;\n  padding: 0 20px;\n  margin: 0px -40px;\n  padding-right: 40px;\n}\n@media (max-width: 767px) {\n  .testimonial-sec .owl-carousel {\n    margin: 0;\n    padding-right: 0;\n  }\n}\n.testimonial-sec .owl-stage-outer {\n  padding: 30px 50px;\n  margin-left: -43px;\n  width: calc(100% + 62px);\n}\n@media (max-width: 767px) {\n  .testimonial-sec .owl-stage-outer {\n    width: inherit;\n    margin-left: 0;\n    padding: 0;\n  }\n}\n@media (max-width: 767px) {\n  .testimonial-sec .testimonial-card {\n    padding: 20px;\n  }\n}\n.testimonial-sec .single-testimonial {\n  border: 7px solid #222222;\n  text-align: center;\n  border-radius: 45px;\n  position: relative;\n  z-index: 2;\n  height: 407px;\n}\n@media (max-width: 767px) {\n  .testimonial-sec .single-testimonial {\n    height: inherit;\n  }\n}\n.testimonial-sec .single-testimonial p {\n  color: #222;\n  font-size: 14px;\n  line-height: 24px;\n  padding: 50px;\n  padding-bottom: 30px;\n  position: relative;\n  z-index: 3;\n}\n.testimonial-sec .single-testimonial::before {\n  content: \"\";\n  position: absolute;\n  left: -35px;\n  top: -35px;\n  background: url(../images/quote.png) no-repeat #e7e7e7;\n  background-size: 60%;\n  width: 126px;\n  height: 100px;\n  transform: rotate(180deg);\n  background-position: 34px 15px;\n}\n.testimonial-sec .single-testimonial::after {\n  content: \"\";\n  position: absolute;\n  right: -35px;\n  bottom: -34px;\n  background: url(../images/quote.png) no-repeat #e7e7e7;\n  background-size: 60%;\n  width: 126px;\n  height: 100px;\n  background-position: 34px 19px;\n}\n@media (max-width: 767px) {\n  .testimonial-sec .single-testimonial::after {\n    bottom: -45px;\n  }\n}\n.testimonial-sec .single-testimonial .round {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 1;\n}\n.testimonial-sec .single-testimonial .round-1::before {\n  content: \"\";\n  position: absolute;\n  left: 88px;\n  top: -6.7px;\n  width: 50px;\n  height: 7px;\n  background: #222222;\n  border-radius: 30px;\n}\n.testimonial-sec .single-testimonial .round-1::after {\n  content: \"\";\n  position: absolute;\n  left: -6.5px;\n  top: 62px;\n  width: 7px;\n  height: 50px;\n  background: #222222;\n  border-radius: 30px;\n}\n.testimonial-sec .single-testimonial .round-2::before {\n  content: \"\";\n  position: absolute;\n  right: 87px;\n  bottom: -7px;\n  width: 50px;\n  height: 7px;\n  background: #222222;\n  border-radius: 30px;\n  z-index: 1;\n}\n.testimonial-sec .single-testimonial .round-2::after {\n  content: \"\";\n  position: absolute;\n  right: -6.5px;\n  bottom: 62px;\n  width: 7px;\n  height: 50px;\n  background: #222222;\n  border-radius: 30px;\n  z-index: 1;\n}\n@media (max-width: 767px) {\n  .testimonial-sec .single-testimonial .round-2::after {\n    right: -7px;\n    bottom: 50px;\n  }\n}\n.testimonial-sec .single-testimonial .client-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: left;\n  padding-bottom: 50px;\n}\n.testimonial-sec .single-testimonial .client-info .client-img {\n  padding-right: 15px;\n}\n.testimonial-sec .single-testimonial .client-info .client-img img {\n  width: 60px;\n  height: 60px;\n  border-radius: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 0 16px rgba(0, 0, 0, 0.16);\n  font-size: 22px;\n}\n.testimonial-sec .single-testimonial .client-info h6 {\n  color: #000;\n  font-weight: 700;\n  font-size: 18px;\n}\n.testimonial-sec .single-testimonial .client-info span {\n  display: inline-block;\n  color: #000;\n  font-size: 12px;\n}\n\n.owl-dots {\n  text-align: center;\n  margin-top: 50px;\n}\n.owl-dots button {\n  background: #fff !important;\n  width: 10px;\n  height: 10px;\n  border-radius: 26px;\n  margin: 0 5px;\n  transition: 0.3s;\n}\n.owl-dots button.active {\n  width: 30px;\n}\n\n.review-sec {\n  position: relative;\n  padding: 30px 0;\n}\n.review-sec .flex {\n  justify-content: center;\n}\n.review-sec .flex .col {\n  flex: 0 1 31.33%;\n  max-width: 31.33%;\n}\n@media (max-width: 767px) {\n  .review-sec .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.review-sec iframe {\n  height: 50vh;\n}\n\n.case-study-sec {\n  position: relative;\n  padding: 50px 0;\n}\n.case-study-sec h2 {\n  margin-bottom: 20px;\n}\n.case-study-sec .swiper {\n  top: 5vh;\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: none;\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card {\n  position: relative;\n  margin: auto;\n  height: 70vh;\n  width: 90vw;\n  max-width: 1000px;\n  border-radius: 50px;\n  overflow: hidden;\n  background: #2e0916;\n  background: linear-gradient(331deg, #767676 0%, #252525 100%);\n}\n@media (max-width: 767px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card {\n    flex-direction: column;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper {\n  width: 100%;\n  height: 70%;\n  text-align: center;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 767px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper {\n    position: relative;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper img {\n  max-height: 80%;\n  width: auto;\n  position: relative;\n  animation: floatAnim 6s ease-in-out infinite;\n  border-radius: 20px;\n  border: 2px solid #da3467;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper img {\n    max-height: 60%;\n  }\n}\n@media (max-width: 767px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card .img-wrapper img {\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper {\n  left: -22%;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper {\n    left: 0;\n    right: 0;\n    height: auto;\n    width: 90%;\n    margin: 0 auto;\n    top: -10%;\n  }\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper img {\n    height: 350px;\n    width: 350px;\n  }\n}\n@media (max-width: 767px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .img-wrapper {\n    top: 5%;\n    left: inherit;\n    right: inherit;\n    display: block;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .img-wrapper {\n  right: -22%;\n  top: 0%;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .img-wrapper {\n    left: 0;\n    right: 0;\n    height: auto;\n    width: 90%;\n    margin: 0 auto;\n    top: -10%;\n    top: -2%;\n  }\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .img-wrapper img {\n    height: 300px;\n    width: 300px;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-content {\n  max-width: 445px;\n  width: 100%;\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  padding: 0 24px;\n}\n@media (max-width: 767px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-content {\n    top: inherit;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-content {\n  margin-left: auto;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-content {\n    max-width: 100%;\n    margin: 0;\n    transform: unset;\n    text-align: center;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-content {\n  margin-right: auto;\n  margin-left: 5%;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-content {\n    max-width: 100%;\n    margin: 0;\n    transform: unset;\n    text-align: center;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info {\n  position: absolute;\n  bottom: 8%;\n  line-height: 1;\n  color: #ffffff;\n  font-size: 1vw;\n  font-weight: 400;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info {\n    bottom: unset;\n    top: 25%;\n    font-size: 8px;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info .ghost-name {\n  font-size: 1.5vw;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info .ghost-name {\n    font-size: 14px;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info span {\n  height: 70px;\n  display: inline-block;\n  width: 0.5px;\n  background-color: #fff;\n  position: absolute;\n  bottom: 0px;\n}\n@media (max-width: 767px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info span {\n    color: rgb(255, 91, 121);\n    left: 50%;\n    height: 34px;\n    top: -42px;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info span:before {\n  content: \"\";\n  height: 5px;\n  width: 5px;\n  background-color: #fff;\n  position: absolute;\n  top: 0px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 50%;\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-ghost-info .indus-name {\n  font-size: 12px;\n  text-align: center;\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info {\n  left: 8%;\n  text-align: right;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info {\n    left: 3%;\n  }\n}\n@media (max-width: 767px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info {\n    left: 50%;\n    transform: translateX(-50%);\n    top: 49%;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(odd) .card-ghost-info span {\n  right: -15px;\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-ghost-info {\n  right: 8%;\n  text-align: left;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-ghost-info {\n    right: 3%;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide:nth-child(even) .card-ghost-info span {\n  left: -15px;\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-title {\n  max-width: 320px;\n  color: #fff;\n  font-weight: bold;\n  font-size: 2vw;\n  line-height: 1.3;\n  margin: 14px 0 25px;\n  position: relative;\n  color: #fff;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-title {\n    font-size: 24px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-title {\n    font-size: 20px;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-sub-title {\n  color: #da3467;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 1.1vw;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-sub-title {\n    font-size: 12px;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-description {\n  color: #fff;\n  font-weight: 500;\n  font-size: 14px;\n  max-width: 300px;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-description {\n    font-size: 10px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta {\n  margin-top: 30px;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta {\n    margin-top: 10px;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta .cta-button {\n  display: inline-block;\n  padding: 20px 40px;\n  background-color: #da3467;\n  color: white;\n  font-family: Arial, sans-serif;\n  font-size: 18px;\n  white-space: nowrap;\n  text-decoration: none;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  width: 161px;\n  height: 81px;\n  -webkit-clip-path: polygon(7.68786px 20.1081px, 7.68786px 20.1081px, 8.16364px 18.1351px, 8.88914px 16.2804px, 9.8446px 14.5617px, 11.0103px 12.9969px, 12.3663px 11.6038px, 13.8931px 10.4002px, 15.5708px 9.4038px, 17.3796px 8.63251px, 19.2998px 8.10411px, 21.3116px 7.83638px, 132.489px 0.710935px, 132.489px 0.710935px, 134.441px 0.714334px, 136.343px 0.968456px, 138.174px 1.46024px, 139.914px 2.17663px, 141.544px 3.10456px, 143.044px 4.23098px, 144.393px 5.54282px, 145.572px 7.02703px, 146.562px 8.67054px, 147.341px 10.4603px, 159.738px 44.9529px, 159.738px 44.9529px, 160.432px 47.6413px, 160.613px 50.3152px, 160.314px 52.9198px, 159.569px 55.4005px, 158.412px 57.7025px, 156.877px 59.7713px, 154.996px 61.5521px, 152.804px 62.9903px, 150.334px 64.0311px, 147.621px 64.62px, 16.6807px 80.5984px, 16.6807px 80.5984px, 13.7927px 80.6726px, 11.051px 80.2112px, 8.50526px 79.2659px, 6.20477px 77.8885px, 4.19901px 76.131px, 2.53742px 74.045px, 1.26946px 71.6825px, 0.444554px 69.0952px, 0.11216px 66.335px, 0.321718px 63.4536px, 7.68786px 20.1081px);\n          clip-path: polygon(7.68786px 20.1081px, 7.68786px 20.1081px, 8.16364px 18.1351px, 8.88914px 16.2804px, 9.8446px 14.5617px, 11.0103px 12.9969px, 12.3663px 11.6038px, 13.8931px 10.4002px, 15.5708px 9.4038px, 17.3796px 8.63251px, 19.2998px 8.10411px, 21.3116px 7.83638px, 132.489px 0.710935px, 132.489px 0.710935px, 134.441px 0.714334px, 136.343px 0.968456px, 138.174px 1.46024px, 139.914px 2.17663px, 141.544px 3.10456px, 143.044px 4.23098px, 144.393px 5.54282px, 145.572px 7.02703px, 146.562px 8.67054px, 147.341px 10.4603px, 159.738px 44.9529px, 159.738px 44.9529px, 160.432px 47.6413px, 160.613px 50.3152px, 160.314px 52.9198px, 159.569px 55.4005px, 158.412px 57.7025px, 156.877px 59.7713px, 154.996px 61.5521px, 152.804px 62.9903px, 150.334px 64.0311px, 147.621px 64.62px, 16.6807px 80.5984px, 16.6807px 80.5984px, 13.7927px 80.6726px, 11.051px 80.2112px, 8.50526px 79.2659px, 6.20477px 77.8885px, 4.19901px 76.131px, 2.53742px 74.045px, 1.26946px 71.6825px, 0.444554px 69.0952px, 0.11216px 66.335px, 0.321718px 63.4536px, 7.68786px 20.1081px);\n  transition: all 0.3s ease;\n}\n@media (max-width: 991px) {\n  .case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta .cta-button {\n    scale: 0.7;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n.case-study-sec .swiper .swiper-wrapper .swiper-slide .card-cta .cta-button:hover {\n  background-color: #fff;\n  color: #da3467;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.swiper-pagination {\n  text-align: center;\n  padding-left: 0;\n  bottom: 20px !important;\n}\n.swiper-pagination .swiper-pagination-bullet {\n  display: inline-block;\n  margin: 2px;\n  height: 6px;\n  width: 12px;\n  background: rgba(254, 121, 194, 0.8);\n  color: transparent;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: 0.5s ease;\n  border: 0;\n}\n.swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background: #da3467;\n  width: 25px;\n}\n\n.swing {\n  animation: swing 6s ease-in-out infinite;\n  transform-origin: left;\n}\n\n.swiper-slide-active .card-cta {\n  animation: bounce;\n  animation-duration: 2.5s;\n  animation-delay: 0.5s;\n}\n.swiper-slide-active .card-ghost-info div {\n  animation: fadeInLeft;\n  animation-duration: 1.5s;\n  animation-delay: 0.3s;\n}\n.swiper-slide-active .card-title {\n  animation: jackInTheBox;\n  animation-duration: 1s;\n  animation-delay: 0.8s;\n}\n.swiper-slide-active .card-sub-title {\n  animation: bounceIn;\n  animation-duration: 1s;\n  animation-delay: 0.5s;\n}\n.swiper-slide-active .card-description {\n  animation: bounceIn;\n  animation-duration: 1s;\n  animation-delay: 0.1s;\n}\n\n@keyframes floatAnim {\n  0% {\n    transform: translateY(-10px);\n  }\n  50% {\n    transform: translateY(10px);\n  }\n  100% {\n    transform: translateY(-10px);\n  }\n}\n@keyframes swing {\n  0% {\n    transform: translateY(-25px) rotate(10deg) scale(1);\n  }\n  50% {\n    transform: translateY(25px) rotate(-5deg) scale(1.1);\n  }\n  100% {\n    transform: translateY(-25px) rotate(10deg) scale(1);\n  }\n}\n.home-sec-G {\n  padding: 50px 0;\n  background: #e7e7e7;\n}\n.home-sec-G .flex {\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 767px) {\n  .home-sec-G .flex {\n    justify-content: center;\n  }\n}\n.home-sec-G .flex .col {\n  flex: 0 1 20%;\n  max-width: 20%;\n  margin-bottom: 50px;\n}\n@media (max-width: 767px) {\n  .home-sec-G .flex .col {\n    flex: 0 1 50%;\n    max-width: 50%;\n    margin-bottom: 20px;\n  }\n}\n.home-sec-G .flex .col.hp .logo {\n  width: 100px;\n}\n.home-sec-G .partners .logo {\n  width: 200px;\n  margin: 0 auto;\n}\n@media (max-width: 767px) {\n  .home-sec-G .partners .logo {\n    width: 150px;\n  }\n}\n\n.casestudy_popup,\n.Version_popup {\n  position: fixed;\n  right: 0;\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, 100%);\n  max-width: 70%;\n  width: 100%;\n  height: 65%;\n  padding: 50px;\n  transition: all 1s ease;\n  background: #222222;\n  z-index: 111;\n  pointer-events: none;\n  border-radius: 20px;\n  border: 2px solid #fff;\n}\n@media (max-width: 767px) {\n  .casestudy_popup,\n  .Version_popup {\n    max-width: 95%;\n    padding: 9rem 15px;\n  }\n}\n.casestudy_popup.pop_open,\n.Version_popup.pop_open {\n  transform: translate(-50%, -50%);\n  top: 50%;\n  pointer-events: all;\n}\n.casestudy_popup .close_model,\n.Version_popup .close_model {\n  position: absolute;\n  right: 32px;\n  top: 32px;\n  width: 32px;\n  height: 32px;\n  opacity: 1;\n  cursor: pointer;\n  z-index: 1;\n}\n.casestudy_popup .close_model::before,\n.Version_popup .close_model::before {\n  position: absolute;\n  left: 15px;\n  content: \" \";\n  height: 25px;\n  width: 2px;\n  cursor: pointer;\n  background-color: #fff;\n  transform: rotate(45deg);\n}\n.casestudy_popup .close_model::after,\n.Version_popup .close_model::after {\n  position: absolute;\n  right: 15px;\n  content: \" \";\n  height: 25px;\n  width: 2px;\n  cursor: pointer;\n  background-color: #fff;\n  transform: rotate(-45deg);\n}\n.casestudy_popup .case_detail,\n.Version_popup .case_detail {\n  margin: 0 20px;\n}\n.casestudy_popup .case_detail.version-sumry,\n.Version_popup .case_detail.version-sumry {\n  height: 300px;\n  overflow-y: scroll;\n  margin-bottom: 20px;\n}\n.casestudy_popup .case_detail.version-sumry p,\n.Version_popup .case_detail.version-sumry p {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #c9c9c9;\n}\n.casestudy_popup .case_detail .caseimg,\n.Version_popup .case_detail .caseimg {\n  text-align: center;\n}\n.casestudy_popup .case_detail .name,\n.Version_popup .case_detail .name {\n  font-size: 22px;\n  margin-bottom: 10px;\n  color: #fff;\n}\n@media (max-width: 767px) {\n  .casestudy_popup .case_detail .name,\n  .Version_popup .case_detail .name {\n    line-height: 1.3;\n  }\n}\n.casestudy_popup .case_detail .summary ul li,\n.Version_popup .case_detail .summary ul li {\n  font-size: 12px;\n  line-height: 1.5;\n  margin-bottom: 10px;\n}\n.casestudy_popup .case_detail .summary ul li b,\n.Version_popup .case_detail .summary ul li b {\n  font-size: 14px;\n}\n.casestudy_popup .case_detail .summary h4,\n.Version_popup .case_detail .summary h4 {\n  color: #da3467;\n  margin-bottom: 10px;\n  font-size: 18px;\n}\n\n.announce {\n  background: #e8e8e8;\n  padding: 50px 20px;\n}\n.announce .flex {\n  align-items: center;\n}\n.announce .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n@media (max-width: 767px) {\n  .announce .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.announce .heading h2 {\n  color: #da3467;\n  margin-bottom: 10px;\n}\n.announce .bullet_points li {\n  color: #666666;\n}\n.announce .bullet_points li::before {\n  background: #da3467;\n}\n.announce .img img {\n  height: 400px;\n}\n.announce .readmore {\n  display: inline-block;\n  margin-top: 20px;\n  width: 100%;\n}\n.announce .readmore a {\n  padding: 5px 18px;\n  border-radius: 20px;\n  background: #da3467;\n  color: #fff;\n  display: inline-block;\n  margin: 0 auto;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.751);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n.modal-overlay .close_model {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  font-size: 18px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.modal-overlay .modal-content {\n  background: #222222;\n  padding: 30px;\n  border-radius: 10px;\n  position: relative;\n  width: 400px;\n  max-width: 90%;\n  border: 2px solid #fff;\n}\n.modal-overlay .modal-content h3 {\n  margin-bottom: 25px;\n  color: #fff;\n  text-align: center;\n}\n.modal-overlay .modal-content .back-input {\n  position: relative;\n  margin-bottom: 25px;\n}\n.modal-overlay .modal-content .back-input .frm-cntrl {\n  background: none;\n  border: none;\n  width: 100%;\n  display: block;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  padding: 10px 25px;\n  color: #fff;\n  border-radius: 10px;\n  border: 2px solid #2e2d2d;\n  transition: all 1s ease;\n}\n.modal-overlay .modal-content .back-input .frm-cntrl:focus ~ label {\n  top: -12px;\n  background: #222222;\n  padding: 0 10px;\n}\n.modal-overlay .modal-content .back-input .frm-cntrl:valid ~ label {\n  top: -12px;\n  background: #222222;\n  padding: 0 10px;\n  font-size: 12px;\n}\n.modal-overlay .modal-content .back-input label {\n  position: absolute;\n  color: #fff;\n  left: 10px;\n  top: 10px;\n  transition: 750ms ease;\n}\n.modal-overlay .modal-content .back-input .error {\n  color: red;\n  display: block;\n  margin-top: 5px;\n  font-size: 12px;\n  line-height: 1;\n}\n.modal-overlay .modal-content .demo-link {\n  background: #fff;\n  text-align: center;\n  padding: 8px 15px;\n  border-radius: 10px;\n  border: 0;\n  width: 100%;\n}\n.modal-overlay .modal-content .demo-link:hover {\n  background: #da3467;\n}\n.modal-overlay .modal-content .demo-link:hover a {\n  color: #fff;\n}\n.modal-overlay .modal-content .demo-link a {\n  color: #666666;\n}\n\n.newhome-sec {\n  padding: 1rem 0;\n}\n@media (max-width: 767px) {\n  .newhome-sec {\n    padding: 3rem 0;\n  }\n}\n.newhome-sec .flex {\n  align-items: center;\n}\n.newhome-sec .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n  padding-right: 40px;\n}\n@media (max-width: 767px) {\n  .newhome-sec .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    padding: 0;\n  }\n}\n.newhome-sec .flex .col:last-child {\n  padding-left: 40px;\n}\n@media (max-width: 767px) {\n  .newhome-sec .flex .col:last-child {\n    padding: 0;\n  }\n}\n.newhome-sec .flex .col:first-child {\n  text-align: center;\n}\n.newhome-sec h2 {\n  font-size: 36px;\n  margin-bottom: 20px;\n}\n@media (max-width: 767px) {\n  .newhome-sec h2 {\n    font-size: 28px;\n  }\n}\n.newhome-sec p {\n  font-size: 18px;\n}\n@media (max-width: 767px) {\n  .newhome-sec p {\n    font-size: 16px;\n  }\n}\n.newhome-sec .highlight {\n  font-size: 24px;\n  margin-top: 20px;\n  display: inline-block;\n  color: #da3467;\n  text-decoration: underline;\n}\n@media (max-width: 767px) {\n  .newhome-sec .banner-image {\n    width: 300px;\n    margin: auto;\n    display: block;\n    margin-bottom: 20px;\n  }\n}\n.newhome-sec .watch-demo {\n  display: inline-block;\n  width: 100%;\n  text-align: center;\n}\n.newhome-sec .watch-demo a {\n  background: #da3467;\n  color: #fff;\n  padding: 7px 45px;\n  border-radius: 20px;\n  margin-top: 40px;\n  display: inline-block;\n}\n.newhome-sec img {\n  width: 400px;\n}\n\n.features {\n  padding: 5rem 0;\n  position: relative;\n  background: #e7e7e7;\n  display: none;\n}\n.features .heading {\n  margin-bottom: 2rem;\n}\n.features .flex {\n  align-items: center;\n  margin: 0 5rem;\n}\n.features .feature-list {\n  margin-bottom: 2rem;\n}\n@media (max-width: 767px) {\n  .features .feature-list:nth-child(3) .flex {\n    flex-direction: column-reverse;\n  }\n}\n@media (max-width: 767px) {\n  .features .feature-list .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    text-align: center;\n  }\n}\n.features .feature-list .feature-heading {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.features .feature-list .feature-heading .icon {\n  background: rgb(245, 190, 209);\n  height: 70px;\n  display: inline-block;\n  width: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  margin-right: 10px;\n}\n@media (max-width: 767px) {\n  .features .feature-list .feature-heading .icon {\n    display: none;\n  }\n}\n.features .feature-list .feature-heading .icon img {\n  width: 40px;\n}\n@media (max-width: 767px) {\n  .features .feature-list .feature-heading h4 {\n    font-size: 22px;\n    text-align: left;\n  }\n}\n.features .feature-list img {\n  width: 300px;\n}\n@media (max-width: 767px) {\n  .features .feature-list img {\n    width: 250px !important;\n  }\n}\n.features .feature-list ul {\n  padding-left: 50px;\n}\n@media (max-width: 767px) {\n  .features .feature-list ul {\n    text-align: left;\n    padding-left: 10px;\n    margin-bottom: 20px;\n  }\n}\n\n.licence-detial {\n  padding: 3rem 0;\n  background: #ffffff;\n}\n.licence-detial .flex .col {\n  flex: 0 1 25%;\n  max-width: 25%;\n}\n@media (max-width: 767px) {\n  .licence-detial .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 10px;\n  }\n}\n.licence-detial .heading {\n  margin-bottom: 3rem;\n}\n.licence-detial .item {\n  background: #222222;\n  padding: 20px;\n  border-radius: 20px;\n  height: 325px;\n  margin: 0 10px;\n  box-shadow: 0px 3px 10px 0px rgba(24, 59, 86, 0.08);\n}\n@media (max-width: 767px) {\n  .licence-detial .item {\n    height: inherit;\n  }\n}\n.licence-detial .item h4 {\n  margin-bottom: 20px;\n  font-weight: 600;\n  text-align: center;\n  color: #fff;\n}\n.licence-detial .item p {\n  text-align: center;\n  color: #fff;\n}\n\n.pricing {\n  background: #e7e7e7;\n  padding: 3rem 0;\n  padding-bottom: 5rem;\n}\n.pricing .heading {\n  margin-bottom: 5rem;\n}\n.pricing .flex .col {\n  flex: 0 1 29%;\n  margin: 0 20px;\n}\n@media (max-width: 767px) {\n  .pricing .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.pricing .item {\n  background: #fff;\n  border-radius: 20px;\n  height: 550px;\n  position: relative;\n  box-shadow: 0px 3px 10px 0px rgba(24, 59, 86, 0.08);\n}\n@media (max-width: 767px) {\n  .pricing .item {\n    height: inherit;\n    border-radius: 10px;\n  }\n}\n.pricing .item .price {\n  padding: 20px;\n  border-radius: 20px 20px 0 0;\n  padding-bottom: 0;\n  margin-bottom: 1.2rem;\n}\n.pricing .item .price .type-btn {\n  display: inline-block;\n  padding: 2px 0px;\n  border-radius: 10px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  font-size: 28px;\n  text-align: center;\n  width: 100%;\n}\n@media (max-width: 767px) {\n  .pricing .item .price .type-btn {\n    font-size: 22px;\n  }\n}\n.pricing .item .price .rupees {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: #2e2d2d;\n  display: none;\n}\n.pricing .item .price .rupees .symbol {\n  margin-right: 5px;\n  color: #fff;\n}\n.pricing .item .price .rupees .rate {\n  margin-right: 5px;\n  color: #2e2d2d;\n}\n.pricing .item .price .rupees .year {\n  font-size: 18px;\n  font-weight: 500;\n  color: #2e2d2d;\n}\n.pricing .item .price .user {\n  font-weight: 600;\n  margin-bottom: 5px;\n  color: #2e2d2d;\n  display: none;\n}\n.pricing .item .price p {\n  padding-right: 20px;\n  color: #fff;\n}\n.pricing .item .buy-now {\n  display: inline-block;\n  text-align: center;\n  width: 100%;\n  margin-bottom: 1.2rem;\n  position: absolute;\n  bottom: 0;\n}\n@media (max-width: 767px) {\n  .pricing .item .buy-now {\n    position: relative;\n  }\n}\n.pricing .item .buy-now a {\n  background: #da3467;\n  padding: 8px 25px;\n  color: #ffffff;\n  border-radius: 10px;\n}\n.pricing .item ul {\n  padding: 20px;\n  padding-top: 0;\n}\n.pricing .item ul li {\n  color: #000000;\n}\n.pricing .item ul li::before {\n  background: #da3467;\n}\n.pricing .item ul .readmore a {\n  display: block;\n  color: #da3467;\n  font-size: 20px;\n  margin-top: 20px;\n  font-weight: 600;\n}\n\n.ai-powered {\n  position: relative;\n  background: url(\"../images/pricing/content-creation.jpg\") no-repeat center center/cover;\n  padding: 6rem 0;\n}\n.ai-powered::before {\n  position: absolute;\n  content: \"\";\n  background: #000000;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  opacity: 0.7;\n}\n.ai-powered .content {\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n}\n.ai-powered .content ul li:first-child {\n  font-size: 36px;\n  padding-left: 0;\n  margin-bottom: 30px;\n}\n@media (max-width: 767px) {\n  .ai-powered .content ul li:first-child {\n    line-height: 1.2;\n    font-size: 28px;\n  }\n}\n.ai-powered .content ul li:first-child::before {\n  content: none;\n}\n.ai-powered .content ul .learn-more {\n  position: relative;\n}\n.ai-powered .content ul .learn-more a {\n  margin-top: 20px;\n  background: #fff;\n  display: inline-block;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.Pricing-form {\n  background: #fff;\n  width: 50%;\n  top: 100%;\n  left: 50%;\n  height: 750px;\n  transform: translate(-50%, 100%);\n  transition: 450ms ease;\n}\n@media (max-width: 767px) {\n  .Pricing-form {\n    width: 100%;\n  }\n}\n.Pricing-form.is-open {\n  transform: translate(-50%, -50%);\n  top: 50%;\n}\n.Pricing-form .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n@media (max-width: 767px) {\n  .Pricing-form .flex .col {\n    max-width: 100%;\n    flex: 0 1 100%;\n  }\n}\n@media (max-width: 767px) {\n  .Pricing-form .flex .col:first-child {\n    display: none;\n  }\n}\n.Pricing-form .banner {\n  line-height: 0;\n}\n.Pricing-form .banner img {\n  height: 750px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.Pricing-form .modelBody {\n  padding: 20px;\n}\n.Pricing-form .modelBody .contact-form .title h3 {\n  font-size: 24px;\n  font-weight: 600;\n}\n.Pricing-form .modelBody .contact-form .back-input {\n  position: relative;\n  margin-top: 25px;\n}\n.Pricing-form .modelBody .contact-form .back-input .frm-cntrl {\n  background: none;\n  border: none;\n  width: 100%;\n  display: block;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  padding: 10px 25px;\n  color: #2e2d2d;\n  border-radius: 10px;\n  border: 2px solid #2e2d2d;\n}\n.Pricing-form .modelBody .contact-form .back-input .frm-cntrl:focus ~ label {\n  top: -12px;\n  background: #ffffff;\n  padding: 0 10px;\n}\n.Pricing-form .modelBody .contact-form .back-input .frm-cntrl:valid ~ label {\n  top: -12px;\n  background: #ffffff;\n  padding: 0 10px;\n}\n.Pricing-form .modelBody .contact-form .back-input .error {\n  color: red;\n}\n.Pricing-form .modelBody .contact-form .back-input label {\n  position: absolute;\n  color: #2e2d2d;\n  left: 10px;\n  top: 10px;\n  transition: 750ms ease;\n}\n.Pricing-form .modelBody .contact-form .demo-link {\n  background: #fff;\n  text-align: center;\n  padding: 8px 15px;\n  border-radius: 10px;\n  border: 0;\n  width: 100%;\n  margin-top: 20px;\n  background: #da3467;\n}\n.Pricing-form .modelBody .contact-form .demo-link a {\n  color: #fff;\n}\n\n#form-message {\n  color: green;\n  margin: 10px 0;\n  font-weight: 600;\n}\n\n.Tablemodel {\n  background: #fff;\n  width: 70%;\n  top: 100%;\n  left: 50%;\n  height: 750px;\n  border-radius: 20px;\n  transform: translate(-50%, 100%);\n  transition: 450ms ease;\n}\n.Tablemodel.is-open {\n  transform: translate(-50%, -50%);\n  top: 50%;\n}\n.Tablemodel .modelBody {\n  padding: 10px;\n}\n.Tablemodel .modelBody .tableheading {\n  margin-bottom: 20px;\n}\n.Tablemodel .modelBody .table-container {\n  max-height: 600px;\n  overflow-y: auto;\n}\n.Tablemodel .modelBody table, .Tablemodel .modelBody tr, .Tablemodel .modelBody th, .Tablemodel .modelBody td {\n  border: 1px solid #000;\n}\n.Tablemodel .modelBody table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.Tablemodel .modelBody table th {\n  background: #da3467;\n  color: #fff;\n  text-align: center;\n}\n.Tablemodel .modelBody table th, .Tablemodel .modelBody table td {\n  padding: 10px;\n}\n.Tablemodel .modelBody table tbody {\n  max-height: 600px;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.video-sec {\n  position: relative;\n  padding: 50px 0;\n}\n.video-sec .flex {\n  align-items: center;\n}\n.video-sec .flex .video-item {\n  flex: 0 1 100%;\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  background: #e7e7e7;\n  border-radius: 25px;\n  padding: 25px;\n  margin-bottom: 20px;\n}\n.video-sec .video-heading {\n  flex: 0 1 50%;\n  max-width: 50%;\n  padding-right: 30px;\n}\n.video-sec .video-heading h2 {\n  font-size: 24px;\n  color: #da3467;\n  font-weight: 600;\n}\n.video-sec .video-heading h4 {\n  font-size: 18px;\n}\n.video-sec .video-heading ul li {\n  color: #2e2d2d;\n  font-size: 14px;\n  line-height: 1.4;\n}\n.video-sec .video-heading ul li::before {\n  background: #da3467;\n}\n.video-sec .video-name {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n.video-sec .video-name h2 {\n  color: #da3467;\n  font-size: 24px;\n  font-weight: 600;\n}\n.video-sec .video-name p {\n  font-size: 14px;\n  text-align: center;\n}\n.video-sec video {\n  width: 100%;\n  padding: 20px;\n}\n\n.cards {\n  padding: 7rem 0;\n  background: #e7e7e7;\n}\n@media (max-width: 767px) {\n  .cards {\n    padding: 7rem 1rem;\n  }\n}\n.cards .card {\n  width: 50%;\n  cursor: pointer;\n  margin: 0 auto;\n}\n@media (max-width: 767px) {\n  .cards .card {\n    width: 100%;\n  }\n}\n.cards .card ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.5rem;\n}\n.cards .card__outer {\n  background: #da3467;\n  position: relative;\n  height: 30rem;\n  border-radius: 0.625rem;\n  display: flex;\n  align-items: flex-end;\n  padding: 1.25rem;\n  transition: 0.3s ease-in-out;\n}\n.cards .card__outer a {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: #fff;\n  font-size: 20px;\n}\n.cards .card__outer a svg {\n  margin-left: 0.375em;\n  width: 1.625rem;\n}\n.cards .card__inner {\n  background: #fff;\n  position: absolute;\n  bottom: 3.75rem;\n  right: 1.25rem;\n  width: 100%;\n  height: 90%;\n  border-radius: 0.625rem;\n  padding: 1.875rem 2.188rem;\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 767px) {\n  .cards .card__inner {\n    height: 100%;\n  }\n}\n.cards .card__inner .title {\n  font-size: 24px;\n  display: inline-block;\n  position: relative;\n  margin-top: 0.313em;\n  margin-bottom: 0.938em;\n}\n@media (max-width: 767px) {\n  .cards .card__inner .title {\n    line-height: 1.3;\n  }\n}\n.cards .card__inner .title:after {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  bottom: -1.563rem;\n  display: block;\n  color: red;\n  background: #da3467;\n  height: 0.325rem;\n  width: 100%;\n}\n.cards .card.active .card__outer a {\n  color: #fff;\n}\n\n#roto {\n  position: relative;\n  overflow: hidden;\n}\n#roto::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  background: linear-gradient(0deg, #fff, transparent);\n  opacity: 0;\n  z-index: 4;\n  transition: 0.2s all ease;\n}\n#roto::before.active::before {\n  opacity: 1;\n  height: 50%;\n}\n\n.slide {\n  width: 100%;\n  min-height: calc(100vh - 100px);\n  position: relative;\n  overflow: hidden;\n  background-color: #000;\n}\n.slide .mainImage {\n  position: absolute;\n  width: 130vw;\n  height: 130vw;\n  -o-object-fit: cover;\n     object-fit: cover;\n  -o-object-position: center;\n     object-position: center;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  animation-name: rotate;\n  animation-timing-function: cubic-bezier(0.02, 0.63, 0.23, 0.99);\n  animation-iteration-count: 1;\n  animation-duration: 1.1s;\n}\n@media (max-width: 675px) {\n  .slide .mainImage {\n    width: 130vh;\n    height: 130vh;\n  }\n}\n.slide .roundOuter {\n  position: absolute;\n  width: 86vw;\n  height: 86vw;\n  overflow: hidden;\n  border-radius: 50%;\n  left: calc(50% - 43vw);\n  top: calc(50% - 43vw);\n  filter: brightness(0.9);\n  z-index: 1;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n@media (max-width: 675px) {\n  .slide .roundOuter {\n    width: 86vh;\n    height: 86vh;\n    left: calc(50% - 43vh);\n    top: calc(50% - 43vh);\n  }\n}\n.slide .roundOuter img {\n  position: absolute;\n  width: 130vw;\n  height: 130vw;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  -o-object-fit: cover;\n     object-fit: cover;\n  -o-object-position: center;\n     object-position: center;\n  animation-name: rotate;\n  animation-timing-function: cubic-bezier(0.02, 0.63, 0.23, 0.99);\n  animation-iteration-count: 1;\n  animation-duration: 1.3s;\n}\n@media (max-width: 675px) {\n  .slide .roundOuter img {\n    width: 130vh;\n    height: 130vh;\n  }\n}\n.slide .roundInner {\n  position: absolute;\n  width: 50vw;\n  height: 50vw;\n  overflow: hidden;\n  left: calc(50% - 25vw);\n  top: calc(50% - 25vw);\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  z-index: 2;\n}\n@media (max-width: 675px) {\n  .slide .roundInner {\n    width: 50vh;\n    height: 50vh;\n    left: calc(50% - 25vh);\n    top: calc(50% - 25vh);\n  }\n}\n.slide .roundInner img {\n  position: absolute;\n  width: 130vw;\n  height: 130vw;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  -o-object-fit: cover;\n     object-fit: cover;\n  -o-object-position: center;\n     object-position: center;\n  animation-name: rotate;\n  animation-timing-function: cubic-bezier(0.02, 0.63, 0.23, 0.99);\n  animation-iteration-count: 1;\n  animation-duration: 1.2s;\n}\n@media (max-width: 675px) {\n  .slide .roundInner img {\n    width: 130vh;\n    height: 130vh;\n  }\n}\n.slide .slideText {\n  position: absolute;\n  z-index: 3;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-content: center;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n.slide .slideText::after {\n  content: \"\";\n  position: absolute;\n  width: 40vw;\n  height: 1px;\n  background-color: #fff;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.slide p {\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 30px;\n  font-size: 2.5rem;\n  padding-left: 1.3rem;\n  color: #fff;\n  line-height: normal;\n  animation-delay: 1.5s;\n  filter: drop-shadow(0 2px 10px #000);\n}\n@media (max-width: 675px) {\n  .slide p {\n    font-size: 5vw;\n    line-height: 1.5;\n    padding-left: 2vw;\n  }\n}\n.slide .buttonNav {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  animation-delay: 1.7s;\n}\n.slide .buttonNav button {\n  border: none;\n  background: transparent;\n  color: #da3467;\n  font-size: 2rem;\n  filter: drop-shadow(0 2px 10px #000);\n}\n.slide .buttonNav span {\n  display: grid;\n  width: 1px;\n  flex: 0 0 1px;\n  background-color: #fff;\n  filter: drop-shadow(0 2px 10px #000);\n}\n\n@keyframes rotate {\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg) scale(5);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg) scale(1);\n  }\n}\n.prodouct-demo-video {\n  width: 100%;\n  height: calc(100vh - 100px);\n  background: #222222;\n}\n@media (max-width: 767px) {\n  .prodouct-demo-video {\n    height: 100%;\n    padding: 50px 0;\n  }\n}\n.prodouct-demo-video video {\n  width: 100%;\n  height: 100%;\n}\n\n.product-sec-C {\n  padding: 50px 0;\n  position: relative;\n}\n.product-sec-C .heading {\n  margin-bottom: 100px;\n}\n@media (max-width: 1024px) {\n  .product-sec-C .flex {\n    justify-content: center;\n  }\n}\n.product-sec-C .flex .col {\n  flex: 0 1 18%;\n  max-width: 18%;\n  background: linear-gradient(to right, #f1f1f1, #a1a1a1);\n  padding: 10px;\n  height: 200px;\n  margin: 0 10px;\n  position: relative;\n  border: 2px solid #da3467;\n  border-radius: 20px 20px 100% 100%;\n}\n@media (max-width: 1024px) {\n  .product-sec-C .flex .col {\n    flex: 0 1 30%;\n    max-width: 30%;\n    margin-bottom: 100px;\n  }\n}\n@media (max-width: 767px) {\n  .product-sec-C .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin: 0 35px;\n    margin-bottom: 75px;\n  }\n  .product-sec-C .flex .col:last-child {\n    margin-bottom: 0;\n  }\n}\n.product-sec-C .content p {\n  margin-top: 40px;\n  font-size: 14px;\n  text-align: center;\n}\n.product-sec-C .icon {\n  position: absolute;\n  top: -25%;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  height: 50px;\n  width: 100px;\n  border-radius: 150px 150px 0 0;\n  background: linear-gradient(to bottom, #da3467, rgba(10, 10, 10, 0.8));\n}\n.product-sec-C .icon span {\n  color: #fff;\n  width: 70px;\n  height: 70px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #da3467;\n  margin: 0 auto;\n  position: relative;\n  top: 15px;\n}\n@media (max-width: 767px) {\n  .product-sec-C .icon span {\n    top: 15px;\n  }\n}\n\n.product-sec-D {\n  background: #222222;\n  position: relative;\n  padding: 50px 0;\n}\n.product-sec-D .heading h2 {\n  color: #fff;\n}\n.product-sec-D .flex .col1 {\n  flex: 0 1 31%;\n  max-width: 31%;\n  margin: 0 10px;\n  margin-bottom: 60px;\n}\n@media (max-width: 991px) {\n  .product-sec-D .flex .col1 {\n    flex: 0 1 47%;\n    max-width: 47%;\n  }\n}\n@media (max-width: 767px) {\n  .product-sec-D .flex .col1 {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 60px;\n  }\n}\n.product-sec-D .item {\n  background: #eeecec;\n  border-radius: 5px;\n  height: 150px;\n  position: relative;\n  padding: 30px 35px 75px;\n  transition: all 0.3s linear 0s;\n  z-index: 2;\n  cursor: pointer;\n}\n.product-sec-D .item::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 5px;\n  background-color: #da3467;\n  border-radius: 0 0 5px 5px;\n  transition: all 0.4s linear 0s;\n  z-index: -1;\n}\n.product-sec-D .item:hover::before {\n  height: 100%;\n  opacity: 0.8;\n  border-radius: 5px;\n}\n.product-sec-D .item:hover .img {\n  opacity: 1;\n  visibility: visible;\n  height: 100%;\n  transform: scale(1);\n}\n.product-sec-D .item:hover p {\n  color: #fff;\n  font-weight: 500;\n}\n.product-sec-D .item:hover .icon {\n  background: #da3467;\n  border: 3px solid #ffffff;\n}\n.product-sec-D .item:hover .icon img {\n  display: none;\n}\n.product-sec-D .item:hover .icon img.white {\n  display: block;\n}\n.product-sec-D .item .img {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  z-index: -2;\n  visibility: hidden;\n  opacity: 0;\n  -o-object-fit: cover;\n     object-fit: cover;\n  transform: scale(0.8);\n  transition: all 0.4s linear 0s;\n}\n.product-sec-D .item p {\n  text-align: center;\n}\n.product-sec-D .item .icon {\n  position: absolute;\n  width: 70px;\n  height: 70px;\n  background: #eeecec;\n  border-radius: 100%;\n  left: 50%;\n  bottom: -30px;\n  transform: translate(-50%, 0%);\n  border: 3px solid #222222;\n  transition: all 0.4s linear 0s;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.product-sec-D .item .icon .white {\n  display: none;\n}\n\n.pathbreak-sec-B.product-sec-6 {\n  background: #fff;\n}\n.pathbreak-sec-B.product-sec-6 h4 {\n  color: #666666;\n}\n.pathbreak-sec-B.product-sec-6 ul li {\n  color: #666666;\n}\n\n.product-sec-7 {\n  position: relative;\n  padding: 50px 0;\n  height: calc(100vh - 100px);\n  background: #222222;\n}\n@media (max-width: 1440px) {\n  .product-sec-7 {\n    height: 100vh;\n  }\n}\n@media (max-width: 1024px) {\n  .product-sec-7 {\n    height: 63vh;\n  }\n}\n@media (max-width: 991px) {\n  .product-sec-7 {\n    height: none;\n  }\n}\n@media (max-width: 767px) {\n  .product-sec-7 {\n    height: 100%;\n  }\n}\n.product-sec-7 .container {\n  position: relative;\n  width: 320px;\n  margin: 100px auto 0 auto;\n  perspective: 1000px;\n}\n@media (max-width: 1024px) {\n  .product-sec-7 .container {\n    perspective: none;\n  }\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container {\n    width: inherit;\n    margin: 0;\n  }\n}\n.product-sec-7 .container .product-data {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  transform-style: preserve-3d;\n  animation: rotate360 90s infinite forwards linear;\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data {\n    animation: none;\n    transform-style: inherit;\n    position: static;\n  }\n}\n.product-sec-7 .container .product-data:hover {\n  animation-play-state: paused;\n}\n.product-sec-7 .container .product-data .image {\n  position: absolute;\n  height: 200px;\n  top: 20px;\n  left: 10px;\n  right: 10px;\n  background-size: cover;\n  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5);\n  display: flex;\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image {\n    position: static;\n    border-radius: 20px;\n    border: 2px solid #da3467;\n    margin-bottom: 20px;\n  }\n}\n.product-sec-7 .container .product-data .image span {\n  margin: auto;\n  font-size: 16px;\n  color: #fff;\n  padding: 0 20px;\n  line-height: 1.3;\n}\n.product-sec-7 .container .product-data .image:nth-child(1) {\n  background-image: url(\"../images/product/slider/watch-live-video.jpg\");\n  transform: rotateY(0deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(1) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(2) {\n  background-image: url(\"../images/product/slider/video-over-document.jpg\");\n  transform: rotateY(40deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(2) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(3) {\n  background-image: url(\"../images/product/slider/knowledge-retention.jpg\");\n  transform: rotateY(80deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(3) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(4) {\n  background-image: url(\"../images/product/slider/explainer-video-content.jpg\");\n  transform: rotateY(120deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(4) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(5) {\n  background-image: url(\"../images/product/slider/attention-to-short-form-videos.jpg\");\n  transform: rotateY(160deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(5) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(6) {\n  background-image: url(\"../images/product/slider/clicks-and-engagement.jpg\");\n  transform: rotateY(200deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(6) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(7) {\n  background-image: url(\"../images/product/slider/no-time-for-learning.jpg\");\n  transform: rotateY(240deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(7) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(8) {\n  background-image: url(\"../images/product/slider/human-attention-span.jpg\");\n  transform: rotateY(280deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(8) {\n    transform: none;\n  }\n}\n.product-sec-7 .container .product-data .image:nth-child(9) {\n  background-image: url(\"../images/product/slider/microlearning.jpg\");\n  transform: rotateY(320deg) translateZ(450px);\n}\n@media (max-width: 767px) {\n  .product-sec-7 .container .product-data .image:nth-child(9) {\n    transform: none;\n  }\n}\n\n@keyframes rotate360 {\n  from {\n    transform: rotateY(360deg);\n  }\n  to {\n    transform: rotateY(-360deg);\n  }\n}\n.product-head {\n  background-color: #2b2b2b;\n  border-top: 5px solid #fff;\n  margin: 0;\n  position: relative;\n}\n.product-head span {\n  background: #da3467;\n  position: absolute;\n  border-radius: 0 0 10px 10px;\n  top: 0;\n  right: 2rem;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n  display: block;\n  color: #fff;\n  font-weight: 500;\n  animation: animate 2s infinite alternate;\n}\n.product-head h2 {\n  color: #fff;\n  margin-top: 2rem;\n}\n\n.new-product-sec {\n  justify-content: space-between;\n  height: 80vh;\n  overflow: hidden;\n  background-color: #2b2b2b;\n}\n.new-product-sec h2 {\n  color: #fff;\n  font-size: 30px;\n}\n.new-product-sec .col1 {\n  width: 40%;\n  position: relative;\n  background-color: #2b2b2b;\n  display: flex;\n  align-items: center;\n}\n.new-product-sec .col2 {\n  width: 60%;\n  position: relative;\n}\n.new-product-sec .content {\n  padding: 0 5rem;\n  position: relative;\n}\n.new-product-sec .content h4 {\n  color: #fff;\n}\n.new-product-sec .content p {\n  color: #eaeaea;\n  font-size: 14px;\n  line-height: 1.2;\n}\n.new-product-sec .content .bullet_points {\n  margin-top: 20px;\n  padding: 0;\n}\n.new-product-sec .imagesv {\n  width: 100%;\n  line-height: 0;\n  height: 100%;\n  position: relative;\n}\n.new-product-sec .imagesv::before {\n  top: 0px;\n  left: 0px;\n  bottom: 0px;\n  width: 50%;\n  height: 100%;\n  content: \"\";\n  position: absolute;\n  background-image: linear-gradient(to right, #2b2b2b, rgba(43, 43, 43, 0.9215686275), rgba(43, 43, 43, 0.4392156863), transparent);\n}\n.new-product-sec .imagesv::after {\n  right: 0;\n  left: 0;\n  width: 100%;\n  height: 50%;\n  content: \"\";\n  position: absolute;\n  background-image: linear-gradient(to bottom, #2b2b2b, rgba(43, 43, 43, 0.9215686275), rgba(43, 43, 43, 0.4392156863), transparent);\n}\n.new-product-sec .imagesv img {\n  width: 100%;\n  height: 100%;\n}\n.new-product-sec .comson {\n  background: #da3467;\n  display: inline-block;\n  padding: 5px 20px;\n  border-radius: 15px;\n  color: #fff;\n  margin-top: 20px;\n  text-align: center;\n}\n\n.new-product-sec-2 {\n  position: relative;\n  padding: 50px 0 0;\n  background: #222222;\n}\n.new-product-sec-2 .container {\n  margin: 0;\n  padding: 0;\n}\n.new-product-sec-2 .heading {\n  margin-bottom: 4rem;\n}\n.new-product-sec-2 .heading span {\n  background: #da3467;\n  position: absolute;\n  border-radius: 0 0 10px 10px;\n  top: 0;\n  right: 2rem;\n  padding: 10px 20px;\n  margin-bottom: 20px;\n  display: block;\n  color: #fff;\n  font-weight: 500;\n  animation: animate 2s infinite alternate;\n}\n.new-product-sec-2 .heading h2 {\n  color: #fff;\n}\n.new-product-sec-2 .flex .col {\n  flex: 0 1 60%;\n  position: relative;\n  max-width: 60%;\n  padding-right: 30px;\n  padding: 50px 0;\n  background: url(\"../images/product/community-power.jpg\") no-repeat center center/cover;\n  z-index: 11;\n}\n.new-product-sec-2 .flex .col::before {\n  position: absolute;\n  content: \"\";\n  background: #000;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  opacity: 0.7;\n  z-index: -1;\n}\n.new-product-sec-2 .flex .col:last-child {\n  flex: 0 1 40%;\n  max-width: 40%;\n  padding-right: 0;\n  display: flex;\n  align-items: center;\n  background: none;\n}\n.new-product-sec-2 .flex .col:last-child::before {\n  content: none;\n}\n.new-product-sec-2 .content.rotating-text-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.new-product-sec-2 .content.rotating-text-wrapper p {\n  font-size: 2em;\n  margin: 0;\n  padding: 0.3em;\n  color: #fff;\n  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2);\n  border: 6px solid #da3467;\n  border-radius: 20px;\n  animation-duration: 15s;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  padding: 20px;\n}\n.new-product-sec-2 .content.rotating-text-wrapper p:first-child {\n  background: rgba(255, 255, 255, 0.4745098039);\n  animation-name: rotating-text-1;\n}\n.new-product-sec-2 .content.rotating-text-wrapper p:nth-child(2) {\n  background: rgba(255, 255, 255, 0.4745098039);\n  animation-name: rotating-text-2;\n}\n.new-product-sec-2 .content.rotating-text-wrapper p:nth-child(3) {\n  background: rgba(255, 255, 255, 0.4745098039);\n  animation-name: rotating-text-3;\n}\n.new-product-sec-2 .content.rotating-text-wrapper p:nth-child(4) {\n  background: rgba(255, 255, 255, 0.4745098039);\n  animation-name: rotating-text-4;\n}\n\n@keyframes animate {\n  0% {\n    box-shadow: 0 0 5px rgba(255, 61, 132, 0.6), 0 0 15px rgba(255, 30, 105, 0.4);\n  }\n  100% {\n    box-shadow: 0 0 15px #ff3d64, 0 0 30px #ff1e5e;\n  }\n}\n@keyframes rotating-text-1 {\n  0% {\n    transform: translateY(200%);\n  }\n  25% {\n    transform: translateY(100%);\n    opacity: 1;\n  }\n  30% {\n    opacity: 0;\n  }\n}\n@keyframes rotating-text-2 {\n  25% {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  50% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  55% {\n    opacity: 0;\n  }\n}\n@keyframes rotating-text-3 {\n  50% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n  75% {\n    transform: translateY(-100%);\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n}\n@keyframes rotating-text-4 {\n  75% {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  99% {\n    transform: translateY(-200%);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-200%);\n    opacity: 0;\n  }\n}\n.ai-sec-A {\n  width: 100%;\n  position: relative;\n}\n.ai-sec-A .bg {\n  height: calc(100vh - 100px);\n}\n.ai-sec-A .bg video {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.ai-sec-A .content {\n  position: absolute;\n  top: 50%;\n  max-width: 600px;\n  width: 100%;\n  padding-left: 30px;\n  transform: translateY(-50%);\n}\n.ai-sec-A .content h2 {\n  color: #fff;\n  font-size: 36px;\n}\n.ai-sec-A .content .bullet_points {\n  margin-top: 20px;\n}\n.ai-sec-A .content .bullet_points li {\n  font-size: 16px;\n}\n\n.ai-sec-B {\n  padding: 50px 0;\n  position: relative;\n  background: #d1d1d1;\n}\n.ai-sec-B .heading h2 {\n  font-size: 36px;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .heading h2 {\n    font-size: 28px;\n  }\n}\n.ai-sec-B .item {\n  position: relative;\n  max-width: 1200px;\n  margin: 50px auto;\n}\n.ai-sec-B .item::before {\n  position: absolute;\n  content: \"\";\n  background: #da3467;\n  width: 5px;\n  height: 100%;\n  z-index: 1;\n  margin-left: -3px;\n  top: 0;\n  left: 50%;\n  animation: moveline 6s linear forwards;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item::before {\n    left: 31px;\n  }\n}\n.ai-sec-B .item .content {\n  padding: 10px 50px;\n  position: relative;\n  width: 50%;\n  animation: movedown 1s linear forwards;\n  opacity: 0;\n  z-index: 1;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item .content {\n    width: 100%;\n    padding-left: 80px;\n    padding-right: 25px;\n  }\n}\n.ai-sec-B .item .content:first-child {\n  animation-delay: 0s;\n}\n.ai-sec-B .item .content:nth-child(2) {\n  animation-delay: 1s;\n}\n.ai-sec-B .item .content:nth-child(3) {\n  animation-delay: 2s;\n}\n.ai-sec-B .item .content:nth-child(4) {\n  animation-delay: 3s;\n}\n.ai-sec-B .item .content:nth-child(5) {\n  animation-delay: 4s;\n}\n.ai-sec-B .item .content:nth-child(6) {\n  animation-delay: 5s;\n}\n.ai-sec-B .item .content:nth-child(7) {\n  animation-delay: 6s;\n}\n.ai-sec-B .item .content .text-box {\n  padding: 20px 30px;\n  background: #fff;\n  border-radius: 6px;\n  font-size: 15px;\n  position: relative;\n  height: 90px;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item .content .text-box {\n    height: 100%;\n  }\n}\n.ai-sec-B .item .content .text-box::before {\n  position: absolute;\n  content: \"\";\n  top: 10px;\n  border-top: 15px solid transparent;\n  border-bottom: 15px solid transparent;\n  border-left: 15px solid #fff;\n  right: -15px;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item .content .text-box::before {\n    transform: rotate(180deg);\n    right: 100%;\n  }\n}\n.ai-sec-B .item .content .text-box p {\n  font-size: 16px;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item .content .text-box p {\n    font-size: 14px;\n  }\n}\n.ai-sec-B .item .content.left {\n  left: 0;\n}\n.ai-sec-B .item .content.right {\n  left: 50%;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item .content.right {\n    left: 0;\n  }\n}\n.ai-sec-B .item .content.right .text-box::before {\n  transform: rotate(180deg);\n  right: 100%;\n}\n.ai-sec-B .item .content.right .icon {\n  left: -20px;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item .content.right .icon {\n    left: 10px;\n  }\n}\n.ai-sec-B .item .icon {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 15px;\n  right: -20px;\n  z-index: 10;\n  background: #fff;\n}\n@media (max-width: 767px) {\n  .ai-sec-B .item .icon {\n    left: 10px;\n  }\n}\n\n@keyframes moveline {\n  0% {\n    height: 0%;\n  }\n  100% {\n    height: 100%;\n  }\n}\n@keyframes movedown {\n  0% {\n    opacity: 1;\n    transform: translateY(-30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n.ai-sec-3 {\n  background: #222222;\n}\n\n.ai-video {\n  height: 500px;\n}\n.ai-video video {\n  height: 100%;\n  width: 100%;\n}\n\n.ai-sec-4 {\n  padding: 50px 0;\n  position: relative;\n}\n.ai-sec-4 .heading h2 {\n  font-size: 36px;\n}\n@media (max-width: 767px) {\n  .ai-sec-4 .heading h2 {\n    font-size: 24px;\n  }\n}\n.ai-sec-4 .flex .col1 {\n  flex: 0 1 31%;\n  max-width: 31%;\n  position: relative;\n  margin: 0 10px;\n  margin-bottom: 30px;\n}\n@media (max-width: 767px) {\n  .ai-sec-4 .flex .col1 {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.ai-sec-4 .img {\n  line-height: 0;\n}\n.ai-sec-4 .img::before {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 50%;\n  bottom: 0;\n  border-radius: 0 0 10px 10px;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);\n}\n.ai-sec-4 .img img {\n  border-radius: 10px;\n}\n.ai-sec-4 .content {\n  position: absolute;\n  left: 50%;\n  bottom: 20px;\n  transform: translateX(-50%);\n  text-align: center;\n  white-space: nowrap;\n}\n.ai-sec-4 .content p {\n  color: #fff;\n}\n\n.ai-sec-5 {\n  position: relative;\n}\n.ai-sec-5 .img {\n  position: relative;\n  line-height: 0;\n}\n.ai-sec-5 .img img {\n  width: 100%;\n}\n.ai-sec-5 .content {\n  padding: 50px 40px;\n  position: absolute;\n  top: 40px;\n  left: 15%;\n}\n.ai-sec-5 .content h3 {\n  margin-bottom: 20px;\n  color: #fff;\n  font-size: 36px;\n}\n.ai-sec-5 .content ul {\n  padding-left: 0;\n}\n\n.managment-sec-A {\n  position: relative;\n  height: 500px;\n  background: #e7e7e7;\n}\n.managment-sec-A video {\n  width: 100%;\n  height: 100%;\n}\n\n.management-sec-B {\n  position: relative;\n  padding: 50px 0;\n}\n.management-sec-B .flex {\n  align-items: center;\n}\n.management-sec-B .flex .col1 {\n  flex: 0 1 50%;\n  max-width: 50%;\n  padding-right: 40px;\n}\n@media (max-width: 767px) {\n  .management-sec-B .flex .col1 {\n    flex: 0 1 100%;\n    max-width: 100%;\n    padding: 0;\n    margin-bottom: 20px;\n  }\n}\n.management-sec-B .flex .col2 {\n  flex: 0 1 50%;\n  max-width: 50%;\n  padding-left: 40px;\n}\n@media (max-width: 767px) {\n  .management-sec-B .flex .col2 {\n    flex: 0 1 100%;\n    max-width: 100%;\n    padding: 0;\n  }\n}\n.management-sec-B .content h3 {\n  margin-bottom: 20px;\n  font-size: 28px;\n  font-weight: 500;\n  color: #666666;\n}\n@media (max-width: 767px) {\n  .management-sec-B .content h3 {\n    font-size: 22px;\n  }\n}\n.management-sec-B .content p {\n  color: #7e7e7e;\n}\n@media (max-width: 767px) {\n  .management-sec-B .content p {\n    font-size: 14px;\n  }\n}\n.management-sec-B .img {\n  line-height: 0;\n  text-align: center;\n}\n.management-sec-B .img img {\n  width: 400px;\n  border-radius: 10px;\n}\n\n.management-sec-C {\n  position: relative;\n  background: #222222;\n  padding: 50px 0;\n}\n.management-sec-C .container {\n  max-width: 700px;\n}\n.management-sec-C .flex {\n  align-items: center;\n}\n.management-sec-C .flex .item {\n  flex: 0 1 50%;\n  max-width: 50%;\n  text-align: center;\n  margin-bottom: 30px;\n}\n.management-sec-C .flex .item:last-child {\n  flex: 0 1 100%;\n  max-width: 100%;\n  margin-bottom: 0;\n}\n.management-sec-C p {\n  background: #fff;\n  display: inline-block;\n  height: 200px;\n  width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  border-radius: 100%;\n  padding: 10px;\n  border: 15px solid #da3467;\n  box-shadow: inset 0px 4px 17px 6px #000;\n}\n@media (max-width: 767px) {\n  .management-sec-C p {\n    width: 150px;\n    height: 150px;\n    border: 5px solid #da3467;\n    box-shadow: inset 0px 1px 10px 4px #000;\n    padding: 15px;\n    font-size: 13px;\n  }\n}\n\n.management-sec-D {\n  position: relative;\n  padding-top: 50px;\n  height: calc(100vh - 200px);\n  background: url(\"../images/product/develop-people.jpg\") no-repeat center center/cover;\n}\n@media (max-width: 767px) {\n  .management-sec-D {\n    height: 100%;\n    padding-bottom: 50px;\n  }\n}\n.management-sec-D::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  background: #000000;\n  opacity: 0.5;\n}\n.management-sec-D .content {\n  position: relative;\n  max-width: 500px;\n  width: 100%;\n}\n.management-sec-D .content h3 {\n  color: #fff;\n  margin-bottom: 20px;\n  font-size: 30px;\n}\n@media (max-width: 767px) {\n  .management-sec-D .content h3 {\n    font-size: 28px;\n  }\n}\n.management-sec-D .content ul {\n  padding: 0;\n}\n.management-sec-D .content ul li {\n  font-weight: 300;\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n.management-sec-D .content ul li::before {\n  background: #da3467;\n}\n\n.management-sec-E {\n  padding: 50px 0;\n  position: relative;\n}\n.management-sec-E .heading {\n  margin-bottom: 40px;\n}\n.management-sec-E .heading h2 {\n  font-size: 36px;\n}\n.management-sec-E .flex .item {\n  flex: 0 1 32%;\n  max-width: 32%;\n  text-align: center;\n  padding: 20px;\n  border-radius: 5px;\n  background: #222222;\n  margin: 0 5px;\n}\n@media (max-width: 767px) {\n  .management-sec-E .flex .item {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.management-sec-E h4 {\n  font-size: 18px;\n  color: #da3467;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.management-sec-E ul {\n  text-align: left;\n}\n.management-sec-E ul li {\n  color: #fff;\n}\n\n.pathbreak-sec-A {\n  padding: 50px 0;\n  position: relative;\n}\n.pathbreak-sec-A .heading h2 {\n  font-size: 36px;\n}\n@media (max-width: 767px) {\n  .pathbreak-sec-A .heading h2 {\n    font-size: 28px;\n  }\n}\n@media (max-width: 767px) {\n  .pathbreak-sec-A .flex {\n    justify-content: center;\n  }\n}\n.pathbreak-sec-A .flex .item {\n  flex: 0 1 20%;\n  max-width: 20%;\n  padding: 0 10px;\n  text-align: center;\n  margin-bottom: 30px;\n}\n@media (max-width: 767px) {\n  .pathbreak-sec-A .flex .item {\n    flex: 0 1 50%;\n    max-width: 50%;\n  }\n}\n.pathbreak-sec-A .circle {\n  background: rgba(106, 104, 104, 0.1490196078);\n  width: 150px;\n  height: 150px;\n  margin: 0 auto;\n  position: relative;\n  border-radius: 100%;\n}\n.pathbreak-sec-A .circle::before {\n  content: \"\";\n  position: absolute;\n  bottom: -30px;\n  height: 8px;\n  border: 13px solid transparent;\n  border-top-color: #da3467;\n  left: 50%;\n  transform: translate(-50%);\n}\n.pathbreak-sec-A .circle .icon {\n  padding: 15px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 120px;\n  height: 120px;\n  background: linear-gradient(white, white) padding-box, linear-gradient(to bottom, #dc1371, #da4a7e) border-box;\n  border-radius: 50em;\n  border: 10px solid transparent;\n  opacity: 1;\n  box-shadow: inset 0 0 8px #222222;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.pathbreak-sec-A .circle .icon img {\n  width: 50px;\n}\n.pathbreak-sec-A span {\n  margin-top: 20px;\n  display: block;\n}\n\n.pathbreak-sec-B {\n  background: #222222;\n  position: relative;\n  padding: 50px 0;\n}\n.pathbreak-sec-B .heading h2 {\n  color: #fff;\n  font-size: 36px;\n}\n.pathbreak-sec-B .flex {\n  align-items: center;\n}\n.pathbreak-sec-B .flex .col1 {\n  flex: 0 1 60%;\n  max-width: 60%;\n}\n@media (max-width: 767px) {\n  .pathbreak-sec-B .flex .col1 {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.pathbreak-sec-B .flex .col2 {\n  flex: 0 1 40%;\n  max-width: 40%;\n}\n@media (max-width: 767px) {\n  .pathbreak-sec-B .flex .col2 {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.pathbreak-sec-B .img {\n  width: 500px;\n  margin: 0 auto;\n}\n@media (max-width: 767px) {\n  .pathbreak-sec-B .img {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.pathbreak-sec-B .img img {\n  width: 100%;\n  border-radius: 20px;\n}\n.pathbreak-sec-B .bullet_points {\n  padding-left: 0;\n}\n.pathbreak-sec-B .bullet_points li {\n  margin-bottom: 5px;\n}\n.pathbreak-sec-B .bullet_points li::before {\n  background: #da3467;\n}\n\n.pathbreak-sec-C {\n  padding: 50px 0;\n}\n.pathbreak-sec-C .flex .item {\n  flex: 0 1 25%;\n  max-width: 25%;\n  text-align: center;\n  position: relative;\n}\n@media (max-width: 767px) {\n  .pathbreak-sec-C .flex .item {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.pathbreak-sec-C .img {\n  line-height: 0;\n  max-width: 280px;\n  width: 100%;\n  margin: 0 auto;\n}\n.pathbreak-sec-C .img::before {\n  position: absolute;\n  content: \"\";\n  width: 280px;\n  bottom: 0;\n  height: 50%;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #da3467);\n}\n.pathbreak-sec-C .img img {\n  width: 100%;\n}\n.pathbreak-sec-C p {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n  font-size: 14px;\n  bottom: 20px;\n  color: #fff;\n  font-weight: 600;\n}\n\n.polls-sec-A {\n  position: relative;\n  padding: 100px 0;\n  background: url(\"../images/product/sentiments.jpg\") no-repeat center center/cover;\n}\n.polls-sec-A .text {\n  max-width: 500px;\n  width: 100%;\n}\n.polls-sec-A .text h3 {\n  color: #fff;\n  font-size: 30px;\n  line-height: 1.5;\n}\n\n.polls-sec-B {\n  position: relative;\n  padding: 60px 0;\n}\n.polls-sec-B .flex {\n  align-items: center;\n}\n.polls-sec-B .flex .item {\n  flex: 0 1 50%;\n  max-width: 50%;\n  text-align: center;\n}\n@media (max-width: 767px) {\n  .polls-sec-B .flex .item {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.polls-sec-B ul {\n  text-align: left;\n  width: 450px;\n  margin: 0 auto;\n}\n@media (max-width: 767px) {\n  .polls-sec-B ul {\n    width: 100%;\n  }\n}\n.polls-sec-B ul li {\n  color: #666666;\n  margin-bottom: 5px;\n  padding-right: 10px;\n}\n.polls-sec-B ul li::before {\n  background: #da3467;\n  top: 10px;\n}\n.polls-sec-B img {\n  border-radius: 10px;\n}\n\n.polls-sec-C {\n  position: relative;\n  padding: 50px 0;\n  background: #222222;\n  z-index: 1;\n}\n.polls-sec-C .flex .item {\n  flex: 0 1 18%;\n  max-width: 18%;\n  background: #fff;\n  height: 150px;\n  margin: 0 12px;\n  border-radius: 10px;\n  box-shadow: 4px 2px 4px 3px #424242;\n  position: relative;\n  border: 5px solid #da3467;\n  margin-bottom: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 767px) {\n  .polls-sec-C .flex .item {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.polls-sec-C .text {\n  text-align: center;\n  padding: 30px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n.polls-sec-C .text h4 {\n  font-size: 16px;\n}\n.polls-sec-C .point {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  background: #da3467;\n  border-radius: 100%;\n  top: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.polls-sec-C .point span {\n  color: #fff;\n  text-align: center;\n  width: 100%;\n  font-size: 18px;\n}\n\n.assesment-sec-A {\n  position: relative;\n  padding: 50px 0;\n}\n.assesment-sec-A.assesment-sec-B {\n  background: #222222;\n}\n.assesment-sec-A.assesment-sec-B .flex .col {\n  flex: 0 1 40%;\n  max-width: 40%;\n}\n@media (max-width: 767px) {\n  .assesment-sec-A.assesment-sec-B .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.assesment-sec-A.assesment-sec-B .flex .col:last-child {\n  padding-left: 40px;\n  flex: 0 1 60%;\n  max-width: 60%;\n}\n@media (max-width: 767px) {\n  .assesment-sec-A.assesment-sec-B .flex .col:last-child {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n    padding-left: 0;\n  }\n}\n.assesment-sec-A.assesment-sec-B h3 {\n  color: #fff;\n}\n.assesment-sec-A.assesment-sec-B ul li {\n  color: #fff;\n}\n@media (max-width: 767px) {\n  .assesment-sec-A.assesment-sec-B ul li {\n    margin-bottom: 10px;\n  }\n}\n.assesment-sec-A .flex {\n  align-items: center;\n}\n.assesment-sec-A .flex .col {\n  flex: 0 1 60%;\n  max-width: 60%;\n  padding-right: 40px;\n}\n@media (max-width: 767px) {\n  .assesment-sec-A .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n    padding-right: 0;\n  }\n}\n.assesment-sec-A .flex .col:last-child {\n  flex: 0 1 40%;\n  max-width: 40%;\n}\n@media (max-width: 767px) {\n  .assesment-sec-A .flex .col:last-child {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.assesment-sec-A h3 {\n  color: #575757;\n  margin-bottom: 30px;\n}\n.assesment-sec-A ul {\n  padding: 0;\n}\n.assesment-sec-A ul li {\n  color: #666666;\n}\n@media (max-width: 767px) {\n  .assesment-sec-A ul li {\n    margin-bottom: 10px;\n  }\n}\n.assesment-sec-A ul li::before {\n  background: #da3467;\n}\n.assesment-sec-A img {\n  border-radius: 10px;\n}\n\n.community-sec-A {\n  padding: 50px 0;\n}\n.community-sec-A .heading {\n  margin-bottom: 50px;\n}\n.community-sec-A .heading h2 {\n  font-size: 36px;\n  line-height: 1.3;\n}\n@media (max-width: 767px) {\n  .community-sec-A .heading h2 {\n    font-size: 28px;\n  }\n}\n.community-sec-A .flex {\n  align-items: center;\n}\n.community-sec-A .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n@media (max-width: 767px) {\n  .community-sec-A .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.community-sec-A .flex .col:first-child {\n  padding-right: 30px;\n}\n.community-sec-A .text p {\n  margin-bottom: 20px;\n}\n.community-sec-A img {\n  border-radius: 20px;\n}\n\n.community-sec-C {\n  position: relative;\n  background: url(\"../images/product/community-power.jpg\") no-repeat center center/cover;\n  height: calc(100vh - 200px);\n  padding: 100px 0;\n}\n@media (max-width: 767px) {\n  .community-sec-C {\n    height: 100%;\n    padding: 50px 0;\n  }\n}\n.community-sec-C::before {\n  position: absolute;\n  content: \"\";\n  background: #000;\n  opacity: 0.5;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n.community-sec-C .content {\n  position: relative;\n}\n.community-sec-C .content h3 {\n  margin-bottom: 20px;\n  color: #fff;\n}\n.community-sec-C ul {\n  padding: 0;\n}\n.community-sec-C ul li {\n  margin-bottom: 10px;\n}\n\n.compliance-sec-A {\n  padding: 50px 0;\n  background: #e7e7e7;\n  position: relative;\n}\n.compliance-sec-A .heading {\n  margin-bottom: 60px;\n}\n.compliance-sec-A .heading h2 {\n  font-size: 36px;\n}\n@media (max-width: 767px) {\n  .compliance-sec-A .heading h2 {\n    font-size: 28px;\n  }\n}\n.compliance-sec-A .item {\n  position: relative;\n  flex: 0 1 50%;\n  max-width: 50%;\n  margin-bottom: 5rem;\n}\n@media (max-width: 767px) {\n  .compliance-sec-A .item {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.compliance-sec-A .item .circle {\n  width: 150px;\n  height: 150px;\n  background: linear-gradient(#da3467, #f5c0d0);\n  border-radius: 100%;\n  border: 10px solid #ffffff;\n  position: absolute;\n  box-shadow: inset 0 0 8px #312b2d;\n  top: -27px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media (max-width: 767px) {\n  .compliance-sec-A .item .circle {\n    width: 120px;\n    height: 120px;\n    top: -10px;\n  }\n}\n.compliance-sec-A .item .circle .icon {\n  background: #fbfbfb;\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n  box-shadow: 0 0 8px 0 #312b2d;\n}\n@media (max-width: 767px) {\n  .compliance-sec-A .item .circle .icon {\n    width: 50px;\n    height: 50px;\n  }\n}\n.compliance-sec-A .item .text {\n  background: #fff;\n  height: 100px;\n  border-radius: 100px;\n  display: flex;\n  align-items: center;\n  width: 85%;\n}\n@media (max-width: 767px) {\n  .compliance-sec-A .item .text {\n    width: 100%;\n  }\n}\n.compliance-sec-A .item .text p {\n  margin-left: 11rem;\n}\n@media (max-width: 767px) {\n  .compliance-sec-A .item .text p {\n    margin-left: 9rem;\n  }\n}\n\n.compliance-sec-B {\n  position: relative;\n  padding: 50px 0;\n}\n.compliance-sec-B .heading {\n  margin-bottom: 50px;\n}\n.compliance-sec-B .heading h2 {\n  font-size: 36px;\n}\n@media (max-width: 767px) {\n  .compliance-sec-B .heading h2 {\n    font-size: 28px;\n  }\n}\n.compliance-sec-B .flex .col {\n  flex: 0 1 30%;\n  max-width: 30%;\n  margin: 0 20px;\n  text-align: center;\n}\n@media (max-width: 767px) {\n  .compliance-sec-B .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.compliance-sec-B .flex .col:last-child .img::before {\n  content: none;\n}\n.compliance-sec-B .img {\n  position: relative;\n}\n.compliance-sec-B .img::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  right: -20px;\n  border-right: 3px solid #da3467;\n  padding: 10px;\n  height: 100%;\n}\n@media (max-width: 767px) {\n  .compliance-sec-B .img::before {\n    content: none;\n  }\n}\n.compliance-sec-B .img img {\n  border-radius: 0px 100px 0 100px;\n  height: 100%;\n}\n.compliance-sec-B p {\n  padding: 10px;\n  font-weight: 500;\n}\n\n.compliance-sec-C {\n  position: relative;\n  padding: 100px 0;\n  background: url(\"../images/product/cinemetic.jpg\");\n}\n.compliance-sec-C::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  background: #000000;\n  opacity: 0.6;\n}\n.compliance-sec-C .content {\n  position: relative;\n}\n.compliance-sec-C .content h3 {\n  color: #fff;\n  margin-bottom: 20px;\n  font-size: 28px;\n}\n.compliance-sec-C .content ul {\n  padding-left: 0;\n}\n\n.content-banner-sec {\n  position: relative;\n}\n.content-banner-sec .bg {\n  width: 100%;\n  line-height: 0;\n  height: calc(100vh - 100px);\n}\n.content-banner-sec .bg::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #000000;\n  opacity: 0.6;\n}\n.content-banner-sec .bg img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.content-banner-sec .content {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 10%;\n  width: 600px;\n}\n@media (max-width: 767px) {\n  .content-banner-sec .content {\n    left: 0;\n    width: 100%;\n    padding: 0 10px;\n  }\n}\n.content-banner-sec .content p {\n  color: #ffffff;\n  font-size: 24px;\n  line-height: 1.2;\n}\n\n.content-sec-A {\n  padding: 100px 0;\n}\n.content-sec-A .flex {\n  justify-content: center;\n}\n.content-sec-A .flex .col {\n  flex: 0 1 25%;\n  max-width: 25%;\n  text-align: center;\n}\n@media (max-width: 767px) {\n  .content-sec-A .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 100px;\n  }\n}\n.content-sec-A .item {\n  background: linear-gradient(to left, #da3467, #303030);\n  height: 180px;\n  width: 180px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  border-radius: 10px;\n  position: relative;\n  transform: rotate(45deg);\n}\n.content-sec-A .item .text {\n  background: #f1f1f1;\n  height: 150px;\n  width: 150px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  border-radius: 10px;\n  position: relative;\n  box-shadow: 0 0 8px 0 #000000;\n}\n.content-sec-A .item .text p {\n  transform: rotate(-45deg);\n}\n\n.content-sec-B {\n  position: relative;\n  background: #222222;\n  padding: 50px 0;\n}\n.content-sec-B .flex {\n  align-items: center;\n}\n.content-sec-B .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n@media (max-width: 767px) {\n  .content-sec-B .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.content-sec-B .img {\n  width: 400px;\n  margin: 0 auto;\n  line-height: 0;\n}\n@media (max-width: 767px) {\n  .content-sec-B .img {\n    width: 100%;\n  }\n}\n.content-sec-B .img img {\n  width: 100%;\n  border-radius: 10px;\n}\n.content-sec-B .content h3 {\n  margin-bottom: 20px;\n  color: #fff;\n}\n.content-sec-B .content ul {\n  text-align: left;\n}\n\n.content-sec-C {\n  padding: 50px 0;\n}\n.content-sec-C .flex .item {\n  flex: 0 1 25%;\n  max-width: 25%;\n  text-align: center;\n  position: relative;\n}\n@media (max-width: 767px) {\n  .content-sec-C .flex .item {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.content-sec-C .img {\n  line-height: 0;\n  max-width: 280px;\n  width: 100%;\n  margin: 0 auto;\n}\n.content-sec-C .img::before {\n  position: absolute;\n  content: \"\";\n  width: 280px;\n  bottom: 0;\n  height: 50%;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);\n}\n.content-sec-C .img img {\n  width: 100%;\n}\n.content-sec-C p {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 14px;\n  bottom: 20px;\n  color: #fff;\n  font-weight: 600;\n  width: 100%;\n  padding: 0 10px;\n}\n\n.content-sec-E {\n  padding: 50px 0;\n  background: #222222;\n}\n.content-sec-E .heading h2 {\n  color: #fff;\n  font-size: 36px;\n}\n.content-sec-E .item {\n  position: relative;\n  margin: auto;\n  transition: all 0.5s ease-in-out;\n  cursor: pointer;\n}\n.content-sec-E .item::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.44);\n  transition: all 1s ease-in-out;\n}\n.content-sec-E .item:hover::after {\n  height: 0%;\n}\n.content-sec-E .img {\n  overflow: hidden;\n  height: 270px;\n}\n.content-sec-E .img img {\n  width: 100%;\n  height: 100%;\n  transition: all 1s ease-in-out;\n}\n.content-sec-E .text {\n  position: absolute;\n  bottom: 15px;\n  z-index: 1;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n.content-sec-E .text p {\n  color: #fff;\n}\n.content-sec-E .VdeMnSemn {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  cursor: pointer;\n  transform: translate(-50%, -50%);\n  z-index: 5;\n}\n.content-sec-E .VdeMnSemn::before {\n  position: absolute;\n  content: \"\";\n  width: 50px;\n  height: 50px;\n  right: 0;\n  bottom: 0;\n  transform: translate(-50%, -50%);\n  display: block;\n  background: #fff;\n  border-radius: 50%;\n  top: 50%;\n  left: 50%;\n  animation: pulse-border 1500ms ease-out infinite;\n}\n.content-sec-E .VdeMnSemn .VdeIcnMn {\n  width: 50px;\n  height: 50px;\n  border: 2px solid #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n}\n.content-sec-E .VdeMnSemn .VdeIcnMn img {\n  width: auto;\n}\n.content-sec-E .owl-dots {\n  text-align: center;\n}\n\n@keyframes pulse-border {\n  0% {\n    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);\n    opacity: 0;\n  }\n}\n.solution-sec-A {\n  padding: 50px 0;\n}\n.solution-sec-A .heading h2 {\n  font-size: 36px;\n}\n@media (max-width: 767px) {\n  .solution-sec-A .heading h2 {\n    font-size: 28px;\n  }\n}\n.solution-sec-A .flex {\n  align-items: center;\n}\n.solution-sec-A .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n.solution-sec-A .flex .col:last-child {\n  padding-left: 50px;\n}\n@media (max-width: 767px) {\n  .solution-sec-A .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n  .solution-sec-A .flex .col:last-child {\n    padding-left: 0;\n  }\n}\n.solution-sec-A video {\n  height: 400px;\n  width: 100%;\n  background: #222222;\n}\n.solution-sec-A .content p {\n  margin-bottom: 20px;\n}\n\n.solution-sec-B {\n  position: relative;\n  padding: 50px 0;\n  background: #222222;\n}\n.solution-sec-B .heading h2 {\n  color: #fff;\n  font-size: 36px;\n}\n.solution-sec-B .flex {\n  align-items: center;\n}\n.solution-sec-B .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n.solution-sec-B .flex .col:first-child {\n  padding-right: 50px;\n}\n@media (max-width: 767px) {\n  .solution-sec-B .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.solution-sec-B video {\n  height: 400px;\n  width: 100%;\n  background: #222222;\n}\n.solution-sec-B .content ul {\n  padding: 0;\n}\n.solution-sec-B .content ul li {\n  margin-bottom: 15px;\n}\n.solution-sec-B .content b {\n  color: #da3467;\n}\n\n.solution-sec-C {\n  position: relative;\n  background: #f1f1f1;\n  line-height: 0;\n}\n.solution-sec-C video {\n  height: 400px;\n  width: 100%;\n}\n\n.solution-sec-D {\n  position: relative;\n  padding: 50px 0;\n  background: #222222;\n}\n.solution-sec-D .heading h2 {\n  color: #fff;\n  font-size: 36px;\n}\n@media (max-width: 767px) {\n  .solution-sec-D .heading h2 {\n    font-size: 28px;\n  }\n}\n.solution-sec-D .flex .col {\n  flex: 0 1 33.33%;\n  max-width: 33.33%;\n}\n@media (max-width: 767px) {\n  .solution-sec-D .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.solution-sec-D .item {\n  background: #fff;\n  height: 300px;\n  padding: 60px 30px;\n  border-radius: 10px;\n  margin: 0 10px;\n  box-shadow: inset 0 0 10px 2px #222222;\n}\n.solution-sec-D .item ul {\n  padding: 0;\n}\n.solution-sec-D .item ul li {\n  color: #505050;\n}\n.solution-sec-D .item ul li::before {\n  background: #da3467;\n}\n\n.solution-sec-E {\n  position: relative;\n  padding: 100px 0;\n  background: url(\"../images/solution/organization.jpg\") no-repeat center center/cover;\n}\n.solution-sec-E::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  background: #222222;\n  opacity: 0.6;\n}\n.solution-sec-E .heading {\n  text-align: left;\n  position: relative;\n}\n.solution-sec-E .heading h2 {\n  color: #fff;\n}\n.solution-sec-E ul {\n  padding: 0;\n}\n\n.frontline-sec-A {\n  padding: 50px 0;\n  padding-bottom: 100px;\n  position: relative;\n}\n.frontline-sec-A .heading {\n  margin-bottom: 5rem;\n}\n.frontline-sec-A .flex {\n  justify-content: center;\n}\n.frontline-sec-A .flex .col {\n  flex: 0 1 33.33%;\n  max-width: 33.33%;\n}\n@media (max-width: 767px) {\n  .frontline-sec-A .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 60px;\n  }\n}\n.frontline-sec-A .flex .col:last-child .item, .frontline-sec-A .flex .col:nth-last-child(2) .item {\n  transform: rotate(-135deg);\n}\n@media (max-width: 767px) {\n  .frontline-sec-A .flex .col:last-child .item, .frontline-sec-A .flex .col:nth-last-child(2) .item {\n    transform: rotate(45deg);\n  }\n}\n.frontline-sec-A .flex .col:last-child .item p, .frontline-sec-A .flex .col:nth-last-child(2) .item p {\n  transform: rotate(-225deg);\n}\n@media (max-width: 767px) {\n  .frontline-sec-A .flex .col:last-child .item p, .frontline-sec-A .flex .col:nth-last-child(2) .item p {\n    transform: rotate(-45deg);\n  }\n}\n.frontline-sec-A .item {\n  background: linear-gradient(to left, #777777, #303030);\n  height: 250px;\n  width: 250px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  border-top-left-radius: 40%;\n  border: 3px solid #da3467;\n  position: relative;\n  transform: rotate(45deg);\n}\n@media (max-width: 767px) {\n  .frontline-sec-A .item {\n    width: 200px;\n    height: 200px;\n  }\n}\n.frontline-sec-A p {\n  transform: rotate(-45deg);\n  color: #fff;\n  font-size: 14px;\n}\n@media (max-width: 767px) {\n  .frontline-sec-A p {\n    padding: 0 10px;\n    font-size: 12px;\n  }\n}\n\n.frontline-sec-B .bg {\n  position: relative;\n  line-height: 0;\n  height: 500px;\n}\n@media (max-width: 767px) {\n  .frontline-sec-B .bg {\n    height: 350px;\n  }\n}\n.frontline-sec-B .bg::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  background: #000000;\n  opacity: 0.6;\n}\n.frontline-sec-B .bg img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.frontline-sec-B .content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  text-align: center;\n  transform: translate(-50%, -50%);\n}\n@media (max-width: 767px) {\n  .frontline-sec-B .content {\n    width: 100%;\n    padding: 0 25px;\n    top: 35%;\n  }\n}\n.frontline-sec-B .content h2 {\n  color: #fff;\n  margin-bottom: 20px;\n}\n.frontline-sec-B .content p {\n  color: #fff;\n}\n@media (max-width: 767px) {\n  .frontline-sec-B .content p {\n    width: 100%;\n  }\n}\n.frontline-sec-B .growth-sec {\n  background: #222222;\n}\n@media (max-width: 767px) {\n  .frontline-sec-B .growth-sec {\n    padding: 0 15px;\n  }\n}\n.frontline-sec-B .growth-sec .flex {\n  padding: 30px 0;\n  align-items: center;\n}\n.frontline-sec-B .growth-sec .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n@media (max-width: 767px) {\n  .frontline-sec-B .growth-sec .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.frontline-sec-B .growth-sec .flex .col:last-child {\n  padding-left: 50px;\n}\n@media (max-width: 767px) {\n  .frontline-sec-B .growth-sec .flex .col:last-child {\n    margin-top: 20px;\n    padding: 0;\n  }\n}\n.frontline-sec-B .growth-sec .flex img {\n  border: 4px solid #da3467;\n  width: 100%;\n  border-radius: 20px;\n}\n.frontline-sec-B .growth-sec .flex .text h3 {\n  margin-bottom: 20px;\n  color: #fff;\n}\n.frontline-sec-B .growth-sec .flex .text ul {\n  padding: 0;\n}\n.frontline-sec-B .growth-sec .flex .text ul li {\n  color: #fff;\n  margin-bottom: 5px;\n}\n.frontline-sec-B .growth-sec .flex .text ul li::before {\n  background: #da3467;\n}\n\n.frontline-sec-C {\n  position: relative;\n  padding: 100px 0;\n  background: url(\"../images/solution/roi.jpg\");\n}\n.frontline-sec-C::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  background: #000000;\n  opacity: 0.6;\n}\n.frontline-sec-C .container {\n  max-width: 1400px;\n}\n.frontline-sec-C .heading {\n  position: relative;\n  text-align: left;\n}\n.frontline-sec-C .heading h2 {\n  color: #fff;\n}\n.frontline-sec-C .content {\n  width: 600px;\n}\n@media (max-width: 767px) {\n  .frontline-sec-C .content {\n    width: 100%;\n  }\n}\n.frontline-sec-C ul {\n  padding-left: 0;\n}\n@media (max-width: 767px) {\n  .frontline-sec-C ul li {\n    margin-bottom: 10px;\n  }\n}\n\n.frontline-sec-D {\n  padding: 50px 0;\n}\n.frontline-sec-D .heading h2 {\n  margin-bottom: 10px;\n}\n.frontline-sec-D .heading p {\n  font-size: 16px;\n}\n.frontline-sec-D .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n  padding-right: 50px;\n}\n@media (max-width: 767px) {\n  .frontline-sec-D .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    padding-right: 0;\n    margin-bottom: 20px;\n  }\n}\n.frontline-sec-D .flex .col:first-child .text {\n  padding: 70px 20px;\n  background: url(\"../images/solution/microai.jpg\");\n}\n.frontline-sec-D .flex .col:first-child .text::before {\n  position: absolute;\n  content: \"\";\n  background: #000;\n  width: 100%;\n  left: 0;\n  top: 0;\n  border-radius: 10px;\n  opacity: 0.6;\n  height: 100%;\n}\n.frontline-sec-D .flex .col:nth-last-child(2) .text {\n  padding-left: 50px;\n  padding: 58px 20px;\n  background: url(\"../images/solution/measure.jpg\");\n}\n.frontline-sec-D .flex .col:last-child {\n  margin-top: 20px;\n  flex: 0 1 100%;\n  max-width: 100%;\n}\n@media (max-width: 767px) {\n  .frontline-sec-D .flex .col:last-child {\n    margin-top: 0px;\n  }\n}\n.frontline-sec-D .flex .col:last-child .content {\n  background: url(\"../images/solution/measure.jpg\") no-repeat center center/cover;\n  padding: 50px 20px;\n}\n@media (max-width: 767px) {\n  .frontline-sec-D .flex .col:last-child .content ul {\n    padding-left: 0;\n  }\n}\n.frontline-sec-D .text, .frontline-sec-D .content {\n  position: relative;\n  border-radius: 10px;\n}\n.frontline-sec-D .text::before, .frontline-sec-D .content::before {\n  position: absolute;\n  content: \"\";\n  background: #000;\n  width: 100%;\n  left: 0;\n  top: 0;\n  border-radius: 10px;\n  opacity: 0.6;\n  height: 100%;\n}\n.frontline-sec-D .text h3, .frontline-sec-D .content h3 {\n  position: relative;\n  color: #fff;\n  font-weight: 500;\n}\n.frontline-sec-D .text p, .frontline-sec-D .content p {\n  position: relative;\n  color: #fff;\n}\n.frontline-sec-D .text p a, .frontline-sec-D .content p a {\n  color: #da3467;\n}\n.frontline-sec-D .text p a:hover, .frontline-sec-D .content p a:hover {\n  color: #da3467;\n}\n.frontline-sec-D .solution-sec {\n  padding: 0 100px;\n}\n@media (max-width: 767px) {\n  .frontline-sec-D .solution-sec {\n    padding: 0 20px;\n  }\n}\n\n.communc-sec-A {\n  padding: 50px 0;\n  position: relative;\n  background: #222222;\n}\n.communc-sec-A .flex {\n  align-items: center;\n}\n.communc-sec-A .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n@media (max-width: 767px) {\n  .communc-sec-A .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.communc-sec-A .flex .col:first-child {\n  padding-right: 50px;\n}\n@media (max-width: 767px) {\n  .communc-sec-A .flex .col:first-child {\n    margin-bottom: 20px;\n  }\n}\n.communc-sec-A .flex h3 {\n  margin-bottom: 20px;\n  color: #fff;\n}\n.communc-sec-A .flex ul li {\n  color: #fff;\n}\n.communc-sec-A .flex ul li::before {\n  background: #da3467;\n}\n.communc-sec-A .flex video {\n  width: 100%;\n  height: 500px;\n}\n\n.communc-sec-B {\n  padding: 50px 0;\n  position: relative;\n}\n.communc-sec-B .flex .col {\n  flex: 0 1 20%;\n  max-width: 20%;\n  text-align: center;\n  position: relative;\n}\n@media (max-width: 767px) {\n  .communc-sec-B .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.communc-sec-B .flex .img {\n  width: 230px;\n  position: relative;\n  margin: 0 10px;\n}\n@media (max-width: 767px) {\n  .communc-sec-B .flex .img {\n    width: 100%;\n    margin: 0;\n  }\n}\n.communc-sec-B .flex .img::before {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(to top, #000000, transparent);\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n}\n.communc-sec-B .flex .img img {\n  width: 100%;\n  border-radius: 10px;\n}\n.communc-sec-B .flex p {\n  position: absolute;\n  bottom: 5%;\n  left: 50%;\n  color: #fff;\n  transform: translateX(-50%);\n  width: 100%;\n  padding: 0 40px;\n}\n\n.communc-sec-C {\n  background: #222222;\n  padding: 50px 0;\n}\n.communc-sec-C .heading h2 {\n  color: #fff;\n}\n.communc-sec-C .flex .col {\n  flex: 0 1 25%;\n  max-width: 25%;\n}\n@media (max-width: 991px) {\n  .communc-sec-C .flex .col {\n    flex: 0 1 50%;\n    max-width: 50%;\n  }\n}\n@media (max-width: 767px) {\n  .communc-sec-C .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.communc-sec-C .item {\n  box-shadow: 0 0 8px 1px #717171;\n  display: flex;\n  height: 150px;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 0 15px;\n  overflow: hidden;\n  cursor: pointer;\n  border-radius: 10px;\n  position: relative;\n  transition: 450ms ease;\n  background: linear-gradient(45deg, #211a1a, #534c4c);\n}\n.communc-sec-C .item::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #da3467;\n  -webkit-clip-path: polygon(0 100%, 0 98%, 0 100%, 0 100%);\n  clip-path: polygon(0 100%, 0 98%, 0 100%, 0 100%);\n  transition: 450ms ease;\n}\n.communc-sec-C .item:hover::before {\n  -webkit-clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);\n  clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%);\n}\n.communc-sec-C .item p {\n  color: #fff;\n  padding: 0 20px;\n  position: relative;\n}\n\n.communc-sec-D {\n  padding: 50px 0;\n  position: relative;\n}\n.communc-sec-D .heading {\n  margin-bottom: 50px;\n}\n.communc-sec-D .owl-carousel .owl-stage-outer .owl-item {\n  transform: scale(0.9);\n  opacity: 0.6;\n  background: #f1f1f1;\n}\n.communc-sec-D .owl-carousel .owl-stage-outer .owl-item.center {\n  transform: scale(1.1);\n  box-shadow: 0px -1px 10px -2px rgba(0, 0, 0, 0.4);\n  position: relative;\n  z-index: 1;\n  background: #222222;\n  opacity: 1;\n}\n.communc-sec-D .owl-carousel .owl-stage-outer .owl-item.center .item p {\n  color: #fff;\n}\n.communc-sec-D .owl-carousel .owl-dots {\n  text-align: center;\n}\n.communc-sec-D .owl-carousel .owl-dots .owl-dot {\n  background: #d2d2d2;\n}\n.communc-sec-D .item {\n  position: relative;\n  display: flex;\n  background: url(\"../images/solution/workplace/each-course-5-min.png\") no-repeat center center/cover;\n  padding: 55px 15px;\n  height: 150px;\n  border-radius: 10px;\n  justify-content: center;\n  align-items: center;\n}\n.communc-sec-D .item.item2 {\n  background: url(\"../images/solution/workplace/real-workplace.png\") no-repeat center center/cover;\n}\n.communc-sec-D .item.item3 {\n  background: url(\"../images/solution/workplace/keep-in-mind.png\") no-repeat center center/cover;\n}\n.communc-sec-D .item.item4 {\n  background: url(\"../images/solution/workplace/scenario.png\") no-repeat center center/cover;\n}\n.communc-sec-D .item.item5 {\n  background: url(\"../images/solution/workplace/prescriptive-content.png\") no-repeat center center/cover;\n}\n.communc-sec-D .item.item6 {\n  background: url(\"../images/solution/workplace/bella.png\") no-repeat center center/cover;\n}\n.communc-sec-D .item.item7 {\n  background: url(\"../images/solution/workplace/track-progress.png\") no-repeat center center/cover;\n}\n.communc-sec-D .item::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: #222222;\n  opacity: 0.6;\n  border-radius: 10px;\n}\n.communc-sec-D .item p {\n  position: relative;\n  color: #fff;\n}\n\n.blog {\n  background: #e8e8e8;\n  padding: 50px 0;\n}\n\n.blog-grid .blog-img {\n  position: relative;\n  border-radius: 5px;\n  overflow: hidden;\n  line-height: 0;\n}\n.blog-grid .blog-img:hover .img::before, .blog-grid .blog-img:hover .img::after {\n  width: 0%;\n}\n.blog-grid .blog-img .img {\n  display: block;\n  height: 250px;\n}\n.blog-grid .blog-img .img img {\n  width: 100%;\n  height: 250px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.blog-grid .blog-img .img::before {\n  position: absolute;\n  content: \"\";\n  background-color: rgba(28, 30, 39, 0.3);\n  width: 50%;\n  height: 100%;\n  left: 0px;\n  top: 0px;\n  transition: all 500ms ease;\n}\n.blog-grid .blog-img .img::after {\n  position: absolute;\n  content: \"\";\n  background-color: rgba(28, 30, 39, 0.3);\n  width: 50%;\n  height: 100%;\n  right: 0px;\n  top: 0px;\n  transition: all 500ms ease;\n}\n.blog-grid .date {\n  position: absolute;\n  background: #ffffff;\n  color: #282828;\n  padding: 15px;\n  right: 0;\n  top: 15px;\n  font-size: 14px;\n  z-index: 1;\n}\n.blog-grid .blog-info {\n  box-shadow: 0 0 30px rgba(31, 45, 61, 0.125);\n  border-radius: 5px;\n  background: #222222;\n  padding: 20px;\n  margin: -30px 20px 0;\n  position: relative;\n  z-index: 1;\n}\n.blog-grid .blog-info h5 {\n  color: #2e2d2d;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  color: #fff;\n}\n.blog-grid .blog-info p {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 5;\n  overflow: hidden;\n  color: #fff;\n}\n.blog-grid .blog-info .btn-primary {\n  background: #da3467;\n}\n.blog-grid .blog-info .btn-primary svg {\n  margin-left: 5px;\n  vertical-align: middle;\n}\n\n.pagination {\n  text-align: center;\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.page-item {\n  cursor: pointer;\n  background-color: white;\n  color: #999;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.4s ease;\n}\n\n.blog_detail_sec .blog-wrap {\n  position: relative;\n  overflow: hidden;\n  line-height: 0;\n}\n.blog_detail_sec .blog-wrap::before {\n  position: absolute;\n  content: \"\";\n  background: #000;\n  opacity: 0.4;\n  width: 100%;\n  height: 100%;\n}\n.blog_detail_sec .blog-wrap img {\n  height: 500px;\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: 100%;\n}\n.blog_detail_sec .blog-wrap .container {\n  position: relative;\n}\n.blog_detail_sec .blog-wrap .blog-inner {\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.blog_detail_sec .blog-wrap .blog-inner .blog-text h2 {\n  color: #fff;\n  width: 100%;\n  font-weight: 600;\n  margin: 0 0 15px;\n}\n.blog_detail_sec .blog-wrap .blog-inner .blog-text .user-section li {\n  padding-right: 30px;\n  font-size: 16px;\n  color: #fff;\n  vertical-align: middle;\n}\n.blog_detail_sec .blog-wrap .blog-inner .blog-text .user-section li svg {\n  width: 18px;\n  position: relative;\n  top: -2px;\n  margin-right: 5px;\n  vertical-align: middle;\n}\n.blog_detail_sec .blog-detailcontent {\n  padding: 50px 0;\n}\n.blog_detail_sec .blog-detailcontent h1 {\n  margin-bottom: 30px;\n}\n.blog_detail_sec .blog-detailcontent p, .blog_detail_sec .blog-detailcontent h4, .blog_detail_sec .blog-detailcontent h3 {\n  margin-bottom: 20px;\n}\n.blog_detail_sec .blog-detailcontent p a, .blog_detail_sec .blog-detailcontent h4 a, .blog_detail_sec .blog-detailcontent h3 a {\n  color: #da3467;\n}\n.blog_detail_sec .blog-detailcontent h2 {\n  margin-bottom: 25px;\n}\n.blog_detail_sec .blog-detailcontent img {\n  height: 100%;\n}\n.blog_detail_sec .blog-detailcontent ul li {\n  display: block;\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 10px;\n}\n.blog_detail_sec .blog-detailcontent ul li::before {\n  position: absolute;\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: #da3467;\n  border-radius: 100%;\n  left: 0;\n  top: 8px;\n}\n\n.team-sec {\n  padding: 50px 0;\n  background-color: #ececec;\n}\n.team-sec .heading {\n  margin-bottom: 40px;\n}\n.team-sec .team-details {\n  position: relative;\n}\n.team-sec .team-details .team_details_sec {\n  position: relative;\n}\n.team-sec .team-details .team_details_sec a {\n  overflow: hidden;\n}\n.team-sec .team-details .team_img {\n  width: 300px;\n  height: 300px;\n  margin: 0 auto;\n  overflow: hidden;\n}\n.team-sec .team-details .team_img::before {\n  width: 300px;\n  height: 300px;\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.7019607843), transparent);\n  pointer-events: none;\n  border-radius: 20px;\n}\n.team-sec .team-details .team_img img {\n  border-radius: 20px;\n  height: 100%;\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.team-sec .team-details .name {\n  font-size: 20px;\n  margin: 10px 0;\n  font-weight: 400;\n  color: #fff;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 23%;\n  width: 100%;\n}\n.team-sec .team-details .designation {\n  color: #2e2d2d;\n  font-weight: 600;\n  font-size: 16px;\n  margin-top: 15px;\n}\n.team-sec .team-details .linked_profile a {\n  display: inline-block;\n}\n.team-sec .team-details .linked_profile a svg {\n  fill: #da3467;\n}\n.team-sec.leadership {\n  background: #222222;\n}\n.team-sec.leadership .designation {\n  color: #e1e1e1;\n}\n.team-sec.leadership .linked_profile a svg {\n  fill: #fff;\n}\n\n.about-sec-A {\n  position: relative;\n  background: #222222;\n}\n.about-sec-A .container {\n  padding: 50px;\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n}\n@media (max-width: 768px) {\n  .about-sec-A .container {\n    flex-direction: column;\n  }\n}\n.about-sec-A .slide-mission {\n  flex: 1;\n  cursor: pointer;\n  padding: 0 50px;\n  height: 100%;\n  pointer-events: auto;\n  transition: all 500ms ease;\n}\n@media (max-width: 768px) {\n  .about-sec-A .slide-mission {\n    overflow: auto;\n    overflow-x: hidden;\n  }\n}\n.about-sec-A .slide-mission.vission {\n  background: linear-gradient(rgba(0, 0, 0, 0.623), rgba(0, 0, 0, 0.623)), url(\"../images/vission.jpg\");\n  background-size: cover;\n  background-position: center center;\n}\n.about-sec-A .slide-mission.mission {\n  background: linear-gradient(rgba(0, 0, 0, 0.623), rgba(0, 0, 0, 0.623)), url(\"../images/purpose.jpg\");\n  background-size: cover;\n  background-position: center center;\n}\n.about-sec-A .slide-mission:hover {\n  flex-grow: 2;\n}\n.about-sec-A .slide-mission:hover .title {\n  top: 20%;\n  transform: rotate(0deg);\n}\n.about-sec-A .slide-mission:hover .desc {\n  opacity: 1;\n  width: 100%;\n  top: 35%;\n}\n.about-sec-A .slide-mission .title {\n  color: #fff;\n  position: relative;\n  font-size: 48px;\n  margin: auto;\n  text-align: center;\n  transform: rotate(90deg);\n  top: 50%;\n  transition: all 500ms ease;\n}\n@media (max-width: 768px) {\n  .about-sec-A .slide-mission .title {\n    transform: rotate(0deg) !important;\n  }\n}\n.about-sec-A .slide-mission .desc {\n  opacity: 0;\n  color: #f1f1f1;\n  position: relative;\n  width: 70%;\n  font-size: 16px;\n  padding: 5%;\n  top: 50%;\n  border: 2px solid #f1f1f1;\n  border-radius: 10px;\n  line-height: 1.3;\n  margin: auto;\n  text-align: left;\n  transform: rotate(0deg);\n  transition: all 500ms ease;\n}\n@media screen and (max-width: 768px) {\n  .about-sec-A .slide-mission .desc {\n    padding: 0%;\n    border: 0px solid #f1f1f1;\n  }\n}\n.about-sec-A .slide-mission .desc p {\n  margin-bottom: 10px;\n}\n\n.newsletter {\n  padding: 50px 0;\n}\n.newsletter .flex .col {\n  flex: 0 1 33.33%;\n  max-width: 33.33%;\n}\n.newsletter .post-slide {\n  background: #fff;\n  margin: 20px 15px 20px;\n  border-radius: 15px;\n  padding-top: 1px;\n  box-shadow: 0px 14px 22px -9px #bbcbd8;\n}\n.newsletter .post-slide .post-img {\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n  margin: -12px 15px 8px 15px;\n  margin-left: -10px;\n}\n.newsletter .post-slide .post-img img {\n  width: 100%;\n  height: auto;\n  transform: scale(1, 1);\n  transition: transform 0.2s linear;\n}\n.newsletter .post-slide:hover .post-img img {\n  transform: scale(1.1, 1.1);\n}\n.newsletter .post-slide .over-layer {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  background: linear-gradient(-45deg, rgba(6, 190, 244, 0.75) 0%, rgba(45, 112, 253, 0.6) 100%);\n  transition: all 0.5s linear;\n}\n.newsletter .post-slide .over-layer i {\n  position: relative;\n  top: 45%;\n  text-align: center;\n  display: block;\n  color: #fff;\n  font-size: 25px;\n}\n.newsletter .post-slide:hover .over-layer {\n  opacity: 1;\n  text-decoration: none;\n}\n.newsletter .post-slide .post-content {\n  background: #fff;\n  padding: 2px 20px 40px;\n  border-radius: 15px;\n}\n.newsletter .post-slide .post-title a {\n  font-size: 15px;\n  font-weight: bold;\n  color: #333;\n  display: inline-block;\n  text-transform: uppercase;\n  transition: all 0.3s ease 0s;\n}\n.newsletter .post-slide .post-title a:hover {\n  text-decoration: none;\n  color: #da3467;\n}\n.newsletter .post-slide .post-description {\n  line-height: 24px;\n  color: #808080;\n  margin-bottom: 25px;\n}\n.newsletter .post-slide .post-date {\n  color: #2c2c2c;\n  font-size: 14px;\n  font-weight: 600;\n  vertical-align: middle;\n}\n.newsletter .post-slide .post-date .date {\n  margin-left: 5px;\n}\n.newsletter .post-slide .read-more {\n  padding: 7px 20px;\n  float: right;\n  font-size: 12px;\n  background: #da3467;\n  color: #ffffff;\n  box-shadow: 0px 10px 20px -10px #1376c5;\n  border-radius: 25px;\n  text-transform: uppercase;\n}\n.newsletter .post-slide .read-more:hover {\n  background: #da3467;\n  text-decoration: none;\n  color: #fff;\n}\n.newsletter.news-sec .col {\n  position: relative;\n}\n.newsletter.news-sec .inkalllm {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n}\n.newsletter.news-sec .post-slide .post-img {\n  margin: 0;\n  height: 250px;\n}\n.newsletter.news-sec .post-slide .post-title {\n  margin: 20px 0;\n}\n.newsletter.news-sec .post-slide .post-title a {\n  text-transform: none;\n}\n.newsletter.news-sec .post-slide .read-btn {\n  display: inline-block;\n  text-align: center;\n  width: 100%;\n}\n.newsletter.news-sec .post-slide .read-btn .read-more {\n  float: inherit;\n  text-transform: lowercase;\n}\n\n.contact-sec {\n  background: rgba(166, 166, 166, 0.2666666667);\n  padding: 50px 0;\n}\n.contact-sec .heading h2 {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n.contact-sec .heading h2 .text-darkpink {\n  color: #da3467;\n}\n.contact-sec .contact-form {\n  background: #fff;\n  padding: 25px;\n  box-shadow: 1px 0px 7px 1px rgba(153, 153, 153, 0.8588235294);\n  border-radius: 20px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.contact-sec .contact-form .img_cnt {\n  flex: 0 1 40%;\n  max-width: 40%;\n  position: relative;\n}\n@media (max-width: 767px) {\n  .contact-sec .contact-form .img_cnt {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.contact-sec .contact-form .img_cnt::before {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(to bottom, transparent, #000000);\n  width: 100%;\n  border-radius: 20px;\n  height: 100%;\n}\n.contact-sec .contact-form .img_cnt img {\n  border-radius: 20px;\n}\n.contact-sec .contact-form .content {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  padding: 0 20px;\n}\n.contact-sec .contact-form .content h5 {\n  color: #fff;\n  margin-bottom: 10px;\n}\n.contact-sec .contact-form .content p {\n  color: #fff;\n}\n.contact-sec .contact-form form {\n  flex: 0 1 60%;\n  max-width: 60%;\n  padding: 36px;\n  position: relative;\n  border-radius: 6px;\n}\n@media (max-width: 767px) {\n  .contact-sec .contact-form form {\n    flex: 0 1 100%;\n    max-width: 100%;\n    padding: 20px;\n  }\n}\n.contact-sec .contact-form form .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n  padding: 0 15px;\n  margin-top: 20px;\n}\n@media (max-width: 767px) {\n  .contact-sec .contact-form form .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    padding: 0;\n  }\n}\n.contact-sec .contact-form form .flex .col:nth-last-child(2), .contact-sec .contact-form form .flex .col:last-child {\n  flex: 0 1 100%;\n  max-width: 100%;\n}\n.contact-sec .contact-form form .flex .col:last-child {\n  text-align: center;\n}\n.contact-sec .contact-form form .back-input .frm-cntrl, .contact-sec .contact-form form .back-textarea .frm-cntrl {\n  display: block;\n  width: 100%;\n  padding: 8px 15px;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border-radius: 5px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.contact-sec .contact-form form .back-input label, .contact-sec .contact-form form .back-textarea label {\n  margin-bottom: 5px;\n}\n.contact-sec .contact-form form .back-input .error, .contact-sec .contact-form form .back-textarea .error {\n  display: block;\n  margin-top: 5px;\n  color: red;\n}\n.contact-sec .contact-form form .demo-link {\n  background: #da3467;\n  padding: 7px 25px;\n  text-align: center;\n  margin: 0 auto;\n  border-radius: 25px;\n  width: 200px;\n  margin-top: 20px;\n  border: 0;\n  margin: 0 auto;\n}\n.contact-sec .contact-form form .demo-link a {\n  color: #fff;\n  display: block;\n}\n\n.office-sec {\n  padding: 50px 0;\n}\n.office-sec .heading h2 {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n.office-sec .heading h2 .text-darkpink {\n  color: #da3467;\n}\n.office-sec .flex .col {\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n@media (max-width: 767px) {\n  .office-sec .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n  }\n}\n.office-sec .offer_card {\n  border: 1px solid #a6a6a6;\n  width: 400px;\n  border-radius: 20px;\n  padding: 20px;\n  margin: 0 auto;\n  height: 250px;\n  background: #222222;\n}\n@media (max-width: 767px) {\n  .office-sec .offer_card {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.office-sec .offer_card img {\n  width: 60px;\n}\n.office-sec .offer_card h4 {\n  color: #fff;\n}\n.office-sec .offer_card p {\n  color: #fff;\n}\n\n.download-banner {\n  position: relative;\n}\n.download-banner .bg {\n  width: 100%;\n  height: calc(100vh - 400px);\n  line-height: 0;\n}\n.download-banner .bg::before {\n  position: absolute;\n  content: \"\";\n  background: #000000;\n  width: 100%;\n  height: 100%;\n  opacity: 0.7;\n}\n.download-banner .bg img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.download-banner .content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n.download-banner .content h2 {\n  color: #fff;\n  margin-bottom: 10px;\n}\n.download-banner .content p {\n  font-size: 18px;\n  color: #fff;\n}\n\n.download-sec {\n  position: relative;\n  padding: 50px 0;\n}\n.download-sec .flex {\n  align-items: center;\n}\n.download-sec .flex .col {\n  text-align: center;\n  flex: 0 1 50%;\n  max-width: 50%;\n}\n.download-sec .qrcode {\n  width: 200px;\n  border-radius: 10px;\n}\n.download-sec .app-links .app-store, .download-sec .app-links .playstore {\n  width: 200px;\n  display: inline-block;\n}\n\n.react-footer {\n  position: relative;\n  background: url(../images/footer-bg.png) no-repeat center center/cover;\n  color: #fff;\n}\n@media (max-width: 767px) {\n  .react-footer {\n    padding-bottom: 50px;\n  }\n}\n.react-footer::before {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  background: rgba(34, 34, 34, 0.5764705882);\n}\n.react-footer .footer-top {\n  position: relative;\n  padding: 100px 0 50px;\n  border-bottom: 1px solid #fff;\n}\n@media (max-width: 767px) {\n  .react-footer .footer-top {\n    padding-top: 30px;\n    padding-bottom: 0;\n  }\n}\n.react-footer .footer-top .flex.reviews {\n  width: 50%;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  margin-top: 30px;\n}\n.react-footer .footer-top .flex .col {\n  flex: 0 1 25%;\n  max-width: 25%;\n}\n@media (max-width: 767px) {\n  .react-footer .footer-top .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.react-footer .footer-top .footer-logo a img {\n  filter: invert(1);\n  width: 90px;\n}\n.react-footer .footer-top h6 {\n  color: #fff;\n  font-size: 14px;\n  padding-right: 30px;\n  line-height: 1.3;\n}\n.react-footer .footer-top .footer-title {\n  margin-bottom: 10px;\n  color: #fff;\n}\n.react-footer .footer-top .footer-menu svg {\n  margin-right: 10px;\n  vertical-align: middle;\n}\n.react-footer .footer-top .footer-menu li {\n  transition: 450ms ease;\n}\n.react-footer .footer-top .footer-menu li a {\n  color: #f7f7f7;\n}\n.react-footer .footer-top .footer-menu li:hover a {\n  margin-left: 10px;\n  color: #da3467;\n}\n.react-footer .footer-top .footer3__form p {\n  margin-bottom: 10px;\n}\n.react-footer .footer-top .footer3__form form {\n  position: relative;\n}\n.react-footer .footer-top .footer3__form form .email {\n  position: relative;\n}\n.react-footer .footer-top .footer3__form form input {\n  padding: 15px 80px 16px 30px;\n  border: none;\n  outline: none;\n  background: #ffffff;\n  border-radius: 4px;\n  width: 90%;\n}\n.react-footer .footer-top .footer3__form form button {\n  position: absolute;\n  width: 60px;\n  bottom: 0;\n  border-radius: 0 4px 4px 0;\n  background-color: #da3467;\n  color: #ffffff;\n  top: 0px;\n  right: 0px;\n  border: none;\n}\n.react-footer .footer-top .footer3__form form button svg {\n  width: 20px;\n}\n.react-footer .footer-top .footer3__form form .error {\n  display: block;\n  color: red;\n  margin-top: 5px;\n}\n.react-footer .copyright {\n  padding: 10px 0;\n  position: relative;\n}\n.react-footer .copyright .byteedge {\n  color: #da3467;\n}\n.react-footer .copyright .flex {\n  align-items: center;\n}\n.react-footer .copyright .flex .col {\n  flex: 0 1 33.33%;\n  max-width: 33.33%;\n  text-align: center;\n}\n@media (max-width: 767px) {\n  .react-footer .copyright .flex .col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n}\n.react-footer .copyright .flex .col:last-child {\n  text-align: right;\n}\n@media (max-width: 767px) {\n  .react-footer .copyright .flex .col:last-child {\n    text-align: left;\n  }\n}\n.react-footer .copyright .isocerti {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.react-footer .copyright .isocerti span {\n  color: #fff;\n  margin-left: 10px;\n}\n.react-footer .copyright .social-links li:first-child {\n  margin-right: 10px;\n}\n.react-footer .copyright .social-links li a {\n  margin: 0 10px;\n  border: 1px solid #fff;\n  width: 40px;\n  height: 40px;\n  display: block;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.react-footer .copyright .social-links li svg {\n  fill: #da3467;\n}\n\n.software-logo a img {\n  width: 100px;\n}\n\n.privacy-sec-A {\n  position: relative;\n  padding: 50px 0;\n}\n.privacy-sec-A .content h3, .privacy-sec-A .content h2 {\n  margin-bottom: 20px;\n}\n.privacy-sec-A .content h3 {\n  color: #da3467;\n  font-weight: 600;\n  margin: 35px 0;\n}\n.privacy-sec-A .content h4 {\n  font-size: 20px;\n  margin-bottom: 20px;\n}\n.privacy-sec-A .content a {\n  color: #da3467;\n  font-weight: 600;\n}\n.privacy-sec-A .content p {\n  margin-bottom: 10px;\n  color: #666666;\n}\n.privacy-sec-A .content table {\n  width: 100%;\n}\n.privacy-sec-A .content table th {\n  font-weight: 600;\n}\n.privacy-sec-A .content table, .privacy-sec-A .content tr, .privacy-sec-A .content th, .privacy-sec-A .content td {\n  margin-top: 20px;\n  padding: 20px;\n  color: #666666;\n  border: 1px solid #666666;\n}\n.privacy-sec-A .content table span, .privacy-sec-A .content tr span, .privacy-sec-A .content th span, .privacy-sec-A .content td span {\n  display: block;\n}\n.privacy-sec-A .content .bullet_points li {\n  color: #666666;\n  margin-bottom: 10px;\n}\n.privacy-sec-A .content .bullet_points li::before {\n  background: #da3467;\n}\n\n.page_404 {\n  padding: 50px 0;\n}\n.page_404 .four_zero_four_bg {\n  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);\n  height: 400px;\n  background-position: center;\n}\n.page_404 .contant_box_404 {\n  text-align: center;\n}\n.page_404 .contant_box_404 .link_404 {\n  color: #fff;\n  padding: 10px 20px;\n  background: #da3467;\n  margin: 20px 0;\n  border-radius: 20px;\n  display: inline-block;\n}\n\n.chatbot-popup {\n  position: fixed;\n  bottom: 90px;\n  right: 35px;\n  opacity: 0;\n  pointer-events: none;\n  margin: 10px 0;\n  width: 350px;\n  overflow: hidden;\n  transform: scale(0.2);\n  background: #fff;\n  border-radius: 15px;\n  box-shadow: 0 0 128px 0 rgba(0, 0, 0, 0.1), 0 32px 64px -48px rgba(0, 0, 0, 0.5);\n  transition: all 0.1s ease;\n  z-index: 111;\n}\n.chatbot-popup .chat-header {\n  background: #da3467;\n  display: flex;\n  padding: 15px 20px;\n  align-items: center;\n  justify-content: space-between;\n}\n.chatbot-popup .chat-header .header-info {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.chatbot-popup .chat-header .header-info h2 {\n  font-size: 20px;\n  color: #fff;\n}\n.chatbot-popup .chat-header .header-info img {\n  border-radius: 100%;\n  border: 2px solid #fff;\n  max-width: 50px;\n}\n.chatbot-popup .chat-header button {\n  outline: none;\n  border: none;\n  background: none;\n  color: #fff;\n  border-radius: 100%;\n  width: 30px;\n  height: 30px;\n  transition: 0.2 ease;\n}\n.chatbot-popup .chat-header button:hover {\n  background: #ce2559;\n}\n.chatbot-popup .chatbot-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: 280px;\n  overflow-y: auto;\n  padding: 25px 20px;\n  scrollbar-width: thin;\n  scrollbar-color: #da3467 transparent;\n}\n.chatbot-popup .chatbot-body .message {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.chatbot-popup .chatbot-body .message .message-text {\n  background: #da3467;\n  padding: 5px 10px;\n  color: #fff;\n  max-width: 75%;\n  font-weight: 400;\n  word-wrap: break-word;\n  white-space: pre-line;\n  font-size: 0.95rem;\n  line-height: 1.3;\n}\n.chatbot-popup .chatbot-body .message.bot-message img {\n  border-radius: 100%;\n  width: 40px;\n  border: 2px solid #da3467;\n  flex-shrink: 0;\n  align-self: flex-start;\n}\n.chatbot-popup .chatbot-body .message.bot-message .message-text {\n  background: rgba(218, 52, 103, 0.3803921569);\n  color: #2e2d2d;\n  border-radius: 10px 10px 10px 2px;\n}\n.chatbot-popup .chatbot-body .message.user-message {\n  flex-direction: column;\n  align-items: flex-end;\n}\n.chatbot-popup .chatbot-body .message.user-message .message-text {\n  border-radius: 10px 10px 2px 10px;\n}\n.chatbot-popup .ai-sugesstion {\n  padding: 8px 20px;\n}\n.chatbot-popup .ai-sugesstion span {\n  background: rgba(218, 52, 103, 0.7294117647);\n  font-size: 12px;\n  padding: 5px 10px;\n  border-radius: 27px;\n  margin-left: 5px;\n  margin-bottom: 5px;\n  display: inline-block;\n  line-height: 1.3;\n  cursor: pointer;\n}\n.chatbot-popup .chat-footer {\n  bottom: 0;\n  width: 100%;\n  background: #fff;\n  padding: 15px 20px;\n}\n.chatbot-popup .chat-footer .chat-form {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border-radius: 30px;\n  outline: 2px solid #c2c2c2;\n}\n.chatbot-popup .chat-footer .chat-form:focus-within {\n  outline: 2px solid #da3467;\n}\n.chatbot-popup .chat-footer .chat-form .message-input {\n  outline: none;\n  background: none;\n  border: none;\n  width: 100%;\n  padding: 0 10px;\n  height: 40px;\n  font-size: 0.95rem;\n}\n.chatbot-popup .chat-footer .chat-form .message-input:valid ~ button {\n  display: block;\n}\n.chatbot-popup .chat-footer .chat-form button {\n  height: 30px;\n  width: 30px;\n  border-radius: 100%;\n  outline: none;\n  font-size: 1.15rem;\n  flex-shrink: 0;\n  margin-right: 8px;\n  background: #da3467;\n  border: none;\n  display: none;\n  color: #fff;\n}\n\n#chatbot-toogler {\n  position: fixed;\n  bottom: 30px;\n  right: 35px;\n  border: none;\n  height: 80px;\n  width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(218, 52, 103, 0.831372549);\n  border-radius: 50%;\n  z-index: 11;\n  transition: all 0.2s ease;\n  overflow: hidden;\n  animation: bounce 1.5s infinite, glow 2s infinite alternate;\n}\n#chatbot-toogler span {\n  position: absolute;\n  color: #fff;\n}\n#chatbot-toogler span img {\n  width: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n@keyframes glow {\n  0% {\n    box-shadow: 0 0 15px rgba(255, 61, 132, 0.6), 0 0 30px rgba(255, 30, 105, 0.4);\n  }\n  100% {\n    box-shadow: 0 0 25px #ff3d64, 0 0 50px #ff1e5e;\n  }\n}\n.container.show-chatbot .chatbot-popup {\n  opacity: 1;\n  transform: scale(1);\n  pointer-events: auto;\n}\n.container.show-chatbot #chatbot-toogler {\n  transform: rotate(90deg);\n  animation: none;\n  height: 50px;\n  width: 50px;\n}\n.container.show-chatbot #chatbot-toogler span:first-child {\n  opacity: 0;\n}\n.container.show-chatbot #chatbot-toogler span:last-child {\n  opacity: 1;\n}\n\n#chatbot-toogler span:last-child {\n  opacity: 0;\n}\n\n.typing {\n  position: relative;\n}\n.typing span {\n  content: \"\";\n  animation: blink 1.5s infinite;\n  animation-fill-mode: both;\n  height: 10px;\n  width: 10px;\n  background: #fff;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border-radius: 50%;\n}\n.typing span:nth-child(2) {\n  animation-delay: 0.2s;\n  margin-left: 15px;\n}\n.typing span:nth-child(3) {\n  animation-delay: 0.4s;\n  margin-left: 30px;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0.1;\n  }\n  20% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.1;\n  }\n}/*# sourceMappingURL=style.css.map */","//media breakpoint\r\n$screen-400 : 400px\r\n$screen-420 : 420px\r\n$screen-520 : 520px\r\n$screen-675 : 675px\r\n$screen-767 : 767px\r\n$screen-768 : 768px\r\n$screen-860 : 860px\r\n$screen-991 : 991px\r\n$screen-992 : 992px\r\n$screen-1024 : 1024px\r\n$screen-1140 : 1140px\r\n$screen-1230 : 1230px\r\n$screen-1300 : 1300px\r\n$screen-1366 : 1366px\r\n$screen-1440 : 1440px\r\n@mixin respond-to($media)\r\n    @if $media == screen-400\r\n        @media only screen and ( max-width: $screen-400)\r\n            @content\r\n    @else if $media == screen-420\r\n        @media only screen and ( max-width: $screen-420)\r\n            @content                       \r\n    @else if $media == screen-520\r\n        @media ( max-width: $screen-520)\r\n            @content                       \r\n    @else if $media == screen-675\r\n        @media ( max-width: $screen-675)\r\n            @content                       \r\n    @else if $media == screen-767\r\n        @media ( max-width: $screen-767)\r\n            @content                       \r\n    @else if $media == screen-768\r\n        @media ( max-width: $screen-768)\r\n            @content                       \r\n    @else if $media == screen-860\r\n        @media ( max-width: $screen-860)\r\n            @content                       \r\n    @else if $media == screen-991\r\n        @media ( max-width: $screen-991)\r\n            @content                       \r\n    @else if $media == screen-992\r\n        @media ( max-width: $screen-992)\r\n            @content                       \r\n    @else if $media == screen-1024\r\n        @media ( max-width: $screen-1024)\r\n            @content                       \r\n    @else if $media == screen-1140\r\n        @media ( max-width: $screen-1140)\r\n            @content                       \r\n    @else if $media == screen-1230\r\n        @media ( max-width: $screen-1230)\r\n            @content                       \r\n    @else if $media == screen-1300\r\n        @media ( max-width: $screen-1300)\r\n            @content                       \r\n    @else if $media == screen-1366\r\n        @media ( max-width: $screen-1366)\r\n            @content                       \r\n    @else if $media == screen-1440\r\n        @media ( max-width: $screen-1440)\r\n            @content                       \r\n                        \r\n\r\n// colors\r\n$primary-color: #da3467\r\n$secondary-color: #666666\r\n$black-color: #000\r\n$white-color: #fff\r\n$text-color: #2e2d2d\r\n\r\n\r\n//font\r\n\r\n$Poppins: 'Poppins', sans-serif     \r\n$Roboto: 'Roboto', sans-serif\r\n$font-wm: 500\r\n$font-wsm: 600 \r\n\r\n\r\n=keyframes($name)\r\n  @-webkit-keyframes #{$name}\r\n    @content\r\n  @-moz-keyframes #{$name}\r\n    @content\r\n  @-ms-keyframes #{$name}\r\n    @content\r\n  @keyframes #{$name}\r\n    @content    \r\n","header\r\n    background: #242424\r\n    position: relative\r\n    z-index: 11\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        top: 0\r\n        left: 0\r\n        bottom: 0\r\n        right: 0\r\n        background: #222222\r\n        -webkit-box-shadow: 0 0 8px 1px #33333354\r\n        box-shadow: 0 0 8px 1px #33333354\r\n        -webkit-transition: 700ms ease\r\n        -o-transition: 700ms ease\r\n        transition: 700ms ease\r\n    .container-fluid\r\n        padding: 0 40px \r\n        \r\n    .top-strip\r\n        position: relative\r\n        padding: 10px 0\r\n        -webkit-transition: 700ms ease\r\n        -o-transition: 700ms ease\r\n        transition: 700ms ease\r\n        z-index: 11\r\n        background: $primary-color\r\n        @include respond-to(screen-767)\r\n            display: none\r\n        .flex\r\n            position: relative\r\n            -webkit-box-align: center\r\n            align-items: center\r\n        .col1\r\n            flex: 0 1 40%\r\n            max-width: 60%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 50%\r\n                max-width: 50%\r\n        .col2\r\n            flex: 0 1 60%\r\n            max-width: 60%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 50%\r\n                max-width: 50%\r\n        .left-side\r\n            ul\r\n                li\r\n                    display: inline-block\r\n                    padding-right: 20px\r\n                    svg\r\n                        vertical-align: middle\r\n                        width: 16px\r\n                        fill: none\r\n                        stroke: $white-color\r\n                    a\r\n                        font-size: 12px\r\n                        margin-left: 5px    \r\n                        color: $white-color\r\n        .right-side\r\n            text-align: right \r\n            .social-links\r\n                li\r\n                    padding: 0 10px\r\n                    svg\r\n                        fill: $white-color\r\n                        vertical-align: middle\r\n    .header-wapper\r\n        position: relative\r\n        z-index: 1\r\n        padding: 10px 0\r\n        .flex\r\n            align-items: center\r\n            -webkit-box-align: center\r\n            .col1\r\n                flex: 0 1 20%\r\n                max-width: 20%\r\n                @include respond-to(screen-1024)\r\n                    flex: 0 1 20%\r\n                    max-width: 20%\r\n            .col2\r\n                flex: 0 1 80%\r\n                max-width: 80% \r\n                @include respond-to(screen-1024)\r\n                    flex: 0 1 80%\r\n                    max-width: 80%\r\n        .menu-trigger\r\n            width: 40px\r\n            height: 36px\r\n            position: absolute\r\n            right: 0\r\n            top: 50%\r\n            cursor: pointer\r\n            display: none\r\n            transform: translateY(-50%)\r\n            @include respond-to(screen-767)\r\n                display: block\r\n                right: 15px\r\n            span\r\n                display: block\r\n                height: 1px\r\n                background: #ffffff\r\n                position: absolute\r\n                left: 0\r\n                right: 0\r\n                top: 50%\r\n                &.sma\r\n                    top: 27%\r\n                    width: 20px\r\n                &.smb\r\n                    display: block\r\n                    width: 30px\r\n                &.smc\r\n                    display: block\r\n                    bottom: 26%\r\n                    top: auto         \r\n        .custom-nav\r\n            text-align: right\r\n            ul\r\n                display: inline-block\r\n                @include respond-to(screen-767)\r\n                    display: none\r\n                li\r\n                    display: inline-block\r\n                    &:nth-child(3)\r\n                         &.has-dropdown\r\n                            ul\r\n                                &.dropdown\r\n                                    width: 150px\r\n\r\n                        \r\n                    @include respond-to(screen-991)\r\n                        &:last-child\r\n                            display: none \r\n                    &.has-dropdown\r\n                        position: relative\r\n                        margin-right: 10px\r\n                        ul\r\n                            &.dropdown\r\n                                position: absolute\r\n                                left: 0\r\n                                width: 290px\r\n                                top: 40px\r\n                                background: $primary-color\r\n                                padding: 8px 0\r\n                                text-align: left\r\n                                opacity: 0\r\n                                pointer-events: none\r\n                                -webkit-user-select: none\r\n                                -moz-user-select: none\r\n                                -ms-user-select: none\r\n                                user-select: none\r\n                                -webkit-box-shadow: 0 6px 13px 1px #3333332e\r\n                                box-shadow: 0 6px 13px 1px #3333332e\r\n                                border-radius: 5px\r\n                                -webkit-transition: 400ms ease\r\n                                -o-transition: 400ms ease\r\n                                transition: 400ms ease\r\n                                &::before\r\n                                        content: \"\"\r\n                                        position: absolute\r\n                                        top: -16px\r\n                                        width: 8px\r\n                                        height: 8px\r\n                                        border: 8px solid transparent\r\n                                        border-bottom-color: $primary-color\r\n                                        left: 43px\r\n                                li\r\n                                    display: block\r\n                                    a\r\n                                        display: block\r\n                                        color: #fff\r\n                                        padding: 9px 15px\r\n                                        font-weight: 400\r\n                                        font-size: 14px\r\n                                        line-height: 18px\r\n                                        -webkit-transition: 700ms ease\r\n                                        -o-transition: 700ms ease\r\n                                        transition: 700ms ease \r\n                        .dd-icon\r\n                            display: inline-block\r\n                            margin-left: 10px             \r\n                        &:hover\r\n                            .dropdown\r\n                                opacity: 1\r\n                                pointer-events: all\r\n                                li\r\n                                    &:hover\r\n                                        a\r\n                                            background: $white-color\r\n                                            color: $secondary-color\r\n                                    \r\n                    a\r\n                        color: $white-color \r\n                        padding: 19px 15px       \r\n            .demo-link\r\n                display: inline-block\r\n                padding-left: 19px\r\n                @include respond-to(screen-991)\r\n                    display: none\r\n                a\r\n                    position: relative\r\n                    color: $white-color\r\n                    padding: 10px 15px\r\n                    border: 2px solid $white-color\r\n                    border-radius: 50px\r\n                    background: $primary-color\r\n                    span\r\n                        z-index: 1\r\n                        position: relative\r\n                    // &::before\r\n                    //     position: absolute\r\n                    //     content: \"\"\r\n                    //     background: $primary-color\r\n                    //     width: 0\r\n                    //     top: 0\r\n                    //     left: 0\r\n                    //     height: 100%\r\n                    //     transform: translateX(0%)\r\n                    //     transition: 450ms ease\r\n                    //     border-radius: 50px\r\n                    //     z-index: 1\r\n                    &:hover\r\n                        &::before\r\n                            width: 100%  \r\n                            \r\n                            transform: translateX(0%)  \r\n    &.header-fixed  \r\n        position: fixed !important\r\n        width: 100%\r\n        -webkit-animation: stickyanimations 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both\r\n        animation: stickyanimations 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both\r\n        box-shadow: 10px 0 20px rgba(8, 0, 41, 0.08)\r\n        top: 0\r\n        left: 0\r\n        right: 0\r\n        z-index: 111\r\n@keyframes name\r\n    0%\r\n        transform: translateY(-100px)\r\n    100%\r\n        transform: translateY(0px)\r\n\r\n.custom-logo\r\n    line-height: 0\r\n    a\r\n        display: block\r\n        img\r\n            -webkit-transform: 450ms ease\r\n            -o-transition: 450ms ease\r\n            transition: 450ms ease\r\n            width: 80px\r\n            filter: invert(1)\r\n   \r\n@keyframes stickyanimations \r\n    0% \r\n      -webkit-transform: translateY(-100px)\r\n      transform: translateY(-100px)\r\n    \r\n    100% \r\n      -webkit-transform: translateY(0px)\r\n      transform: translateY(0px)   ",".model\r\n    &.model-navigation\r\n        overflow-y: scroll\r\n    &.model-navigation,&.EnquiryModel\r\n        background: #222222\r\n        top: 0\r\n        bottom: 0\r\n        right: 0\r\n        max-width: 360px\r\n        width: 100%\r\n        padding: 50px\r\n        transform: translateX(100%)\r\n        transition: 450ms ease\r\n        &.is-open\r\n            transform: translate(0%)\r\n        .navover\r\n            position: absolute\r\n            bottom: 5px\r\n            right: 20px\r\n            opacity: 0.2\r\n            img\r\n                width: 200px\r\n                filter: invert(1)\r\n        .close_model\r\n            img\r\n                filter: invert(1)        \r\n        .modelBody\r\n            height: 100%\r\n            &.contactform\r\n                padding-top: 40px\r\n            .navigation-list\r\n                height: 100%\r\n                .serviice_nav\r\n                    padding: 40px 0\r\n                    position: relative\r\n                    ul\r\n                        .nablist\r\n                            width: 100%\r\n                            position: relative\r\n                            cursor: pointer\r\n                        li\r\n                            position: relative\r\n                            display: block\r\n                            a\r\n                                display: inline-block\r\n                                color: #e5e5e5\r\n                                font-size: 23px\r\n                                padding: 6px 0\r\n                                margin: 4px 0\r\n                                line-height: 30px\r\n                                font-weight: 600\r\n                                transition: 450ms ease\r\n                            .nablisting\r\n                                padding-left: 20px\r\n                                display: none\r\n                                &.open\r\n                                    display: block\r\n                                li\r\n                                    a\r\n                                        font-size: 16px\r\n                                        margin: 0\r\n                                        margin-bottom: 3px\r\n                                        font-weight: 300px  \r\n                            .downarrow\r\n                                position: absolute\r\n                                top: 10px\r\n                                right: 10px\r\n                    &::after\r\n                        content: \"\"\r\n                        position: absolute\r\n                        bottom: 0\r\n                        right: 0\r\n                        width: 100%\r\n                        height: 2px\r\n                        background: $white-color\r\n                        opacity: 0.2\r\n                .nav_list\r\n                    position: relative\r\n                    padding: 40px 0\r\n                    ul\r\n                        li\r\n                            margin-bottom: 10px\r\n                            a\r\n                                color: $white-color\r\n                                font-size: 16px\r\n                                padding: 6px 0\r\n                                margin: 4px 0\r\n                                transition: 450ms ease\r\n                .social-links\r\n                    ul\r\n                        li\r\n                            display: inline-block\r\n                            margin: 0 5px\r\n                            &:first-child\r\n                               margin-left: 0 \r\n                            a\r\n                                width: 30px\r\n                                height: 30px\r\n                                background: $white-color\r\n                                display: flex\r\n                                align-items: center\r\n                                justify-content: center\r\n                                border-radius: 3px\r\n                                transition: 450ms ease\r\n                                svg\r\n                                    fill: $primary-color\r\n            .back-input,.back-textarea\r\n                position: relative\r\n                margin-bottom: 25px\r\n                .frm-cntrl\r\n                    background: none\r\n                    border: none\r\n                    width: 100%\r\n                    display: block\r\n                    user-select: none\r\n                    padding: 10px 25px\r\n                    color: $white-color\r\n                    border-radius: 10px\r\n                    border: 2px solid $text-color\r\n                    transition: all 1s ease\r\n                    &:focus ~ label\r\n                            top: -12px\r\n                            background: #222222\r\n                            padding: 0 10px\r\n                    &:valid ~ label\r\n                            top: -12px\r\n                            background: #222222\r\n                            padding: 0 10px\r\n\r\n                label\r\n                    position: absolute\r\n                    color: #fff\r\n                    left: 10px\r\n                    top: 10px  \r\n                    transition: 750ms ease \r\n                .custom\r\n                    display: inline-block \r\n                    margin-right: 5px\r\n                    margin-bottom: 0\r\n                    vertical-align: middle\r\n                    width: auto\r\n                .text\r\n                    display: inline-block \r\n                    vertical-align: middle\r\n                    color: $white-color\r\n                .error\r\n                    color: red\r\n                    display: block\r\n                    margin-top: 5px\r\n                    font-size: 12px \r\n                    line-height: 1   \r\n            .demo-link\r\n                background: $white-color\r\n                text-align: center\r\n                padding: 8px 15px\r\n                border-radius: 10px\r\n                border: 0\r\n                width: 100%\r\n                &:hover\r\n                    background: $primary-color\r\n                    a\r\n                        color: $white-color\r\n                a\r\n                    color: $secondary-color",".model\r\n    &.model-video\r\n        max-width: 1000px\r\n        width: 100%\r\n        left: 50%\r\n        top: 100%\r\n        transform: translate(-50%, 100%)\r\n        background: #fff\r\n        transition: all 1s ease\r\n        &.is-open\r\n            transform: translate(-50%, -50%)\r\n            top: 50%\r\n        .modelBody\r\n            // height: 600px\r\n            width: 100%\r\n            line-height: 0\r\n            // display: flex\r\n            // align-items: center\r\n            // flex-wrap: wrap\r\n            iframe\r\n                width: 100%\r\n                height: 100%\r\n                -o-object-fit: cover\r\n                object-fit: cover\r\n                border: 0\r\n                padding: 50px 0\r\n                padding-bottom: 30px \r\n            video\r\n                height: 400px\r\n                width: 100%",".demo-video\r\n    width: 100%\r\n    line-height: 0\r\n    height: 500px\r\n    background: #272727\r\n    @include respond-to(screen-767)\r\n        height: 100%\r\n    video\r\n        width: 100%\r\n        height: 100%\r\n\r\n/*----------------- sectionA ----------------*/\r\n.about-app\r\n    position: relative\r\n    padding: 35px 0\r\n    background: #272727\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            &:first-child\r\n                padding-right: 30px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n        &.aiplatform\r\n            justify-content: center\r\n            .col\r\n                flex: 0 1 48%\r\n                max-width: 48%\r\n                padding: 0\r\n                margin: 0 10px\r\n                margin-bottom: 20px\r\n    .bullet_points\r\n        display: none\r\n        @include respond-to(screen-767)\r\n            display: block\r\n    .item\r\n        display: flex\r\n        align-items: center\r\n        position: relative\r\n        // justify-content: center\r\n        .num\r\n            background: $primary-color\r\n            height: 100px\r\n            width: 25%\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            border-radius: 10rem 0 0 10rem\r\n            span\r\n                color: $white-color\r\n                font-size: 24px\r\n                margin-right: 2rem\r\n        .circle\r\n            background: #fff\r\n            width: 100px\r\n            height: 100px\r\n            border-radius: 100%\r\n            position: absolute\r\n            left: 6rem\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            &::before\r\n                position: absolute\r\n                content: \"\"\r\n                width: 85px\r\n                height: 85px\r\n                background: transparent\r\n                border-radius: 100%\r\n                border: 4px solid $primary-color\r\n            .round\r\n                border-radius: 100%\r\n                width: 60px\r\n                height: 60px\r\n                background: #da3467\r\n                display: flex\r\n                align-items: center\r\n                justify-content: center\r\n                img\r\n                    width: 30px\r\n                    // filter: invert(1)  \r\n        .desc\r\n            background: #525252\r\n            padding: 1rem 30px 1rem 4rem\r\n            border-radius: 0 10rem 10rem 0\r\n            height: 100px\r\n            width: 75%\r\n            display: flex\r\n            align-items: center\r\n        @include respond-to(screen-767)\r\n            display: none\r\n        p\r\n            color: #e4e4e4\r\n            font-size: 17px\r\n            font-weight: 400\r\n            span\r\n                color: $primary-color\r\n                font-weight: 700\r\n\r\n    .content\r\n        margin-bottom: 50px\r\n        h2\r\n            font-size: 48px\r\n            color: $white-color\r\n            padding-bottom: 20px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n        span\r\n            color: $primary-color\r\n        li\r\n            font-size: 16px\r\n\r\n/*----------------- sectionA ----------------*/\r\n.home-sec-A\r\n    .item\r\n        height: 60vh\r\n        position: relative\r\n        transition: all 1s ease\r\n        img\r\n            width: 100%\r\n            height: 100%\r\n            object-fit: cover\r\n        .cover\r\n            padding: 75px 100px\r\n            position: absolute\r\n            width: 100%\r\n            height: 100%\r\n            top: 0\r\n            left: 0\r\n            background: rgba(0, 0, 0, 0.6)\r\n            display: flex\r\n            align-items: center\r\n            @include respond-to(screen-991)\r\n                padding: 75px 30px\r\n            .header-content\r\n                position: relative\r\n                padding: 56px\r\n                overflow: hidden\r\n                @include respond-to(screen-767)\r\n                    padding: 20PX\r\n                .line\r\n                    content: \"\"\r\n                    display: inline-block\r\n                    width: 100%\r\n                    height: 100%\r\n                    left: 0\r\n                    top: 0\r\n                    position: absolute\r\n                    border: 9px solid #fff\r\n                    -webkit-clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%)\r\n                    clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%)\r\n                    pointer-events: none\r\n                    @include respond-to(screen-991)\r\n                        clip-path: polygon(0 0, 90% 0, 55% 100%, 0 100%)\r\n                    @include respond-to(screen-767)\r\n                        border: 5px solid #fff\r\n                h1\r\n                    color: #fff\r\n                    font-size: 36px\r\n                    line-height: 1.5\r\n                    margin-bottom: 20px\r\n                    @include respond-to(screen-1024)\r\n                        font-size: 30px\r\n                    @include respond-to(screen-767)\r\n                        font-size: 20px\r\n                .readmore\r\n                    a\r\n                        color: $primary-color\r\n                        font-size: 14px\r\n                        background: #fff\r\n                        padding: 8px 25px\r\n                        border-radius: 10px\r\n                        margin-top: 20px\r\n                        margin-left: 8rem\r\n                        font-weight: 600\r\n                        display: inline-block\r\n                        @include respond-to(screen-767)\r\n                            margin-left: 4rem\r\n    .owl-item\r\n        &.active\r\n            h2\r\n                -webkit-animation-duration: 1s\r\n                animation-duration: 1s\r\n                -webkit-animation-fill-mode: both\r\n                animation-fill-mode: both\r\n                animation-name: fadeInDown\r\n                animation-delay: 0.3s\r\n                color: #fff\r\n            .line\r\n                -webkit-animation-duration: 1s\r\n                animation-duration: 1s\r\n                -webkit-animation-fill-mode: both\r\n                animation-fill-mode: both\r\n                animation-name: fadeInLeft\r\n                animation-delay: 0.3s\r\n    .owl-nav\r\n        display: none\r\n        .owl-prev\r\n            position: absolute\r\n            left: 15px\r\n            top: 43%\r\n            opacity: 0\r\n            -webkit-transition: all 0.4s ease-out\r\n            transition: all 0.4s ease-out\r\n            background: rgba(0, 0, 0, 0.5) !important\r\n            width: 40px\r\n            cursor: pointer\r\n            height: 40px\r\n            position: absolute\r\n            display: block\r\n            z-index: 1000\r\n            border-radius: 0\r\n            span\r\n                font-size: 1.6875rem\r\n                color: #fff\r\n            &:focus\r\n                outline: 0\r\n            &:hover\r\n                background: #000 !important\r\n        .owl-next\r\n            position: absolute\r\n            right: 15px\r\n            top: 43%\r\n            opacity: 0\r\n            -webkit-transition: all 0.4s ease-out\r\n            transition: all 0.4s ease-out\r\n            background: rgba(0, 0, 0, 0.5) !important\r\n            width: 40px\r\n            cursor: pointer\r\n            height: 40px\r\n            position: absolute\r\n            display: block\r\n            z-index: 1000\r\n            border-radius: 0\r\n            span\r\n                font-size: 1.6875rem\r\n                color: #fff\r\n            &:focus\r\n                outline: 0\r\n            &:hover\r\n                background: #000 !important\r\n    &:hover\r\n        .owl-prev\r\n            left: 0px\r\n            opacity: 1\r\n        .owl-next\r\n            right: 0px\r\n            opacity: 1\r\n    .owl-dots\r\n        text-align: center\r\n        height: auto\r\n        position: absolute\r\n        bottom: 20px\r\n        left: 0\r\n        right: 0\r\n\r\n/*----------------- sectionB ----------------*/\r\n.home-sec-B1\r\n    position: relative\r\n    padding: 50px 0\r\n    overflow: hidden\r\n    background: #e7e7e7\r\n    height: 95vh\r\n    @include respond-to(screen-767)\r\n        display: none\r\n    .heading\r\n        margin-bottom: 7em\r\n        h1\r\n            font-size: 40px\r\n    .challenges\r\n        @include respond-to(screen-991)\r\n            transform: rotate(90deg)\r\n            position: relative\r\n            top: 15rem\r\n        @include respond-to(screen-767)\r\n            transform: rotate(90deg)\r\n            position: relative\r\n            top: 0\r\n    .flex\r\n        &::before\r\n            position: absolute\r\n            // content: \"\"\r\n            width: 100%\r\n            height: 100%\r\n            background: url(../images/line.png) no-repeat center\r\n            background-size: 80%\r\n            left: 0px\r\n            top: 35px\r\n            pointer-events: none\r\n    .col\r\n        flex: 0 1 16.6%\r\n        max-width: 16.6%\r\n        position: relative\r\n        display: flex\r\n        justify-content: space-between\r\n        gap: 110px\r\n        flex-direction: column\r\n        @include respond-to(screen-1440)\r\n            gap: 90px\r\n        @include respond-to(screen-1024)\r\n            gap: 50px\r\n        .hexa\r\n            position: relative\r\n            width: 6rem\r\n            height: 10rem\r\n            background: #b5b5b5\r\n            border-radius: 1em/0.5em\r\n            top: 3rem\r\n            left: -1rem\r\n            @include respond-to(screen-1440)\r\n                left: 2rem\r\n                top: 1rem\r\n            @include respond-to(screen-1024)\r\n                width: 5rem\r\n                height: 8rem\r\n                left: 4rem\r\n                top: 5.5rem\r\n            @include respond-to(screen-991)\r\n                left: 3rem\r\n                top: 1.5rem\r\n            @include respond-to(screen-767)\r\n                width: 4rem\r\n                height: 6rem\r\n                left: 3rem\r\n                top: 1.5rem\r\n            &.hexa2\r\n                left: .2rem\r\n                top: -3rem\r\n                background: #2f586a\r\n                @include respond-to(screen-1440)\r\n                    top: -5rem\r\n                    left: 2.5rem\r\n                @include respond-to(screen-1024)\r\n                    left: 3.5rem\r\n                    top: 0\r\n                @include respond-to(screen-991)\r\n                    left: 2.5rem\r\n                    top: 1.5rem\r\n            &.hexa3\r\n                left: 2.5rem\r\n                background: #00b5d0\r\n                @include respond-to(screen-1440)\r\n                    top: 1rem\r\n                    left: 3.5rem\r\n                @include respond-to(screen-1024)\r\n                    left: 3.3rem\r\n                    top: 5.5rem\r\n                @include respond-to(screen-991)\r\n                    left: 2rem\r\n                    top: 1.5rem\r\n            &.hexa4\r\n                top: -3rem\r\n                left: 5rem\r\n                background: #ee073f\r\n                @include respond-to(screen-1440)\r\n                    top: -5rem\r\n                    left: 4rem\r\n                @include respond-to(screen-1024)\r\n                    left: 3rem\r\n                    top: 0\r\n                @include respond-to(screen-991)\r\n                    left: 1.5rem\r\n                    top: 1.5rem\r\n            &.hexa5\r\n                left: 7rem\r\n                background: #ffad27\r\n                @include respond-to(screen-1440)\r\n                    top: 1rem\r\n                    left: 5rem\r\n                @include respond-to(screen-1024)\r\n                    left: 2.5rem\r\n                    top: 5.5rem\r\n                @include respond-to(screen-991)\r\n                    left: 1.2rem\r\n                    top: 1.5rem\r\n            &.hexa6\r\n                top: -3rem\r\n                left: 10rem\r\n                background: #8f4a81\r\n                @include respond-to(screen-1440)\r\n                    top: -5rem\r\n                    left: 6rem\r\n                @include respond-to(screen-1024)\r\n                    left: 2rem\r\n                    top: 0\r\n                @include respond-to(screen-991)\r\n                    left: 1.5rem\r\n                    top: 1.5rem\r\n            &::before,&::after\r\n                position: absolute\r\n                content: \"\"\r\n                width: inherit\r\n                height: inherit\r\n                background: inherit\r\n                border-radius: inherit\r\n            &::before\r\n                transform: rotate(60deg)\r\n            &::after\r\n                transform: rotate(-60deg)\r\n        p\r\n            text-align: center\r\n            position: relative\r\n            @include respond-to(screen-991)\r\n                transform: rotate(-90deg)\r\n                width: 200px\r\n            @include respond-to(screen-767)\r\n                font-size: 12px\r\n            &.text\r\n                left: -5rem\r\n                @include respond-to(screen-1440)\r\n                    left: -1rem\r\n                    top: -2rem\r\n                @include respond-to(screen-1024)\r\n                    left: 2rem\r\n                    top: 3rem\r\n                @include respond-to(screen-991)\r\n                    left: -1rem\r\n                    top: 6rem\r\n            &.text2\r\n                left: -3rem\r\n                @include respond-to(screen-1440)\r\n                    top: -2rem\r\n                    left: -1rem\r\n                @include respond-to(screen-1024)\r\n                    left: 1rem\r\n                    top: 1rem\r\n                @include respond-to(screen-991)\r\n                    left: -1.5rem\r\n                    top: -3rem\r\n            &.text3\r\n                top: -1rem\r\n                @include respond-to(screen-1440)\r\n                    left: -.5rem\r\n                    top: -4rem\r\n                @include respond-to(screen-1024)\r\n                    left: .5rem\r\n                    top: 3rem\r\n                @include respond-to(screen-991)\r\n                    left: -2rem\r\n                    top: 6rem\r\n            &.text4\r\n                left: 1rem\r\n                @include respond-to(screen-1440)\r\n                    top: -2rem\r\n                    left: 1rem\r\n                @include respond-to(screen-1024)\r\n                    left: .5rem\r\n                    top: 1rem\r\n                @include respond-to(screen-991)\r\n                    left: -2rem\r\n                    top: -3rem\r\n            &.text5\r\n                top: -1rem\r\n                left: 4rem\r\n                @include respond-to(screen-1440)\r\n                    left: 1rem\r\n                    top: -4rem\r\n                @include respond-to(screen-1024)\r\n                    left: 0rem\r\n                    top: 3rem\r\n                @include respond-to(screen-991)\r\n                    left: -2rem\r\n                    top: 6rem\r\n            &.text6\r\n                left: 5rem\r\n                @include respond-to(screen-1440)\r\n                    top: -2rem\r\n                    left: 1rem\r\n                @include respond-to(screen-1024)\r\n                    left: 0rem\r\n                    top: 2rem\r\n                @include respond-to(screen-991)\r\n                    left: -3rem\r\n                    top: -3rem\r\n        .icon\r\n            position: absolute\r\n            top: 32px\r\n            z-index: 1\r\n            @include respond-to(screen-1024)\r\n                top: 22px\r\n            img\r\n                border-radius: 100%\r\n                filter: grayscale(1)\r\n\r\n/*--------------------------- main-sec ------------------------*/\r\n.main-sec\r\n    position: relative\r\n    padding: 50px 0\r\n    background: #272727\r\n    // background: url(../images/diagram-banner.jpg) no-repeat center center/cover\r\n    z-index: 1\r\n    .heading\r\n        position: relative\r\n        h1\r\n            color: $white-color\r\n            font-size: 40px\r\n            @include respond-to(screen-1024)\r\n                font-size: 36px\r\n                margin-bottom: 50px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n                line-height: 1.5\r\n    .flex\r\n        justify-content: center\r\n        .col\r\n            flex: 0 1 100%\r\n            max-width: 100%\r\n            margin: 0 10px\r\n            position: relative\r\n            margin-bottom: 1rem\r\n    .content\r\n        background: linear-gradient(45deg, white, #b7b7b7)\r\n        width: 50%\r\n        border-radius: 50px\r\n        padding: 20px\r\n        padding-left: 7rem\r\n        border: 10px solid\r\n        border-color: #da3467\r\n        margin: 0 auto\r\n        h3\r\n            margin-bottom: 10px\r\n        .rounded\r\n            background: linear-gradient(45deg, #da3467, #da537c)\r\n            display: inline-block\r\n            position: absolute\r\n            left: 22rem\r\n            top: 50%\r\n            transform: translateY(-50%)\r\n            width: 70px\r\n            height: 70px\r\n            border-radius: 100% !important\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            span\r\n                color: $white-color\r\n                font-size: 20px\r\n        .bullet_points\r\n            li\r\n                color: $text-color\r\n                &::before\r\n                    background: $primary-color\r\n\r\n/*--------------------------- sectionC ------------------------*/\r\n.home-sec-C\r\n    padding: 50px 0\r\n    @include respond-to(screen-767)\r\n        background: #e8e8e8\r\n    .heading\r\n        margin-bottom: 50px\r\n        h1\r\n            font-size: 40px\r\n\r\n            @include respond-to(screen-1024)\r\n                font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 24px\r\n\r\n    .homeslider\r\n        .owl-stage-outer\r\n            .owl-item\r\n                transform: scale(0.9)\r\n                opacity: .8\r\n                &.center\r\n                    transform: scale(1.3)\r\n                    position: relative\r\n                    z-index: 1\r\n                    opacity: 1\r\n                    .itemslider\r\n                        .card\r\n                            .card__link\r\n                                display: block\r\n        .owl-dots\r\n            text-align: center\r\n            .owl-dot\r\n                background: #d2d2d2\r\n        .itemslider\r\n            position: relative\r\n            // padding: 20px\r\n            // transform: scale(.9)\r\n            transition: transform 400ms\r\n            .test\r\n                display: block\r\n                position: absolute\r\n                top: 0\r\n                left: 0\r\n                width: 100%\r\n                height: 100%\r\n                z-index: 5\r\n            .card\r\n                position: relative\r\n                height: 100%\r\n                // &::before \r\n                //     content: ''\r\n                //     display: block\r\n                //     background-color: transparent\r\n                //     top: 0\r\n                //     left: 0\r\n                //     position: absolute\r\n                //     width: 100%\r\n                //     height: 100%\r\n                //     transform: translate(-20px, -20px)\r\n                //     border: 3px solid #da3467\r\n                //     z-index: -2  \r\n                &::after\r\n                    content: ''\r\n                    display: block\r\n                    position: absolute\r\n                    top: 0\r\n                    left: 0\r\n                    width: 100%\r\n                    height: 100%\r\n                    background: #000\r\n                    opacity: .7\r\n                    z-index: 1\r\n                .card__content\r\n                    position: absolute\r\n                    top: 0\r\n                    left: 0\r\n                    width: 100%\r\n                    height: 100%\r\n                    z-index: 11\r\n                    .card__content-inner\r\n                        position: relative\r\n                        height: 100%\r\n                        display: flex\r\n                        flex-direction: column\r\n                        justify-content: center\r\n                        align-items: center\r\n                        padding: 32px\r\n                        color: rgba(255, 255, 255)\r\n                        isolation: isolate\r\n                        z-index: 1\r\n                        .card__excerpt\r\n                            margin-bottom: 16px\r\n                            font-size: 20px\r\n                            text-align: center\r\n                            margin-bottom: 20px\r\n                            @include respond-to(screen-767)\r\n                                font-size: 16px\r\n                                padding: 0 10px\r\n                        .card__link\r\n                            padding: 5px 24px\r\n                            color: #ffffff\r\n                            text-decoration: none\r\n                            font-size: 14px\r\n                            line-height: 1.5\r\n                            display: none\r\n                            border: 1px solid rgba(255, 255, 255)\r\n                            background: #da3467\r\n                            font-weight: 600\r\n                            border-radius: 10px\r\n                            @include respond-to(screen-767)\r\n                                padding: 5px 15px\r\n                                font-size: 10px\r\n\r\n/*--------------------------- sectionD ------------------------*/\r\n.home-sec-D\r\n    position: relative\r\n    padding: 50px 0\r\n    // background: #e8e8e8\r\n    @include respond-to(screen-767)\r\n        background: #ffffff\r\n    .heading\r\n        h1\r\n            font-size: 40px\r\n    .flex\r\n        justify-content: center\r\n        .col\r\n            flex: 0 1 25%\r\n            max-width: 25%\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            position: relative\r\n            margin-bottom: 30px\r\n            flex-direction: column\r\n            @include respond-to(screen-991)\r\n                max-width: 33.33%\r\n                flex: 0 1 33.33\r\n            @include respond-to(screen-767)\r\n                max-width: 100%\r\n                flex: 0 1 100%\r\n            &:last-child,&:nth-last-child(2)\r\n                svg\r\n                    // top: 14px\r\n                    @include respond-to(screen-767)\r\n                        top: 0\r\n\r\n            // .outer\r\n            //     margin-bottom: 10px\r\n            //     .text\r\n            //         span\r\n            //             font-size: 36px\r\n            //             color: $primary-color\r\n            //             font-weight: 600\r\n            // .name\r\n            //     font-size: 24px              \r\n        .outer\r\n            width: 160px\r\n            height: 160px\r\n            border-radius: 50%\r\n            padding: 20px\r\n            box-shadow: 6px 6px 10px -1px rgba(0,0,0,0.15), -6px -6px 10px -1px rgba(176,176,176,0.5)\r\n            .inner\r\n                width: 120px\r\n                height: 120px\r\n                display: flex\r\n                align-items: center\r\n                justify-content: center\r\n                border-radius: 50%\r\n                box-shadow: inset 4px 4px 6px -1px rgba(134, 134, 134, 0.2), inset -4px -4px 6px -1px rgba(202, 202, 202, 0.7), -0.5px -0.5px 0 rgba(225,225,225,1)\r\n                span\r\n                    font-size: 20px\r\n                    color: $primary-color\r\n                    font-weight: 600\r\n                    display: inline-block\r\n        circle\r\n            fill: none\r\n            stroke: url(#GradientColor)\r\n            stroke-width: 20px\r\n            stroke-dasharray: 472\r\n            stroke-dashoffset: 472\r\n            animation: anim 2s linear forwards\r\n        svg\r\n            position: absolute\r\n            top: 0\r\n        .name\r\n            margin-top: 10px\r\n            font-size: 16px\r\n            @include respond-to(screen-1024)\r\n                font-size: 14px\r\n@keyframes anim\r\n    100%\r\n        stroke-dashoffset: 0\r\n\r\n/*--------------------------- sectionE ------------------------*/\r\n.home-sec-E\r\n    position: relative\r\n    padding: 50px 0\r\n    // background: #e7e7e7\r\n    @include respond-to(screen-767)\r\n        padding: 30px 0\r\n    .heading\r\n        margin-bottom: 30px\r\n        text-align: center\r\n        h1\r\n            font-size: 40px\r\n    .partners\r\n        position: relative\r\n        .flex\r\n            align-items: center\r\n            // justify-content: center\r\n            .col\r\n                flex: 0 1 20%\r\n                max-width: 20%\r\n                @include respond-to(screen-991)\r\n                    flex: 33.33%\r\n                    max-width: 33.33%\r\n                @include respond-to(screen-767)\r\n                    flex: 50%\r\n                    max-width: 50%\r\n        .logo\r\n            width: 150px\r\n            max-width: 100%\r\n            @include respond-to(screen-767)\r\n                width: 100px\r\n                margin: 0 auto\r\n            img\r\n                width: 100%\r\n                filter: grayscale(1)\r\n    // .HBrandsnav\r\n    //     @include respond-to(screen-767)\r\n    //         display: none\r\n    //     button\r\n    //         position: absolute\r\n    //         background: $primary-color\r\n    //         outline: none\r\n    //         border: 0\r\n    //         padding: 10px\r\n    //         border-radius: 100%\r\n    //         top: 55%\r\n    //         display: flex\r\n    //         align-content: center\r\n    //         -webkit-transform: translateY(-50%)\r\n    //         -ms-transform: translateY(-50%)\r\n    //         transform: translateY(-50%)\r\n    //         &.owl-next\r\n    //             right: 30px\r\n    //         &.owl-prev\r\n    //             left: 30px\r\n    //         img\r\n    //             width: 30px             \r\n    // .owl-dots \r\n    //     text-align: center\r\n    //     margin-top: 50px\r\n    //     button\r\n    //         background: #f1f1f1 !important\r\n    //         width: 10px\r\n    //         height: 10px\r\n    //         border-radius: 26px\r\n    //         margin: 0 5px\r\n    //         transition: 0.3s\r\n    //         &.active\r\n    //             // width: 30px\r\n    //             background: $primary-color !important\r\n\r\n/*-------------------- testimonial-sec-------------------*/\r\n.testimonial-sec\r\n    // background: linear-gradient( rgb(0, 0, 0), rgba(0, 22, 37, 0.85) )\r\n    background: #e7e7e7\r\n    position: relative\r\n    padding: 60px 0\r\n\r\n    .heading\r\n        margin-bottom: 50px\r\n        h1\r\n            font-size: 40px\r\n            color: #666666\r\n            @include respond-to(screen-767)\r\n                font-size: 30px\r\n\r\n    .owl-carousel \r\n        overflow: hidden\r\n        padding: 0 20px\r\n        margin: 0px -40px\r\n        padding-right: 40px\r\n        @include respond-to(screen-767)\r\n            margin: 0\r\n            padding-right: 0\r\n    .owl-stage-outer \r\n            padding: 30px 50px\r\n            margin-left: -43px\r\n            width: calc(100% + 62px)\r\n            @include respond-to(screen-767)\r\n                width: inherit\r\n                margin-left: 0\r\n                padding: 0\r\n    .testimonial-card\r\n        @include respond-to(screen-767)\r\n            padding: 20px\r\n    .single-testimonial \r\n        border: 7px solid #222222\r\n        text-align: center\r\n        border-radius: 45px\r\n        position: relative\r\n        z-index: 2\r\n        height: 407px\r\n        @include respond-to(screen-767)\r\n            height: inherit\r\n        p \r\n            color: #222\r\n            font-size: 14px\r\n            line-height: 24px\r\n            padding: 50px\r\n            padding-bottom: 30px\r\n            position: relative\r\n            z-index: 3\r\n\r\n        &::before \r\n            content: \"\"\r\n            position: absolute\r\n            left: -35px\r\n            top: -35px\r\n            background: url(../images/quote.png) no-repeat #e7e7e7\r\n            background-size: 60%\r\n            width: 126px\r\n            height: 100px\r\n            transform: rotate(180deg)\r\n            background-position: 34px 15px\r\n\r\n        &::after \r\n            content: \"\"\r\n            position: absolute\r\n            right: -35px\r\n            bottom: -34px\r\n            background: url(../images/quote.png) no-repeat #e7e7e7\r\n            background-size: 60%\r\n            width: 126px\r\n            height: 100px\r\n            background-position: 34px 19px\r\n            @include respond-to(screen-767)\r\n                bottom: -45px\r\n\r\n        .round \r\n            width: 100%\r\n            height: 100%\r\n            position: absolute\r\n            z-index: 1\r\n\r\n        .round-1\r\n            &::before \r\n                content: \"\"\r\n                position: absolute\r\n                left: 88px\r\n                top: -6.7px\r\n                width: 50px\r\n                height: 7px\r\n                background: #222222\r\n                border-radius: 30px\r\n\r\n            &::after \r\n                content: \"\"\r\n                position: absolute\r\n                left: -6.5px\r\n                top: 62px\r\n                width: 7px\r\n                height: 50px\r\n                background: #222222\r\n                border-radius: 30px\r\n\r\n        .round-2\r\n            &::before \r\n                content: \"\"\r\n                position: absolute\r\n                right: 87px\r\n                bottom: -7px\r\n                width: 50px\r\n                height: 7px\r\n                background: #222222\r\n                border-radius: 30px\r\n                z-index: 1\r\n\r\n            &::after \r\n                content: \"\"\r\n                position: absolute\r\n                right: -6.5px\r\n                bottom: 62px\r\n                width: 7px\r\n                height: 50px\r\n                background: #222222\r\n                border-radius: 30px\r\n                z-index: 1\r\n                @include respond-to(screen-767)\r\n                    right: -7px\r\n                    bottom: 50px\r\n\r\n\r\n        .client-info \r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            text-align: left\r\n            padding-bottom: 50px\r\n            .client-img\r\n                padding-right: 15px\r\n                img\r\n                    width: 60px\r\n                    height: 60px\r\n                    border-radius: 100px\r\n                    display: flex\r\n                    justify-content: center\r\n                    align-items: center\r\n                    box-shadow: 0 0 16px rgba(0, 0, 0, 0.16)\r\n                    font-size: 22px\r\n            h6 \r\n                color: #000\r\n                font-weight: 700\r\n                font-size: 18px\r\n                // color: #fff\r\n\r\n            span \r\n                display: inline-block\r\n                color: #000\r\n                font-size: 12px\r\n\r\n.owl-dots \r\n    text-align: center\r\n    margin-top: 50px\r\n    button \r\n        background: #fff !important\r\n        width: 10px\r\n        height: 10px\r\n        border-radius: 26px\r\n        margin: 0 5px\r\n        transition: 0.3s\r\n        &.active \r\n            width: 30px\r\n\r\n           \r\n    // .testimonial-card\r\n    //     padding: 0 10rem\r\n    //     border-radius: 40px\r\n    //     @include respond-to(screen-767)\r\n    //         padding: 0\r\n    // .single-testimonial\r\n    //     text-align: center\r\n    //     position: relative\r\n    //     z-index: 2\r\n       \r\n    //     @include respond-to(screen-767)\r\n    //         height: 100%\r\n    //     p\r\n    //         color: #ffffff\r\n    //         font-size: 18px\r\n    //         line-height: 24px\r\n    //         padding: 50px 10px\r\n    //         padding-bottom: 30px\r\n    //         position: relative\r\n    //         z-index: 3\r\n    //         font-weight: 300\r\n    //         @include respond-to(screen-767)\r\n    //             padding: 25px 50px\r\n    //             font-size: 12px\r\n    //             padding-top: 5px\r\n    //         &::before\r\n    //             content: \"\"\r\n    //             position: absolute\r\n    //             left: -6rem\r\n    //             top: -1rem\r\n    //             width: 78px\r\n    //             height: 86px\r\n    //             background: url(../images/quote.png) no-repeat\r\n    //             background-size: 60%\r\n    //             transform: rotate(180deg)\r\n    //             // background-position: 20px 3px\r\n    //             @include respond-to(screen-767)\r\n    //                 background-position: 8px 13px\r\n    //                 width: 75px\r\n    //                 height: 65px\r\n    //                 left: 0\r\n\r\n    //         &::after\r\n    //             content: \"\"\r\n    //             position: absolute\r\n    //             right: -6rem\r\n    //             bottom: -1rem\r\n    //             width: 78px\r\n    //             height: 86px\r\n    //             background: url(../images/quote.png) no-repeat\r\n    //             background-size: 60%\r\n    //             transform: rotate(360deg)\r\n    //             // background-position: 20px 3px\r\n    //             @include respond-to(screen-767)\r\n    //                 background-position: 8px -5px\r\n    //                 width: 75px\r\n    //                 height: 65px\r\n    //                 right: 0\r\n    //     .client-details\r\n    //         margin-bottom: 20px\r\n    //         h6\r\n    //             color: $primary-color\r\n    //             font-weight: 600\r\n    //             @include respond-to(screen-767)\r\n    //                 font-size: 16px\r\n    //         span\r\n    //             color: #ffffff\r\n    //             font-size: 14px\r\n    //             @include respond-to(screen-767)\r\n    //                 font-size: 12px\r\n    //         .client_img\r\n    //             width: 70px\r\n    //             margin: 0 auto\r\n    //             border: 2px solid $primary-color\r\n    //             border-radius: 100%\r\n    //             img\r\n    //                 border-radius: 100%\r\n    // .owl-dots\r\n        text-align: center\r\n        // margin-top: 50px\r\n        button\r\n            background: #f1f1f1 !important\r\n            width: 10px\r\n            height: 10px\r\n            border-radius: 26px\r\n            margin: 0 5px\r\n            transition: 0.3s\r\n            &.active\r\n                width: 30px\r\n                background: $primary-color !important\r\n\r\n.review-sec\r\n    position: relative\r\n    padding: 30px 0\r\n    .flex\r\n        justify-content: center\r\n        .col\r\n            flex: 0 1 31.33%\r\n            max-width: 31.33%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n    iframe\r\n        height: 50vh\r\n\r\n.case-study-sec\r\n    position: relative\r\n    padding: 50px 0\r\n    h2\r\n        margin-bottom: 20px\r\n    .swiper\r\n        top: 5vh\r\n        @include respond-to(991px)\r\n            top: 10vh\r\n        .swiper-wrapper\r\n            .swiper-slide\r\n                display: flex\r\n                align-items: center\r\n                justify-content: center\r\n                overflow: hidden\r\n                background: none\r\n                .card\r\n                    position: relative\r\n                    margin: auto\r\n                    height: 70vh\r\n                    width: 90vw\r\n                    max-width: 1000px\r\n                    border-radius: 50px\r\n                    overflow: hidden\r\n                    background: #2e0916\r\n                    background: linear-gradient(331deg, #767676 0%, #252525 100%)\r\n                    @include respond-to(screen-767)\r\n                        flex-direction: column\r\n                        // height: 100%\r\n                    .img-wrapper\r\n                        width: 100%\r\n                        height: 70%\r\n                        text-align: center\r\n                        position: absolute\r\n                        display: flex\r\n                        align-items: center\r\n                        justify-content: center\r\n                        @include respond-to(screen-767)\r\n                            position: relative\r\n                        img\r\n                            max-height: 80%\r\n                            width: auto\r\n                            position: relative\r\n                            animation: floatAnim 6s ease-in-out infinite\r\n                            border-radius: 20px\r\n                            border: 2px solid $primary-color\r\n                            @include respond-to(screen-991)\r\n                                max-height: 60%\r\n                            @include respond-to(screen-767)\r\n                                object-fit: cover    \r\n                &:nth-child(odd) \r\n                    .img-wrapper\r\n                        left: -22%\r\n                        @include respond-to(screen-991)\r\n                            left: 0\r\n                            right: 0\r\n                            height: auto\r\n                            width: 90%\r\n                            margin: 0 auto\r\n                            top: -10%\r\n                            img\r\n                                height: 350px\r\n                                width: 350px\r\n                        @include respond-to(screen-767)\r\n                            top: 5%      \r\n                            left: inherit      \r\n                            right: inherit  \r\n                            display: block    \r\n                &:nth-child(even) \r\n                    .img-wrapper\r\n                        right: -22%\r\n                        top: -0%\r\n                        @include respond-to(screen-991)\r\n                            left: 0\r\n                            right: 0\r\n                            height: auto\r\n                            width: 90%\r\n                            margin: 0 auto\r\n                            top: -10%\r\n                            top: -2% \r\n                            img\r\n                                height: 300px\r\n                                width: 300px                   \r\n                .card-content\r\n                    max-width: 445px\r\n                    width: 100%\r\n                    position: relative\r\n                    top: 50%\r\n                    transform: translateY(-50%)\r\n                    padding: 0 24px\r\n                    @include respond-to(screen-767)\r\n                        top: inherit\r\n                &:nth-child(odd) \r\n                    .card-content\r\n                        margin-left: auto\r\n                        @include respond-to(screen-991)\r\n                            max-width: 100%\r\n                            margin: 0\r\n                            transform: unset\r\n                            text-align: center\r\n\r\n                &:nth-child(even) \r\n                    .card-content\r\n                        margin-right: auto\r\n                        margin-left: 5%\r\n                        @include respond-to(screen-991)\r\n                            max-width: 100%\r\n                            margin: 0\r\n                            transform: unset\r\n                            text-align: center\r\n\r\n                .card-ghost-info\r\n                    position: absolute\r\n                    bottom: 8%\r\n                    line-height: 1\r\n                    color: #ffffff\r\n                    font-size: 1vw\r\n                    font-weight: 400\r\n                    @include respond-to(screen-991)\r\n                        bottom: unset\r\n                        top: 25%\r\n                        font-size: 8px\r\n                        \r\n                    .ghost-name\r\n                        font-size: 1.5vw\r\n                        text-transform: uppercase\r\n                        margin-bottom: 10px\r\n                        font-weight: bold\r\n                        @include respond-to(screen-991)\r\n                            font-size: 14px\r\n                    span\r\n                        height: 70px\r\n                        display: inline-block\r\n                        width: 0.5px\r\n                        background-color:#fff\r\n                        position: absolute\r\n                        bottom: 0px\r\n                        @include respond-to(screen-767)\r\n                            color: rgb(255, 91, 121)\r\n                            left: 50%\r\n                            height: 34px\r\n                            top: -42px\r\n                        &:before\r\n                            content: \"\"\r\n                            height: 5px\r\n                            width: 5px\r\n                            background-color:#fff\r\n                            position: absolute\r\n                            top: 0px\r\n                            left: 50%\r\n                            transform: translateX(-50%)\r\n                            border-radius: 50%\r\n                    .indus-name\r\n                        font-size: 12px\r\n                        text-align: center\r\n                &:nth-child(odd) \r\n                    .card-ghost-info\r\n                        left: 8%\r\n                        text-align: right\r\n                        @include respond-to(screen-991)\r\n                            left: 3%\r\n                        @include respond-to(screen-767)\r\n                            left: 50%\r\n                            transform: translateX(-50%)\r\n                            top: 49%    \r\n                        span\r\n                            right: -15px\r\n\r\n                &:nth-child(even) \r\n                    .card-ghost-info\r\n                        right: 8%\r\n                        text-align: left\r\n                        @include respond-to(screen-991)\r\n                            right: 3%\r\n                        span\r\n                            left: -15px\r\n\r\n                .card-title\r\n                    max-width: 320px\r\n                    color:#fff\r\n                    font-weight: bold\r\n                    font-size: 2vw\r\n                    line-height: 1.3\r\n                    margin: 14px 0 25px\r\n                    position: relative\r\n                    color: $white-color\r\n                    @include respond-to(screen-991)\r\n                        font-size: 24px\r\n                        margin-left: auto\r\n                        margin-right: auto\r\n                    @include respond-to(screen-991)\r\n                        font-size: 20px    \r\n                \r\n                .card-sub-title\r\n                    color: $primary-color\r\n                    text-transform: uppercase\r\n                    font-weight: bold\r\n                    font-size: 1.1vw\r\n                    @include respond-to(screen-991)\r\n                        font-size: 12px\r\n                .card-description\r\n                    color: $white-color\r\n                    font-weight: 500\r\n                    font-size: 14px \r\n                    max-width: 300px\r\n                    @include respond-to(screen-991)\r\n                        font-size: 10px\r\n                        margin-left: auto\r\n                        margin-right: auto\r\n                .card-cta\r\n                    margin-top: 30px\r\n                    @include respond-to(screen-991)\r\n                        margin-top: 10px\r\n                    .cta-button\r\n                        display: inline-block\r\n                        padding: 20px 40px\r\n                        background-color: $primary-color\r\n                        color: white\r\n                        font-family: Arial, sans-serif\r\n                        font-size: 18px\r\n                        white-space: nowrap\r\n                        text-decoration: none\r\n                        text-align: center\r\n                        display: flex\r\n                        align-items: center\r\n                        justify-content: center\r\n                        font-weight: bold\r\n                        width: 161px\r\n                        height: 81px\r\n                        clip-path: polygon(7.68786px 20.1081px, 7.68786px 20.1081px, 8.16364px 18.1351px, 8.88914px 16.2804px, 9.8446px 14.5617px, 11.0103px 12.9969px, 12.3663px 11.6038px, 13.8931px 10.4002px, 15.5708px 9.4038px, 17.3796px 8.63251px, 19.2998px 8.10411px, 21.3116px 7.83638px, 132.489px 0.710935px, 132.489px 0.710935px, 134.441px 0.714334px, 136.343px 0.968456px, 138.174px 1.46024px, 139.914px 2.17663px, 141.544px 3.10456px, 143.044px 4.23098px, 144.393px 5.54282px, 145.572px 7.02703px, 146.562px 8.67054px, 147.341px 10.4603px, 159.738px 44.9529px, 159.738px 44.9529px, 160.432px 47.6413px, 160.613px 50.3152px, 160.314px 52.9198px, 159.569px 55.4005px, 158.412px 57.7025px, 156.877px 59.7713px, 154.996px 61.5521px, 152.804px 62.9903px, 150.334px 64.0311px, 147.621px 64.62px, 16.6807px 80.5984px, 16.6807px 80.5984px, 13.7927px 80.6726px, 11.051px 80.2112px, 8.50526px 79.2659px, 6.20477px 77.8885px, 4.19901px 76.131px, 2.53742px 74.045px, 1.26946px 71.6825px, 0.444554px 69.0952px, 0.11216px 66.335px, 0.321718px 63.4536px, 7.68786px 20.1081px)\r\n                        transition: all 0.3s ease\r\n                        @include respond-to(screen-991)\r\n                            scale: 0.7\r\n                            margin-left: auto\r\n                            margin-right: auto\r\n                        &:hover\r\n                            background-color: #fff\r\n                            color: $primary-color \r\n@keyframes fadeInUp \r\n    from \r\n        opacity: 0\r\n        transform: translateY(30px)\r\n    to \r\n        opacity: 1\r\n        transform: translateY(0) \r\n.swiper-pagination\r\n    text-align: center\r\n    padding-left: 0\r\n    bottom: 20px !important\r\n    .swiper-pagination-bullet\r\n        display: inline-block\r\n        margin: 2px\r\n        height: 6px\r\n        width: 12px\r\n        background: rgba(254, 121, 194, 0.8)\r\n        color: transparent\r\n        border-radius: 10px\r\n        overflow: hidden\r\n        transition: 0.5s ease\r\n        border: 0\r\n        &.swiper-pagination-bullet-active\r\n            background: $primary-color\r\n            width: 25px\r\n.swing\r\n  animation: swing 6s ease-in-out infinite\r\n  transform-origin: left\r\n\r\n.swiper-slide-active\r\n    .card-cta\r\n        animation: bounce\r\n        animation-duration: 2.5s\r\n        animation-delay: 0.5s\r\n\r\n    .card-ghost-info \r\n        div\r\n            animation: fadeInLeft\r\n            animation-duration: 1.5s\r\n            animation-delay: 0.3s\r\n\r\n    .card-title\r\n        animation: jackInTheBox\r\n        animation-duration: 1s\r\n        animation-delay: 0.8s\r\n\r\n    .card-sub-title\r\n        animation: bounceIn\r\n        animation-duration: 1s\r\n        animation-delay: 0.5s\r\n\r\n    .card-description\r\n        animation: bounceIn\r\n        animation-duration: 1s\r\n        animation-delay: 0.1s\r\n@keyframes floatAnim\r\n    0%\r\n        transform: translateY(-10px)\r\n\r\n    50%\r\n        transform: translateY(10px)\r\n\r\n    100%\r\n        transform: translateY(-10px)\r\n\r\n@keyframes swing\r\n    0%\r\n        transform: translateY(-25px) rotate(10deg) scale(1)\r\n\r\n    50%\r\n        transform: translateY(25px) rotate(-5deg) scale(1.1)\r\n\r\n    100%\r\n        transform: translateY(-25px) rotate(10deg) scale(1)\r\n//add partners\r\n\r\n.home-sec-G\r\n    padding: 50px 0\r\n    background: #e7e7e7\r\n    .flex\r\n        align-items: center\r\n        justify-content: center\r\n        @include respond-to(screen-767)\r\n            justify-content: center\r\n        .col\r\n            flex: 0 1 20%\r\n            max-width: 20%\r\n            margin-bottom: 50px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 50%\r\n                max-width: 50%\r\n                margin-bottom: 20px\r\n            &.hp\r\n                .logo\r\n                    width: 100px\r\n    .partners\r\n        .logo\r\n            width: 200px \r\n            margin: 0 auto  \r\n            @include respond-to(screen-767)\r\n                width: 150px     \r\n\r\n\r\n//pop-up\r\n\r\n.casestudy_popup,\r\n.Version_popup\r\n    position: fixed\r\n    right: 0\r\n    top: 100%\r\n    left: 50%\r\n    transform: translate(-50%, 100%)\r\n    max-width: 70%\r\n    width: 100%\r\n    height: 65%\r\n    padding: 50px\r\n    transition: all 1s ease\r\n    background: #222222\r\n    z-index: 111\r\n    pointer-events: none\r\n    border-radius: 20px  \r\n    border: 2px solid $white-color\r\n    @include respond-to(screen-767)\r\n        max-width: 95%\r\n        padding: 9rem 15px\r\n    &.pop_open\r\n        transform: translate(-50%, -50%)\r\n        top: 50%\r\n        pointer-events: all\r\n    .close_model\r\n        position: absolute\r\n        right: 32px\r\n        top: 32px\r\n        width: 32px\r\n        height: 32px\r\n        opacity: 1\r\n        cursor: pointer\r\n        z-index: 1 \r\n        &::before\r\n            position: absolute\r\n            left: 15px\r\n            content: \" \"\r\n            height: 25px\r\n            width: 2px\r\n            cursor: pointer\r\n            background-color: #fff\r\n            transform: rotate(45deg)\r\n        &::after\r\n            position: absolute\r\n            right: 15px\r\n            content: \" \"\r\n            height: 25px\r\n            width: 2px\r\n            cursor: pointer\r\n            background-color: #fff\r\n            transform: rotate(-45deg)\r\n    .case_detail\r\n        margin: 0 20px\r\n        &.version-sumry\r\n            height: 300px\r\n            overflow-y: scroll\r\n            margin-bottom: 20px\r\n            p\r\n                font-size: 14px\r\n                line-height: 1.5\r\n                color: #c9c9c9\r\n        .caseimg\r\n            text-align: center\r\n        .name\r\n            font-size: 22px\r\n            margin-bottom: 10px\r\n            color: $white-color \r\n            @include respond-to(screen-767)\r\n                line-height: 1.3\r\n        .summary\r\n            ul\r\n                li\r\n                    font-size: 12px\r\n                    line-height: 1.5\r\n                    margin-bottom: 10px\r\n                    b\r\n                        font-size: 14px           \r\n            h4\r\n                color: $primary-color\r\n                margin-bottom: 10px   \r\n                font-size: 18px\r\n                \r\n.announce\r\n    background: #e8e8e8\r\n    padding: 50px 20px\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n    .heading\r\n        h2\r\n            color: $primary-color\r\n            margin-bottom: 10px            \r\n    .bullet_points\r\n        li\r\n            color: $secondary-color\r\n            &::before\r\n                background: $primary-color\r\n    .img\r\n        img\r\n            height: 400px          \r\n    .readmore\r\n        display: inline-block\r\n        margin-top: 20px\r\n        width: 100%\r\n        a\r\n            padding: 5px 18px\r\n            border-radius: 20px\r\n            background: $primary-color\r\n            color: #fff\r\n            display: inline-block\r\n            margin: 0 auto\r\n\r\n// add css\r\n\r\n.modal-overlay\r\n    position: fixed\r\n    top: 0\r\n    left: 0\r\n    width: 100%\r\n    height: 100%\r\n    background: rgba(0, 0, 0, 0.751)\r\n    display: flex\r\n    align-items: center\r\n    justify-content: center\r\n    z-index: 999\r\n    .close_model\r\n        position: absolute\r\n        top: 8px\r\n        right: 12px\r\n        font-size: 18px\r\n        background: none\r\n        border: none\r\n        cursor: pointer\r\n    .modal-content\r\n        background: #222222\r\n        padding: 30px\r\n        border-radius: 10px\r\n        position: relative\r\n        width: 400px\r\n        max-width: 90%\r\n        border: 2px solid #fff\r\n        h3\r\n            margin-bottom: 25px\r\n            color: $white-color\r\n            text-align: center\r\n        .back-input\r\n            position: relative\r\n            margin-bottom: 25px\r\n            .frm-cntrl\r\n                background: none\r\n                border: none\r\n                width: 100%\r\n                display: block\r\n                user-select: none\r\n                padding: 10px 25px\r\n                color: $white-color\r\n                border-radius: 10px\r\n                border: 2px solid $text-color\r\n                transition: all 1s ease\r\n                &:focus ~ label\r\n                        top: -12px\r\n                        background: #222222\r\n                        padding: 0 10px\r\n                &:valid ~ label\r\n                        top: -12px\r\n                        background: #222222\r\n                        padding: 0 10px\r\n                        font-size: 12px\r\n            label\r\n                position: absolute\r\n                color: #fff\r\n                left: 10px\r\n                top: 10px  \r\n                transition: 750ms ease \r\n            .error\r\n                color: red\r\n                display: block\r\n                margin-top: 5px\r\n                font-size: 12px \r\n                line-height: 1  \r\n   \r\n        .demo-link\r\n            background: $white-color\r\n            text-align: center\r\n            padding: 8px 15px\r\n            border-radius: 10px\r\n            border: 0\r\n            width: 100%\r\n            &:hover\r\n                background: $primary-color\r\n                a\r\n                    color: $white-color\r\n            a\r\n                color: $secondary-color\r\n",".newhome-sec\r\n    // background: #ffe5ee\r\n    padding: 1rem 0\r\n    @include respond-to(screen-767)\r\n        padding: 3rem 0\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            padding-right: 40px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                padding: 0\r\n            &:last-child\r\n                padding-left: 40px\r\n                @include respond-to(screen-767)\r\n                    padding: 0\r\n            &:first-child\r\n                text-align: center\r\n    h2\r\n        font-size: 36px\r\n        margin-bottom: 20px\r\n        @include respond-to(screen-767)\r\n            font-size: 28px\r\n    p\r\n        font-size: 18px\r\n        @include respond-to(screen-767)\r\n            font-size: 16px\r\n    .highlight\r\n        font-size: 24px\r\n        margin-top: 20px\r\n        display: inline-block\r\n        color: $primary-color\r\n        text-decoration: underline\r\n    .banner-image\r\n        @include respond-to(screen-767)\r\n            width: 300px\r\n            margin: auto\r\n            display: block\r\n            margin-bottom: 20px\r\n    .watch-demo\r\n        display: inline-block\r\n        width: 100%\r\n        text-align: center\r\n        a\r\n            background: $primary-color\r\n            color: #fff\r\n            padding: 7px 45px\r\n            border-radius: 20px\r\n            margin-top: 40px\r\n            display: inline-block\r\n    img\r\n        width: 400px\r\n\r\n.features\r\n    padding: 5rem 0\r\n    position: relative\r\n    background: #e7e7e7\r\n    display: none\r\n    .heading\r\n        margin-bottom: 2rem\r\n    .flex\r\n        align-items: center\r\n        margin: 0 5rem\r\n\r\n    .feature-list\r\n        margin-bottom: 2rem\r\n        &:nth-child(3)\r\n            .flex\r\n                @include respond-to(screen-767)\r\n                    flex-direction: column-reverse\r\n        .flex\r\n            .col\r\n                @include respond-to(screen-767)\r\n                    flex: 0 1 100%\r\n                    max-width: 100%\r\n                    text-align: center\r\n        .feature-heading\r\n            display: flex\r\n            align-items: center\r\n            margin-bottom: 10px\r\n            .icon\r\n                background: rgb(245, 190, 209)\r\n                height: 70px\r\n                display: inline-block\r\n                width: 70px\r\n                display: flex\r\n                align-items: center\r\n                justify-content: center\r\n                border-radius: 100%\r\n                margin-right: 10px\r\n                @include respond-to(screen-767)\r\n                    display: none\r\n                img\r\n                    width: 40px\r\n            h4\r\n                @include respond-to(screen-767)\r\n                    font-size: 22px\r\n                    text-align: left\r\n        img\r\n            width: 300px\r\n            @include respond-to(screen-767)\r\n                width: 250px !important\r\n        ul\r\n            padding-left: 50px\r\n            @include respond-to(screen-767)\r\n                text-align: left\r\n                padding-left: 10px\r\n                margin-bottom: 20px\r\n\r\n.licence-detial\r\n    padding: 3rem 0\r\n    background: #ffffff\r\n    // background: #ffe5ee\r\n    .flex\r\n        .col\r\n            flex: 0 1 25%\r\n            max-width: 25%\r\n            // flex: 0 1 33.33%\r\n            // max-width: 33.33%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 10px\r\n    .heading\r\n        margin-bottom: 3rem\r\n    .item\r\n        background: #222222\r\n        padding: 20px\r\n        border-radius: 20px\r\n        height: 325px\r\n        margin: 0 10px\r\n        box-shadow: 0px 3px 10px 0px rgba(24, 59, 86, .08)\r\n        @include respond-to(screen-767)\r\n            height: inherit\r\n        h4\r\n            margin-bottom: 20px\r\n            font-weight: 600\r\n            text-align: center\r\n            color: $white-color\r\n        p\r\n            text-align: center\r\n            color: $white-color\r\n\r\n.pricing\r\n    background: #e7e7e7\r\n    padding: 3rem 0\r\n    padding-bottom: 5rem\r\n    .heading\r\n        margin-bottom: 5rem\r\n    .flex\r\n        .col\r\n            flex: 0 1 29%\r\n            margin: 0 20px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n    .item\r\n        background: #fff\r\n        border-radius: 20px\r\n        height: 550px\r\n        position: relative\r\n        box-shadow: 0px 3px 10px 0px rgba(24, 59, 86, .08)\r\n        @include respond-to(screen-767)\r\n            height: inherit\r\n            border-radius: 10px\r\n        .price\r\n            padding: 20px          \r\n            border-radius: 20px 20px 0 0\r\n            padding-bottom: 0\r\n            margin-bottom: 1.2rem\r\n            .type-btn\r\n                display: inline-block\r\n                padding: 2px 0px\r\n                border-radius: 10px\r\n                font-weight: 600\r\n                margin-bottom: 15px\r\n                font-size: 28px\r\n                text-align: center\r\n                width: 100%\r\n                @include respond-to(screen-767)\r\n                    font-size: 22px\r\n            .rupees\r\n                font-size: 24px\r\n                font-weight: 600\r\n                margin-bottom: 10px\r\n                color: $text-color\r\n                display: none\r\n                .symbol\r\n                    margin-right: 5px\r\n                    color: $white-color\r\n                .rate\r\n                    margin-right: 5px\r\n                    color: $text-color\r\n                .year\r\n                    font-size: 18px\r\n                    font-weight: 500\r\n                    color: $text-color\r\n            .user\r\n                font-weight: 600\r\n                margin-bottom: 5px\r\n                color: $text-color\r\n                display: none\r\n            p\r\n                padding-right: 20px\r\n                color: $white-color\r\n        .buy-now\r\n            display: inline-block\r\n            text-align: center\r\n            width: 100%\r\n            margin-bottom: 1.2rem\r\n            position: absolute\r\n            bottom: 0\r\n            @include respond-to(screen-767)\r\n                position: relative\r\n            a\r\n                background: $primary-color\r\n                padding: 8px 25px\r\n                color: #ffffff\r\n                border-radius: 10px\r\n        ul\r\n            padding: 20px\r\n            padding-top: 0\r\n            li\r\n                color: #000000\r\n                &::before\r\n                    background: $primary-color\r\n            .readmore\r\n                a\r\n                    display: block\r\n                    color: $primary-color\r\n                    font-size: 20px\r\n                    margin-top: 20px\r\n                    font-weight: 600\r\n\r\n.ai-powered\r\n    position: relative\r\n    background: url('../images/pricing/content-creation.jpg')no-repeat center center/cover\r\n    padding: 6rem 0\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        background: #000000\r\n        width: 100%\r\n        height: 100%\r\n        top: 0\r\n        opacity: .7\r\n    .content\r\n        display: flex\r\n        align-items: flex-end\r\n        flex-direction: column\r\n        ul\r\n            li\r\n                &:first-child\r\n                    font-size: 36px\r\n                    padding-left: 0\r\n                    margin-bottom: 30px\r\n                    @include respond-to(screen-767)\r\n                        line-height: 1.2\r\n                        font-size: 28px\r\n                    &::before\r\n                        content: none\r\n            .learn-more\r\n                position: relative\r\n                a\r\n                    margin-top: 20px\r\n                    background: $white-color\r\n                    display: inline-block\r\n                    border-radius: 10px\r\n                    font-size: 16px\r\n                    font-weight: 600\r\n\r\n.Pricing-form\r\n    background: #fff\r\n    width: 50%\r\n    top: 100%\r\n    left: 50%\r\n    height: 750px\r\n    transform: translate(-50%, 100%)\r\n    transition: 450ms ease\r\n    @include respond-to(screen-767)\r\n        width: 100%\r\n    &.is-open\r\n        transform: translate(-50%, -50%)\r\n        top: 50%\r\n    .flex\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            @include respond-to(screen-767)\r\n                max-width: 100%\r\n                flex: 0 1 100%\r\n            &:first-child\r\n                @include respond-to(screen-767)\r\n                    display: none\r\n    .banner\r\n        line-height: 0\r\n        img\r\n            height: 750px\r\n            object-fit: cover\r\n    .modelBody\r\n        padding: 20px\r\n        .contact-form\r\n            .title\r\n                h3\r\n                    font-size: 24px\r\n                    font-weight: 600\r\n            .back-input\r\n                position: relative\r\n                margin-top: 25px\r\n                .frm-cntrl\r\n                    background: none\r\n                    border: none\r\n                    width: 100%\r\n                    display: block\r\n                    user-select: none\r\n                    padding: 10px 25px\r\n                    color: $text-color\r\n                    border-radius: 10px\r\n                    border: 2px solid $text-color\r\n                    &:focus~label\r\n                        top: -12px\r\n                        background: #ffffff\r\n                        padding: 0 10px\r\n                    &:valid~label\r\n                        top: -12px\r\n                        background: #ffffff\r\n                        padding: 0 10px\r\n                    // &.valid\r\n                    //     top: -12px\r\n                    //     background: #ffffff\r\n                    //     padding: 0 10px\r\n                .error\r\n                    color: red\r\n\r\n                label\r\n                    position: absolute\r\n                    color: $text-color\r\n                    left: 10px\r\n                    top: 10px\r\n                    transition: 750ms ease\r\n            .demo-link\r\n                background: $white-color\r\n                text-align: center\r\n                padding: 8px 15px\r\n                border-radius: 10px\r\n                border: 0\r\n                width: 100%\r\n                margin-top: 20px\r\n                background: $primary-color\r\n                a\r\n                    color: #fff\r\n#form-message\r\n    color: green\r\n    margin: 10px 0\r\n    font-weight: 600\r\n\r\n.Tablemodel\r\n    background: #fff\r\n    width: 70%\r\n    top: 100%\r\n    left: 50%\r\n    height: 750px\r\n    border-radius: 20px\r\n    transform: translate(-50%, 100%)\r\n    transition: 450ms ease\r\n    &.is-open\r\n        transform: translate(-50%, -50%)\r\n        top: 50%\r\n    .modelBody\r\n        padding: 10px\r\n        .tableheading\r\n            margin-bottom: 20px\r\n        .table-container\r\n            max-height: 600px\r\n            overflow-y: auto\r\n        table,tr,th,td\r\n            border: 1px solid #000\r\n        table\r\n            width: 100%\r\n            border-collapse: collapse\r\n            // tbody,thead\r\n            //     display: block\r\n            th\r\n                background: $primary-color\r\n                color: $white-color\r\n                text-align: center\r\n            th,td\r\n                padding: 10px\r\n            tbody\r\n                max-height: 600px\r\n                overflow-y: auto\r\n                width: 100%\r\n\r\n.video-sec\r\n    position: relative\r\n    padding: 50px 0\r\n    .flex\r\n        align-items: center\r\n        .video-item\r\n            flex: 0 1 100%\r\n            max-width: 100%\r\n            display: flex\r\n            align-items: center\r\n            background: #e7e7e7\r\n            border-radius: 25px\r\n            padding: 25px\r\n            margin-bottom: 20px\r\n    .video-heading\r\n        flex: 0 1 50%\r\n        max-width: 50%\r\n        padding-right: 30px\r\n        h2\r\n            font-size: 24px\r\n            color: $primary-color\r\n            font-weight: 600\r\n        h4\r\n            font-size: 18px\r\n        ul\r\n            li\r\n                color: $text-color\r\n                font-size: 14px\r\n                line-height: 1.4\r\n                &::before\r\n                    background: $primary-color   \r\n    .video-name\r\n        flex: 0 1 50%\r\n        max-width: 50%\r\n        h2\r\n            color: $primary-color\r\n            font-size: 24px\r\n            font-weight: 600\r\n        p\r\n            font-size: 14px\r\n            text-align: center                           \r\n    video\r\n        width: 100%\r\n        padding: 20px\r\n\r\n\r\n// ai-powered\r\n\r\n.cards\r\n    padding: 7rem 0\r\n    background: #e7e7e7\r\n    @include respond-to(screen-767)\r\n        padding: 7rem 1rem\r\n    .card\r\n        width: 50%\r\n        cursor: pointer\r\n        margin: 0 auto\r\n        @include respond-to(screen-767)\r\n            width: 100%\r\n        ul\r\n            margin: 0\r\n            padding: 0\r\n            list-style: none\r\n            height: 100%\r\n            display: flex\r\n            flex-direction: column\r\n            justify-content: center\r\n            gap: 0.5rem\r\n\r\n        &__outer\r\n            background: $primary-color\r\n            position: relative\r\n            height: 30rem\r\n            border-radius: 0.625rem\r\n            display: flex\r\n            align-items: flex-end\r\n            padding: 1.25rem\r\n            transition: 0.3s ease-in-out\r\n            a\r\n                display: flex\r\n                align-items: center\r\n                text-decoration: none\r\n                // font-weight: bold\r\n                color: $white-color\r\n                // background: $white-color\r\n                // padding: 10px 20px\r\n                font-size: 20px\r\n                // margin-top: 20px\r\n                svg\r\n                    margin-left: 0.375em\r\n                    width: 1.625rem\r\n\r\n        &__inner\r\n            background: #fff\r\n            position: absolute\r\n            bottom: 3.75rem\r\n            right: 1.25rem\r\n            width: 100%\r\n            height: 90%\r\n            border-radius: 0.625rem\r\n            padding: 1.875rem 2.188rem\r\n            display: flex\r\n            flex-direction: column\r\n            @include respond-to(screen-767)\r\n                height: 100%\r\n            .title\r\n                font-size: 24px\r\n                display: inline-block\r\n                position: relative\r\n                margin-top: 0.313em\r\n                margin-bottom: 0.938em\r\n                @include respond-to(screen-767)\r\n                    line-height: 1.3\r\n                &:after\r\n                    position: absolute\r\n                    content: \"\"\r\n                    left: 0\r\n                    bottom: -1.563rem\r\n                    display: block\r\n                    color: red\r\n                    background: $primary-color\r\n                    height: 0.325rem\r\n                    width: 100%\r\n                \r\n\r\n        &.active\r\n            .card__outer\r\n                a\r\n                    color: #fff\r\n    \r\n   ","$anim: cubic-bezier(0.02, 0.63, 0.23, 0.99)\r\n#roto\r\n    position: relative\r\n    overflow: hidden\r\n    &::before\r\n        content: \"\"\r\n        position: absolute\r\n        width: 100%\r\n        height: 0\r\n        bottom: 0\r\n        left: 0\r\n        pointer-events: none\r\n        background: linear-gradient(0deg,#fff, transparent)\r\n        opacity: 0\r\n        z-index: 4\r\n        transition: .2s all ease\r\n        &.active::before\r\n            opacity: 1\r\n            height: 50%\r\n\r\n.slide\r\n    width: 100%\r\n    min-height: calc( 100vh - 100px )\r\n    position: relative\r\n    overflow: hidden\r\n    background-color: #000\r\n    .mainImage\r\n        position: absolute\r\n        width: 130vw\r\n        height: 130vw\r\n        object-fit: cover\r\n        object-position: center\r\n        left: 50%\r\n        top: 50%\r\n        transform: translate(-50%, -50%)\r\n        animation-name: rotate\r\n        animation-timing-function: $anim\r\n        animation-iteration-count: 1\r\n        animation-duration: 1.1s\r\n        @include respond-to(screen-675)\r\n            width: 130vh\r\n            height: 130vh\r\n\r\n    .roundOuter\r\n        position: absolute\r\n        width: 86vw\r\n        height: 86vw\r\n        overflow: hidden\r\n        border-radius: 50%\r\n        left: calc(50% - 43vw)\r\n        top: calc(50% - 43vw)\r\n        filter: brightness(0.9)\r\n        z-index: 1\r\n        border: 1px solid rgba(255,255,255,0.2)\r\n        @include respond-to(screen-675)\r\n            width: 86vh\r\n            height: 86vh\r\n            left: calc(50% - 43vh)\r\n            top: calc(50% - 43vh)\r\n\r\n        img\r\n            position: absolute\r\n            width: 130vw\r\n            height: 130vw\r\n            left: 50%\r\n            top: 50%\r\n            transform: translate(-50%, -50%)\r\n            object-fit: cover\r\n            object-position: center\r\n            animation-name: rotate\r\n            animation-timing-function: $anim\r\n            animation-iteration-count: 1\r\n            animation-duration: 1.3s\r\n            @include respond-to(screen-675)\r\n                width: 130vh\r\n                height: 130vh\r\n    .roundInner\r\n        position: absolute\r\n        width: 50vw\r\n        height: 50vw\r\n        overflow: hidden\r\n        left: calc(50% - 25vw)\r\n        top: calc(50% - 25vw)\r\n        border-radius: 50%\r\n        border: 1px solid rgba(255,255,255,0.2)\r\n        z-index: 2\r\n        @include respond-to(screen-675)\r\n            width: 50vh\r\n            height: 50vh\r\n            left: calc(50% - 25vh)\r\n            top: calc(50% - 25vh)\r\n        img\r\n            position: absolute\r\n            width: 130vw\r\n            height: 130vw\r\n            left: 50%\r\n            top: 50%\r\n            transform: translate(-50%, -50%)\r\n            object-fit: cover\r\n            object-position: center\r\n            animation-name: rotate\r\n            animation-timing-function: $anim\r\n            animation-iteration-count: 1\r\n            animation-duration: 1.2s\r\n            @include respond-to(screen-675)\r\n                width: 130vh\r\n                height: 130vh\r\n    .slideText\r\n        position: absolute\r\n        z-index: 3\r\n        width: 100%\r\n        height: 100%\r\n        display: grid\r\n        place-content: center\r\n        text-align: center\r\n        background-color: rgba(0,0,0,0.3)\r\n        &::after\r\n            content: \"\"\r\n            position: absolute\r\n            width: 40vw\r\n            height: 1px\r\n            background-color: #fff\r\n            bottom: 0\r\n            left: 50%\r\n            transform: translateX(-50%)\r\n    p\r\n        text-align: center\r\n        font-weight: 400\r\n        margin-bottom: 30px\r\n        font-size: 2.5rem\r\n        padding-left: 1.3rem\r\n        color: $white-color\r\n        line-height: normal\r\n        animation-delay: 1.5s\r\n        filter: drop-shadow(0 2px 10px #000)\r\n        @include respond-to(screen-675)\r\n            font-size: 5vw\r\n            line-height: 1.5\r\n            padding-left: 2vw\r\n\r\n    .buttonNav\r\n        display: flex\r\n        justify-content: center\r\n        gap: 12px\r\n        animation-delay: 1.7s\r\n        button\r\n            border: none\r\n            background: transparent\r\n            color: $primary-color\r\n            font-size: 2rem\r\n            filter: drop-shadow(0 2px 10px #000)\r\n\r\n        span\r\n            display: grid\r\n            width: 1px\r\n            flex: 0 0 1px\r\n            background-color: #fff\r\n            filter: drop-shadow(0 2px 10px #000)\r\n\r\n@keyframes rotate\r\n    0%\r\n        transform: translate(-50%, -50%) rotate(0deg) scale(5)\r\n\r\n    100%\r\n        transform: translate(-50%, -50%) rotate(360deg) scale(1)\r\n\r\n// ------------------------- section-2-------------------------       \r\n.prodouct-demo-video\r\n    width: 100%\r\n    height: calc( 100vh - 100px )\r\n    background: #222222\r\n    @include respond-to(screen-767)\r\n        height: 100%\r\n        padding: 50px 0\r\n    video\r\n        width: 100%\r\n        height: 100%\r\n\r\n// ------------------------- section-3-------------------------\r\n.product-sec-C\r\n    padding: 50px 0\r\n    position: relative\r\n    .heading\r\n        margin-bottom: 100px\r\n    .flex\r\n        @include respond-to(screen-1024)\r\n            justify-content: center\r\n        .col\r\n            flex: 0 1 18%\r\n            max-width: 18%\r\n            background: linear-gradient(to right, #f1f1f1, #a1a1a1)\r\n            padding: 10px\r\n            height: 200px\r\n            margin: 0 10px\r\n            position: relative\r\n            border: 2px solid $primary-color\r\n            border-radius: 20px 20px 100% 100%\r\n            @include respond-to(screen-1024)\r\n                flex: 0 1 30%\r\n                max-width: 30%\r\n                margin-bottom: 100px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin: 0 35px\r\n                margin-bottom: 75px\r\n                &:last-child\r\n                    margin-bottom: 0\r\n\r\n    .content\r\n        p\r\n            margin-top: 40px\r\n            font-size: 14px\r\n            text-align: center\r\n    .icon\r\n        position: absolute\r\n        top: -25%\r\n        left: 50%\r\n        transform: translate(-50%, 0%)\r\n        height: 50px\r\n        width: 100px\r\n        border-radius: 150px 150px 0 0\r\n        background: linear-gradient(to bottom, #da3467, #0a0a0acc)\r\n        span\r\n            color: $white-color\r\n            width: 70px\r\n            height: 70px\r\n            border-radius: 100%\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            background: $primary-color\r\n            margin: 0 auto\r\n            position: relative\r\n            top: 15px\r\n            @include respond-to(screen-767)\r\n                top: 15px\r\n\r\n// ------------------------- section-4-------------------------\r\n.product-sec-D\r\n    background: #222222\r\n    position: relative\r\n    padding: 50px 0\r\n    .heading\r\n        h2\r\n            color: $white-color\r\n    .flex\r\n        .col1\r\n            flex: 0 1 31%\r\n            max-width: 31%\r\n            margin: 0 10px\r\n            margin-bottom: 60px\r\n            @include respond-to(screen-991)\r\n                flex: 0 1 47%\r\n                max-width: 47%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                // margin: 0 10rem\r\n                margin-bottom: 60px\r\n\r\n    .item\r\n        background: #eeecec\r\n        border-radius: 5px\r\n        height: 150px\r\n        position: relative\r\n        padding: 30px 35px 75px\r\n        -webkit-transition: all 0.3s linear 0s\r\n        -moz-transition: all 0.3s linear 0s\r\n        -ms-transition: all 0.3s linear 0s\r\n        -o-transition: all 0.3s linear 0s\r\n        transition: all 0.3s linear 0s\r\n        z-index: 2\r\n        cursor: pointer\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            left: 0\r\n            bottom: 0\r\n            right: 0\r\n            width: 100%\r\n            height: 5px\r\n            background-color: $primary-color\r\n            border-radius: 0 0 5px 5px\r\n            -webkit-transition: all 0.4s linear 0s\r\n            -moz-transition: all 0.4s linear 0s\r\n            -ms-transition: all 0.4s linear 0s\r\n            -o-transition: all 0.4s linear 0s\r\n            transition: all 0.4s linear 0s\r\n            z-index: -1\r\n        &:hover\r\n            &::before\r\n                height: 100%\r\n                opacity: 0.8\r\n                border-radius: 5px\r\n            .img\r\n                opacity: 1\r\n                visibility: visible\r\n                height: 100%\r\n                transform: scale(1)\r\n            p\r\n                color: $white-color\r\n                font-weight: 500\r\n            .icon\r\n                background: $primary-color\r\n                border: 3px solid #ffffff\r\n                img\r\n                    display: none\r\n                    &.white\r\n                        display: block\r\n\r\n        .img\r\n            position: absolute\r\n            left: 0\r\n            bottom: 0\r\n            width: 100%\r\n            height: 100%\r\n            border-radius: 5px\r\n            z-index: -2\r\n            visibility: hidden\r\n            opacity: 0\r\n            object-fit: cover\r\n            transform: scale(0.8)\r\n            -webkit-transition: all 0.4s linear 0s\r\n            -moz-transition: all 0.4s linear 0s\r\n            -ms-transition: all 0.4s linear 0s\r\n            -o-transition: all 0.4s linear 0s\r\n            transition: all 0.4s linear 0s\r\n        p\r\n            text-align: center\r\n        .icon\r\n            position: absolute\r\n            width: 70px\r\n            height: 70px\r\n            background: #eeecec\r\n            border-radius: 100%\r\n            left: 50%\r\n            bottom: -30px\r\n            transform: translate(-50%, 0%)\r\n            border: 3px solid #222222\r\n            transition: all 0.4s linear 0s\r\n            z-index: 5\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            .white\r\n                display: none\r\n\r\n//---------------------- video-sec-----------------\r\n// .csm-video\r\n//     width: 100%\r\n//     height: 400px\r\n//     video\r\n//         width: 100%\r\n//         height: 100%    \r\n\r\n//--------------------------- section-6-------------------------\r\n.pathbreak-sec-B\r\n    &.product-sec-6\r\n        background: $white-color\r\n        h4\r\n            color: #666666\r\n        ul\r\n            li\r\n                color: #666666\r\n\r\n//--------------------------- section-7-------------------------\r\n.product-sec-7\r\n    position: relative\r\n    padding: 50px 0\r\n    height: calc( 100vh - 100px )\r\n    background: #222222\r\n    @include respond-to(screen-1440)\r\n        height: 100vh\r\n    @include respond-to(screen-1024)\r\n        height: 63vh\r\n    @include respond-to(screen-991)\r\n        height: none\r\n    @include respond-to(screen-767)\r\n        height: 100%\r\n    .container\r\n        position: relative\r\n        width: 320px\r\n        margin: 100px auto 0 auto\r\n        perspective: 1000px\r\n        @include respond-to(screen-1024)\r\n            perspective: none\r\n        @include respond-to(screen-767)\r\n            width: inherit\r\n            margin: 0\r\n        .product-data\r\n            position: absolute\r\n            width: 100%\r\n            height: 100%\r\n            transform-style: preserve-3d\r\n            animation: rotate360 90s infinite forwards linear\r\n            @include respond-to(screen-767)\r\n                animation: none\r\n                transform-style: inherit\r\n                position: static\r\n            &:hover\r\n                animation-play-state: paused\r\n            .image\r\n                position: absolute\r\n                height: 200px\r\n                top: 20px\r\n                left: 10px\r\n                right: 10px\r\n                background-size: cover\r\n                box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.5)\r\n                display: flex\r\n                @include respond-to(screen-767)\r\n                    position: static\r\n                    border-radius: 20px\r\n                    border: 2px solid $primary-color\r\n                    margin-bottom: 20px\r\n                span\r\n                    margin: auto\r\n                    font-size: 16px\r\n                    color: #fff\r\n                    padding: 0 20px\r\n                    line-height: 1.3\r\n                &:nth-child(1)\r\n                    background-image: url('../images/product/slider/watch-live-video.jpg')\r\n                    transform: rotateY(0deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(2)\r\n                    background-image: url('../images/product/slider/video-over-document.jpg')\r\n                    transform: rotateY(40deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(3)\r\n                    background-image: url('../images/product/slider/knowledge-retention.jpg')\r\n                    transform: rotateY(80deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(4)\r\n                    background-image: url('../images/product/slider/explainer-video-content.jpg')\r\n                    transform: rotateY(120deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(5)\r\n                    background-image: url('../images/product/slider/attention-to-short-form-videos.jpg')\r\n                    transform: rotateY(160deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(6)\r\n                    background-image: url('../images/product/slider/clicks-and-engagement.jpg')\r\n                    transform: rotateY(200deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(7)\r\n                    background-image: url('../images/product/slider/no-time-for-learning.jpg')\r\n                    transform: rotateY(240deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(8)\r\n                    background-image: url('../images/product/slider/human-attention-span.jpg')\r\n                    transform: rotateY(280deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n                &:nth-child(9)\r\n                    background-image: url('../images/product/slider/microlearning.jpg')\r\n                    transform: rotateY(320deg) translateZ(450px)\r\n                    @include respond-to(screen-767)\r\n                        transform: none\r\n\r\n@keyframes rotate360\r\n    from\r\n        transform: rotateY(360deg)\r\n\r\n    to\r\n        transform: rotateY(-360deg)\r\n\r\n\r\n.product-head\r\n    background-color: #2b2b2b\r\n    border-top: 5px solid $white-color\r\n    margin: 0\r\n    position: relative\r\n    span\r\n        background: #da3467\r\n        position: absolute\r\n        border-radius: 0 0 10px 10px\r\n        top: 0\r\n        right: 2rem\r\n        padding: 10px 20px\r\n        margin-bottom: 20px\r\n        display: block\r\n        color: $white-color\r\n        font-weight: 500\r\n        animation: animate 2s infinite alternate\r\n    h2\r\n        color: $white-color\r\n        margin-top: 2rem\r\n        \r\n.new-product-sec\r\n    justify-content: space-between\r\n    height: 80vh\r\n    overflow: hidden\r\n    background-color: #2b2b2b\r\n    h2\r\n        color: $white-color\r\n        font-size: 30px\r\n    .col1\r\n        width: 40%\r\n        position: relative\r\n        background-color: #2b2b2b\r\n        display: flex\r\n        align-items: center\r\n    .col2\r\n        width: 60%\r\n        position: relative\r\n    .content\r\n        padding: 0 5rem\r\n        position: relative\r\n       \r\n        h4\r\n            color: $white-color\r\n        p\r\n            color: #eaeaea \r\n            font-size: 14px\r\n            line-height: 1.2\r\n        .bullet_points\r\n            margin-top: 20px\r\n            padding: 0   \r\n    .imagesv\r\n        width: 100%\r\n        line-height: 0\r\n        height: 100%\r\n        position: relative\r\n        &::before\r\n            top: 0px\r\n            left: 0px\r\n            bottom: 0px\r\n            width: 50%\r\n            height: 100%\r\n            content: \"\"\r\n            position: absolute\r\n            background-image: linear-gradient(to right, #2b2b2b, rgba(43, 43, 43, 0.9215686275), rgba(43, 43, 43, 0.4392156863), transparent)\r\n        &::after\r\n            // top: 0px\r\n            // left: 0px\r\n            // bottom: 0px\r\n            // bottom: 0\r\n            right: 0\r\n            left: 0\r\n            width: 100%\r\n            height: 50%\r\n            content: \"\"\r\n            position: absolute\r\n            background-image: linear-gradient(to bottom, #2b2b2b, rgba(43, 43, 43, 0.9215686275), rgba(43, 43, 43, 0.4392156863), transparent)\r\n        img\r\n            width: 100%\r\n            height: 100%\r\n    .comson\r\n        background: #da3467\r\n        display: inline-block\r\n        padding: 5px 20px\r\n        border-radius: 15px\r\n        color: #fff\r\n        margin-top: 20px\r\n        text-align: center\r\n\r\n.new-product-sec-2\r\n    position: relative\r\n    padding: 50px 0 0\r\n    background: #222222\r\n    .container\r\n        margin: 0\r\n        padding: 0\r\n    .heading\r\n        margin-bottom: 4rem\r\n        span\r\n            background: #da3467\r\n            position: absolute\r\n            border-radius: 0 0 10px 10px\r\n            top: 0\r\n            right: 2rem\r\n            padding: 10px 20px\r\n            margin-bottom: 20px\r\n            display: block\r\n            color: $white-color\r\n            font-weight: 500\r\n            animation: animate 2s infinite alternate\r\n        h2\r\n            color: $white-color\r\n    .flex\r\n        .col\r\n            flex: 0 1 60%\r\n            position: relative\r\n            max-width: 60%\r\n            padding-right: 30px\r\n            padding: 50px 0\r\n            background: url('../images/product/community-power.jpg') no-repeat center center/cover\r\n            z-index: 11\r\n            &::before\r\n                position: absolute\r\n                content: \"\"\r\n                background: #000\r\n                top: 0\r\n                left: 0\r\n                bottom: 0\r\n                right: 0\r\n                opacity: .7\r\n                z-index: -1\r\n            &:last-child\r\n                flex: 0 1 40%\r\n                max-width: 40% \r\n                padding-right: 0       \r\n                display: flex\r\n                align-items: center\r\n                background: none\r\n                &::before\r\n                    content: none\r\n    // .content\r\n    //     display: flex\r\n    //     align-items: center\r\n    //     justify-content: center\r\n    //     flex-wrap: wrap\r\n    //     .item\r\n    //         width: 45%\r\n    //         background: #ffffff79\r\n    //         height: 100px\r\n    //         margin: 0 10px\r\n    //         margin-bottom: 20px\r\n    //         display: flex\r\n    //         align-items: center\r\n    //         justify-content: center\r\n    //         border-radius: 20px\r\n    //         text-align: center\r\n    //         border: 6px solid #da3467\r\n    //         color: #fff\r\n    //         box-shadow: inset -4px 5px 7px 0px #353434\r\n    .content\r\n        &.rotating-text-wrapper\r\n            // height: 90vh\r\n            display: flex\r\n            flex-direction: column\r\n            align-items: center\r\n            justify-content: center\r\n            text-align: center\r\n\r\n            p\r\n                font-size: 2em\r\n                margin: 0\r\n                padding: 0.3em\r\n                color: #fff\r\n                box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2)\r\n                border: 6px solid #da3467\r\n                border-radius: 20px\r\n                animation-duration: 15s\r\n                animation-iteration-count: infinite\r\n                opacity: 0\r\n                padding: 20px\r\n                &:first-child\r\n                    background: #ffffff79\r\n                    animation-name: rotating-text-1\r\n                &:nth-child(2)\r\n                    background: #ffffff79\r\n                    animation-name: rotating-text-2\r\n                &:nth-child(3) \r\n                    background: #ffffff79\r\n                    animation-name: rotating-text-3\r\n                &:nth-child(4) \r\n                    background: #ffffff79\r\n                    animation-name: rotating-text-4\r\n                \r\n\r\n@keyframes animate\r\n    0% \r\n        box-shadow: 0 0 5px rgba(255, 61, 132, 0.6), 0 0 15px rgba(255, 30, 105, 0.4)\r\n    100% \r\n        box-shadow: 0 0 15px #ff3d64, 0 0 30px #ff1e5e\r\n\r\n@keyframes rotating-text-1 \r\n    0% \r\n        transform: translateY(200%)\r\n    \r\n    25% \r\n        transform: translateY(100%)\r\n        opacity: 1\r\n    30% \r\n        opacity: 0\r\n\r\n@keyframes rotating-text-2 \r\n    25% \r\n        transform: translateY(100%)\r\n        opacity: 0\r\n    50% \r\n        transform: translateY(0)\r\n        opacity: 1\r\n    55% \r\n        opacity: 0\r\n\r\n@keyframes rotating-text-3\r\n    50%\r\n        transform: translateY(0)\r\n        opacity: 0\r\n    75%\r\n        transform: translateY(-100%)\r\n        opacity: 1\r\n    80%\r\n        opacity: 0\r\n\r\n@keyframes rotating-text-4\r\n    75%\r\n        transform: translateY(-100%)\r\n        opacity: 0\r\n    99%\r\n        transform: translateY(-200%)\r\n        opacity: 1\r\n    100%\r\n        transform: translateY(-200%)\r\n        opacity: 0\r\n              \r\n    \r\n            \r\n\r\n// .rotating-text-wrapper\r\n//     p\r\n//         font-size: 2.5em\r\n//         padding: 0.3em\r\n//         margin: 0\r\n//         color: #fff\r\n//         &:first-child   \r\n//             background-color: lightseagreen\r\n//         &:nth-child(2)\r\n//             background-color: tomato\r\n//         &:nth-child(3)\r\n//             background-color: cornflowerblue\r\n    ",".ai-sec-A\r\n    width: 100%\r\n    position: relative\r\n    .bg\r\n        height: calc( 100vh - 100px )\r\n        video\r\n            width: 100%\r\n            height: 100%\r\n            object-fit: cover\r\n    .content\r\n        position: absolute\r\n        top: 50%\r\n        max-width: 600px\r\n        width: 100%\r\n        padding-left: 30px\r\n        transform: translateY(-50%)\r\n        h2\r\n            color: $white-color\r\n            font-size: 36px\r\n        .bullet_points\r\n            margin-top: 20px\r\n            li\r\n                font-size: 16px\r\n\r\n//-----------------ai-sec-B---------------------------\r\n\r\n.ai-sec-B\r\n    padding: 50px 0\r\n    position: relative\r\n    background: #d1d1d1\r\n    .heading\r\n        h2\r\n            font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n    .item\r\n        position: relative\r\n        max-width: 1200px\r\n        margin: 50px auto\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            background: $primary-color\r\n            width: 5px\r\n            height: 100%\r\n            z-index: 1\r\n            margin-left: -3px\r\n            top: 0\r\n            left: 50%\r\n            animation: moveline 6s linear forwards\r\n            @include respond-to(screen-767)\r\n                left: 31px\r\n        \r\n        .content\r\n            padding: 10px 50px\r\n            position: relative\r\n            width: 50%\r\n            animation: movedown 1s linear forwards\r\n            opacity: 0\r\n            z-index: 1\r\n            @include respond-to(screen-767)\r\n                width: 100%\r\n                padding-left: 80px\r\n                padding-right: 25px\r\n            &:first-child\r\n                animation-delay: 0s\r\n            &:nth-child(2)\r\n                animation-delay: 1s\r\n            &:nth-child(3)\r\n                animation-delay: 2s\r\n            &:nth-child(4)\r\n                animation-delay: 3s\r\n            &:nth-child(5)\r\n                animation-delay: 4s\r\n            &:nth-child(6)\r\n                animation-delay: 5s\r\n            &:nth-child(7)\r\n                animation-delay: 6s\r\n\r\n            .text-box\r\n                padding: 20px 30px\r\n                background: $white-color\r\n                border-radius: 6px\r\n                font-size: 15px\r\n                position: relative\r\n                height: 90px\r\n                @include respond-to(screen-767)\r\n                    height: 100%\r\n                &::before\r\n                    position: absolute\r\n                    content: \"\"\r\n                    top: 10px\r\n                    border-top: 15px solid transparent\r\n                    border-bottom: 15px solid transparent\r\n                    border-left: 15px solid $white-color\r\n                    right: -15px\r\n                    @include respond-to(screen-767)\r\n                        transform: rotate(180deg)\r\n                        right: 100%\r\n                p\r\n                    font-size: 16px\r\n                    @include respond-to(screen-767)\r\n                        font-size: 14px\r\n            &.left\r\n                left: 0\r\n            &.right\r\n                left: 50%\r\n                @include respond-to(screen-767)\r\n                    left: 0\r\n                .text-box\r\n                    &::before\r\n                        transform: rotate(180deg)\r\n                        right: 100%\r\n                .icon\r\n                    left: -20px\r\n                    @include respond-to(screen-767)\r\n                        left:10px       \r\n        .icon\r\n            position: absolute\r\n            width: 40px\r\n            height: 40px\r\n            border-radius: 50%\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            top: 15px\r\n            right: -20px\r\n            z-index: 10\r\n            background: $white-color\r\n            @include respond-to(screen-767)\r\n                left: 10px\r\n       \r\n@keyframes moveline\r\n    0%\r\n        height: 0%\r\n    100%\r\n        height: 100%            \r\n@keyframes movedown\r\n    0%\r\n       opacity: 1\r\n       transform: translateY(-30px)\r\n    100%\r\n       opacity: 1\r\n       transform: translateY(0px)\r\n       \r\n//-----------------ai-sec-C---------------------------\r\n.ai-sec-3\r\n    background: #222222\r\n.ai-video\r\n    height: 500px\r\n    video\r\n        height: 100%\r\n        width: 100%    \r\n\r\n//-----------------ai-sec-D---------------------------    \r\n\r\n.ai-sec-4\r\n    padding: 50px 0   \r\n    position: relative\r\n    .heading\r\n        h2\r\n            font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 24px\r\n    .flex\r\n        .col1\r\n            flex: 0 1 31%\r\n            max-width: 31%\r\n            position: relative\r\n            margin: 0 10px\r\n            margin-bottom: 30px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n\r\n    .img \r\n        line-height: 0\r\n        &::before\r\n            position: absolute\r\n            content: \"\"       \r\n            width: 100%\r\n            height: 50%\r\n            bottom: 0\r\n            border-radius: 0 0 10px 10px\r\n            background: linear-gradient(to bottom, #00000000, #000000)\r\n        img\r\n            border-radius: 10px    \r\n    .content\r\n        position: absolute\r\n        left: 50%\r\n        bottom: 20px\r\n        transform: translateX(-50%)\r\n        text-align: center\r\n        white-space: nowrap\r\n        p\r\n            color: $white-color\r\n            \r\n//-----------------ai-sec-E---------------------------              \r\n\r\n.ai-sec-5\r\n    position: relative\r\n    .img\r\n        position: relative\r\n        line-height: 0\r\n        img\r\n            width: 100%\r\n    .content\r\n        padding: 50px 40px\r\n        position: absolute\r\n        top: 40px\r\n        left: 15%\r\n        h3\r\n            margin-bottom: 20px \r\n            color: $white-color   \r\n            font-size: 36px\r\n        ul\r\n            padding-left: 0",".managment-sec-A\r\n    position: relative\r\n    height: 500px\r\n    background: #e7e7e7\r\n    video\r\n        width: 100%\r\n        height: 100%\r\n        \r\n//----------------------- section-2 ------------------\r\n.management-sec-B\r\n    position: relative\r\n    padding: 50px 0\r\n    .flex\r\n        align-items: center\r\n        .col1\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            padding-right: 40px \r\n            @include respond-to(screen-767)             \r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                padding: 0\r\n                margin-bottom: 20px\r\n        .col2\r\n            flex: 0 1 50%\r\n            max-width: 50%  \r\n            padding-left: 40px \r\n            @include respond-to(screen-767)             \r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                padding: 0             \r\n    .content\r\n        h3\r\n            margin-bottom: 20px\r\n            font-size: 28px\r\n            font-weight: 500\r\n            color: #666666\r\n            @include respond-to(screen-767)\r\n                font-size: 22px\r\n        p\r\n            color: #7e7e7e \r\n            @include respond-to(screen-767)\r\n                font-size: 14px   \r\n    .img\r\n        line-height: 0\r\n        text-align: center\r\n        img\r\n            width: 400px\r\n            border-radius: 10px\r\n\r\n//---------------- section-3-----------------\r\n.management-sec-C\r\n    position: relative\r\n    background: #222222\r\n    padding: 50px 0\r\n    .container\r\n        max-width: 700px\r\n    .flex\r\n        align-items: center\r\n        \r\n        .item\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            text-align: center\r\n            margin-bottom: 30px\r\n            &:last-child\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 0\r\n    p\r\n        background: #fff\r\n        display: inline-block\r\n        height: 200px\r\n        width: 200px\r\n        display: flex\r\n        align-items: center\r\n        justify-content: center\r\n        margin: 0 auto\r\n        border-radius: 100%\r\n        padding: 10px\r\n        border: 15px solid $primary-color\r\n        box-shadow: inset 0px 4px 17px 6px #000\r\n        @include respond-to(screen-767)      \r\n            width: 150px\r\n            height: 150px\r\n            border: 5px solid $primary-color\r\n            box-shadow: inset 0px 1px 10px 4px #000\r\n            padding: 15px\r\n            font-size: 13px\r\n\r\n//---------------- section-4-----------------\r\n.management-sec-D\r\n    position: relative\r\n    padding-top: 50px\r\n    height: calc( 100vh - 200px )\r\n    background: url('../images/product/develop-people.jpg') no-repeat center center/cover\r\n    @include respond-to(screen-767)\r\n        height: 100%\r\n        padding-bottom: 50px\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        left: 0\r\n        top: 0\r\n        bottom: 0\r\n        right: 0\r\n        background: #000000\r\n        opacity: .5\r\n    .content\r\n        position: relative\r\n        max-width: 500px\r\n        width: 100%\r\n        h3\r\n            color: $white-color\r\n            margin-bottom: 20px\r\n            font-size: 30px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n        ul\r\n            padding: 0\r\n            li\r\n                font-weight: 300\r\n                font-size: 14px\r\n                margin-bottom: 5px\r\n                \r\n                &::before\r\n                    background: $primary-color\r\n\r\n//---------------- section-4-----------------   \r\n.management-sec-E\r\n    padding: 50px 0\r\n    position: relative\r\n    .heading\r\n        margin-bottom: 40px\r\n        h2\r\n            font-size: 36px\r\n    .flex\r\n        .item\r\n            flex: 0 1 32%\r\n            max-width: 32%\r\n            text-align: center\r\n            padding: 20px\r\n            border-radius: 5px\r\n            background: #222222\r\n            margin: 0 5px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n    h4\r\n        font-size: 18px\r\n        color: $primary-color\r\n        margin-bottom: 20px\r\n        display: flex\r\n        align-items: center\r\n        justify-content: center\r\n    ul\r\n        text-align: left \r\n        li\r\n            color: $white-color             \r\n       \r\n",".pathbreak-sec-A\r\n    padding: 50px 0\r\n    position: relative\r\n    .heading\r\n        h2\r\n            font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n    .flex\r\n        @include respond-to(screen-767)\r\n            justify-content: center\r\n        .item\r\n            flex: 0 1 20%\r\n            max-width: 20%\r\n            padding: 0 10px\r\n            text-align: center\r\n            margin-bottom: 30px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 50%\r\n                max-width: 50%\r\n                // text-align: center\r\n    .circle\r\n        background: rgba(106, 104, 104, 0.1490196078)\r\n        width: 150px\r\n        height: 150px\r\n        margin: 0 auto\r\n        position: relative\r\n        border-radius: 100%\r\n        &::before\r\n            content: \"\"\r\n            position: absolute\r\n            bottom: -30px\r\n            height: 8px\r\n            border: 13px solid transparent\r\n            border-top-color: $primary-color\r\n            left: 50%\r\n            transform: translate(-50%)\r\n        .icon\r\n            padding: 15px\r\n            position: absolute\r\n            top: 50%\r\n            left: 50%\r\n            transform: translate(-50%, -50%)\r\n            width: 120px\r\n            height: 120px\r\n            background: linear-gradient(white, white) padding-box, linear-gradient(to bottom, #dc1371, #da4a7e) border-box\r\n            border-radius: 50em\r\n            border: 10px solid transparent\r\n            opacity: 1\r\n            box-shadow: inset 0 0 8px #222222\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            img\r\n                width: 50px\r\n    span\r\n        margin-top: 20px\r\n        display: block\r\n\r\n// --------------------- section-2 ------------------//\r\n\r\n.pathbreak-sec-B\r\n    background: #222222\r\n    position: relative\r\n    padding: 50px 0\r\n    .heading\r\n        h2\r\n            color: $white-color\r\n            font-size: 36px\r\n    .flex\r\n        align-items: center\r\n        .col1\r\n            flex: 0 1 60%\r\n            max-width: 60%\r\n            @include respond-to(screen-767)     \r\n                flex: 0 1 100%\r\n                max-width: 100% \r\n        .col2\r\n            flex: 0 1 40%\r\n            max-width: 40% \r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n    .img\r\n        width: 500px\r\n        margin: 0 auto\r\n        @include respond-to(screen-767)\r\n            width: 100%\r\n            margin-bottom: 20px\r\n        img\r\n            width: 100%  \r\n            border-radius: 20px             \r\n    .bullet_points\r\n        padding-left: 0\r\n        li\r\n            margin-bottom: 5px\r\n            &::before\r\n                background: $primary-color\r\n\r\n// --------------------- section-2 ------------------//\r\n.pathbreak-sec-C\r\n    padding: 50px 0\r\n    .flex\r\n        .item\r\n            flex: 0  1 25%\r\n            max-width: 25%\r\n            text-align: center\r\n            position: relative\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n    .img\r\n        line-height: 0\r\n        max-width: 280px\r\n        width: 100%\r\n        margin: 0 auto\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            width: 280px\r\n            bottom: 0\r\n            height: 50%\r\n            background: linear-gradient(to bottom, #00000000, $primary-color)\r\n        img\r\n            width: 100%\r\n    p\r\n        position: absolute\r\n        left: 50%\r\n        transform: translateX(-50%) \r\n        white-space: nowrap\r\n        font-size: 14px\r\n        bottom: 20px\r\n        color: $white-color\r\n        font-weight: 600\r\n",".polls-sec-A\r\n    position: relative\r\n    padding: 100px 0\r\n    background: url('../images/product/sentiments.jpg') no-repeat center center/cover\r\n    .text\r\n        max-width: 500px\r\n        width: 100%\r\n        h3\r\n            color: $white-color\r\n            font-size: 30px\r\n            line-height: 1.5\r\n\r\n.polls-sec-B\r\n    position: relative\r\n    padding: 60px 0\r\n    .flex\r\n        align-items: center\r\n        .item\r\n            flex:  0 1 50%\r\n            max-width: 50%\r\n            text-align: center\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n    ul\r\n        text-align: left\r\n        width: 450px\r\n        margin: 0 auto\r\n        @include respond-to(screen-767)\r\n            width: 100%\r\n        li\r\n            color: #666666\r\n            margin-bottom: 5px\r\n            padding-right: 10px\r\n            &::before\r\n                background: $primary-color\r\n                top: 10px\r\n    img\r\n        border-radius: 10px\r\n\r\n.polls-sec-C\r\n    position: relative\r\n    padding: 50px 0\r\n    background: #222222\r\n    z-index: 1\r\n    .flex\r\n        .item\r\n            flex: 0 1 18%\r\n            max-width: 18%\r\n            background: $white-color\r\n            height: 150px\r\n            margin: 0 12px\r\n            border-radius: 10px\r\n            box-shadow: 4px 2px 4px 3px #424242\r\n            position: relative\r\n            border: 5px solid $primary-color\r\n            margin-bottom: 50px\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n    .text\r\n        text-align: center\r\n        padding: 30px 10px\r\n        display: flex\r\n        flex-direction: column\r\n        align-items: center\r\n        justify-content: space-between\r\n        h4\r\n            font-size: 16px\r\n    .point\r\n        position: absolute\r\n        width: 50px\r\n        height: 50px\r\n        display: flex\r\n        align-items: center\r\n        justify-items: center\r\n        background: $primary-color\r\n        border-radius: 100%\r\n        top: -30px\r\n        left: 50%\r\n        transform: translateX(-50%)\r\n        span\r\n            color: #fff\r\n            text-align: center\r\n            width: 100%\r\n            font-size: 18px\r\n            ",".assesment-sec-A\r\n    position: relative\r\n    padding: 50px 0\r\n    &.assesment-sec-B\r\n        background: #222222\r\n        .flex\r\n            .col\r\n                flex: 0 1 40%\r\n                max-width: 40%\r\n                @include respond-to(screen-767)\r\n                    flex: 0 1 100%\r\n                    max-width: 100%\r\n                    margin-bottom: 20px\r\n                &:last-child\r\n                    padding-left: 40px\r\n                    flex: 0 1 60%\r\n                    max-width: 60%\r\n                    @include respond-to(screen-767)\r\n                        flex: 0 1 100%\r\n                        max-width: 100%\r\n                        margin-bottom: 20px\r\n                        padding-left: 0\r\n        h3\r\n            color: $white-color\r\n        ul\r\n            li\r\n                color: $white-color\r\n                @include respond-to(screen-767)\r\n                    margin-bottom: 10px\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 60%\r\n            max-width: 60%\r\n            padding-right: 40px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n                padding-right: 0\r\n            &:last-child\r\n                flex: 0 1 40%\r\n                max-width: 40%\r\n                @include respond-to(screen-767)\r\n                    flex: 0 1 100%\r\n                    max-width: 100%\r\n    h3\r\n        color: #575757  \r\n        margin-bottom: 30px          \r\n    ul\r\n        padding: 0\r\n        li\r\n            color: #666666\r\n            @include respond-to(screen-767)\r\n                margin-bottom: 10px\r\n            &::before\r\n                background: $primary-color           \r\n    img\r\n        border-radius: 10px\r\n",".community-sec-A\r\n    padding: 50px 0\r\n    .heading\r\n        margin-bottom: 50px\r\n        h2\r\n            font-size: 36px\r\n            line-height: 1.3\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n            &:first-child\r\n                padding-right: 30px\r\n    .text\r\n        p\r\n            margin-bottom: 20px \r\n    img\r\n        border-radius: 20px         \r\n\r\n.community-sec-C\r\n    position: relative\r\n    background: url('../images/product/community-power.jpg') no-repeat center center/cover\r\n    height: calc( 100vh - 200px )\r\n    padding: 100px 0\r\n    @include respond-to(screen-767)\r\n        height: 100%\r\n        padding: 50px 0\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        background: #000\r\n        opacity: 0.5\r\n        left: 0\r\n        top: 0\r\n        right: 0\r\n        bottom: 0\r\n    .content\r\n        position: relative\r\n        h3\r\n            margin-bottom: 20px\r\n            color: #fff\r\n    ul\r\n        padding: 0  \r\n        li\r\n            margin-bottom: 10px      ",".compliance-sec-A\r\n    padding: 50px 0\r\n    background: #e7e7e7\r\n    position: relative\r\n    .heading\r\n        margin-bottom: 60px\r\n        h2\r\n            font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n    .item\r\n        position: relative\r\n        flex: 0 1 50%\r\n        max-width: 50%\r\n        margin-bottom: 5rem\r\n        @include respond-to(screen-767)\r\n            flex: 0 1 100%\r\n            max-width: 100%\r\n        .circle\r\n            width: 150px\r\n            height: 150px\r\n            background: linear-gradient(#da3467, #f5c0d0)\r\n            border-radius: 100%\r\n            border: 10px solid #ffffff\r\n            position: absolute\r\n            box-shadow: inset 0 0 8px #312b2d\r\n            top: -27px\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            @include respond-to(screen-767)\r\n                width: 120px\r\n                height: 120px\r\n                top: -10px\r\n            .icon\r\n                background: #fbfbfb\r\n                width: 80px\r\n                height: 80px\r\n                display: flex\r\n                align-items: center\r\n                justify-content: center\r\n                border-radius: 100%\r\n                box-shadow: 0 0 8px 0 #312b2d\r\n                @include respond-to(screen-767)\r\n                    width: 50px\r\n                    height: 50px\r\n\r\n                \r\n        .text\r\n            background: #fff\r\n            height: 100px\r\n            border-radius: 100px\r\n            display: flex\r\n            align-items: center\r\n            width: 85%\r\n            @include respond-to(screen-767)\r\n                width: 100%\r\n            p\r\n                margin-left: 11rem\r\n                @include respond-to(screen-767)\r\n                    margin-left: 9rem\r\n\r\n\r\n.compliance-sec-B\r\n    position: relative\r\n    padding: 50px 0\r\n    .heading\r\n        margin-bottom: 50px\r\n        h2\r\n            font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n    .flex\r\n        .col\r\n            flex: 0 1 30%\r\n            max-width: 30%\r\n            margin: 0 20px\r\n            text-align: center\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n            &:last-child\r\n                .img\r\n                    &::before\r\n                        content: none          \r\n    .img\r\n        position: relative\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            left: 0\r\n            right: -20px\r\n            border-right: 3px solid $primary-color\r\n            padding: 10px\r\n            height: 100%\r\n            @include respond-to(screen-767)\r\n                content: none\r\n\r\n        img\r\n            border-radius: 0px 100px 0 100px\r\n            height: 100%\r\n    p\r\n        padding: 10px\r\n        font-weight: 500\r\n\r\n\r\n.compliance-sec-C\r\n    position: relative\r\n    padding: 100px 0\r\n    background: url('../images/product/cinemetic.jpg')\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        left: 0\r\n        top: 0\r\n        bottom: 0\r\n        right: 0\r\n        background: #000000\r\n        opacity: 0.6\r\n    .content\r\n        position: relative\r\n        h3\r\n            color: #fff\r\n            margin-bottom: 20px\r\n            font-size: 28px\r\n        ul\r\n            padding-left: 0    ",".content-banner-sec\r\n    position: relative\r\n    .bg\r\n        width: 100%\r\n        line-height: 0\r\n        height: calc( 100vh - 100px )\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            left: 0\r\n            right: 0\r\n            top: 0\r\n            bottom: 0\r\n            background: #000000\r\n            opacity: .6\r\n        img\r\n            width: 100%\r\n            height: 100%\r\n            object-fit: cover\r\n    .content\r\n        position: absolute\r\n        top: 50%\r\n        transform: translateY(-50%)\r\n        left: 10%\r\n        width: 600px\r\n        @include respond-to(screen-767)\r\n            left: 0\r\n            width: 100%\r\n            padding: 0 10px\r\n        p\r\n            color: #ffffff\r\n            font-size: 24px\r\n            line-height: 1.2    \r\n\r\n.content-sec-A\r\n    padding: 100px 0            \r\n    .flex\r\n        justify-content: center\r\n        .col\r\n            flex: 0 1 25%\r\n            max-width: 25%\r\n            text-align: center\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 100px\r\n    .item\r\n        background: linear-gradient(to left, #da3467, #303030)\r\n        height: 180px\r\n        width: 180px\r\n        text-align: center\r\n        display: flex\r\n        align-items: center\r\n        justify-content: center        \r\n        margin: 0 auto\r\n        border-radius: 10px\r\n        position: relative\r\n        transform: rotate(45deg)\r\n        .text\r\n            background: #f1f1f1\r\n            height: 150px\r\n            width: 150px\r\n            text-align: center\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center        \r\n            margin: 0 auto\r\n            border-radius: 10px\r\n            position: relative\r\n            box-shadow: 0 0 8px 0 #000000\r\n            p\r\n                transform: rotate(-45deg)\r\n\r\n\r\n.content-sec-B\r\n    position: relative\r\n    background: #222222\r\n    padding: 50px 0\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n    .img\r\n        width: 400px\r\n        margin: 0 auto\r\n        line-height: 0\r\n        @include respond-to(screen-767)\r\n            width: 100%\r\n        img\r\n            width: 100%\r\n            border-radius: 10px\r\n    .content\r\n        // text-align: center\r\n        h3\r\n            margin-bottom: 20px\r\n            color: #fff \r\n        ul\r\n            text-align: left          \r\n\r\n.content-sec-C\r\n    padding: 50px 0\r\n    .flex\r\n        .item\r\n            flex: 0  1 25%\r\n            max-width: 25%\r\n            text-align: center\r\n            position: relative\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n    .img\r\n        line-height: 0\r\n        max-width: 280px\r\n        width: 100%\r\n        margin: 0 auto\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            width: 280px\r\n            bottom: 0\r\n            height: 50%\r\n            background: linear-gradient(to bottom, #00000000, #000000)\r\n        img\r\n            width: 100%\r\n    p\r\n        position: absolute\r\n        left: 50%\r\n        transform: translateX(-50%) \r\n        font-size: 14px\r\n        bottom: 20px\r\n        color: $white-color\r\n        font-weight: 600  \r\n        width: 100%\r\n        padding: 0 10px\r\n\r\n\r\n\r\n\r\n\r\n// ------------------- section-E ------------------------\r\n\r\n.content-sec-E\r\n    padding: 50px 0\r\n    background: #222222\r\n    .heading\r\n        h2\r\n            color: $white-color\r\n            font-size: 36px\r\n    .item\r\n        position: relative\r\n        margin: auto\r\n        transition: all .5s ease-in-out\r\n        cursor: pointer\r\n        &::after\r\n            content: ''\r\n            position: absolute\r\n            left: 0\r\n            top: 0\r\n            width: 100%\r\n            height: 100%\r\n            background: rgba(0, 0, 0, .44)\r\n            transition: all 1s ease-in-out\r\n        &:hover\r\n            &::after\r\n                height: 0%\r\n    .img\r\n        overflow: hidden\r\n        height: 270px\r\n        img\r\n            width: 100%\r\n            height: 100%\r\n            transition: all 1s ease-in-out\r\n    .text\r\n        position: absolute\r\n        bottom: 15px\r\n        z-index: 1\r\n        left: 50%\r\n        transform: translateX(-50%)\r\n        white-space: nowrap\r\n        p\r\n            color: $white-color\r\n    .VdeMnSemn\r\n        position: absolute\r\n        left: 50%\r\n        top: 50%\r\n        cursor: pointer\r\n        transform: translate(-50%,-50%)\r\n        z-index: 5\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            width: 50px\r\n            height: 50px\r\n            right: 0\r\n            bottom: 0\r\n            transform: translate(-50%,-50%)\r\n            display: block\r\n            background: $white-color\r\n            border-radius: 50%\r\n            top: 50%\r\n            left: 50%\r\n            animation: pulse-border 1500ms ease-out infinite\r\n        .VdeIcnMn\r\n            width: 50px\r\n            height: 50px\r\n            border: 2px solid $white-color\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            border-radius: 100%\r\n            img\r\n                width: auto\r\n    .owl-dots\r\n        text-align: center    \r\n\r\n\r\n@keyframes pulse-border\r\n    0%\r\n        transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1)\r\n        opacity: 0.5\r\n    100%\r\n        transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5)\r\n        opacity: 0\r\n                ",".solution-sec-A\r\n    padding: 50px 0\r\n    .heading\r\n        h2\r\n            font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            &:last-child\r\n                padding-left: 50px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n                &:last-child\r\n                    padding-left: 0  \r\n    video\r\n        height: 400px\r\n        width: 100%\r\n        background: #222222\r\n    .content\r\n        p\r\n            margin-bottom: 20px\r\n\r\n\r\n.solution-sec-B\r\n    position: relative\r\n    padding: 50px 0\r\n    background: #222222\r\n    .heading\r\n        h2\r\n            color: $white-color\r\n            font-size: 36px    \r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            &:first-child\r\n                padding-right: 50px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n    video\r\n        height: 400px\r\n        width: 100%\r\n        background: #222222\r\n    .content\r\n        ul\r\n            padding: 0\r\n            li\r\n                margin-bottom: 15px\r\n        b\r\n            color: $primary-color    \r\n\r\n\r\n.solution-sec-C \r\n    position: relative\r\n    background: #f1f1f1\r\n    line-height: 0\r\n    video\r\n        height: 400px\r\n        width: 100%    \r\n\r\n\r\n.solution-sec-D\r\n    position: relative\r\n    padding: 50px 0\r\n    background: #222222\r\n    .heading\r\n        h2\r\n            color: $white-color\r\n            font-size: 36px\r\n            @include respond-to(screen-767)\r\n                font-size: 28px\r\n    .flex\r\n        .col\r\n            flex: 0 1 33.33%\r\n            max-width: 33.33%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n\r\n    .item\r\n        background: $white-color\r\n        height: 300px\r\n        padding: 60px 30px\r\n        border-radius: 10px\r\n        margin: 0 10px\r\n        box-shadow: inset 0 0 10px 2px #222222\r\n        ul\r\n            padding: 0\r\n            li\r\n                color: #505050\r\n                &::before\r\n                    background: $primary-color\r\n\r\n\r\n.solution-sec-E\r\n    position: relative\r\n    padding: 100px 0\r\n    background: url('../images/solution/organization.jpg') no-repeat center center/cover\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        left: 0\r\n        top: 0\r\n        bottom: 0\r\n        right: 0\r\n        background: #222222\r\n        opacity: .6\r\n    .heading\r\n        text-align: left\r\n        position: relative\r\n        h2\r\n            color: $white-color\r\n    ul\r\n        padding: 0        ",".frontline-sec-A\r\n    padding: 50px 0\r\n    padding-bottom: 100px\r\n    position: relative\r\n    .heading\r\n        margin-bottom: 5rem\r\n    .flex\r\n        justify-content: center\r\n        .col\r\n            flex: 0 1 33.33%\r\n            max-width: 33.33%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 60px\r\n            &:last-child,&:nth-last-child(2)\r\n                .item\r\n                    transform: rotate(-135deg)\r\n                    @include respond-to(screen-767)\r\n                        transform: rotate(45deg)\r\n                    p\r\n                        transform: rotate(-225deg)\r\n                        @include respond-to(screen-767)\r\n                            transform: rotate(-45deg)\r\n    .item\r\n        background: linear-gradient(to left, #777777, #303030)\r\n        height: 250px\r\n        width: 250px\r\n        text-align: center\r\n        display: flex\r\n        align-items: center\r\n        justify-content: center\r\n        margin: 0 auto\r\n        border-top-left-radius: 40%\r\n        border: 3px solid $primary-color\r\n        position: relative\r\n        transform: rotate(45deg)\r\n        @include respond-to(screen-767)\r\n            width: 200px\r\n            height: 200px\r\n    p\r\n        transform: rotate(-45deg)\r\n        color: $white-color\r\n        font-size: 14px\r\n        @include respond-to(screen-767)\r\n            padding: 0 10px\r\n            font-size: 12px    \r\n            \r\n.frontline-sec-B\r\n    .bg\r\n        position: relative\r\n        line-height: 0\r\n        height: 500px\r\n        @include respond-to(screen-767)\r\n            height: 350px\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            left: 0\r\n            right: 0\r\n            bottom: 0\r\n            top: 0\r\n            background: #000000\r\n            opacity: .6\r\n        img\r\n            width: 100%\r\n            height: 100%\r\n            object-fit: cover                   \r\n    .content\r\n        position: absolute\r\n        top: 50%\r\n        left: 50%\r\n        text-align: center\r\n        transform: translate(-50%,-50%)\r\n        @include respond-to(screen-767)\r\n            width: 100%\r\n            padding: 0 25px\r\n            top: 35%\r\n        h2\r\n            color: $white-color\r\n            margin-bottom: 20px\r\n        p\r\n            color: $white-color\r\n            @include respond-to(screen-767)\r\n                width: 100%\r\n    .growth-sec\r\n        background: #222222 \r\n        @include respond-to(screen-767)\r\n            padding: 0 15px      \r\n        .flex\r\n            padding: 30px 0\r\n            align-items: center\r\n            .col\r\n                flex: 0 1 50%\r\n                max-width: 50%\r\n                @include respond-to(screen-767)\r\n                    flex: 0 1 100%\r\n                    max-width: 100%\r\n                &:last-child\r\n                    padding-left: 50px\r\n                    @include respond-to(screen-767)\r\n                        margin-top: 20px\r\n                        padding: 0\r\n            img\r\n                border: 4px solid $primary-color\r\n                width: 100%\r\n                border-radius: 20px        \r\n            .text\r\n                h3\r\n                    margin-bottom: 20px\r\n                    color: $white-color\r\n                ul\r\n                    padding: 0\r\n                    \r\n                    li\r\n                        color: $white-color\r\n                        margin-bottom: 5px\r\n                        &::before\r\n                            background: $primary-color\r\n\r\n.frontline-sec-C\r\n    position: relative\r\n    padding: 100px 0\r\n    background: url('../images/solution/roi.jpg')\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        left: 0\r\n        top: 0\r\n        bottom: 0\r\n        right: 0\r\n        background: #000000\r\n        opacity: .6\r\n    .container\r\n        max-width: 1400px\r\n    .heading\r\n        position: relative\r\n        text-align: left\r\n        h2\r\n            color: $white-color \r\n    .content\r\n        width: 600px \r\n        @include respond-to(screen-767)\r\n            width: 100%       \r\n    ul\r\n        padding-left: 0\r\n        li\r\n            @include respond-to(screen-767)\r\n                margin-bottom: 10px\r\n\r\n\r\n.frontline-sec-D\r\n    padding: 50px 0\r\n    .heading\r\n        h2\r\n            margin-bottom: 10px\r\n        p\r\n            font-size: 16px\r\n    .flex\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            padding-right: 50px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                padding-right: 0\r\n                margin-bottom: 20px\r\n            &:first-child\r\n                .text \r\n                    padding: 70px 20px\r\n                    background: url('../images/solution/microai.jpg')\r\n                    @include respond-to(screen-767)\r\n                    &::before\r\n                        position: absolute\r\n                        content: \"\"\r\n                        background: #000\r\n                        width: 100%\r\n                        left: 0\r\n                        top: 0\r\n                        border-radius: 10px\r\n                        opacity: .6\r\n                        height: 100%                     \r\n            &:nth-last-child(2)\r\n                .text\r\n                    padding-left: 50px\r\n                    padding: 58px 20px\r\n                    background: url('../images/solution/measure.jpg')\r\n            &:last-child\r\n                margin-top: 20px\r\n                flex: 0 1 100%\r\n                max-width: 100% \r\n                @include respond-to(screen-767)\r\n                    margin-top: 0px\r\n                .content\r\n                    background: url('../images/solution/measure.jpg') no-repeat center center/cover\r\n                    padding: 50px  20px  \r\n                    @include respond-to(screen-767)\r\n                        ul\r\n                            padding-left: 0                  \r\n    .text,.content\r\n        position: relative\r\n        border-radius: 10px\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            background: #000\r\n            width: 100%\r\n            left: 0\r\n            top: 0\r\n            border-radius: 10px\r\n            opacity: .6\r\n            height: 100%\r\n        h3\r\n            position: relative\r\n            color: $white-color\r\n            font-weight: 500\r\n        p\r\n            position: relative\r\n            color: $white-color \r\n            a\r\n                color: $primary-color\r\n                &:hover\r\n                    color: $primary-color    \r\n\r\n    .solution-sec\r\n        padding: 0 100px\r\n        @include respond-to(screen-767)\r\n            padding: 0 20px\r\n                    ",".communc-sec-A\r\n    padding: 50px 0\r\n    position: relative\r\n    background: #222222\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n            &:first-child\r\n                padding-right: 50px\r\n                @include respond-to(screen-767)\r\n                    margin-bottom: 20px\r\n        h3\r\n            margin-bottom: 20px\r\n            color: $white-color     \r\n        ul\r\n            li\r\n                color: $white-color \r\n                &::before\r\n                    background: $primary-color\r\n        video\r\n            width: 100% \r\n            height: 500px           \r\n\r\n\r\n.communc-sec-B\r\n    padding: 50px 0\r\n    position: relative\r\n    .flex\r\n        .col\r\n            flex: 0 1 20%\r\n            max-width: 20% \r\n            text-align: center\r\n            position: relative\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n        .img\r\n            width: 230px\r\n            position: relative\r\n            margin: 0 10px\r\n            @include respond-to(screen-767)\r\n                width: 100%\r\n                margin: 0\r\n            &::before\r\n                position: absolute\r\n                content: \"\"\r\n                background: linear-gradient(to top, #000000, transparent)\r\n                width: 100%\r\n                height: 100%\r\n                border-radius: 10px\r\n            img\r\n                width: 100% \r\n                border-radius: 10px       \r\n\r\n        p\r\n            position: absolute\r\n            bottom: 5%\r\n            left: 50%\r\n            color: $white-color\r\n            transform: translateX(-50%)\r\n            width: 100%\r\n            padding: 0 40px\r\n\r\n\r\n.communc-sec-C\r\n    // position: relative\r\n    background: #222222\r\n    padding: 50px 0\r\n    .heading\r\n        h2\r\n            color: $white-color \r\n    .flex\r\n        .col\r\n            flex: 0 1 25%\r\n            max-width: 25%\r\n            @include respond-to(screen-991)\r\n                flex: 0 1 50%\r\n                max-width: 50%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                margin-bottom: 20px\r\n    .item\r\n        box-shadow: 0 0 8px 1px #717171\r\n        display: flex\r\n        height: 150px\r\n        align-items: center\r\n        justify-content: center\r\n        text-align: center\r\n        margin: 0 15px\r\n        overflow: hidden\r\n        cursor: pointer\r\n        border-radius: 10px\r\n        position: relative\r\n        transition: 450ms ease\r\n        background: linear-gradient(45deg, #211a1a, #534c4c)\r\n        &::before\r\n            content: \"\"\r\n            position: absolute\r\n            left: 0\r\n            right: 0\r\n            top: 0\r\n            bottom: 0\r\n            background: $primary-color\r\n            -webkit-clip-path: polygon(0 100%, 0 98%, 0 100%, 0 100%)\r\n            clip-path: polygon(0 100%, 0 98%, 0 100%, 0 100%)\r\n            transition: 450ms ease\r\n        &:hover\r\n            &::before\r\n                -webkit-clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%)\r\n                clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 100%)\r\n        p\r\n            color: $white-color\r\n            padding: 0 20px \r\n            position: relative             \r\n\r\n.communc-sec-D\r\n    padding: 50px 0\r\n    position: relative\r\n    .heading\r\n        margin-bottom: 50px\r\n    .owl-carousel\r\n        .owl-stage-outer\r\n            .owl-item\r\n                transform: scale(0.9)\r\n                opacity: .6\r\n                background: #f1f1f1\r\n                &.center\r\n                    transform: scale(1.1)\r\n                    box-shadow: 0px -1px 10px -2px rgba(0, 0, 0, 0.4)\r\n                    position: relative\r\n                    z-index: 1\r\n                    background: #222222\r\n                    opacity: 1\r\n                    .item\r\n                        p\r\n                            color: $white-color \r\n        .owl-dots\r\n            text-align: center \r\n            .owl-dot\r\n                background: #d2d2d2                     \r\n               \r\n    .item\r\n        position: relative\r\n        display: flex\r\n        background: url('../images/solution/workplace/each-course-5-min.png') no-repeat center center/cover\r\n        padding: 55px 15px\r\n        height: 150px\r\n        border-radius: 10px\r\n        justify-content: center\r\n        align-items: center\r\n        &.item2\r\n            background: url('../images/solution/workplace/real-workplace.png') no-repeat center center/cover\r\n        &.item3\r\n            background: url('../images/solution/workplace/keep-in-mind.png') no-repeat center center/cover\r\n        &.item4\r\n            background: url('../images/solution/workplace/scenario.png') no-repeat center center/cover\r\n        &.item5\r\n            background: url('../images/solution/workplace/prescriptive-content.png') no-repeat center center/cover\r\n        &.item6\r\n            background: url('../images/solution/workplace/bella.png') no-repeat center center/cover\r\n        &.item7\r\n            background: url('../images/solution/workplace/track-progress.png') no-repeat center center/cover\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            left: 0\r\n            top: 0\r\n            right: 0\r\n            bottom: 0\r\n            background: #222222\r\n            opacity: .6\r\n            border-radius: 10px\r\n        p\r\n            position: relative \r\n            color: $white-color   ",".blog\r\n    background: #e8e8e8\r\n    padding: 50px 0\r\n\r\n.blog-grid \r\n    .blog-img \r\n        position: relative\r\n        border-radius: 5px\r\n        overflow: hidden\r\n        line-height: 0\r\n        &:hover\r\n            .img\r\n                &::before,&::after\r\n                    width: 0%\r\n        .img\r\n            display: block\r\n            height: 250px\r\n            img\r\n                width: 100%\r\n                height: 250px\r\n                object-fit: cover\r\n            &::before\r\n                position: absolute\r\n                content: ''\r\n                background-color: rgba(28, 30, 39, .30)\r\n                width: 50%\r\n                height: 100%\r\n                left: 0px\r\n                top: 0px\r\n                // z-index: 1\r\n                transition: all 500ms ease\r\n            &::after\r\n                position: absolute\r\n                content: ''\r\n                background-color: rgba(28, 30, 39, .30)\r\n                width: 50%\r\n                height: 100%\r\n                right: 0px\r\n                top: 0px\r\n                // z-index: 1\r\n                transition: all 500ms ease\r\n    .date\r\n        position: absolute\r\n        background: #ffffff\r\n        color: #282828\r\n        padding: 15px\r\n        right: 0\r\n        top: 15px\r\n        font-size: 14px\r\n        z-index: 1\r\n    .blog-info\r\n        box-shadow: 0 0 30px rgba(31, 45, 61, 0.125)\r\n        border-radius: 5px\r\n        background: #222222\r\n        padding: 20px\r\n        margin: -30px 20px 0\r\n        position: relative\r\n        z-index: 1\r\n        h5\r\n            color: $text-color \r\n            display: -webkit-box\r\n            -webkit-box-orient: vertical\r\n            -webkit-line-clamp: 2\r\n            overflow: hidden\r\n            color: $white-color\r\n        p\r\n            display: -webkit-box\r\n            -webkit-box-orient: vertical\r\n            -webkit-line-clamp: 5\r\n            overflow: hidden\r\n            color: $white-color      \r\n        .btn-primary\r\n            background: $primary-color\r\n            svg\r\n                margin-left: 5px\r\n                vertical-align: middle\r\n        \r\n//pagination\r\n.pagination\r\n    text-align: center\r\n    margin-top: 40px\r\n    display: flex\r\n    align-items: center\r\n    justify-content: center\r\n\r\n.page-item\r\n    cursor: pointer\r\n    background-color: white\r\n    color: #999\r\n    border-radius: 50%\r\n    display: flex\r\n    align-items: center\r\n    justify-content: center\r\n    transition: .4s ease \r\n       \r\n  \r\n",".blog_detail_sec\r\n    .blog-wrap\r\n        position: relative\r\n        overflow: hidden\r\n        line-height: 0\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            background: $black-color\r\n            opacity: .4\r\n            width: 100%\r\n            height: 100% \r\n        img\r\n            height: 500px\r\n            object-fit: cover\r\n            width: 100%\r\n        .container\r\n            position: relative\r\n        .blog-inner\r\n            width: 100%\r\n            position: absolute\r\n            top: 50%\r\n            transform: translateY(-50%)\r\n            .blog-text\r\n                h2\r\n                    color: $white-color\r\n                    width: 100%\r\n                    font-weight: 600\r\n                    margin: 0 0 15px\r\n                .user-section\r\n                    li\r\n                        padding-right: 30px\r\n                        font-size: 16px\r\n                        color: $white-color\r\n                        vertical-align: middle\r\n                        svg\r\n                            width: 18px\r\n                            position: relative\r\n                            top: -2px\r\n                            margin-right: 5px\r\n                            vertical-align: middle\r\n    .blog-detailcontent\r\n        padding: 50px 0\r\n        h1\r\n            margin-bottom: 30px\r\n        p,h4,h3\r\n            margin-bottom: 20px           \r\n            a\r\n                color: $primary-color           \r\n        h2\r\n            margin-bottom: 25px\r\n        img\r\n            height: 100%    \r\n        ul\r\n            li\r\n                display: block\r\n                position: relative\r\n                padding-left: 20px    \r\n                margin-bottom: 10px\r\n                &::before\r\n                    position: absolute\r\n                    content: \"\"\r\n                    width: 10px\r\n                    height: 10px\r\n                    background: $primary-color\r\n                    border-radius: 100%\r\n                    left: 0\r\n                    top: 8px\r\n                         \r\n                \r\n            \r\n        \r\n    \r\n",".team-sec\r\n    padding: 50px 0\r\n    background-color: #ececec\r\n    .heading\r\n        margin-bottom: 40px\r\n    .team-details\r\n        position: relative\r\n        .team_details_sec\r\n            position: relative\r\n            a\r\n                overflow: hidden\r\n        .team_img\r\n            width: 300px\r\n            height: 300px\r\n            margin: 0 auto\r\n            overflow: hidden       \r\n            &::before\r\n                width: 300px\r\n                height: 300px\r\n                position: absolute\r\n                content: \"\"\r\n                background: linear-gradient(to top, rgba(0, 0, 0, 0.7019607843), transparent)\r\n                pointer-events: none\r\n                border-radius: 20px  \r\n            img\r\n                border-radius: 20px\r\n                height: 100%\r\n                width: 100%\r\n                object-fit: cover       \r\n        .name\r\n            font-size: 20px\r\n            margin: 10px 0\r\n            font-weight: 400\r\n            color: $white-color\r\n            position: absolute\r\n            left: 50%\r\n            transform: translateX(-50%)\r\n            bottom: 23%\r\n            width: 100%\r\n        \r\n        .designation\r\n            color: $text-color\r\n            font-weight: 600\r\n            font-size: 16px\r\n            margin-top: 15px\r\n        .linked_profile\r\n            a\r\n                display: inline-block\r\n                svg\r\n                    fill: $primary-color\r\n    &.leadership\r\n        background: #222222\r\n        .designation\r\n            color: #e1e1e1  \r\n        \r\n        .linked_profile\r\n            a\r\n                svg\r\n                    fill: $white-color\r\n\r\n\r\n\r\n$defaultSeconds: 3s\r\n\r\n.about-sec-A\r\n    position: relative\r\n    background: #222222\r\n    .container\r\n        padding: 50px\r\n        height: 100vh\r\n        width: 100%\r\n        display: -webkit-flex\r\n        display: flex\r\n        overflow: hidden\r\n        @include respond-to(screen-768)\r\n            flex-direction: column\r\n    .slide-mission\r\n        -webkit-flex: 1  \r\n        -ms-flex: 1  \r\n        flex: 1\r\n        cursor: pointer\r\n        padding: 0 50px\r\n        height: 100%\r\n        pointer-events: auto\r\n        -webkit-transition: all 500ms ease\r\n        -moz-transition: all 500ms ease\r\n        -ms-transition: all 500ms ease\r\n        -o-transition: all 500ms ease\r\n        transition: all 500ms ease\r\n        @include respond-to(screen-768) \r\n            overflow: auto\r\n            overflow-x: hidden \r\n        &.vission\r\n            background: linear-gradient(rgba(0, 0, 0, 0.623), rgba(0, 0, 0, 0.623)), url('../images/vission.jpg')\r\n            background-size: cover\r\n            background-position: center center\r\n        &.mission\r\n            background: linear-gradient(rgba(0, 0, 0, 0.623), rgba(0, 0, 0, 0.623)), url('../images/purpose.jpg')\r\n            background-size: cover\r\n            background-position: center center \r\n        &:hover\r\n            flex-grow: 2\r\n            .title\r\n                top: 20%\r\n                transform: rotate(0deg)  \r\n            .desc\r\n                opacity: 1  \r\n                width: 100% \r\n                top: 35%   \r\n        .title\r\n            color: $white-color\r\n            position: relative\r\n            font-size: 48px\r\n            margin: auto\r\n            text-align: center\r\n            transform: rotate(90deg)\r\n            top: 50%\r\n            -webkit-transition: all 500ms ease\r\n            -moz-transition: all 500ms ease\r\n            -ms-transition: all 500ms ease\r\n            -o-transition: all 500ms ease\r\n            transition: all 500ms ease\r\n            @include respond-to(screen-768)\r\n                transform: rotate(0deg) !important\r\n        .desc\r\n            opacity: 0\r\n            color: #f1f1f1\r\n            position: relative\r\n            width: 70%\r\n            font-size: 16px\r\n            padding: 5%\r\n            top: 50%\r\n            border: 2px solid #f1f1f1\r\n            border-radius: 10px\r\n            line-height: 1.3\r\n            margin: auto\r\n            text-align: left\r\n            transform: rotate(0deg)\r\n            -webkit-transition: all 500ms ease\r\n            -moz-transition: all 500ms ease\r\n            -ms-transition: all 500ms ease\r\n            -o-transition: all 500ms ease\r\n            transition: all 500ms ease\r\n            @media screen and (max-width: 768px)\r\n                padding: 0%\r\n                border: 0px solid #f1f1f1\r\n            p\r\n                margin-bottom: 10px    ",".newsletter\r\n    padding: 50px 0\r\n    .flex\r\n        .col\r\n            flex: 0 1 33.33%\r\n            max-width: 33.33%\r\n    .post-slide \r\n        background: #fff\r\n        margin: 20px 15px 20px\r\n        border-radius: 15px\r\n        padding-top: 1px\r\n        box-shadow: 0px 14px 22px -9px #bbcbd8\r\n        .post-img \r\n            position: relative\r\n            overflow: hidden\r\n            border-radius: 10px\r\n            margin: -12px 15px 8px 15px\r\n            margin-left: -10px\r\n            img \r\n                width: 100%\r\n                height: auto\r\n                transform: scale(1, 1)\r\n                transition: transform 0.2s linear\r\n        &:hover\r\n            .post-img \r\n                img \r\n                    transform: scale(1.1, 1.1)\r\n        .over-layer \r\n            width: 100%\r\n            height: 100%\r\n            position: absolute\r\n            top: 0\r\n            left: 0\r\n            opacity: 0\r\n            background: linear-gradient(-45deg, rgba(6, 190, 244, 0.75) 0%, rgba(45, 112, 253, 0.6) 100%)\r\n            transition: all 0.5s linear\r\n            i \r\n                position: relative\r\n                top: 45%\r\n                text-align: center\r\n                display: block\r\n                color: #fff\r\n                font-size: 25px\r\n        &:hover\r\n            .over-layer \r\n                opacity: 1\r\n                text-decoration: none\r\n        .post-content \r\n            background: #fff\r\n            padding: 2px 20px 40px\r\n            border-radius: 15px\r\n        .post-title \r\n            a \r\n                font-size: 15px\r\n                font-weight: bold\r\n                color: #333\r\n                display: inline-block\r\n                text-transform: uppercase\r\n                transition: all 0.3s ease 0s\r\n                &:hover \r\n                    text-decoration: none\r\n                    color:$primary-color\r\n\r\n        .post-description \r\n            line-height: 24px\r\n            color: #808080\r\n            margin-bottom: 25px\r\n        .post-date \r\n            color: #2c2c2c\r\n            font-size: 14px\r\n            font-weight: 600\r\n            vertical-align: middle\r\n            .date\r\n                margin-left: 5px\r\n        .read-more \r\n            padding: 7px 20px\r\n            float: right\r\n            font-size: 12px\r\n            background: $primary-color\r\n            color: #ffffff\r\n            box-shadow: 0px 10px 20px -10px #1376c5\r\n            border-radius: 25px\r\n            text-transform: uppercase\r\n            &:hover \r\n                background: $primary-color\r\n                text-decoration: none\r\n                color: #fff\r\n    &.news-sec\r\n        .col\r\n            position: relative\r\n        .inkalllm\r\n            position: absolute\r\n            left: 0\r\n            right: 0\r\n            top: 0\r\n            bottom: 0\r\n            width: 100%\r\n            height: 100%\r\n        .post-slide\r\n            .post-img\r\n                margin: 0\r\n                height: 250px\r\n                // margin-bottom: 20px\r\n            .post-title\r\n                margin: 20px 0 \r\n                a\r\n                    text-transform: none\r\n            .read-btn   \r\n                display: inline-block\r\n                text-align: center\r\n                width: 100%   \r\n                .read-more    \r\n                    float: inherit\r\n                    text-transform: lowercase",".contact-sec\r\n    background: #a6a6a644\r\n    padding: 50px 0\r\n    .heading\r\n        h2\r\n            font-size: 36px\r\n            margin-bottom: 10px\r\n            .text-darkpink\r\n                color: $primary-color\r\n    .contact-form \r\n        background: $white-color\r\n        padding: 25px\r\n        box-shadow: 1px 0px 7px 1px #999999db\r\n        border-radius: 20px\r\n        display: flex\r\n        flex-wrap: wrap\r\n        .img_cnt\r\n            flex: 0 1 40%\r\n            max-width: 40%\r\n            position: relative\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n            &::before\r\n                position: absolute\r\n                content: \"\"\r\n                background: linear-gradient(to bottom, transparent ,#000000)\r\n                width: 100%\r\n                border-radius: 20px\r\n                height: 100%\r\n            img\r\n                border-radius: 20px\r\n        .content\r\n            position: absolute\r\n            bottom: 20px\r\n            left: 20px\r\n            padding: 0 20px\r\n            h5\r\n                color: $white-color\r\n                margin-bottom: 10px\r\n            p\r\n                color: $white-color      \r\n        form\r\n            flex: 0 1 60%\r\n            max-width: 60%\r\n            padding: 36px\r\n            position: relative\r\n            border-radius: 6px\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n                padding: 20px\r\n            .flex\r\n                .col\r\n                    flex: 0 1 50%\r\n                    max-width: 50%\r\n                    padding: 0 15px\r\n                    margin-top: 20px\r\n                    @include respond-to(screen-767)\r\n                        flex: 0 1 100%\r\n                        max-width: 100%\r\n                        padding: 0\r\n                    &:nth-last-child(2),&:last-child\r\n                        flex: 0 1 100%\r\n                        max-width: 100%\r\n                    &:last-child\r\n                        text-align: center    \r\n                        \r\n            .back-input,.back-textarea\r\n                .frm-cntrl\r\n                    display: block\r\n                    width: 100%\r\n                    padding: 8px 15px\r\n                    font-size: 1rem\r\n                    font-weight: 400\r\n                    line-height: 1.5\r\n                    color: #212529\r\n                    background-color: #fff\r\n                    background-clip: padding-box\r\n                    border: 1px solid #ced4da\r\n                    appearance: none\r\n                    border-radius: 5px\r\n                    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out\r\n                label\r\n                    margin-bottom: 5px\r\n                .error\r\n                    display: block\r\n                    margin-top: 5px\r\n                    color: red \r\n            .demo-link\r\n                background: $primary-color\r\n                padding: 7px 25px\r\n                text-align: center\r\n                margin: 0 auto\r\n                border-radius: 25px\r\n                width: 200px\r\n                margin-top: 20px\r\n                border: 0\r\n                margin: 0 auto\r\n                a\r\n                    color: $white-color\r\n                    display: block        \r\n\r\n\r\n.office-sec\r\n    padding: 50px 0\r\n    .heading\r\n        h2\r\n            font-size: 36px\r\n            margin-bottom: 10px\r\n            .text-darkpink\r\n                color: $primary-color\r\n    .flex\r\n        .col\r\n            flex: 0 1 50%\r\n            max-width: 50%\r\n            @include respond-to(screen-767)\r\n                flex: 0 1 100%\r\n                max-width: 100%\r\n\r\n    .offer_card\r\n        border: 1px solid #a6a6a6\r\n        width: 400px\r\n        border-radius: 20px\r\n        padding: 20px\r\n        margin: 0 auto\r\n        height: 250px\r\n        background: #222222\r\n        @include respond-to(screen-767)\r\n            width: 100%\r\n            margin-bottom: 20px\r\n        img\r\n            width: 60px\r\n        h4\r\n            color: $white-color\r\n        p\r\n            color: $white-color        ",".download-banner\r\n    position: relative\r\n    .bg\r\n        width: 100%\r\n        height: calc( 100vh - 400px )\r\n        line-height: 0\r\n        &::before\r\n            position: absolute\r\n            content: \"\"\r\n            background: #000000\r\n            width: 100%\r\n            height: 100%\r\n            opacity: .7\r\n        img\r\n            width: 100%\r\n            height: 100%\r\n            object-fit: cover\r\n    .content\r\n        position: absolute\r\n        top: 50%\r\n        left: 50%\r\n        transform: translate(-50%,-50%)\r\n        text-align: center\r\n        h2\r\n            color: $white-color\r\n            margin-bottom: 10px\r\n        p\r\n            font-size: 18px\r\n            color: $white-color    \r\n\r\n.download-sec\r\n    position: relative\r\n    padding: 50px 0\r\n    .flex\r\n        align-items: center\r\n        .col\r\n            text-align: center\r\n            flex: 0 1 50%\r\n            max-width: 50%    \r\n    .qrcode\r\n        width: 200px\r\n        border-radius: 10px\r\n    .app-links\r\n        .app-store,.playstore\r\n            width: 200px\r\n            display: inline-block    ",".react-footer\r\n    position: relative\r\n    background: url(../images/footer-bg.png) no-repeat center center/cover\r\n    color: #fff\r\n    @include respond-to(screen-767)\r\n        padding-bottom: 50px\r\n    &::before\r\n        position: absolute\r\n        content: \"\"\r\n        width: 100%\r\n        height: 100%\r\n        background: #22222293\r\n        \r\n    .footer-top\r\n        position: relative\r\n        padding: 100px 0 50px\r\n        border-bottom: 1px solid #fff\r\n        @include respond-to(screen-767)\r\n            padding-top: 30px\r\n            padding-bottom: 0\r\n        .flex\r\n            &.reviews\r\n                width: 50%\r\n                justify-content: center\r\n                align-items: center\r\n                margin: 0 auto\r\n                margin-top: 30px\r\n            .col\r\n                flex: 0 1 25%\r\n                max-width: 25%\r\n                @include respond-to(screen-767)\r\n                    flex: 0 1 100%\r\n                    max-width: 100%\r\n                    margin-bottom: 20px\r\n        .footer-logo\r\n            a\r\n                img\r\n                    filter: invert(1)\r\n                    width: 90px\r\n                   \r\n        h6\r\n            color: $white-color \r\n            font-size: 14px\r\n            padding-right: 30px \r\n            line-height: 1.3         \r\n        .footer-title\r\n            margin-bottom: 10px\r\n            color: $white-color\r\n        .footer-menu\r\n            svg\r\n                margin-right: 10px\r\n                vertical-align: middle\r\n            li\r\n                transition: 450ms ease\r\n                a\r\n                    color: #f7f7f7\r\n                &:hover\r\n                    a\r\n                        margin-left: 10px\r\n                        color: $primary-color\r\n        .footer3__form\r\n            p\r\n                margin-bottom: 10px\r\n            form\r\n                position: relative\r\n                .email\r\n                    position: relative\r\n                input\r\n                    padding: 15px 80px 16px 30px\r\n                    border: none\r\n                    outline: none\r\n                    background: #ffffff\r\n                    border-radius: 4px\r\n                    width: 90%\r\n                   \r\n                button\r\n                    position: absolute\r\n                    width: 60px\r\n                    bottom: 0\r\n                    border-radius: 0 4px 4px 0\r\n                    background-color: $primary-color\r\n                    color: #ffffff\r\n                    top: 0px\r\n                    right: 0px\r\n                    border: none\r\n                    svg\r\n                        width: 20px\r\n                .error\r\n                    display: block\r\n                    color: red  \r\n                    margin-top: 5px      \r\n    .copyright\r\n        padding: 10px 0\r\n        position: relative\r\n        .byteedge\r\n            color: $primary-color\r\n        .flex\r\n            align-items: center\r\n            .col\r\n                flex: 0 1 33.33%\r\n                max-width: 33.33%\r\n                text-align: center\r\n                @include respond-to(screen-767)\r\n                    flex: 0 1 100%\r\n                    max-width: 100%\r\n                    margin-bottom: 20px\r\n                &:last-child\r\n                    text-align: right\r\n                    @include respond-to(screen-767)\r\n                        text-align: left\r\n        .isocerti\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            span\r\n                color: $white-color\r\n                margin-left: 10px                \r\n        .social-links\r\n            li\r\n                &:first-child\r\n                    margin-right: 10px\r\n               \r\n                a\r\n                    margin: 0 10px\r\n                    border: 1px solid #fff\r\n                    // padding: 10px\r\n                    width: 40px\r\n                    height: 40px\r\n                    display: block\r\n                    border-radius: 50%\r\n                    display: flex\r\n                    align-items: center\r\n                    justify-content: center\r\n               \r\n                svg\r\n                    fill: $primary-color\r\n\r\n.software-logo\r\n    a\r\n        img\r\n            width: 100px                    ",".privacy-sec-A\r\n    position: relative\r\n    padding: 50px 0\r\n    .content\r\n        h3,h2\r\n            margin-bottom: 20px\r\n        h3\r\n            color: $primary-color\r\n            font-weight: 600\r\n            margin: 35px 0\r\n        h4\r\n            font-size: 20px\r\n            margin-bottom: 20px\r\n        a    \r\n            color: $primary-color\r\n            font-weight: 600\r\n        p\r\n            margin-bottom: 10px\r\n            color: #666666 \r\n        table\r\n            width: 100%\r\n            th\r\n                font-weight: 600    \r\n        table,tr,th,td\r\n            margin-top: 20px\r\n            padding: 20px\r\n            color: #666666\r\n            border: 1px solid #666666\r\n            span\r\n                display: block\r\n        .bullet_points\r\n            li\r\n                color: #666666\r\n                margin-bottom: 10px\r\n                &::before\r\n                    background: $primary-color  \r\n",".page_404 \r\n    padding:50px 0\r\n    // img \r\n    //     width:100%\r\n    .four_zero_four_bg\r\n        background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif)\r\n        height: 400px\r\n        background-position: center\r\n    .contant_box_404\r\n        text-align: center\r\n        .link_404\t\t\t \r\n            color: #fff\r\n            padding: 10px 20px\r\n            background: $primary-color\r\n            margin: 20px 0\r\n            border-radius: 20px\r\n            display: inline-block\r\n//     h1\r\n//         font-size:80px\r\n//     h3\r\n//         font-size:80px\r\n//     .contant_box_404\r\n//         margin-top: 50px\r\n//         text-align: center\r\n//         \r\n\t",".chatbot-popup\r\n    position: fixed\r\n    bottom: 90px\r\n    right: 35px\r\n    opacity: 0\r\n    pointer-events: none\r\n    margin: 10px 0\r\n    width: 350px\r\n    overflow: hidden\r\n    transform: scale(0.2)\r\n    background: $white-color\r\n    border-radius: 15px\r\n    box-shadow: 0 0 128px 0 rgba(0, 0, 0, 0.1), 0 32px 64px -48px rgba(0, 0, 0, 0.5)\r\n    transition: all 0.1s ease\r\n    z-index: 111\r\n    .chat-header\r\n        background: #da3467\r\n        display: flex\r\n        padding: 15px 20px\r\n        align-items: center\r\n        justify-content: space-between\r\n        .header-info\r\n            display: flex\r\n            gap: 10px\r\n            align-items: center\r\n            h2\r\n                font-size: 20px\r\n                color: $white-color\r\n            img\r\n                border-radius: 100%\r\n                border: 2px solid $white-color\r\n                max-width: 50px\r\n        button\r\n            outline: none\r\n            border: none\r\n            background: none\r\n            color: #fff\r\n            border-radius: 100%\r\n            width: 30px\r\n            height: 30px\r\n            transition: 0.2 ease\r\n            &:hover\r\n                background: #ce2559\r\n    .chatbot-body\r\n        display: flex\r\n        flex-direction: column\r\n        gap: 20px\r\n        height: 280px\r\n        // margin-bottom: 80px\r\n        overflow-y: auto\r\n        padding: 25px 20px\r\n        scrollbar-width: thin\r\n        scrollbar-color: #da3467 transparent\r\n        .message\r\n            display: flex\r\n            gap: 10px\r\n            align-items: center\r\n            .message-text\r\n                background: $primary-color\r\n                padding: 5px 10px\r\n                color: $white-color\r\n                max-width: 75%\r\n                font-weight: 400\r\n                word-wrap: break-word\r\n                white-space: pre-line\r\n                font-size: 0.95rem\r\n                line-height: 1.3\r\n            &.bot-message\r\n                img\r\n                    border-radius: 100%\r\n                    width: 40px\r\n                    border: 2px solid $primary-color\r\n                    flex-shrink: 0\r\n                    align-self: flex-start\r\n                .message-text\r\n                    background: #da346761\r\n                    color: $text-color\r\n                    border-radius: 10px 10px 10px 2px\r\n\r\n            &.user-message\r\n                flex-direction: column\r\n                align-items: flex-end\r\n                .message-text\r\n                    border-radius: 10px 10px 2px 10px\r\n    .ai-sugesstion\r\n        // position: absolute\r\n        // bottom: 17%\r\n        padding: 8px 20px\r\n        span\r\n            background: #da3467ba\r\n            font-size: 12px\r\n            padding: 5px 10px\r\n            border-radius: 27px\r\n            margin-left: 5px\r\n            margin-bottom: 5px\r\n            display: inline-block\r\n            line-height: 1.3\r\n            cursor: pointer\r\n\r\n    .chat-footer\r\n        // position: absolute\r\n        bottom: 0\r\n        width: 100%\r\n        background: $white-color\r\n        padding: 15px 20px\r\n        .chat-form\r\n            display: flex\r\n            align-items: center\r\n            background: $white-color\r\n            border-radius: 30px\r\n            outline: 2px solid #c2c2c2\r\n            &:focus-within\r\n                outline: 2px solid $primary-color\r\n            .message-input\r\n                outline: none\r\n                background: none\r\n                border: none\r\n                width: 100%\r\n                padding: 0 10px\r\n                height: 40px\r\n                font-size: 0.95rem\r\n                &:valid ~ button\r\n                    display: block\r\n\r\n            button\r\n                height: 30px\r\n                width: 30px\r\n                border-radius: 100%\r\n                outline: none\r\n                font-size: 1.15rem\r\n                flex-shrink: 0\r\n                margin-right: 8px\r\n                background: $primary-color\r\n                border: none\r\n                display: none\r\n                color: $white-color\r\n\r\n#chatbot-toogler\r\n    position: fixed\r\n    bottom: 30px\r\n    right: 35px\r\n    border: none\r\n    height: 80px\r\n    width: 80px\r\n    display: flex\r\n    align-items: center\r\n    justify-content: center\r\n    background: #da3467d4\r\n    border-radius: 50%\r\n    z-index: 11\r\n    transition: all 0.2s ease\r\n    overflow: hidden\r\n    animation: bounce 1.5s infinite, glow 2s infinite alternate\r\n    span\r\n        position: absolute\r\n        color: $white-color\r\n        img\r\n            width: 60px\r\n            display: flex\r\n            align-items: center\r\n            justify-content: center\r\n            border-radius: 50%\r\n           \r\n@keyframes bounce\r\n    0%,100%\r\n       transform: translateY(0) \r\n    50%\r\n        transform: translateY(-10px)\r\n@keyframes glow\r\n    0%\r\n       box-shadow: 0 0 15px rgba(255, 61, 132, 0.6), 0 0 30px rgba(255, 30, 105, 0.4)\r\n    100%\r\n        box-shadow: 0 0 25px #ff3d64, 0 0 50px #ff1e5e\r\n\r\n.container\r\n    &.show-chatbot\r\n        .chatbot-popup\r\n            opacity: 1\r\n            transform: scale(1)\r\n            pointer-events: auto\r\n        #chatbot-toogler\r\n            transform: rotate(90deg)\r\n            animation: none\r\n            height: 50px\r\n            width: 50px\r\n            span\r\n                &:first-child\r\n                    opacity: 0\r\n                &:last-child\r\n                    opacity: 1    \r\n#chatbot-toogler\r\n    span\r\n        &:last-child\r\n            opacity: 0\r\n\r\n.typing\r\n    position: relative\r\n    span\r\n        content: ''\r\n        animation: blink 1.5s infinite\r\n        animation-fill-mode: both\r\n        height: 10px\r\n        width: 10px\r\n        background: $white-color\r\n        position: absolute\r\n        left:0\r\n        top:0\r\n        border-radius: 50%\r\n        &:nth-child(2)\r\n            animation-delay: .2s\r\n            margin-left: 10px * 1.5\r\n        &:nth-child(3)\r\n            animation-delay: .4s\r\n            margin-left: 10px * 3\r\n\r\n@keyframes blink\r\n    0%\r\n        opacity: .1\r\n    20%\r\n        opacity: 1\r\n    100%\r\n        opacity: .1   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
